/* This file was auto-generated, do not modify! Run `pnpm run generate` to re-generate. */
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  DateTime: { input: string; output: string };
};

/** Abwesenheit einer Person, wie sie die handgeschriebenen Root-Felder liefern. */
export type AbsenceEntry = {
  __typename?: 'AbsenceEntry';
  comment?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  personListName: Scalars['String']['output'];
  personUuid: Scalars['ID']['output'];
  reason: AbsenceReason;
  start: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export enum AbsenceReason {
  Business = 'BUSINESS',
  ChildCare = 'CHILD_CARE',
  Emergency = 'EMERGENCY',
  Illness = 'ILLNESS',
  OnLeave = 'ON_LEAVE',
  Other = 'OTHER',
  Privat = 'PRIVAT',
  Training = 'TRAINING',
}

/** Eine aktive Stundenplan-Version mit ihrem Stundenplan und den Klassen, Lehrkräften und Räumen, die in sie aufgenommen sind. */
export type ActiveTimetableVersion = {
  __typename?: 'ActiveTimetableVersion';
  classUuids: Array<Scalars['ID']['output']>;
  roomUuids: Array<Scalars['ID']['output']>;
  teacherUuids: Array<Scalars['ID']['output']>;
  timetableName: Scalars['String']['output'];
  timetableUuid: Scalars['ID']['output'];
  uuid: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type AdditionalTeachingLoadInput = {
  classUuid?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  hours: Scalars['Float']['input'];
  hoursRaw?: InputMaybe<Scalars['String']['input']>;
  schoolYearUuid: Scalars['ID']['input'];
  subjectUuid?: InputMaybe<Scalars['ID']['input']>;
  teacherUuid: Scalars['ID']['input'];
};

/** Zusätzliches Deputat einer Lehrkraft (Stunden außerhalb der Zuordnungen), wie es die handgeschriebenen Root-Felder liefern. */
export type AdditionalTeachingLoadItem = {
  __typename?: 'AdditionalTeachingLoadItem';
  class?: Maybe<AdditionalTeachingLoadRef>;
  comment?: Maybe<Scalars['String']['output']>;
  hours: Scalars['Float']['output'];
  hoursRaw?: Maybe<Scalars['String']['output']>;
  schoolYearUuid: Scalars['ID']['output'];
  subject?: Maybe<AdditionalTeachingLoadRef>;
  teacher: AdditionalTeachingLoadTeacherRef;
  teacherListName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type AdditionalTeachingLoadRef = {
  __typename?: 'AdditionalTeachingLoadRef';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type AdditionalTeachingLoadTeacherRef = {
  __typename?: 'AdditionalTeachingLoadTeacherRef';
  listName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export enum AffectedEntityType {
  Absence = 'ABSENCE',
  Class = 'CLASS',
  Group = 'GROUP',
  OtherEvent = 'OTHER_EVENT',
  Person = 'PERSON',
  Room = 'ROOM',
}

export type AttendancePlanEvent = {
  __typename?: 'AttendancePlanEvent';
  canceled: Scalars['Boolean']['output'];
  class: MinimalClass;
  end: Scalars['DateTime']['output'];
  isClassbookRelevant: Scalars['Boolean']['output'];
  isSchoolEvent: Scalars['Boolean']['output'];
  persons: Array<MinimalPerson>;
  print: Scalars['Boolean']['output'];
  rooms: Array<MinimalRoom>;
  start: Scalars['DateTime']['output'];
  subject: MinimalSubject;
  uuid: Scalars['ID']['output'];
};

export enum BillingMethods {
  ContractIsMax = 'CONTRACT_IS_MAX',
  ContractIsMin = 'CONTRACT_IS_MIN',
  Exact = 'EXACT',
  GivenHours = 'GIVEN_HOURS',
}

/** Vollständiger Stand eines Gebäudes; nicht gesetzte optionale Felder werden geleert. */
export type BuildingInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Gebäude, wie es die handgeschriebenen Root-Felder liefern. */
export type BuildingItem = {
  __typename?: 'BuildingItem';
  active?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Verweis auf ein Gebäude innerhalb eines Item-Typs. */
export type BuildingRefItem = {
  __typename?: 'BuildingRefItem';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Teilung einer Klasse innerhalb von ClassItem, mit ihren Gruppen in der festgelegten Reihenfolge. */
export type ClassDivisionItem = {
  __typename?: 'ClassDivisionItem';
  groups: Array<ClassGroupItem>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type ClassGridCard = {
  __typename?: 'ClassGridCard';
  classUuid: Scalars['ID']['output'];
  colors: Array<Scalars['String']['output']>;
  cssGradientString?: Maybe<Scalars['String']['output']>;
  cssHeight?: Maybe<Scalars['String']['output']>;
  cssTop?: Maybe<Scalars['String']['output']>;
  divisionsCount?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  lessonUuid: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  startTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  timetableCardUuid: Scalars['ID']['output'];
  usedPosition: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
  weekday?: Maybe<Scalars['String']['output']>;
};

/** Gruppe einer Teilung innerhalb von ClassItem. */
export type ClassGroupItem = {
  __typename?: 'ClassGroupItem';
  /** Anteil der Gruppe an der Klasse: eins durch die Zahl der Gruppen der Teilung. */
  classFraction: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/**
 * Vollständiger Stand einer Klasse. Klassenraum, Klassenzug und Klassenlehrer werden ersetzt: was hier nicht steht, ist
 * danach nicht mehr verbunden. Die Reihenfolge von tutorUuids ist die Reihenfolge der Klassenlehrer. Teilungen und das
 * Verhalten im Vertretungsplan bleiben unberührt.
 */
export type ClassInput = {
  certificatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  colorLabel?: InputMaybe<Scalars['String']['input']>;
  defaultRoomUuid?: InputMaybe<Scalars['ID']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  gradeGroupUuid?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  printOrder?: InputMaybe<Scalars['Int']['input']>;
  printPageNr?: InputMaybe<Scalars['Int']['input']>;
  relevantForSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  studentCount?: InputMaybe<Scalars['Int']['input']>;
  tutorUuids: Array<Scalars['ID']['input']>;
};

export type ClassInterface = {
  __typename?: 'ClassInterface';
  grade?: Maybe<Scalars['Int']['output']>;
  gradeGroup?: Maybe<GradeGroupRefItem>;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** Klasse, wie sie die handgeschriebenen Root-Felder liefern. */
export type ClassItem = {
  __typename?: 'ClassItem';
  certificatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Klassenraum */
  defaultRoomUuid?: Maybe<Scalars['ID']['output']>;
  /** Teilungen der Klasse, nach Name sortiert. */
  divisions: Array<ClassDivisionItem>;
  functionalClassSubstitutionBehavior?: Maybe<FunctionalClassSubstitutionBehavior>;
  grade?: Maybe<Scalars['Int']['output']>;
  gradeGroup?: Maybe<GradeGroupRefItem>;
  name: Scalars['String']['output'];
  relevantForSubstitution?: Maybe<Scalars['Boolean']['output']>;
  schoolYearUuid?: Maybe<Scalars['ID']['output']>;
  shortName: Scalars['String']['output'];
  /**
   * Sortierschlüssel als Zeichenkette: Jahrgang plus 1000, dahinter der Name des Klassenzugs ("1005a"); ohne Jahrgang
   * "10000". Als Zeichenkette verglichen stehen Klassen ohne Jahrgang damit vor allen anderen.
   */
  sortName: Scalars['String']['output'];
  studentCount?: Maybe<Scalars['Int']['output']>;
  /** null, solange die Klasse keine Einstellungen hat (Altbestand). */
  timetableConfig?: Maybe<TimetableConfigItem>;
  /** Klassenlehrer in der festgelegten Reihenfolge. */
  tutorUuids: Array<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ConnectDisconnectInput = {
  connect?: InputMaybe<Array<Scalars['ID']['input']>>;
  disconnect?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ContractInput = {
  billingMethod?: InputMaybe<BillingMethods>;
  freelancer?: InputMaybe<Scalars['Boolean']['input']>;
  hoursWeekly?: InputMaybe<Scalars['Float']['input']>;
  limitedToFullTime?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  substituteHours?: InputMaybe<Scalars['Float']['input']>;
  validFrom: Scalars['Date']['input'];
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

/** Vertrag einer Person, wie ihn das handgeschriebene Root-Feld contracts liefert. */
export type ContractItem = {
  __typename?: 'ContractItem';
  billingMethod?: Maybe<BillingMethods>;
  freelancer?: Maybe<Scalars['Boolean']['output']>;
  hoursWeekly?: Maybe<Scalars['Float']['output']>;
  limitedToFullTime?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  personUuid: Scalars['ID']['output'];
  substituteHours?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['ID']['output'];
  validFrom: Scalars['Date']['output'];
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type CreateAbsenceInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  person: Scalars['ID']['input'];
  reason: AbsenceReason;
  start: Scalars['DateTime']['input'];
};

export type CreateLessonsFromCurriculaResult = {
  __typename?: 'CreateLessonsFromCurriculaResult';
  createdLessonUuids: Array<Scalars['ID']['output']>;
  failed: Array<CurriculumImportFailure>;
  skipped: Array<CurriculumImportSkip>;
};

export type CreateResponse = {
  __typename?: 'CreateResponse';
  nodeUuids: Array<Scalars['String']['output']>;
  nodesCreated: Scalars['Int']['output'];
};

export type CreateTimeGridEntryInput = {
  end: Scalars['DateTime']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pause: Scalars['Boolean']['input'];
  print: Scalars['Boolean']['input'];
  reliable: Scalars['Boolean']['input'];
  shortName: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  /** TimeGrid, an das der Eintrag gehängt wird (HAS_ITEMS) */
  timeGridUuid: Scalars['ID']['input'];
};

export enum CurriculumFlag {
  Elective = 'ELECTIVE',
  IsClassTrip = 'IS_CLASS_TRIP',
  TeachingLoadEnabled = 'TEACHING_LOAD_ENABLED',
  TimetableEnabled = 'TIMETABLE_ENABLED',
}

export type CurriculumGradeGroupItem = {
  __typename?: 'CurriculumGradeGroupItem';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type CurriculumGradeInput = {
  gradeGroupUuids: Array<Scalars['ID']['input']>;
  grades: Array<Scalars['Int']['input']>;
  /** Gruppen aus Vorlagen-Teilungen. */
  groupUuids: Array<Scalars['ID']['input']>;
};

/** Jahrgangs-Eintrag einer Sollstunde: Jahrgänge, Klassenzüge und Gruppen (aus Vorlagen-Teilungen). */
export type CurriculumGradeItem = {
  __typename?: 'CurriculumGradeItem';
  gradeGroups: Array<CurriculumGradeGroupItem>;
  grades: Array<Scalars['Int']['output']>;
  groups: Array<CurriculumGroupItem>;
  /** Die Klassen, für die der Eintrag gilt. */
  plannedClasses: Array<CurriculumPlannedClassItem>;
  uuid: Scalars['ID']['output'];
};

export type CurriculumGroupItem = {
  __typename?: 'CurriculumGroupItem';
  /** Anteil der Gruppe an der Klasse: eins durch die Zahl der Gruppen ihrer Teilung. */
  classFraction: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type CurriculumImportFailure = {
  __typename?: 'CurriculumImportFailure';
  curriculumUuid: Scalars['ID']['output'];
  error: Scalars['String']['output'];
};

export type CurriculumImportSkip = {
  __typename?: 'CurriculumImportSkip';
  curriculumUuid: Scalars['ID']['output'];
  reason: CurriculumImportSkipReason;
};

export enum CurriculumImportSkipReason {
  AlreadyExists = 'ALREADY_EXISTS',
  NoClasses = 'NO_CLASSES',
}

/**
 * Vollständiger Stand einer Sollstunde für Anlegen und Ändern. Lehrer-Platzhalter, Jahrgangs-Einträge, Einheiten und
 * Räume werden ersetzt; die Reihenfolge der Listen ist ihre Reihenfolge.
 */
export type CurriculumInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  curriculumGrades: Array<CurriculumGradeInput>;
  curriculumUnits: Array<CurriculumUnitInput>;
  elective?: InputMaybe<Scalars['Boolean']['input']>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  persons: Array<CurriculumPersonInput>;
  roomSupply: Array<CurriculumRoomInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  /** uuid eines Fachs oder einer Schiene. */
  subjectUuid: Scalars['ID']['input'];
  teachingLoadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetableEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Sollstunde, wie sie die handgeschriebenen Root-Felder liefern. */
export type CurriculumItem = {
  __typename?: 'CurriculumItem';
  comment?: Maybe<Scalars['String']['output']>;
  /** Jahrgangs-Einträge in der festgelegten Reihenfolge. */
  curriculumGrades: Array<CurriculumGradeItem>;
  /** Einheiten in der festgelegten Reihenfolge. */
  curriculumUnits: Array<CurriculumUnitItem>;
  curriculumVersionUuid: Scalars['ID']['output'];
  elective?: Maybe<Scalars['Boolean']['output']>;
  /** Anzeigenamen der Klassen je geplanter Zuordnung. */
  groupGradeNames: Array<Scalars['String']['output']>;
  isClassTrip?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<CurriculumLabelItem>;
  /** Zuordnungen, die aus der Sollstunde entstanden sind. */
  lessons: Array<CurriculumLessonRefItem>;
  /** Lehrer-Platzhalter in der festgelegten Reihenfolge. */
  persons: Array<CurriculumPersonItem>;
  /**
   * Die Zuordnungen, die aus der Sollstunde entstünden. Hat jeder Jahrgangs-Eintrag höchstens einen Jahrgang, einen
   * Klassenzug und eine Gruppe, ist es eine Zuordnung mit allen Einträgen als Klassen; bei genau einem Eintrag mit
   * mehreren Werten je geplanter Klasse eine eigene Zuordnung; sonst keine.
   */
  plannedLessons: Array<CurriculumPlannedLessonItem>;
  /** Räume in der festgelegten Reihenfolge. */
  roomSupply: Array<CurriculumRoomItem>;
  subTitle?: Maybe<Scalars['String']['output']>;
  subject: CurriculumSubjectItem;
  teachingLoadEnabled?: Maybe<Scalars['Boolean']['output']>;
  timetableEnabled?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
};

export type CurriculumLabelItem = {
  __typename?: 'CurriculumLabelItem';
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Zuordnung, die aus der Sollstunde entstanden ist. */
export type CurriculumLessonRefItem = {
  __typename?: 'CurriculumLessonRefItem';
  schoolYearUuid?: Maybe<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
};

export type CurriculumLessonStatus = {
  __typename?: 'CurriculumLessonStatus';
  canImport: Scalars['Boolean']['output'];
  curriculumUuid: Scalars['ID']['output'];
  existing: Scalars['Int']['output'];
  possible: Scalars['Int']['output'];
};

export type CurriculumPersonInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  present?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoad?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Lehrer-Platzhalter einer Sollstunde. */
export type CurriculumPersonItem = {
  __typename?: 'CurriculumPersonItem';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  present?: Maybe<Scalars['Boolean']['output']>;
  teachingLoad?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
};

/**
 * Eine Klasse, für die die Sollstunde gilt: aus einem Jahrgangs-Eintrag entsteht je Jahrgang, Klassenzug und Gruppe
 * eine geplante Klasse. Sie ist keine Klasse eines Schuljahres, sondern beschreibt sie nur über Jahrgang und Klassenzug.
 */
export type CurriculumPlannedClassItem = {
  __typename?: 'CurriculumPlannedClassItem';
  grade: Scalars['Int']['output'];
  gradeGroup?: Maybe<CurriculumGradeGroupItem>;
  groups: Array<CurriculumPlannedGroupItem>;
  /** Jahrgang und Name des Klassenzugs, z. B. 5a. */
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

/**
 * Gruppe innerhalb einer geplanten Klasse. Sie trägt bewusst keinen Klassenanteil: die Berechnung der Sollstunden
 * zählt eine Gruppe vorerst als ganze Klasse (offene Entscheidung, Stand 2026-10-10). Der echte Anteil steht in
 * CurriculumGradeItem.groups.classFraction.
 */
export type CurriculumPlannedGroupItem = {
  __typename?: 'CurriculumPlannedGroupItem';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Eine Zuordnung, die beim Übertragen aus der Sollstunde entstünde, beschrieben durch ihre Klassen. */
export type CurriculumPlannedLessonItem = {
  __typename?: 'CurriculumPlannedLessonItem';
  classes: Array<CurriculumPlannedClassItem>;
  /** Laufende Kennung innerhalb der Sollstunde (uuid der Sollstunde, #, Position). */
  uuid: Scalars['ID']['output'];
};

export type CurriculumRoomInput = {
  descriptions?: InputMaybe<Scalars['String']['input']>;
  roomUuid: Scalars['ID']['input'];
};

export type CurriculumRoomItem = {
  __typename?: 'CurriculumRoomItem';
  descriptions?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  roomUuid: Scalars['ID']['output'];
};

/** Fach oder Schiene einer Sollstunde. */
export type CurriculumSubjectItem = {
  __typename?: 'CurriculumSubjectItem';
  epochEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Jahrgänge der Schiene; leer bei einem Fach. */
  grades: Array<Scalars['Int']['output']>;
  /** true: die Sollstunde hängt an einer Schiene (Epochenplan), false: an einem Fach. */
  isSubjectContainer: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  subjectHourEnabled?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
};

export type CurriculumUnitInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  subjectContainerUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Einheit einer Sollstunde: Anzahl und Dauer, bei Epochen mit Schiene. */
export type CurriculumUnitItem = {
  __typename?: 'CurriculumUnitItem';
  count?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  subjectContainer?: Maybe<CurriculumUnitSubjectContainerItem>;
  uuid: Scalars['ID']['output'];
};

export type CurriculumUnitSubjectContainerItem = {
  __typename?: 'CurriculumUnitSubjectContainerItem';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type CurriculumVersionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Version der Sollstunden, wie sie die handgeschriebenen Root-Felder liefern. */
export type CurriculumVersionItem = {
  __typename?: 'CurriculumVersionItem';
  /** Zahl der Sollstunden der Version; eine Version mit Sollstunden lässt sich nicht löschen. */
  curriculaCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type DeleteInfo = {
  __typename?: 'DeleteInfo';
  nodesDeleted: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

export type DependencyInput = {
  active: Scalars['Boolean']['input'];
  alias: Scalars['String']['input'];
  classUuids: Array<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  otherData?: InputMaybe<Scalars['String']['input']>;
  priority: DependencyPriority;
  subjectUuids: Array<Scalars['ID']['input']>;
};

/** Eine Abhängigkeit (Regel zwischen Fächern und Klassen) einer Stundenplan-Version. */
export type DependencyItem = {
  __typename?: 'DependencyItem';
  active: Scalars['Boolean']['output'];
  /** Art der Abhängigkeit, z. B. 4001. */
  alias: Scalars['String']['output'];
  /** Nach Kurzname. */
  classes: Array<DependencyResourceItem>;
  comment?: Maybe<Scalars['String']['output']>;
  /** Zusatzdaten der Art als JSON. */
  otherData?: Maybe<Scalars['String']['output']>;
  priority: DependencyPriority;
  /** Nach Kurzname. */
  subjects: Array<DependencyResourceItem>;
  uuid: Scalars['ID']['output'];
};

export enum DependencyPriority {
  Important = 'IMPORTANT',
  Mandatory = 'MANDATORY',
  Optimizing = 'OPTIMIZING',
}

export type DependencyResourceItem = {
  __typename?: 'DependencyResourceItem';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Klasse einer Teilung innerhalb von DivisionItem. */
export type DivisionClassItem = {
  __typename?: 'DivisionClassItem';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type DivisionGroupInput = {
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  studentCount?: InputMaybe<Scalars['Int']['input']>;
  /** uuid einer bestehenden Gruppe dieser Teilung; ohne uuid wird die Gruppe angelegt. */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Vollständiger Stand einer Teilung für Anlegen und Ändern. Die Gruppen werden ersetzt: Gruppen mit uuid werden
 * geändert, Gruppen ohne uuid angelegt, nicht genannte Gruppen der Teilung gelöscht. Die Reihenfolge der Liste ist
 * die Reihenfolge der Gruppen.
 */
export type DivisionInput = {
  groups: Array<DivisionGroupInput>;
  name: Scalars['String']['input'];
};

/** Teilung, wie sie die handgeschriebenen Root-Felder liefern, mit ihren Gruppen in der festgelegten Reihenfolge. */
export type DivisionItem = {
  __typename?: 'DivisionItem';
  /** Klasse der Teilung; null bei einer Vorlage (Default-Teilung). */
  class?: Maybe<DivisionClassItem>;
  groups: Array<GroupItem>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type DuplicateTeachingBlockVersionOptions = {
  includeAvailabilityExclusions?: InputMaybe<Scalars['Boolean']['input']>;
  includeCardPlacements?: InputMaybe<Scalars['Boolean']['input']>;
  includeConditions?: InputMaybe<Scalars['Boolean']['input']>;
  includeVersionLessons?: InputMaybe<Scalars['Boolean']['input']>;
  snapshot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DuplicateTeachingBlockVersionResponse = {
  __typename?: 'DuplicateTeachingBlockVersionResponse';
  active?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type DuplicateTimetableVersionNewTimetableInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  mapping?: InputMaybe<Array<TimeGridEntryMappingInput>>;
  name: Scalars['String']['input'];
  resetAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  timeGridUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Custom mutations */
export type DuplicateTimetableVersionOptions = {
  createNewTimetable?: InputMaybe<Scalars['Boolean']['input']>;
  newTimetable?: InputMaybe<DuplicateTimetableVersionNewTimetableInput>;
  snapshot?: InputMaybe<Scalars['Boolean']['input']>;
  targetTimetableUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type DuplicateTimetableVersionResponse = {
  __typename?: 'DuplicateTimetableVersionResponse';
  active?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type EntitiesUpdateInfo = {
  __typename?: 'EntitiesUpdateInfo';
  entitiesUpdated: Scalars['Int']['output'];
};

/** Eine Klasse oder Gruppe eines Termins. */
export type EventClassOrGroupRef = {
  __typename?: 'EventClassOrGroupRef';
  type: EventClassOrGroupType;
  uuid: Scalars['ID']['output'];
};

export enum EventClassOrGroupType {
  Class = 'CLASS',
  Group = 'GROUP',
}

/**
 * Ein Termin zum Lesen. Fach, Lehrkräfte, Räume, Klassen und Gruppen stehen als uuid darin; die original…-Felder
 * halten den Stand vor einer Vertretung.
 */
export type EventItem = {
  __typename?: 'EventItem';
  /** Termin, in den dieser zusammengelegt wurde. */
  aggregatedIntoUuid?: Maybe<Scalars['ID']['output']>;
  canceled: Scalars['Boolean']['output'];
  classesOrGroups: Array<EventClassOrGroupRef>;
  comment?: Maybe<Scalars['String']['output']>;
  /** JSON-Text mit EventStateType[] */
  currentState?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  isClassTrip: Scalars['Boolean']['output'];
  isClassbookRelevant: Scalars['Boolean']['output'];
  /** Der Termin gehört zu einem Wahlfach (lässt sich nicht aufteilen). */
  isElective: Scalars['Boolean']['output'];
  isSchoolEvent: Scalars['Boolean']['output'];
  /** Stamm-Teil der Aufteilung (behält Rest und neue Klassen/Gruppen); null = nicht aufgeteilt. */
  isSplitPrimary?: Maybe<Scalars['Boolean']['output']>;
  originalClassesOrGroups: Array<EventClassOrGroupRef>;
  originalPersonUuids: Array<Scalars['ID']['output']>;
  originalRooms: Array<EventItemRoom>;
  persons: Array<EventItemPerson>;
  print: Scalars['Boolean']['output'];
  roomUuids: Array<Scalars['ID']['output']>;
  /** Teil einer Aufteilung: Teile derselben Stunde haben denselben Schlüssel; null = nicht aufgeteilt. */
  splitKey?: Maybe<Scalars['ID']['output']>;
  start: Scalars['DateTime']['output'];
  subjectUuid?: Maybe<Scalars['ID']['output']>;
  substitutionComment?: Maybe<Scalars['String']['output']>;
  substitutionReasons?: Maybe<SubstitutionReason>;
  /** Kürzel der Stunde im Zeitraster, aus der der Termin entstand. */
  timeGridEntryShortName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Eine Lehrkraft eines Termins. */
export type EventItemPerson = {
  __typename?: 'EventItemPerson';
  /** Anrechnungsstunden für die Vertretung, auch anteilig. */
  givenSubstituteHours?: Maybe<Scalars['Float']['output']>;
  /** Vertritt diese Lehrkraft? */
  isCoveringTeacher: Scalars['Boolean']['output'];
  uuid: Scalars['ID']['output'];
};

export type EventItemRoom = {
  __typename?: 'EventItemRoom';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Ein Lauf des Termin-Abgleichs: from und to sind Beginn und Ende des Laufs, eventsFrom und eventsTo der abgeglichene Zeitraum. */
export type EventJobItem = {
  __typename?: 'EventJobItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdEvents: Scalars['Int']['output'];
  deletedEvents: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  eventsFrom?: Maybe<Scalars['Date']['output']>;
  eventsTo?: Maybe<Scalars['Date']['output']>;
  from: Scalars['DateTime']['output'];
  processed: Scalars['Int']['output'];
  status: EventJobStatus;
  timetableVersionUuid?: Maybe<Scalars['ID']['output']>;
  to: Scalars['DateTime']['output'];
  updatedEvents: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

export enum EventJobStatus {
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Finished = 'FINISHED',
  Running = 'RUNNING',
}

export type EventPersonRelationInput = {
  givenSubstituteHours?: InputMaybe<Scalars['Float']['input']>;
  isCoveringTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};

export enum EventState {
  ClassConflict = 'CLASS_CONFLICT',
  ClassNotAvailable = 'CLASS_NOT_AVAILABLE',
  ClassOnSchoolTrip = 'CLASS_ON_SCHOOL_TRIP',
  EventCancelled = 'EVENT_CANCELLED',
  GroupConflict = 'GROUP_CONFLICT',
  GroupNotAvailable = 'GROUP_NOT_AVAILABLE',
  GroupOnSchoolTrip = 'GROUP_ON_SCHOOL_TRIP',
  NeverSubstituted = 'NEVER_SUBSTITUTED',
  PersonConflict = 'PERSON_CONFLICT',
  PersonMissing = 'PERSON_MISSING',
  PersonNotAvailable = 'PERSON_NOT_AVAILABLE',
  PersonOnSchoolTrip = 'PERSON_ON_SCHOOL_TRIP',
  RoomConflict = 'ROOM_CONFLICT',
  RoomNotAvailable = 'ROOM_NOT_AVAILABLE',
}

export type EventStateType = {
  __typename?: 'EventStateType';
  affectedEntityType?: Maybe<AffectedEntityType>;
  /** Gibt bei Konflikten oder nicht Verfügbarkleit die UUID des betroffenen Objekts an (Person, Room, Class, Group). Bei Fehlenden Lehrern ist es die UUID des betroffenen Lehrers */
  affectedEntityUuid?: Maybe<Scalars['String']['output']>;
  conflictedEntityType?: Maybe<AffectedEntityType>;
  /** Gibt bei Konflikten die UUID des Events an, mit dem es zu einem Konflikt kommt */
  conflictedEventUuid?: Maybe<Scalars['String']['output']>;
  /** Gibt an ob z.B PERSON_ON_SCHOOL_TRIP für den ganzen Tag gilt */
  fullDay?: Maybe<Scalars['Boolean']['output']>;
  state: EventState;
};

/** Stand des Termin-Abgleichs über offene Tage. */
export type EventSyncStatus = {
  __typename?: 'EventSyncStatus';
  firstOpenDay?: Maybe<Scalars['Date']['output']>;
  lastOpenDay?: Maybe<Scalars['Date']['output']>;
  /** Tage ab heute, die auf den Abgleich warten (auch die zurückgehaltenen). */
  openDays: Scalars['Int']['output'];
  /** Versionen in Korrektur; leer ohne Leserecht für Stundenpläne. */
  versionsInCorrection: Array<VersionInCorrection>;
};

export enum FactorType {
  Base = 'BASE',
  Person = 'PERSON',
  Time = 'TIME',
}

export enum FunctionalClassSubstitutionBehavior {
  AttendancePlanSource = 'ATTENDANCE_PLAN_SOURCE',
  NormalClassBehavior = 'NORMAL_CLASS_BEHAVIOR',
  ShowInSubstitutionPlan = 'SHOW_IN_SUBSTITUTION_PLAN',
}

/** Vollständiger Stand eines Klassenzugs; eine nicht gesetzte Beschreibung wird geleert. */
export type GradeGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
};

/** Klassenzug, wie ihn die handgeschriebenen Root-Felder liefern. */
export type GradeGroupItem = {
  __typename?: 'GradeGroupItem';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Verweis auf einen Klassenzug innerhalb eines Item-Typs. */
export type GradeGroupRefItem = {
  __typename?: 'GradeGroupRefItem';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Gruppe einer Teilung, wie sie die handgeschriebenen Root-Felder liefern. */
export type GroupItem = {
  __typename?: 'GroupItem';
  /** Anteil der Gruppe an der Klasse: eins durch die Zahl der Gruppen der Teilung. */
  classFraction: Scalars['Float']['output'];
  divisionUuid: Scalars['ID']['output'];
  entireClass?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** Position der Gruppe in ihrer Teilung, beginnend bei 0. */
  order: Scalars['Int']['output'];
  shortName: Scalars['String']['output'];
  studentCount?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Vollständiger Stand von Ferien; start darf nicht nach end liegen. */
export type HolidayInput = {
  end: Scalars['Date']['input'];
  name: Scalars['String']['input'];
  start: Scalars['Date']['input'];
};

/** Ferien, wie sie die handgeschriebenen Root-Felder liefern. */
export type HolidayItem = {
  __typename?: 'HolidayItem';
  end: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  start: Scalars['Date']['output'];
  uuid: Scalars['ID']['output'];
};

export enum InheritLessonTeachersType {
  SameClassLevel = 'sameClassLevel',
  SameStudents = 'sameStudents',
}

/** Klasse einer Zuordnungs-Klasse. */
export type LessonClassClassItem = {
  __typename?: 'LessonClassClassItem';
  color?: Maybe<Scalars['String']['output']>;
  defaultRoom?: Maybe<LessonRefItem>;
  divisions: Array<LessonClassDivisionRefItem>;
  grade?: Maybe<Scalars['Int']['output']>;
  gradeGroup?: Maybe<LessonGradeGroupItem>;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type LessonClassDivisionGroupItem = {
  __typename?: 'LessonClassDivisionGroupItem';
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

/** Die Teilung, aus der die Gruppen einer Zuordnungs-Klasse stammen. */
export type LessonClassDivisionItem = {
  __typename?: 'LessonClassDivisionItem';
  /** Alle Gruppen der Teilung in ihrer Reihenfolge. */
  groups: Array<LessonClassDivisionGroupItem>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Teilung einer Klasse mit den uuids ihrer Gruppen. */
export type LessonClassDivisionRefItem = {
  __typename?: 'LessonClassDivisionRefItem';
  groupUuids: Array<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Gruppe einer Zuordnungs-Klasse. */
export type LessonClassGroupItem = {
  __typename?: 'LessonClassGroupItem';
  /** Anteil der Gruppe an der Klasse: eins durch die Zahl der Gruppen ihrer Teilung; 0 ohne Teilung. */
  classFraction: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type LessonClassInput = {
  classUuid: Scalars['ID']['input'];
  /** Gruppen der Klasse; leer heißt: die ganze Klasse. */
  groupUuids: Array<Scalars['ID']['input']>;
};

export type LessonClassInterface = {
  __typename?: 'LessonClassInterface';
  class: ClassInterface;
  groups: Array<TeachingLoadGroupRefItem>;
};

/** Klasse einer Zuordnung, ganz oder mit einzelnen Gruppen. */
export type LessonClassItem = {
  __typename?: 'LessonClassItem';
  class: LessonClassClassItem;
  groups: Array<LessonClassGroupItem>;
  order: Scalars['Int']['output'];
  usedDivision?: Maybe<LessonClassDivisionItem>;
  uuid: Scalars['ID']['output'];
};

/** Lehrer-Platzhalter der Sollstunde, aus der die Zuordnung entstanden ist. */
export type LessonCurriculumPersonItem = {
  __typename?: 'LessonCurriculumPersonItem';
  description?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  present?: Maybe<Scalars['Boolean']['output']>;
  teachingLoad?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
};

export enum LessonEditStatus {
  Blocked = 'BLOCKED',
  InVersion = 'IN_VERSION',
  PlacedCards = 'PLACED_CARDS',
  Unused = 'UNUSED',
}

export type LessonEditStatusInfo = {
  __typename?: 'LessonEditStatusInfo';
  reasons: Array<LessonEditStatusReasonDetail>;
  status: LessonEditStatus;
};

export enum LessonEditStatusReason {
  ActiveTeachingblock = 'ACTIVE_TEACHINGBLOCK',
  ActiveTimetable = 'ACTIVE_TIMETABLE',
  InTeachingblockVersion = 'IN_TEACHINGBLOCK_VERSION',
  InTimetableVersion = 'IN_TIMETABLE_VERSION',
  ManagedOutsideVersion = 'MANAGED_OUTSIDE_VERSION',
  PlacedTeachingblockCards = 'PLACED_TEACHINGBLOCK_CARDS',
  PlacedTimetableCards = 'PLACED_TIMETABLE_CARDS',
}

export type LessonEditStatusReasonDetail = {
  __typename?: 'LessonEditStatusReasonDetail';
  label: Scalars['String']['output'];
  reason: LessonEditStatusReason;
  references: Array<LessonEditStatusReference>;
};

export type LessonEditStatusReference = {
  __typename?: 'LessonEditStatusReference';
  label: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  planUuid: Scalars['ID']['output'];
  version?: Maybe<Scalars['Int']['output']>;
  versionUuid?: Maybe<Scalars['ID']['output']>;
};

export enum LessonFlag {
  Elective = 'ELECTIVE',
  IsClassTrip = 'IS_CLASS_TRIP',
  TeachingLoadEnabled = 'TEACHING_LOAD_ENABLED',
  TimetableEnabled = 'TIMETABLE_ENABLED',
}

export type LessonGradeGroupItem = {
  __typename?: 'LessonGradeGroupItem';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/**
 * Vollständiger Stand einer Zuordnung für Anlegen und Ändern. Klassen, Lehrer, Einheiten und Räume werden ersetzt;
 * die Reihenfolge der Listen ist ihre Reihenfolge.
 */
export type LessonInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  elective?: InputMaybe<Scalars['Boolean']['input']>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  lessonClasses: Array<LessonClassInput>;
  lessonUnits: Array<LessonUnitInput>;
  roomSupply: Array<LessonRoomInput>;
  /** Schülerzahl, gepflegt bei Wahlfächern. */
  studentCount?: InputMaybe<Scalars['Int']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  /** uuid eines Fachs oder einer Schiene. */
  subjectUuid: Scalars['ID']['input'];
  teachers: Array<LessonTeacherInput>;
  teachingLoadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetableEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Zuordnung, wie sie die handgeschriebenen Root-Felder liefern. */
export type LessonItem = {
  __typename?: 'LessonItem';
  /** Sortierschlüssel: Jahrgang, Klassenzug und Gruppe der Klassen. */
  classSort: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  /** Lehrer-Platzhalter der Sollstunde in ihrer Reihenfolge; leer ohne Sollstunde. */
  curriculumPersons: Array<LessonCurriculumPersonItem>;
  curriculumUuid?: Maybe<Scalars['ID']['output']>;
  /** Anzeigenamen der Zuordnung, je Einheit einer (bei Epochen mit dem Kürzel der Schiene). */
  displayName: Array<Scalars['String']['output']>;
  /** Bearbeitungs-Status in der Deputate-Übersicht. */
  editStatus: LessonEditStatusInfo;
  /** Bearbeitungs-Status innerhalb einer Stundenplan-Version. */
  editStatusInVersion: LessonEditStatusInfo;
  elective?: Maybe<Scalars['Boolean']['output']>;
  gradeGroupUuids: Array<Scalars['ID']['output']>;
  /** Anzeigename der Klassen und Gruppen. */
  groupClassNames: Scalars['String']['output'];
  isClassTrip?: Maybe<Scalars['Boolean']['output']>;
  /** Klassen in der festgelegten Reihenfolge. */
  lessonClasses: Array<LessonClassItem>;
  /** Einheiten in der festgelegten Reihenfolge. */
  lessonUnits: Array<LessonUnitItem>;
  /** Nur in einer Epochenplan-Version angelegt; keine Deputats-Zuordnung. */
  onlyInTeachingBlockVersion: Scalars['Boolean']['output'];
  /** Nur in einer Stundenplan-Version angelegt; keine Deputats-Zuordnung. */
  onlyInTimetableVersion: Scalars['Boolean']['output'];
  /** Zahl der gesteckten Stundenplan-Karten. */
  placedCardsCount: Scalars['Int']['output'];
  /** Räume in der festgelegten Reihenfolge. */
  roomSupply: Array<LessonRoomItem>;
  schoolYearUuid?: Maybe<Scalars['ID']['output']>;
  /** Schülerzahl, gepflegt bei Wahlfächern. */
  studentCount?: Maybe<Scalars['Int']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  subject: LessonSubjectItem;
  subjectName: Scalars['String']['output'];
  /** Lehrer in der festgelegten Reihenfolge. */
  teachers: Array<LessonTeacherItem>;
  /** Sortierschlüssel: Nachname, Vorname der Lehrer in ihrer Reihenfolge. */
  teachersSort: Scalars['String']['output'];
  /** Zahl der gesteckten Epochen-Karten. */
  teachingBlockPlacedCardsCount: Scalars['Int']['output'];
  teachingBlockVersions: Array<LessonTeachingBlockVersionItem>;
  teachingLoadEnabled?: Maybe<Scalars['Boolean']['output']>;
  timetableEnabled?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
  versions: Array<LessonVersionItem>;
};

/** Verweis mit Name innerhalb von LessonItem (Raum, Stundenplan, Epochenplan). */
export type LessonRefItem = {
  __typename?: 'LessonRefItem';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type LessonRoomInput = {
  descriptions?: InputMaybe<Scalars['String']['input']>;
  roomUuid: Scalars['ID']['input'];
};

/** Raum einer Zuordnung. */
export type LessonRoomItem = {
  __typename?: 'LessonRoomItem';
  descriptions?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

/** Fach oder Schiene einer Zuordnung. */
export type LessonSubjectItem = {
  __typename?: 'LessonSubjectItem';
  active?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** Fachräume des Fachs; leer bei einer Schiene. */
  defaultRooms: Array<LessonRefItem>;
  epochEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** true: die Zuordnung hängt an einer Schiene (Epochenplan), false: an einem Fach. */
  isSubjectContainer: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  subjectHourEnabled?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
};

export type LessonTeacherInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  personUuid: Scalars['ID']['input'];
  present?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoad?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoadHours?: InputMaybe<Scalars['Float']['input']>;
  writesCertificate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Lehrer einer Zuordnung mit den Angaben seiner Zuweisung. */
export type LessonTeacherItem = {
  __typename?: 'LessonTeacherItem';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayNameShort: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  present?: Maybe<Scalars['Boolean']['output']>;
  shortName: Scalars['String']['output'];
  teachingLoad?: Maybe<Scalars['Boolean']['output']>;
  teachingLoadHours?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['ID']['output'];
  writesCertificate?: Maybe<Scalars['Boolean']['output']>;
};

/** Epochenplan-Version, in der die Zuordnung steckt. */
export type LessonTeachingBlockVersionItem = {
  __typename?: 'LessonTeachingBlockVersionItem';
  active?: Maybe<Scalars['Boolean']['output']>;
  teachingBlock?: Maybe<LessonRefItem>;
  uuid: Scalars['ID']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type LessonUnitInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  subjectContainerUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Einheit einer Zuordnung: Anzahl und Dauer, bei Epochen mit Schiene. */
export type LessonUnitItem = {
  __typename?: 'LessonUnitItem';
  count?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  order: Scalars['Int']['output'];
  subjectContainer?: Maybe<LessonUnitSubjectContainerItem>;
  uuid: Scalars['ID']['output'];
};

export type LessonUnitSubjectContainerItem = {
  __typename?: 'LessonUnitSubjectContainerItem';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Verwendung eines Stammdaten-Eintrags (Klasse, Person, Teilung) in Zuordnungen. */
export type LessonUsage = {
  __typename?: 'LessonUsage';
  /** Höchstens drei dieser Zuordnungen als Beispiel, nach Fachname sortiert. */
  lessons: Array<LessonUsageItem>;
  /** Zahl der Zuordnungen, in denen der Eintrag steckt. */
  lessonsCount: Scalars['Int']['output'];
  /** uuid der Klasse, der Person oder der Teilung. */
  uuid: Scalars['ID']['output'];
};

/** Eine Zuordnung, soweit sie der Hinweis „verwendet in“ anzeigt. */
export type LessonUsageItem = {
  __typename?: 'LessonUsageItem';
  /** Kürzel der Klassen der Zuordnung, sortiert. */
  classShortNames: Array<Scalars['String']['output']>;
  /** Nur in einer Epochenplan-Version angelegt. */
  onlyInTeachingBlockVersion: Scalars['Boolean']['output'];
  /** Nur in einer Stundenplan-Version angelegt. */
  onlyInTimetableVersion: Scalars['Boolean']['output'];
  subjectName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
  /** Höchstens drei Stundenplan-Versionen, in denen die Zuordnung steckt. */
  versions: Array<LessonUsageVersionItem>;
  /** Zahl aller Stundenplan-Versionen, in denen die Zuordnung steckt. */
  versionsCount: Scalars['Int']['output'];
};

/** Stundenplan-Version einer Zuordnung im Hinweis „verwendet in“. */
export type LessonUsageVersionItem = {
  __typename?: 'LessonUsageVersionItem';
  timetableName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

/** Stundenplan-Version, in der die Zuordnung steckt. */
export type LessonVersionItem = {
  __typename?: 'LessonVersionItem';
  active?: Maybe<Scalars['Boolean']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  timetable?: Maybe<LessonRefItem>;
  uuid: Scalars['ID']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type MergeLessonNewCardsInput = {
  count: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
};

export type MinimalClass = {
  __typename?: 'MinimalClass';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type MinimalGroup = {
  __typename?: 'MinimalGroup';
  divisionUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type MinimalPerson = {
  __typename?: 'MinimalPerson';
  displayName: Scalars['String']['output'];
  displayNameShort?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  listName: Scalars['String']['output'];
  pimProfileUuid?: Maybe<Scalars['String']['output']>;
  selectName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type MinimalRoom = {
  __typename?: 'MinimalRoom';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type MinimalSubject = {
  __typename?: 'MinimalSubject';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Nimmt Klassen, Lehrkräfte, Räume oder Fächer in die Version auf; schon aufgenommene bleiben. Liefert alle Ressourcen der Version. */
  addTeachingBlockVersionResources: Array<TeachingBlockVersionResource>;
  /**
   * Nimmt Klassen, Lehrkräfte, Räume oder Fächer in die Version auf, mit offener Verfügbarkeit (überall 2); schon
   * aufgenommene bleiben, wie sie sind. Liefert die Ressourcen dieses Typs in der Version. Nur in einer bearbeitbaren
   * Version, sonst Fehler CONFLICT.
   */
  addTimetableVersionResources: Array<TimetableVersionResourceAvailability>;
  addUser: PimProfile;
  /** Ordnet die Räume einem Gebäude zu; ohne buildingUuid gehören sie danach zu keinem. */
  assignRoomsToBuilding: Array<RoomItem>;
  /**
   * Weist den Zuordnungen die genannten Lehrer zusätzlich zu, hinter den schon zugewiesenen. Ein Lehrer, der einer
   * Zuordnung schon zugewiesen ist, bekommt dort die neuen Angaben.
   */
  assignTeachersToLessons: Array<LessonItem>;
  /**
   * Nimmt bestehende Zuordnungen in die Epochenplan-Version auf. Karten entstehen dabei nicht. Eine Zuordnung, die
   * schon in der Version steckt, bleibt unverändert.
   */
  attachLessonsToTeachingBlockVersion: Array<LessonItem>;
  cancelEvent: EntitiesUpdateInfo;
  /** Einen laufenden Termin-Abgleich als abgebrochen markieren; null, wenn es ihn nicht gibt. Nur für Omni-Admins. */
  cancelEventJob?: Maybe<EventJobItem>;
  connectEntityWithVersion?: Maybe<EntitiesUpdateInfo>;
  connectLessonsToTimetableVersion: UpdateResponse;
  /**
   * „In dieser Version bearbeiten“: legt von einer Deputats-Zuordnung eine Kopie an, die es nur in dieser
   * Epochenplan-Version gibt, hängt die Karten der Version samt Position, Räumen und Sperre auf die Kopie um und
   * löst das Original aus der Version. Liefert die Kopie.
   */
  copyLessonIntoTeachingBlockVersion: LessonItem;
  copyLessonsToTimetableVersion: CreateResponse;
  createAbsence: CreateResponse;
  /** Legt ein zusätzliches Deputat im Schuljahr an. Unbekannte Bezüge: Fehler, nichts wird angelegt. */
  createAdditionalTeachingLoad: AdditionalTeachingLoadItem;
  createBackendTeachingBlockVersion: CreateResponse;
  createBuilding: BuildingItem;
  /** Legt eine Klasse im genannten Schuljahr an. Eine Klasse wechselt ihr Schuljahr nicht. */
  createClass: ClassItem;
  createCurriculum: CurriculumItem;
  createCurriculumVersion: CurriculumVersionItem;
  /** Legt eine Abhängigkeit in der Version an. */
  createDependency: DependencyItem;
  /**
   * Legt eine Teilung mit ihren Gruppen an. Mit classUuid gehört sie zu dieser Klasse, ohne classUuid ist sie eine
   * Vorlage (Default-Teilung).
   */
  createDivision: DivisionItem;
  createGradeGroup: GradeGroupItem;
  createHoliday: HolidayItem;
  /** Legt eine Zuordnung im Schuljahr an. Mit curriculumUuid gilt sie als aus dieser Sollstunde entstanden. */
  createLesson: LessonItem;
  /**
   * Legt eine Zuordnung an, die es nur in dieser Epochenplan-Version gibt (keine Deputats-Zuordnung), samt je einer
   * ungesteckten Karte je genannter Dauer (in Wochen).
   */
  createLessonInTeachingBlockVersion: LessonItem;
  /**
   * Legt eine Zuordnung an, die es nur in dieser Stundenplan-Version gibt (keine Deputats-Zuordnung), samt je einer
   * ungesteckten Karte je genannter Dauer.
   */
  createLessonInTimetableVersion: LessonItem;
  createLessonsFromCurricula: CreateLessonsFromCurriculaResult;
  createPerson: PersonItem;
  createRecurrenceSchoolEvents: CreateResponse;
  createRoom: RoomItem;
  createSchoolEvent: CreateResponse;
  createSchoolYear: SchoolYearItem;
  createSubject: SubjectItem;
  createSubjectContainer: SubjectContainerItem;
  createSubjectGroup: SubjectGroupItem;
  /** Legt für eine Zuordnung der Version je Dauer (in Wochen) eine ungesteckte Karte an. */
  createTeachingBlockCards: Array<TeachingBlockVersionCard>;
  createTeachingBlockExclusion: TeachingBlockVersionExclusion;
  /** Legt einen Deputatsfaktor im Schuljahr an. Unbekannte Bezüge: Fehler, nichts wird angelegt. */
  createTeachingLoadFactor: TeachingLoadFactorItem;
  createTimeGrid: TimeGridItem;
  createTimeGridEntry: CreateResponse;
  /**
   * Legt einen Stundenplan (als Entwurf) im Schuljahr an, mit je einer Raster-Zuordnung je genanntem Stundenraster.
   * Eine Version entsteht dabei nicht; die legt createTimetableVersion an.
   */
  createTimetable: TimetableItem;
  /**
   * Legt einen Zeitraum mit Deputatsfaktor 1 an. Beginn und Ende (beide inklusive) liegen im Schuljahr, die Stundenpläne
   * gehören zum Schuljahr, und der Zeitraum überlappt keinen anderen des Schuljahres (sonst Fehler CONFLICT).
   */
  createTimetableBlock: TimetableBlockItem;
  /**
   * Legt für eine Zuordnung der Version je Dauer eine ungesteckte, nicht gesperrte Karte an; mit subjectContainerUuid
   * Karten einer Epochenschiene.
   */
  createTimetableCards: Array<TimetableCardItem>;
  createTimetableVersion: CreateResponse;
  deleteAbsence: DeleteInfo;
  /** Idempotent: bereits gelöschte Deputate zählen nicht mit. */
  deleteAdditionalTeachingLoads: DeleteInfo;
  /** Scheitert mit dem Code DELETE_BLOCKED, solange dem Gebäude Räume zugeordnet sind. */
  deleteBuilding: DeleteInfo;
  /**
   * Löscht die Klasse samt ihrer Einstellungen, Teilungen und deren Gruppen und löst sie aus allen Zuordnungen (die
   * Zuordnungen bleiben). Scheitert mit dem Code DELETE_BLOCKED, solange die Klasse in einer Stundenplan-Version steckt.
   */
  deleteClass: DeleteInfo;
  /**
   * Löscht die Sollstunden samt ihrer Jahrgangs-Einträge, Einheiten und Lehrer-Platzhalter. Zuordnungen, die aus ihnen
   * entstanden sind, bleiben bestehen.
   */
  deleteCurricula: DeleteInfo;
  /** Scheitert mit dem Code DELETE_BLOCKED, solange die Version Sollstunden enthält. */
  deleteCurriculumVersion: DeleteInfo;
  /** Löscht die Abhängigkeit. Idempotent. */
  deleteDependency: DeleteInfo;
  /**
   * Löscht die Teilung samt ihrer Gruppen. Scheitert mit dem Code DELETE_BLOCKED, solange eine ihrer Gruppen in
   * Zuordnungen oder Sollstunden verwendet wird.
   */
  deleteDivision: DeleteInfo;
  /** Löscht den Klassenzug; Klassen, Schienen und Faktoren, die auf ihn zeigen, bleiben bestehen und sind danach ohne ihn. */
  deleteGradeGroup: DeleteInfo;
  deleteHoliday: DeleteInfo;
  /**
   * Löscht die Zuordnungen samt ihrer Zuordnungs-Klassen und Einheiten. Scheitert mit dem Code DELETE_BLOCKED, solange
   * an einer von ihnen Stundenplan- oder Epochen-Karten hängen.
   */
  deleteLessons: DeleteInfo;
  /**
   * Löscht die Personen samt ihrer Einstellungen und Lehrbefähigungen. Scheitert mit dem Code DELETE_BLOCKED und löscht
   * nichts, solange eine der Personen Verträge oder Zusatzdeputate hat.
   */
  deletePeople: DeleteInfo;
  deleteRecurrenceSchoolEvents: DeleteInfo;
  /**
   * Löscht die Räume. Scheitert mit dem Code DELETE_BLOCKED und löscht nichts, solange einer der Räume in Zuordnungen
   * oder Sollstunden verwendet wird.
   */
  deleteRooms: DeleteInfo;
  /** Einen offenen Auftrag verwerfen, ohne den Unterricht anzupassen (nur für Sonderfälle) */
  deleteSchoolEventLessonSync: DeleteInfo;
  deleteSchoolEvents: DeleteInfo;
  /**
   * Löscht das Schuljahr. Scheitert mit dem Code DELETE_BLOCKED, solange Klassen, Zuordnungen, Stundenpläne,
   * Stundenplan-Blöcke, Epochenpläne, Zusatzdeputate oder Deputats-Faktoren daran hängen.
   */
  deleteSchoolYear: DeleteInfo;
  /**
   * Löscht die Schienen und Epochen samt ihrer Einstellungen. Scheitert mit dem Code DELETE_BLOCKED und löscht nichts,
   * solange eine davon in Zuordnungen, Sollstunden, Epochenplänen oder Unterrichtseinheiten verwendet wird.
   */
  deleteSubjectContainers: DeleteInfo;
  /** Löscht die Fachgruppe; ihre Fächer bleiben bestehen und sind danach ohne Gruppe. */
  deleteSubjectGroup: DeleteInfo;
  /**
   * Löscht die Fächer samt ihrer Einstellungen und der Qualifikationen, die auf sie zeigen. Scheitert mit dem Code
   * DELETE_BLOCKED und löscht nichts, solange eines der Fächer in Zuordnungen oder Sollstunden verwendet wird.
   */
  deleteSubjects: DeleteInfo;
  /** Löscht einen Epochenplan ohne Versionen. Mit Versionen: Fehler DELETE_BLOCKED. */
  deleteTeachingBlock: DeleteInfo;
  deleteTeachingBlockCards: DeleteInfo;
  deleteTeachingBlockExclusions: DeleteInfo;
  /**
   * Löscht eine Epochenplan-Version mit ihren Karten, Ausschlüssen und den nur in ihr angelegten Zuordnungen.
   * Idempotent: eine bereits gelöschte Version ergibt Zähler 0.
   */
  deleteTeachingBlockVersion: DeleteInfo;
  /** Idempotent: bereits gelöschte Faktoren zählen nicht mit. */
  deleteTeachingLoadFactors: DeleteInfo;
  deleteTimeGridEntry: DeleteInfo;
  /** Löscht den Zeitraum. Idempotent. */
  deleteTimetableBlock: DeleteInfo;
  /** Löscht Karten. Idempotent. */
  deleteTimetableCards: DeleteInfo;
  deleteTimetableVersion: DeleteInfo;
  /** Löscht Stundenpläne ohne Versionen samt ihrer Raster-Zuordnungen. Mit Versionen: Fehler DELETE_BLOCKED. */
  deleteTimetables: DeleteInfo;
  /**
   * Löst die Zuordnungen aus der Epochenplan-Version. Scheitert mit dem Code DELETE_BLOCKED, solange in der Version noch
   * Karten der Zuordnungen liegen.
   */
  detachLessonsFromTeachingBlockVersion: Array<LessonItem>;
  /**
   * Löst die Zuordnungen aus der Stundenplan-Version. Scheitert mit dem Code DELETE_BLOCKED, solange in der Version noch
   * Karten der Zuordnungen liegen.
   */
  detachLessonsFromTimetableVersion: Array<LessonItem>;
  /** Löst alle Lehrer von den Zuordnungen. */
  detachTeachersFromLessons: Array<LessonItem>;
  duplicateTeachingBlockVersion: DuplicateTeachingBlockVersionResponse;
  duplicateTimetableVersion: DuplicateTimetableVersionResponse;
  inheritLessonTeachers: EntitiesUpdateInfo;
  inviteUser: PimProfile;
  mergeEvents: EntitiesUpdateInfo;
  mergeLessons: CreateResponse;
  /** Steckt oder verschiebt eine Karte auf den Zeitraum (beide Tage inklusive). */
  placeTeachingBlockCard: TeachingBlockVersionCard;
  /** Steckt oder verschiebt eine Karte auf den Wochentag (mon bis sun) von der ersten bis zur letzten Stunde. Liefert die uuid der Karte. */
  placeTimetableCard: Scalars['ID']['output'];
  removePlanungAccess: PimProfile;
  /**
   * Nimmt Ressourcen aus der Version und löscht ihre Ausschlüsse in dieser Version. Liefert die verbleibenden
   * Ressourcen der Version.
   */
  removeTeachingBlockVersionResources: Array<TeachingBlockVersionResource>;
  /**
   * Nimmt Ressourcen aus der Version; ihre Verfügbarkeit und ihre Bedingungen in dieser Version gehen dabei verloren.
   * Liefert die verbleibenden Ressourcen dieses Typs.
   */
  removeTimetableVersionResources: Array<TimetableVersionResourceAvailability>;
  resetEvent: EntitiesUpdateInfo;
  resetMyTableConfigs: Scalars['Boolean']['output'];
  resetMyUiSettings: Scalars['Boolean']['output'];
  /** Offene Unterrichtsanpassungen der Organisation jetzt in Reihenfolge nachholen */
  retrySchoolEventLessonSyncs: SchoolEventLessonSyncRetryResult;
  /** Legt die Ankündigung des Tages an oder ersetzt sie; je Tag gibt es höchstens eine. */
  saveSubstitutionAnnouncement: SubstitutionAnnouncementItem;
  /** Legt die Einstellungen der Vertretungsplan-App an oder ersetzt sie. */
  saveSubstitutionAppConfig: SubstitutionAppConfigItem;
  /** Legt die Druck-Einstellungen des Vertretungsplans an oder ersetzt sie samt ihren Spalten. */
  saveSubstitutionPrintConfig: SubstitutionPrintConfigItem;
  /** Speichert die übergebenen Felder; nicht übergebene bleiben, wie sie sind. Nur für die Verwaltung. */
  saveSubstitutionSoftwareSettings: SubstitutionSoftwareSettings;
  /**
   * Legt die Einstellungen eines Deputats-Berichtstyps an oder ersetzt sie; je Berichtstyp gibt es höchstens eine.
   * Was in input fehlt, wird null und folgt damit der Vorgabe des Berichtstyps.
   */
  saveTeachingLoadReportConfig: TeachingLoadReportConfigItem;
  /**
   * Legt die Druck-Einstellungen eines Berichtstyps an oder ersetzt sie; je Berichtstyp gibt es höchstens eine.
   * Was in input fehlt, wird null und folgt damit der Vorgabe des Berichtstyps.
   */
  saveTimetablePrintConfig: TimetablePrintConfigItem;
  setClassColor: ClassItem;
  /** Legt fest, wie eine Funktionsklasse im Vertretungsplan behandelt wird; ohne behavior wird die Angabe entfernt. */
  setClassSubstitutionBehavior: ClassItem;
  /** Setzt einen Schalter für mehrere Sollstunden. */
  setCurriculaFlag: Array<CurriculumItem>;
  setDependencyActive: DependencyItem;
  /** Legt fest, welche Solver die Schule benutzen darf, und liefert die gespeicherte Liste. Nur für die Verwaltung. */
  setEnabledSolverEngines: Array<SolverEngine>;
  /** Setzt einen Schalter für mehrere Zuordnungen. */
  setLessonsFlag: Array<LessonItem>;
  setMySchoolYear: MyUserConfig;
  /** Setzt mehrere Personen auf aktiv oder inaktiv. */
  setPeopleActive: Array<PersonItem>;
  setPersonColor: PersonItem;
  setPrintEvent: EntitiesUpdateInfo;
  /** Setzt einen der Schalter für mehrere Räume auf einmal. */
  setRoomsFlag: Array<RoomItem>;
  setSelfWorkForEvent: EntitiesUpdateInfo;
  setSubjectColor: SubjectItem;
  setSubjectContainerColor: SubjectContainerItem;
  /** Setzt einen der Schalter für mehrere Fächer auf einmal. */
  setSubjectsFlag: Array<SubjectItem>;
  setSubstitution: EntitiesUpdateInfo;
  /** Ersetzt die Räume einer Karte. */
  setTeachingBlockCardRooms: TeachingBlockVersionCard;
  setTeachingBlockCardsLocked: Array<TeachingBlockVersionCard>;
  /** Setzt den Kommentar eines Epochenplans; null oder leer entfernt ihn. */
  setTeachingBlockComment: TeachingBlockItem;
  /** Sperrt (false) oder entsperrt (true) eine Epochenplan-Version für Änderungen an Karten, Ausschlüssen und Ressourcen. */
  setTeachingBlockVersionEditable: TeachingBlockVersionMeta;
  setTeachingLoadFactorActive: TeachingLoadFactorItem;
  /** Setzt Deputatsfaktor (0 bis 1) und Kommentar des Zeitraums; null oder leer entfernt den Kommentar. */
  setTimetableBlockTeachingLoadFactor: TimetableBlockItem;
  setTimetableCardRooms: UpdateResponse;
  /** Sperrt oder entsperrt Karten. Liefert die uuids der gefundenen Karten. */
  setTimetableCardsLocked: Array<Scalars['ID']['output']>;
  /** Ersetzt die Verfügbarkeit einer Ressource der Version. Die Ressource muss in die Version aufgenommen sein. */
  setTimetableVersionAvailability: TimetableVersionResourceAvailability;
  /** Ersetzt den Constraint-Katalog der Version (JSON); null oder leer stellt die Solver-Defaults wieder her. */
  setTimetableVersionConstraintSettings?: Maybe<Scalars['String']['output']>;
  /** Ersetzt den Bedingungs-Blob einer Ressource der Version; null oder leer entfernt ihn. */
  setTimetableVersionConstraints: TimetableVersionConstraints;
  /** Sperrt (false) oder entsperrt (true) eine Stundenplan-Version für Änderungen. */
  setTimetableVersionEditable: TimetableVersionMeta;
  /**
   * Teilt einen Unterrichtstermin (samt Mehrfachstunde) in Teile: `parts` verteilt alle Klassen bzw. Gruppen des Termins
   * (mindestens zwei Teile); der erste Teil bleibt der bisherige Termin. Je Lehrkraft und Raum höchstens ein Teil; ein Teil
   * ohne Lehrkraft wird vertreten. Auch auf einen schon geteilten Termin anwendbar.
   */
  splitEvent: EntitiesUpdateInfo;
  /** Legt Karten zurück auf den Stapel; ihre Räume bleiben. */
  unplaceTeachingBlockCards: Array<TeachingBlockVersionCard>;
  /** Legt Karten zurück auf den Stapel; ihre Räume und ihre Sperre bleiben. Liefert die uuids der gefundenen Karten. */
  unplaceTimetableCards: Array<Scalars['ID']['output']>;
  /** Hebt die Aufteilung der Mehrfachstunde auf; die Vertretungen der Teile gehen verloren. */
  unsplitEvent: EntitiesUpdateInfo;
  updateAbsence: UpdateResponse;
  /** Ersetzt Stunden, Kommentar, Lehrkraft, Fach und Klasse; das Deputat hängt danach am genannten Schuljahr. */
  updateAdditionalTeachingLoad: AdditionalTeachingLoadItem;
  updateBuilding: BuildingItem;
  updateClass: ClassItem;
  updateCurriculum: CurriculumItem;
  updateCurriculumVersion: CurriculumVersionItem;
  /** Ersetzt Priorität, Kommentar, Aktiv-Status, Zusatzdaten, Fächer und Klassen. Die Art (alias) bleibt. */
  updateDependency: DependencyItem;
  /**
   * Ersetzt Name und Gruppen der Teilung. Scheitert mit dem Code DELETE_BLOCKED, wenn eine Gruppe entfallen soll,
   * die in Zuordnungen oder Sollstunden verwendet wird.
   */
  updateDivision: DivisionItem;
  updateGradeGroup: GradeGroupItem;
  updateGrantedProfiles: EntitiesUpdateInfo;
  updateHoliday: HolidayItem;
  /** Ersetzt den Stand der Zuordnung. Schuljahr, Sollstunde und Versionen bleiben unberührt. */
  updateLesson: LessonItem;
  updatePerson: PersonItem;
  updateRecurrenceSchoolEvents: UpdateResponse;
  updateRoom: RoomItem;
  updateSchoolEvent: UpdateResponse;
  updateSchoolYear: SchoolYearItem;
  updateSubject: SubjectItem;
  updateSubjectContainer: SubjectContainerItem;
  updateSubjectGroup: SubjectGroupItem;
  updateTeachingBlockExclusion: TeachingBlockVersionExclusion;
  /**
   * Setzt Beschreibung und Aktiv-Status einer Epochenplan-Version. Beim Aktivieren wird die bisher aktive Version
   * desselben Epochenplans im selben Schritt deaktiviert.
   */
  updateTeachingBlockVersion: TeachingBlockVersionMeta;
  /** Ersetzt alle Skalare und Bezüge des Faktors; er hängt danach am genannten Schuljahr. */
  updateTeachingLoadFactor: TeachingLoadFactorItem;
  updateTimeGrid: TimeGridItem;
  updateTimeGridEntry: UpdateResponse;
  /**
   * Ersetzt Name, Kommentar und Schuljahr des Stundenplans und gleicht seine Stundenraster ab: ein Stundenraster, das
   * in der Liste bleibt, behält die Klassen, für die es gilt; entfernte fallen weg, neue kommen dazu.
   */
  updateTimetable: TimetableItem;
  /** Ersetzt Beginn, Ende und Stundenpläne des Zeitraums; Regeln wie beim Anlegen. Das Schuljahr bleibt. */
  updateTimetableBlock: TimetableBlockItem;
  /**
   * Setzt Beschreibung und Aktiv-Status einer Stundenplan-Version. Beim Aktivieren wird die bisher aktive Version
   * desselben Stundenplans im selben Schritt deaktiviert.
   */
  updateTimetableVersion: TimetableVersionMeta;
  updateUserPermissions: PimProfile;
  upsertMyTableConfig: MyTableConfig;
  upsertMyUiSettings: MyUiSettings;
};

export type MutationAddTeachingBlockVersionResourcesArgs = {
  resourceType: TeachingBlockResourceType;
  uuids: Array<Scalars['ID']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type MutationAddTimetableVersionResourcesArgs = {
  resourceType: TimetableVersionResourceType;
  uuids: Array<Scalars['ID']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type MutationAddUserArgs = {
  email: Scalars['String']['input'];
  frontendUri: Scalars['String']['input'];
  organizationUuid: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  planungPersonUuid: Scalars['ID']['input'];
  profileUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationAssignRoomsToBuildingArgs = {
  buildingUuid?: InputMaybe<Scalars['ID']['input']>;
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationAssignTeachersToLessonsArgs = {
  teachers: Array<LessonTeacherInput>;
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationAttachLessonsToTeachingBlockVersionArgs = {
  uuids: Array<Scalars['ID']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type MutationCancelEventArgs = {
  eventUuid: Scalars['ID']['input'];
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCancelEventJobArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationConnectEntityWithVersionArgs = {
  entityType: Scalars['String']['input'];
  organizationUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type MutationConnectLessonsToTimetableVersionArgs = {
  lessonUuids: Array<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
};

export type MutationCopyLessonIntoTeachingBlockVersionArgs = {
  lessonUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type MutationCopyLessonsToTimetableVersionArgs = {
  lessonUuids: Array<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
};

export type MutationCreateAbsenceArgs = {
  input: CreateAbsenceInput;
};

export type MutationCreateAdditionalTeachingLoadArgs = {
  input: AdditionalTeachingLoadInput;
};

export type MutationCreateBackendTeachingBlockVersionArgs = {
  connectLessons?: InputMaybe<Scalars['Boolean']['input']>;
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  subjectContainerUuid: Scalars['ID']['input'];
};

export type MutationCreateBuildingArgs = {
  input: BuildingInput;
};

export type MutationCreateClassArgs = {
  input: ClassInput;
  schoolYearUuid: Scalars['ID']['input'];
};

export type MutationCreateCurriculumArgs = {
  curriculumVersionUuid: Scalars['ID']['input'];
  input: CurriculumInput;
};

export type MutationCreateCurriculumVersionArgs = {
  input: CurriculumVersionInput;
};

export type MutationCreateDependencyArgs = {
  input: DependencyInput;
  versionUuid: Scalars['ID']['input'];
};

export type MutationCreateDivisionArgs = {
  classUuid?: InputMaybe<Scalars['ID']['input']>;
  input: DivisionInput;
};

export type MutationCreateGradeGroupArgs = {
  input: GradeGroupInput;
};

export type MutationCreateHolidayArgs = {
  input: HolidayInput;
};

export type MutationCreateLessonArgs = {
  curriculumUuid?: InputMaybe<Scalars['ID']['input']>;
  input: LessonInput;
  schoolYearUuid: Scalars['ID']['input'];
};

export type MutationCreateLessonInTeachingBlockVersionArgs = {
  cardDurations: Array<Scalars['Int']['input']>;
  input: LessonInput;
  schoolYearUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type MutationCreateLessonInTimetableVersionArgs = {
  cardDurations: Array<Scalars['Int']['input']>;
  input: LessonInput;
  schoolYearUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type MutationCreateLessonsFromCurriculaArgs = {
  curriculumUuids: Array<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
};

export type MutationCreatePersonArgs = {
  input: PersonInput;
};

export type MutationCreateRecurrenceSchoolEventsArgs = {
  input: RecurrenceSchoolEventCreateInput;
};

export type MutationCreateRoomArgs = {
  input: RoomInput;
};

export type MutationCreateSchoolEventArgs = {
  input: SchoolEventCreateInput;
};

export type MutationCreateSchoolYearArgs = {
  input: SchoolYearInput;
};

export type MutationCreateSubjectArgs = {
  input: SubjectInput;
};

export type MutationCreateSubjectContainerArgs = {
  input: SubjectContainerInput;
};

export type MutationCreateSubjectGroupArgs = {
  input: SubjectGroupInput;
};

export type MutationCreateTeachingBlockCardsArgs = {
  durations: Array<Scalars['Int']['input']>;
  lessonUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type MutationCreateTeachingBlockExclusionArgs = {
  input: TeachingBlockExclusionInput;
  versionUuid: Scalars['ID']['input'];
};

export type MutationCreateTeachingLoadFactorArgs = {
  input: TeachingLoadFactorInput;
};

export type MutationCreateTimeGridArgs = {
  input: TimeGridInput;
};

export type MutationCreateTimeGridEntryArgs = {
  input: CreateTimeGridEntryInput;
};

export type MutationCreateTimetableArgs = {
  input: TimetableInput;
};

export type MutationCreateTimetableBlockArgs = {
  input: TimetableBlockInput;
};

export type MutationCreateTimetableCardsArgs = {
  durations: Array<Scalars['Int']['input']>;
  lessonUuid: Scalars['ID']['input'];
  subjectContainerUuid?: InputMaybe<Scalars['ID']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type MutationCreateTimetableVersionArgs = {
  organizationUuid: Scalars['ID']['input'];
  timetableUuid: Scalars['ID']['input'];
};

export type MutationDeleteAbsenceArgs = {
  removeSubstitutions: Scalars['Boolean']['input'];
  where: OnlyUuids;
};

export type MutationDeleteAdditionalTeachingLoadsArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteBuildingArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteClassArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteCurriculaArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteCurriculumVersionArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteDependencyArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteDivisionArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteGradeGroupArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteHolidayArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteLessonsArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDeletePeopleArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteRecurrenceSchoolEventsArgs = {
  recurrenceUuid: Scalars['ID']['input'];
};

export type MutationDeleteRoomsArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteSchoolEventLessonSyncArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteSchoolEventsArgs = {
  where: OnlyUuids;
};

export type MutationDeleteSchoolYearArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteSubjectContainersArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteSubjectGroupArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteSubjectsArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteTeachingBlockArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteTeachingBlockCardsArgs = {
  cardUuids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteTeachingBlockExclusionsArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteTeachingBlockVersionArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteTeachingLoadFactorsArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteTimeGridEntryArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteTimetableBlockArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteTimetableCardsArgs = {
  cardUuids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteTimetableVersionArgs = {
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
};

export type MutationDeleteTimetablesArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDetachLessonsFromTeachingBlockVersionArgs = {
  uuids: Array<Scalars['ID']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type MutationDetachLessonsFromTimetableVersionArgs = {
  uuids: Array<Scalars['ID']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type MutationDetachTeachersFromLessonsArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationDuplicateTeachingBlockVersionArgs = {
  options: DuplicateTeachingBlockVersionOptions;
  organizationUuid: Scalars['ID']['input'];
  teachingBlockVersionUuid: Scalars['ID']['input'];
};

export type MutationDuplicateTimetableVersionArgs = {
  options: DuplicateTimetableVersionOptions;
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
};

export type MutationInheritLessonTeachersArgs = {
  lessonUuids: Array<Scalars['ID']['input']>;
  type: InheritLessonTeachersType;
};

export type MutationInviteUserArgs = {
  email: Scalars['String']['input'];
  frontendUri?: InputMaybe<Scalars['String']['input']>;
  organizationUuid: Scalars['ID']['input'];
  profileUuid: Scalars['ID']['input'];
};

export type MutationMergeEventsArgs = {
  eventsToMerge: Array<Scalars['ID']['input']>;
  rooms: Array<Scalars['ID']['input']>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  targetEvent: Scalars['ID']['input'];
};

export type MutationMergeLessonsArgs = {
  cardsFromLesson?: InputMaybe<Scalars['ID']['input']>;
  lessonUuids: Array<Scalars['ID']['input']>;
  newCards: Array<MergeLessonNewCardsInput>;
  timetableVersion?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationPlaceTeachingBlockCardArgs = {
  cardUuid: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  includeHoliday: Scalars['Boolean']['input'];
  startDate: Scalars['Date']['input'];
};

export type MutationPlaceTimetableCardArgs = {
  cardUuid: Scalars['ID']['input'];
  endTimeGridEntryUuid: Scalars['ID']['input'];
  startTimeGridEntryUuid: Scalars['ID']['input'];
  weekday: Scalars['String']['input'];
};

export type MutationRemovePlanungAccessArgs = {
  organizationUuid: Scalars['ID']['input'];
  profileUuid: Scalars['ID']['input'];
};

export type MutationRemoveTeachingBlockVersionResourcesArgs = {
  resourceType: TeachingBlockResourceType;
  uuids: Array<Scalars['ID']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type MutationRemoveTimetableVersionResourcesArgs = {
  resourceType: TimetableVersionResourceType;
  uuids: Array<Scalars['ID']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type MutationResetEventArgs = {
  eventUuid: Scalars['ID']['input'];
};

export type MutationResetMyTableConfigsArgs = {
  tables?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationResetMyUiSettingsArgs = {
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationSaveSubstitutionAnnouncementArgs = {
  date: Scalars['Date']['input'];
  internalAnnouncement?: InputMaybe<Scalars['String']['input']>;
  publicAnnouncement?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSaveSubstitutionAppConfigArgs = {
  input: SubstitutionAppConfigInput;
};

export type MutationSaveSubstitutionPrintConfigArgs = {
  input: SubstitutionPrintConfigInput;
};

export type MutationSaveSubstitutionSoftwareSettingsArgs = {
  input: SubstitutionSoftwareSettingsInput;
};

export type MutationSaveTeachingLoadReportConfigArgs = {
  input: TeachingLoadReportConfigInput;
  type: TeachingLoadReportType;
};

export type MutationSaveTimetablePrintConfigArgs = {
  input: TimetablePrintConfigInput;
  type: TimetableReportType;
};

export type MutationSetClassColorArgs = {
  color: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type MutationSetClassSubstitutionBehaviorArgs = {
  behavior?: InputMaybe<FunctionalClassSubstitutionBehavior>;
  uuid: Scalars['ID']['input'];
};

export type MutationSetCurriculaFlagArgs = {
  flag: CurriculumFlag;
  uuids: Array<Scalars['ID']['input']>;
  value: Scalars['Boolean']['input'];
};

export type MutationSetDependencyActiveArgs = {
  active: Scalars['Boolean']['input'];
  uuid: Scalars['ID']['input'];
};

export type MutationSetEnabledSolverEnginesArgs = {
  engines: Array<SolverEngine>;
};

export type MutationSetLessonsFlagArgs = {
  flag: LessonFlag;
  uuids: Array<Scalars['ID']['input']>;
  value: Scalars['Boolean']['input'];
};

export type MutationSetMySchoolYearArgs = {
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetPeopleActiveArgs = {
  active: Scalars['Boolean']['input'];
  uuids: Array<Scalars['ID']['input']>;
};

export type MutationSetPersonColorArgs = {
  color: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type MutationSetPrintEventArgs = {
  eventUuid: Scalars['ID']['input'];
  print: Scalars['Boolean']['input'];
};

export type MutationSetRoomsFlagArgs = {
  flag: RoomFlag;
  uuids: Array<Scalars['ID']['input']>;
  value: Scalars['Boolean']['input'];
};

export type MutationSetSelfWorkForEventArgs = {
  eventUuid: Scalars['ID']['input'];
  rooms: Array<Scalars['ID']['input']>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSetSubjectColorArgs = {
  color: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type MutationSetSubjectContainerColorArgs = {
  color: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type MutationSetSubjectsFlagArgs = {
  flag: SubjectFlag;
  uuids: Array<Scalars['ID']['input']>;
  value: Scalars['Boolean']['input'];
};

export type MutationSetSubstitutionArgs = {
  coveringTeachers: Array<SetCoveringTeachersInput>;
  eventUuid: Scalars['ID']['input'];
  rooms: Array<Scalars['ID']['input']>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSetTeachingBlockCardRoomsArgs = {
  cardUuid: Scalars['ID']['input'];
  roomUuids: Array<Scalars['ID']['input']>;
};

export type MutationSetTeachingBlockCardsLockedArgs = {
  cardUuids: Array<Scalars['ID']['input']>;
  locked: Scalars['Boolean']['input'];
};

export type MutationSetTeachingBlockCommentArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type MutationSetTeachingBlockVersionEditableArgs = {
  editable: Scalars['Boolean']['input'];
  uuid: Scalars['ID']['input'];
};

export type MutationSetTeachingLoadFactorActiveArgs = {
  active: Scalars['Boolean']['input'];
  uuid: Scalars['ID']['input'];
};

export type MutationSetTimetableBlockTeachingLoadFactorArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  factor: Scalars['Float']['input'];
  uuid: Scalars['ID']['input'];
};

export type MutationSetTimetableCardRoomsArgs = {
  cardUuid: Scalars['ID']['input'];
  roomUuids: Array<Scalars['ID']['input']>;
};

export type MutationSetTimetableCardsLockedArgs = {
  cardUuids: Array<Scalars['ID']['input']>;
  locked: Scalars['Boolean']['input'];
};

export type MutationSetTimetableVersionAvailabilityArgs = {
  availability: TimetableVersionAvailabilityInput;
  resourceType: TimetableVersionResourceType;
  resourceUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type MutationSetTimetableVersionConstraintSettingsArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type MutationSetTimetableVersionConstraintsArgs = {
  constraints?: InputMaybe<Scalars['String']['input']>;
  resourceType: TimetableVersionResourceType;
  resourceUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type MutationSetTimetableVersionEditableArgs = {
  editable: Scalars['Boolean']['input'];
  uuid: Scalars['ID']['input'];
};

export type MutationSplitEventArgs = {
  eventUuid: Scalars['ID']['input'];
  parts: Array<SplitEventPartInput>;
};

export type MutationUnplaceTeachingBlockCardsArgs = {
  cardUuids: Array<Scalars['ID']['input']>;
};

export type MutationUnplaceTimetableCardsArgs = {
  cardUuids: Array<Scalars['ID']['input']>;
};

export type MutationUnsplitEventArgs = {
  eventUuid: Scalars['ID']['input'];
};

export type MutationUpdateAbsenceArgs = {
  update: UpdateAbsenceInput;
  where: OnlyUuids;
};

export type MutationUpdateAdditionalTeachingLoadArgs = {
  input: AdditionalTeachingLoadInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateBuildingArgs = {
  input: BuildingInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateClassArgs = {
  input: ClassInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateCurriculumArgs = {
  input: CurriculumInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateCurriculumVersionArgs = {
  input: CurriculumVersionInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateDependencyArgs = {
  input: DependencyInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateDivisionArgs = {
  input: DivisionInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateGradeGroupArgs = {
  input: GradeGroupInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateGrantedProfilesArgs = {
  frontendUri?: InputMaybe<Scalars['String']['input']>;
  organizationUuid: Scalars['ID']['input'];
  profiles: Array<Scalars['ID']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationUpdateHolidayArgs = {
  input: HolidayInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateLessonArgs = {
  input: LessonInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdatePersonArgs = {
  input: PersonInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateRecurrenceSchoolEventsArgs = {
  excludeHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  recurrenceUuid: Scalars['ID']['input'];
  rrule: Scalars['String']['input'];
  update: SchoolEventUpdateInput;
};

export type MutationUpdateRoomArgs = {
  input: RoomInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateSchoolEventArgs = {
  eventUuid: Scalars['ID']['input'];
  update: SchoolEventUpdateInput;
};

export type MutationUpdateSchoolYearArgs = {
  input: SchoolYearInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateSubjectArgs = {
  input: SubjectInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateSubjectContainerArgs = {
  input: SubjectContainerInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateSubjectGroupArgs = {
  input: SubjectGroupInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateTeachingBlockExclusionArgs = {
  input: TeachingBlockExclusionInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateTeachingBlockVersionArgs = {
  input: TeachingBlockVersionInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateTeachingLoadFactorArgs = {
  input: TeachingLoadFactorInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateTimeGridArgs = {
  input: TimeGridInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateTimeGridEntryArgs = {
  update: UpdateTimeGridEntryInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateTimetableArgs = {
  input: TimetableInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateTimetableBlockArgs = {
  input: TimetableBlockInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateTimetableVersionArgs = {
  input: TimetableVersionInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateUserPermissionsArgs = {
  organizationUuid: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
  profileUuid: Scalars['ID']['input'];
};

export type MutationUpsertMyTableConfigArgs = {
  columnsSort: Scalars['String']['input'];
  hiddenColumns: Array<Scalars['String']['input']>;
  table: Scalars['String']['input'];
};

export type MutationUpsertMyUiSettingsArgs = {
  data: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type MyTableConfig = {
  __typename?: 'MyTableConfig';
  /** JSON-Array `[{ "id": String, "desc": Boolean }]`. */
  columnsSort: Scalars['String']['output'];
  hiddenColumns: Array<Scalars['String']['output']>;
  table: Scalars['String']['output'];
};

export type MyUiSettings = {
  __typename?: 'MyUiSettings';
  /** JSON-Objekt, im Frontend per Zod validiert. */
  data: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['Int']['output'];
};

/**
 * UserConfig des aufrufenden Profils. Gibt nur die `schoolYearUuid` zurueck; das
 * Schuljahr selbst holt das Frontend aus der bestehenden `schoolYears`-Query.
 */
export type MyUserConfig = {
  __typename?: 'MyUserConfig';
  schoolYearUuid?: Maybe<Scalars['ID']['output']>;
  tableConfigs: Array<MyTableConfig>;
  uiSettings: Array<MyUiSettings>;
};

export type OnlyUuids = {
  uuids: Array<Scalars['ID']['input']>;
};

export type PersonConnectDisconnectInput = {
  connect: Array<EventPersonRelationInput>;
  disconnect?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Vollständiger Stand einer Person. Stammraum, Verträge und Lehrbefähigungen werden ersetzt: was hier nicht steht, ist
 * danach nicht mehr vorhanden. Verträge werden dabei neu angelegt und bekommen neue uuids.
 */
export type PersonInput = {
  active: Scalars['Boolean']['input'];
  birthday?: InputMaybe<Scalars['Date']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  colorLabel?: InputMaybe<Scalars['String']['input']>;
  contracts: Array<ContractInput>;
  defaultRoomUuid?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  personalId?: InputMaybe<Scalars['String']['input']>;
  pimProfileUuid?: InputMaybe<Scalars['String']['input']>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  qualifications: Array<QualificationInput>;
  role: PersonRole;
  salutation?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Person, wie sie die handgeschriebenen Root-Felder liefern. */
export type PersonItem = {
  __typename?: 'PersonItem';
  active: Scalars['Boolean']['output'];
  birthday?: Maybe<Scalars['Date']['output']>;
  contractUuids: Array<Scalars['ID']['output']>;
  /** Stammraum */
  defaultRoomUuid?: Maybe<Scalars['ID']['output']>;
  /** Titel Vorname Namensvorsatz Nachname */
  displayName: Scalars['String']['output'];
  /** Nachname mit so vielen Buchstaben des Vornamens, wie zur Unterscheidung nötig sind (z. B. Müller, Th.). */
  displayNameShort: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  /** Vorname Nachname */
  fullName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  /** Nachname, Titel Vorname Namensvorsatz */
  listName: Scalars['String']['output'];
  personalId?: Maybe<Scalars['String']['output']>;
  pimProfileUuid?: Maybe<Scalars['String']['output']>;
  prefixName?: Maybe<Scalars['String']['output']>;
  qualifications: Array<QualificationItem>;
  /** Rolle der Person in der Organisation; null, wenn die Person keine hat (Altbestand). */
  role?: Maybe<PersonRole>;
  salutation?: Maybe<Scalars['String']['output']>;
  /** Vorname Namensvorsatz Nachname */
  selectName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  /** null, solange die Person keine Einstellungen hat (Altbestand). */
  timetableConfig?: Maybe<TimetableConfigItem>;
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export enum PersonRole {
  Other = 'OTHER',
  Teacher = 'TEACHER',
}

export type PimOrganization = {
  __typename?: 'PimOrganization';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  bpEnabled?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  iphisEnabled?: Maybe<Scalars['Boolean']['output']>;
  iphisVplanEnabled?: Maybe<Scalars['Boolean']['output']>;
  licensedModules?: Maybe<Array<Scalars['String']['output']>>;
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  planungEnabled?: Maybe<Scalars['Boolean']['output']>;
  timezone: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
  vpoEnabled?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PimProfile = {
  __typename?: 'PimProfile';
  accessGranted?: Maybe<Scalars['Boolean']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayNameShort?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  firstNames?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  listName?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  prefixName?: Maybe<Scalars['String']['output']>;
  profileEmail?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
  selectName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userStatus?: Maybe<UserStatus>;
  uuid: Scalars['ID']['output'];
};

export type PreviewDeputatResult = {
  __typename?: 'PreviewDeputatResult';
  deputat: Scalars['Float']['output'];
  factor: Scalars['Float']['output'];
  teacherUuid: Scalars['String']['output'];
};

export type PreviewGroupInput = {
  classFraction?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['ID']['input'];
};

export type PreviewLessonClassInput = {
  classUuid: Scalars['ID']['input'];
  groups?: InputMaybe<Array<PreviewGroupInput>>;
};

export type PreviewLessonUnitInput = {
  count: Scalars['Float']['input'];
  duration: Scalars['Float']['input'];
  subjectContainerUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Ein veröffentlichter Tag des Vertretungsplans; teachers, classes, substitutions und notifications sind JSON-Texte. */
export type PublishedSubstitutionDay = {
  __typename?: 'PublishedSubstitutionDay';
  classes: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  lastPublished?: Maybe<Scalars['DateTime']['output']>;
  notifications: Scalars['String']['output'];
  substitutions: Scalars['String']['output'];
  teachers: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type QualificationInput = {
  maxGrade?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad?: InputMaybe<Scalars['Int']['input']>;
  minGrade?: InputMaybe<Scalars['Int']['input']>;
  subjectUuid: Scalars['ID']['input'];
};

/** Lehrbefähigung einer Person für ein Fach. */
export type QualificationItem = {
  __typename?: 'QualificationItem';
  maxGrade?: Maybe<Scalars['Int']['output']>;
  maxTeachingLoad?: Maybe<Scalars['Int']['output']>;
  minGrade?: Maybe<Scalars['Int']['output']>;
  subjectUuid: Scalars['ID']['output'];
};

export type Query = {
  __typename?: 'Query';
  absence?: Maybe<AbsenceEntry>;
  /** Abwesenheiten, die sich mit dem Zeitraum überschneiden (Beginn vor end und Ende nach start), nach Beginn. */
  absencesInRange: Array<AbsenceEntry>;
  /** Aktive Versionen der Stundenpläne eines Schuljahres, nach Name des Stundenplans. */
  activeTimetableVersions: Array<ActiveTimetableVersion>;
  /** Aktive Versionen der Stundenpläne, die an diesem Tag in einem Zeitraum liegen, nach Name des Stundenplans. */
  activeTimetableVersionsForDate: Array<ActiveTimetableVersion>;
  /** Zusätzliche Deputate eines Schuljahres nach Listenname der Lehrkraft; mit teacherUuid nur die einer Lehrkraft. */
  additionalTeachingLoads: Array<AdditionalTeachingLoadItem>;
  /** Alle Termine, die den Zeitraum berühren, nach Beginn, seitenweise. Nur für die Verwaltung. */
  adminEvents: Array<EventItem>;
  /** Zahl der Termine, die adminEvents für den Zeitraum insgesamt liefert. */
  adminEventsCount: Scalars['Int']['output'];
  attendancePlanEvents: Array<AttendancePlanEvent>;
  /** Gebäude der Organisation, inaktive zuerst, dann nach Name sortiert. */
  buildings: Array<BuildingItem>;
  /** Eine Klasse; null, wenn es sie in der Organisation nicht gibt. */
  class?: Maybe<ClassItem>;
  /**
   * In welchen Zuordnungen die genannten Klassen stecken: Zähler und höchstens drei Zuordnungen als Beispiel.
   * Klassen, die es in der Organisation nicht gibt, fehlen im Ergebnis.
   */
  classUsage: Array<LessonUsage>;
  /**
   * Klassen der Organisation, nach sortName (Jahrgang und Klassenzug), dann nach Kürzel sortiert.
   * Mit schoolYearUuid nur die Klassen dieses Schuljahrs, sonst die aller Schuljahre.
   */
  classes: Array<ClassItem>;
  /** Verträge der genannten Personen, nach Person und Beginn sortiert; ohne personUuids alle Verträge der Organisation. */
  contracts: Array<ContractItem>;
  /**
   * Sollstunden, nach Fachname, dann nach den Klassenzügen ihrer Jahrgangs-Einträge und dann nach der Reihenfolge
   * des Anlegens sortiert. Mit curriculumVersionUuid nur die dieser Version, mit subjectUuid nur die dieses Fachs.
   */
  curricula: Array<CurriculumItem>;
  curriculaLessonStatus: Array<CurriculumLessonStatus>;
  /** Versionen der Sollstunden, nach Name sortiert. */
  curriculumVersions: Array<CurriculumVersionItem>;
  /** Vorlagen: Teilungen ohne Klasse, nach Name sortiert. */
  defaultDivisions: Array<DivisionItem>;
  /** Abhängigkeiten einer Stundenplan-Version, nach Art und uuid. */
  dependenciesForVersion: Array<DependencyItem>;
  /** Eine Teilung (mit oder ohne Klasse); null, wenn es sie in der Organisation nicht gibt. */
  division?: Maybe<DivisionItem>;
  /**
   * In welchen Zuordnungen Gruppen der genannten Teilungen stecken: Zähler und höchstens drei Zuordnungen als
   * Beispiel. Teilungen, die es in der Organisation nicht gibt, fehlen im Ergebnis.
   */
  divisionUsage: Array<LessonUsage>;
  /**
   * Teilungen von Klassen, nach Name sortiert. Mit schoolYearUuid nur die der Klassen dieses Schuljahres, mit classUuid
   * nur die dieser Klasse. Vorlagen ohne Klasse liefert defaultDivisions.
   */
  divisions: Array<DivisionItem>;
  /** Die für die Schule freigeschalteten Solver; leer, solange nichts eingestellt ist. */
  enabledSolverEngines: Array<SolverEngine>;
  event?: Maybe<EventItem>;
  /** Läufe des Termin-Abgleichs der Schule, neueste zuerst; mit runningOnly nur die laufenden. */
  eventJobs: Array<EventJobItem>;
  /** Offene Tage des Termin-Abgleichs und Versionen in Korrektur, die Tage zurückhalten. */
  eventSyncStatus: EventSyncStatus;
  /** Termine, die den Zeitraum berühren (Beginn bis end, Ende ab start): Schulveranstaltungen zuerst, dann nach Beginn. Ohne includeSchoolEvents nur Unterricht. */
  eventsInRange: Array<EventItem>;
  /** Klassenzüge der Organisation, nach Name, dann nach Kürzel sortiert. */
  gradeGroups: Array<GradeGroupItem>;
  /**
   * Gruppen der Teilungen von Klassen, nach Name sortiert. Mit schoolYearUuid nur die der Klassen dieses Schuljahres.
   * Gruppen von Vorlagen sind nicht dabei.
   */
  groups: Array<GroupItem>;
  /**
   * Zuordnungen des Schuljahres, die sich in die Epochenplan-Version übernehmen lassen: noch nicht in ihr, mindestens
   * eine Einheit an der Schiene, nicht nur in einer Version angelegt.
   */
  importableLessonsForTeachingBlockVersion: Array<LessonItem>;
  /**
   * Zuordnungen des Schuljahres, die sich in die Stundenplan-Version übernehmen lassen: noch nicht in ihr, alle ihre
   * Klassen gehören zur Version, mindestens eine Einheit ohne Schiene, nicht nur in einer Version angelegt.
   */
  importableLessonsForTimetableVersion: Array<LessonItem>;
  /** Der zuletzt geänderte Solver-Lauf der Version. */
  latestSolverJobForVersion?: Maybe<SolverJobItem>;
  /** Welche der genannten Zuordnungen Stundenplan- oder Epochen-Karten haben; liefert ihre uuids. */
  lessonUuidsWithCards: Array<Scalars['ID']['output']>;
  /** Die genannten Zuordnungen; unbekannte fehlen im Ergebnis. */
  lessonsByUuids: Array<LessonItem>;
  /** Zuordnungen eines Schuljahres, ohne die nur in einer Version angelegten. */
  lessonsForSchoolYear: Array<LessonItem>;
  /** Zuordnungen, die direkt an der Schiene hängen (Epochenplan); mit schoolYearUuid nur die dieses Schuljahres. */
  lessonsForSubjectContainer: Array<LessonItem>;
  /** Zuordnungen einer Epochenplan-Version. */
  lessonsForTeachingBlockVersion: Array<LessonItem>;
  /** Zuordnungen einer Stundenplan-Version. */
  lessonsForTimetableVersion: Array<LessonItem>;
  myUserConfig: MyUserConfig;
  /**
   * Personen der Organisation, aktive zuerst, dann nach Nachname und Vorname sortiert. Mit activeOnly nur die aktiven,
   * mit role nur Personen dieser Rolle.
   */
  people: Array<PersonItem>;
  /** Eine Person; null, wenn es sie in der Organisation nicht gibt. */
  person?: Maybe<PersonItem>;
  /**
   * In welchen Zuordnungen die genannten Personen Lehrer sind: Zähler und höchstens drei Zuordnungen als Beispiel.
   * Personen, die es in der Organisation nicht gibt, fehlen im Ergebnis.
   */
  personUsage: Array<LessonUsage>;
  /** Alle Organisationen aus dem PIM mit ihren gebuchten Anwendungen. Nur für Omni-Admins. */
  pimOrganizations: Array<PimOrganization>;
  pimProfiles: Array<PimProfile>;
  /** Gesteckte Karten (mit Wochentag) einer Stundenplan-Version, nach uuid. */
  placedTimetableCards: Array<TimetableCardItem>;
  plannedTeachingLoadByTeacher: Array<TeacherTeachingLoad>;
  previewTeachingLoad: Array<PreviewDeputatResult>;
  /** Veröffentlichte Tage des Vertretungsplans zwischen start und end (beide einschließlich), nach Datum. Nur für die Verwaltung. */
  publishedSubstitutionDays: Array<PublishedSubstitutionDay>;
  recurringEvent?: Maybe<RecurringEventItem>;
  /**
   * Wie oft die genannten Räume in Zuordnungen und Sollstunden verwendet werden. Ein verwendeter Raum lässt sich
   * nicht löschen (siehe deleteRooms). Räume, die es in der Organisation nicht gibt, fehlen im Ergebnis.
   */
  roomUsage: Array<RoomUsage>;
  /** Räume der Organisation, nach Name, dann nach Raumnummer sortiert. */
  rooms: Array<RoomItem>;
  /** Offene Unterrichtsanpassungen nach dem Bearbeiten von Schulveranstaltungen, in Anlage-Reihenfolge. */
  schoolEventLessonSyncs: Array<SchoolEventLessonSyncItem>;
  schoolEvents: Array<SchoolEvent>;
  /** Schuljahre der Organisation, nach Beginn sortiert, jeweils mit den Ferien, die in das Schuljahr fallen. */
  schoolYears: Array<SchoolYearItem>;
  solverJob?: Maybe<SolverJobItem>;
  /** Nur für die Verwaltung. */
  solverJobDetails?: Maybe<SolverJobDetails>;
  /** Alle Solver-Läufe der Schule, neueste zuerst. Nur für die Verwaltung. */
  solverJobs: Array<SolverJobItem>;
  /** Ein Fach; null, wenn es in der Organisation nicht existiert. */
  subject?: Maybe<SubjectItem>;
  /**
   * Wie oft die genannten Schienen und Epochen verwendet werden. Zuordnungen, Sollstunden, Epochenpläne und
   * Unterrichtseinheiten verhindern das Löschen (siehe deleteSubjectContainers). Einträge, die es in der Organisation
   * nicht gibt, fehlen im Ergebnis.
   */
  subjectContainerUsage: Array<SubjectContainerUsage>;
  /** Schienen und Epochen der Organisation, nach Reihenfolge (order), dann nach Name sortiert. */
  subjectContainers: Array<SubjectContainerItem>;
  /** Fachgruppen der Organisation, nach Name sortiert. */
  subjectGroups: Array<SubjectGroupItem>;
  /**
   * Wie oft die genannten Fächer in Zuordnungen und Sollstunden verwendet werden. Ein verwendetes Fach lässt sich
   * nicht löschen (siehe deleteSubjects). Fächer, die es in der Organisation nicht gibt, fehlen im Ergebnis.
   */
  subjectUsage: Array<SubjectUsage>;
  /** Fächer der Organisation, aktive zuerst, dann nach Name sortiert. Mit activeOnly nur die aktiven. */
  subjects: Array<SubjectItem>;
  /** Ankündigung des Vertretungsplans für den Tag; null, solange keine gespeichert ist. */
  substitutionAnnouncement?: Maybe<SubstitutionAnnouncementItem>;
  /** Einstellungen der Vertretungsplan-App; null, solange keine gespeichert sind. */
  substitutionAppConfig?: Maybe<SubstitutionAppConfigItem>;
  /** Druck-Einstellungen des Vertretungsplans; null, solange keine gespeichert sind. */
  substitutionPrintConfig?: Maybe<SubstitutionPrintConfigItem>;
  /** Vertretungs-Berichte (Statistik) eines Schuljahres, neueste zuerst; mit type nur die eines Berichtstyps. */
  substitutionReports: Array<SubstitutionReportItem>;
  /** Anbindung der Vertretungs-Software (Iphis, VPO). Nur für die Verwaltung. */
  substitutionSoftwareSettings: SubstitutionSoftwareSettings;
  teachersSubstitutions: Array<TeacherSubstitutionStats>;
  /** Gesteckte Karten von Klassenfahrten in den aktiven Versionen aller veröffentlichten Epochenpläne des Schuljahres. */
  teachingBlockClassTripCards: Array<TeachingBlockClassTripCard>;
  teachingBlockCurrentStatus: Array<TeachingBlockCurrentStatus>;
  /** Der Epochenplan einer Schiene im Schuljahr. */
  teachingBlockForSubjectContainer?: Maybe<TeachingBlockItem>;
  /** Der Epochenplan, zu dem die Version gehört. */
  teachingBlockForVersion?: Maybe<TeachingBlockItem>;
  /**
   * Alles, was das Board einer Epochenplan-Version braucht, in einer Anfrage: Kopfdaten, Ressourcen der Version mit
   * ihren Constraints, Karten und Ausschlüsse. Die Zuordnungen der Karten liefert lessonsForTeachingBlockVersion.
   * null, wenn es die Version nicht gibt.
   */
  teachingBlockVersionData?: Maybe<TeachingBlockVersionData>;
  /**
   * Epochenpläne eines Schuljahres in der Reihenfolge ihres Anlegens. Mit onlyWithActiveVersion nur Pläne, die eine
   * aktive Version haben.
   */
  teachingBlocks: Array<TeachingBlockItem>;
  teachingLoadByTeacher: Array<TeacherTeachingLoad>;
  /** Deputatsfaktoren eines Schuljahres: aktive zuerst, dann nach Art (absteigend). */
  teachingLoadFactors: Array<TeachingLoadFactorItem>;
  /** Einstellungen eines Deputats-Berichtstyps; null, solange für ihn nichts gespeichert ist. */
  teachingLoadReportConfig?: Maybe<TeachingLoadReportConfigItem>;
  /**
   * Deputats-Berichte, neueste zuerst: die des Schuljahres, der genannten Epochenpläne und der genannten Zeiträume;
   * mit type nur die eines Berichtstyps. Was nicht angegeben ist, zählt nicht mit.
   */
  teachingLoadReports: Array<TeachingLoadReportItem>;
  /**
   * Wie viele gesteckte Stundenplan-Karten in den Einträgen eines Zeitrasters beginnen oder enden, je Eintrag eine Zeile.
   * Ein Eintrag mit gesteckten Karten soll nicht gelöscht werden.
   */
  timeGridEntryUsage: Array<TimeGridEntryUsage>;
  /** Zeitraster der Organisation, nach Name sortiert, jeweils mit ihren Einträgen. */
  timeGrids: Array<TimeGridItem>;
  timetable?: Maybe<TimetableItem>;
  timetableBlock?: Maybe<TimetableBlockItem>;
  /**
   * Zeiträume eines Schuljahres nach Beginn. Mit onlyWithActiveVersion nur Zeiträume, in denen ein Stundenplan eine
   * aktive Version hat; mit date nur die, die an diesem Tag gelten.
   */
  timetableBlocks: Array<TimetableBlockItem>;
  /** Zahl der Karten, die in dieser Stunde eines Stundenrasters beginnen. */
  timetableCardsCountForTimeGridEntry: Scalars['Int']['output'];
  /** Karten einer Zuordnung in einer Stundenplan-Version, kürzeste zuerst. */
  timetableCardsForLesson: Array<TimetableCardItem>;
  /** Der Stundenplan, zu dem die Version gehört. */
  timetableForVersion?: Maybe<TimetableItem>;
  /** Druck-Einstellungen eines Berichtstyps; null, solange für ihn nichts gespeichert ist. */
  timetablePrintConfig?: Maybe<TimetablePrintConfigItem>;
  /**
   * Stundenplan-Berichte, neueste zuerst: die des Schuljahres, der genannten Epochenpläne und der genannten Zeiträume.
   * Was nicht angegeben ist, zählt nicht mit.
   */
  timetableReports: Array<TimetableReportItem>;
  timetableVersion?: Maybe<TimetableVersionMeta>;
  /** Verfügbarkeiten der in die Version aufgenommenen Ressourcen; mit resourceType nur die eines Typs. */
  timetableVersionAvailabilities: Array<TimetableVersionResourceAvailability>;
  /** Der Constraint-Katalog der Version (JSON); null, solange die Solver-Defaults gelten. */
  timetableVersionConstraintSettings?: Maybe<Scalars['String']['output']>;
  /** Bedingungen der Ressourcen eines Typs in der Version; mit resourceUuids nur die genannten. */
  timetableVersionConstraints: Array<TimetableVersionConstraints>;
  timetableVersionData: TimetableVersionData;
  timetableVersionLessonData: TimetableVersionLessonData;
  /** Stundenpläne eines Schuljahres (ohne Angabe: alle), zuletzt geänderte zuerst. */
  timetables: Array<TimetableItem>;
};

export type QueryAbsenceArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryAbsencesInRangeArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type QueryActiveTimetableVersionsArgs = {
  schoolYearUuid: Scalars['ID']['input'];
};

export type QueryActiveTimetableVersionsForDateArgs = {
  date: Scalars['Date']['input'];
};

export type QueryAdditionalTeachingLoadsArgs = {
  schoolYearUuid: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAdminEventsArgs = {
  end: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  start: Scalars['DateTime']['input'];
};

export type QueryAdminEventsCountArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type QueryAttendancePlanEventsArgs = {
  day: Scalars['Date']['input'];
  organizationUuid: Scalars['ID']['input'];
};

export type QueryClassArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryClassUsageArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type QueryClassesArgs = {
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryContractsArgs = {
  personUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryCurriculaArgs = {
  curriculumVersionUuid?: InputMaybe<Scalars['ID']['input']>;
  subjectUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCurriculaLessonStatusArgs = {
  curriculumUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
};

export type QueryDependenciesForVersionArgs = {
  versionUuid: Scalars['ID']['input'];
};

export type QueryDivisionArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryDivisionUsageArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type QueryDivisionsArgs = {
  classUuid?: InputMaybe<Scalars['ID']['input']>;
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryEventArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryEventJobsArgs = {
  runningOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryEventsInRangeArgs = {
  end: Scalars['DateTime']['input'];
  includeSchoolEvents?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['DateTime']['input'];
};

export type QueryGroupsArgs = {
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryImportableLessonsForTeachingBlockVersionArgs = {
  schoolYearUuid: Scalars['ID']['input'];
  subjectContainerUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type QueryImportableLessonsForTimetableVersionArgs = {
  schoolYearUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type QueryLatestSolverJobForVersionArgs = {
  versionUuid: Scalars['ID']['input'];
};

export type QueryLessonUuidsWithCardsArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type QueryLessonsByUuidsArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type QueryLessonsForSchoolYearArgs = {
  schoolYearUuid: Scalars['ID']['input'];
};

export type QueryLessonsForSubjectContainerArgs = {
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
  subjectContainerUuid: Scalars['ID']['input'];
};

export type QueryLessonsForTeachingBlockVersionArgs = {
  versionUuid: Scalars['ID']['input'];
};

export type QueryLessonsForTimetableVersionArgs = {
  versionUuid: Scalars['ID']['input'];
};

export type QueryPeopleArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PersonRole>;
};

export type QueryPersonArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryPersonUsageArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type QueryPimProfilesArgs = {
  organizationUuid: Scalars['ID']['input'];
};

export type QueryPlacedTimetableCardsArgs = {
  versionUuid: Scalars['ID']['input'];
};

export type QueryPlannedTeachingLoadByTeacherArgs = {
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryPreviewTeachingLoadArgs = {
  lessonClasses: Array<PreviewLessonClassInput>;
  lessonUnits: Array<PreviewLessonUnitInput>;
  organizationUuid: Scalars['String']['input'];
  schoolYearUuid: Scalars['String']['input'];
  subjectUuid: Scalars['String']['input'];
  teacherUuids: Array<Scalars['String']['input']>;
};

export type QueryPublishedSubstitutionDaysArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

export type QueryRecurringEventArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryRoomUsageArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type QuerySchoolEventsArgs = {
  from: Scalars['Date']['input'];
  organizationUuid: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};

export type QuerySolverJobArgs = {
  jobId: Scalars['String']['input'];
};

export type QuerySolverJobDetailsArgs = {
  jobId: Scalars['String']['input'];
};

export type QuerySubjectArgs = {
  uuid: Scalars['ID']['input'];
};

export type QuerySubjectContainerUsageArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type QuerySubjectUsageArgs = {
  uuids: Array<Scalars['ID']['input']>;
};

export type QuerySubjectsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySubstitutionAnnouncementArgs = {
  date: Scalars['Date']['input'];
};

export type QuerySubstitutionReportsArgs = {
  schoolYearUuid: Scalars['ID']['input'];
  type?: InputMaybe<SubstitutionReportType>;
};

export type QueryTeachersSubstitutionsArgs = {
  classUuids: Array<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  subjectUuid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTeachingBlockClassTripCardsArgs = {
  schoolYearUuid: Scalars['ID']['input'];
};

export type QueryTeachingBlockCurrentStatusArgs = {
  teachingBlockUuids: Array<Scalars['ID']['input']>;
};

export type QueryTeachingBlockForSubjectContainerArgs = {
  schoolYearUuid: Scalars['ID']['input'];
  subjectContainerUuid: Scalars['ID']['input'];
};

export type QueryTeachingBlockForVersionArgs = {
  versionUuid: Scalars['ID']['input'];
};

export type QueryTeachingBlockVersionDataArgs = {
  versionUuid: Scalars['ID']['input'];
};

export type QueryTeachingBlocksArgs = {
  onlyWithActiveVersion?: InputMaybe<Scalars['Boolean']['input']>;
  schoolYearUuid: Scalars['ID']['input'];
};

export type QueryTeachingLoadByTeacherArgs = {
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
  timetableBlockUuid: Scalars['ID']['input'];
};

export type QueryTeachingLoadFactorsArgs = {
  schoolYearUuid: Scalars['ID']['input'];
};

export type QueryTeachingLoadReportConfigArgs = {
  type: TeachingLoadReportType;
};

export type QueryTeachingLoadReportsArgs = {
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
  teachingBlockUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  timetableBlockUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<TeachingLoadReportType>;
};

export type QueryTimeGridEntryUsageArgs = {
  timeGridUuid: Scalars['ID']['input'];
};

export type QueryTimetableArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryTimetableBlockArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryTimetableBlocksArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  onlyWithActiveVersion?: InputMaybe<Scalars['Boolean']['input']>;
  schoolYearUuid: Scalars['ID']['input'];
};

export type QueryTimetableCardsCountForTimeGridEntryArgs = {
  timeGridEntryUuid: Scalars['ID']['input'];
};

export type QueryTimetableCardsForLessonArgs = {
  lessonUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type QueryTimetableForVersionArgs = {
  versionUuid: Scalars['ID']['input'];
};

export type QueryTimetablePrintConfigArgs = {
  type: TimetableReportType;
};

export type QueryTimetableReportsArgs = {
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
  teachingBlockUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  timetableBlockUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryTimetableVersionArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryTimetableVersionAvailabilitiesArgs = {
  resourceType?: InputMaybe<TimetableVersionResourceType>;
  versionUuid: Scalars['ID']['input'];
};

export type QueryTimetableVersionConstraintSettingsArgs = {
  versionUuid: Scalars['ID']['input'];
};

export type QueryTimetableVersionConstraintsArgs = {
  resourceType: TimetableVersionResourceType;
  resourceUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  versionUuid: Scalars['ID']['input'];
};

export type QueryTimetableVersionDataArgs = {
  includeEditorData?: InputMaybe<Scalars['Boolean']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type QueryTimetableVersionLessonDataArgs = {
  versionUuid: Scalars['ID']['input'];
};

export type QueryTimetablesArgs = {
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type RecurrenceSchoolEventCreateInput = {
  classes?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  excludeHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  isClassbookRelevant: Scalars['Boolean']['input'];
  persons?: InputMaybe<Array<Scalars['ID']['input']>>;
  rooms?: InputMaybe<Array<Scalars['ID']['input']>>;
  rrule: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  subject: Scalars['ID']['input'];
};

/** Eine Serie von Schulveranstaltungen. */
export type RecurringEventItem = {
  __typename?: 'RecurringEventItem';
  excludeHolidays: Scalars['Boolean']['output'];
  /** Zahl der künftigen, nicht ausgenommenen Termine der Serie. */
  futureEventsCount: Scalars['Int']['output'];
  rrule: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type ReportFileEntryItem = {
  __typename?: 'ReportFileEntryItem';
  filename?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export enum RoomFlag {
  BarrierFree = 'BARRIER_FREE',
  CanBeDarkened = 'CAN_BE_DARKENED',
  CanBeLeased = 'CAN_BE_LEASED',
  Classroom = 'CLASSROOM',
  HasMediaCabinet = 'HAS_MEDIA_CABINET',
  HasPiano = 'HAS_PIANO',
  HasProjector = 'HAS_PROJECTOR',
  HasScreen = 'HAS_SCREEN',
}

/**
 * Vollständiger Stand eines Raums. Gebäude und Raumverantwortliche werden ersetzt: was hier nicht steht, ist danach
 * nicht mehr verbunden. Die Reihenfolge von responsiblePersonUuids ist die Reihenfolge der Raumverantwortlichen.
 */
export type RoomInput = {
  barrierFree?: InputMaybe<Scalars['Boolean']['input']>;
  buildingUuid?: InputMaybe<Scalars['ID']['input']>;
  canBeDarkened?: InputMaybe<Scalars['Boolean']['input']>;
  canBeLeased?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  chairs?: InputMaybe<Scalars['Int']['input']>;
  classroom?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasMediaCabinet?: InputMaybe<Scalars['Boolean']['input']>;
  hasPiano?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjector?: InputMaybe<Scalars['Boolean']['input']>;
  hasScreen?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  otherInventory?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  responsiblePersonUuids: Array<Scalars['ID']['input']>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  tables?: InputMaybe<Scalars['Int']['input']>;
};

/** Raum, wie ihn die handgeschriebenen Root-Felder liefern. */
export type RoomItem = {
  __typename?: 'RoomItem';
  barrierFree?: Maybe<Scalars['Boolean']['output']>;
  building?: Maybe<BuildingRefItem>;
  /** Verdunklung möglich */
  canBeDarkened?: Maybe<Scalars['Boolean']['output']>;
  canBeLeased?: Maybe<Scalars['Boolean']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  chairs?: Maybe<Scalars['Int']['output']>;
  classroom?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Medienschrank */
  hasMediaCabinet?: Maybe<Scalars['Boolean']['output']>;
  /** Klavier */
  hasPiano?: Maybe<Scalars['Boolean']['output']>;
  /** Beamer */
  hasProjector?: Maybe<Scalars['Boolean']['output']>;
  /** Leinwand */
  hasScreen?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  otherInventory?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  /** Raumverantwortliche in der festgelegten Reihenfolge. */
  responsiblePersonUuids: Array<Scalars['ID']['output']>;
  roomNumber?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  tables?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Verweis auf einen Raum innerhalb eines Item-Typs. */
export type RoomRefItem = {
  __typename?: 'RoomRefItem';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Verwendung eines Raums in Zuordnungen und Sollstunden. */
export type RoomUsage = {
  __typename?: 'RoomUsage';
  curriculaCount: Scalars['Int']['output'];
  lessonsCount: Scalars['Int']['output'];
  /** uuid des Raums. */
  uuid: Scalars['ID']['output'];
};

export type SchoolEvent = {
  __typename?: 'SchoolEvent';
  canceled: Scalars['Boolean']['output'];
  classesOrGroups: Array<SchoolEventClassOrGroup>;
  comment?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  groupClassNames: Scalars['String']['output'];
  groupClassNamesLong: Scalars['String']['output'];
  isClassTrip: Scalars['Boolean']['output'];
  isClassbookRelevant: Scalars['Boolean']['output'];
  isSchoolEvent: Scalars['Boolean']['output'];
  persons: Array<MinimalPerson>;
  print: Scalars['Boolean']['output'];
  recurrenceUuid?: Maybe<Scalars['String']['output']>;
  rooms: Array<MinimalRoom>;
  start: Scalars['DateTime']['output'];
  subject: MinimalSubject;
  uuid: Scalars['ID']['output'];
};

export type SchoolEventClassOrGroup = MinimalClass | MinimalGroup;

export type SchoolEventCreateInput = {
  classes?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  isClassbookRelevant: Scalars['Boolean']['input'];
  isSchoolEvent: Scalars['Boolean']['input'];
  persons?: InputMaybe<Array<Scalars['ID']['input']>>;
  rooms?: InputMaybe<Array<Scalars['ID']['input']>>;
  start: Scalars['DateTime']['input'];
  subject: Scalars['ID']['input'];
};

/** Eine offene Unterrichtsanpassung; oldFootprints und newFootprints sind JSON-Texte (start, end, teacherUuids, classUuids, groupUuids, roomUuids). */
export type SchoolEventLessonSyncItem = {
  __typename?: 'SchoolEventLessonSyncItem';
  /** Anzahl gescheiterter Versuche */
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  lastAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  newFootprints: Scalars['String']['output'];
  oldFootprints: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type SchoolEventLessonSyncRetryResult = {
  __typename?: 'SchoolEventLessonSyncRetryResult';
  /** Weiterhin offene Aufträge (Abarbeitung stoppt beim ersten Fehler, um die Reihenfolge zu wahren) */
  pending: Scalars['Int']['output'];
  /** Erfolgreich nachgeholte Aufträge */
  processed: Scalars['Int']['output'];
};

export type SchoolEventUpdateInput = {
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  classes?: InputMaybe<ConnectDisconnectInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  groups?: InputMaybe<ConnectDisconnectInput>;
  isClassbookRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  persons?: InputMaybe<PersonConnectDisconnectInput>;
  print?: InputMaybe<Scalars['Boolean']['input']>;
  printUpdatedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  rooms?: InputMaybe<ConnectDisconnectInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['ID']['input']>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  substitutionReason?: InputMaybe<SubstitutionReason>;
};

/** Vollständiger Stand eines Schuljahrs; start darf nicht nach end liegen. */
export type SchoolYearInput = {
  end: Scalars['Date']['input'];
  fullTimeHours?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  start: Scalars['Date']['input'];
};

/** Schuljahr, wie es die handgeschriebenen Root-Felder liefern. */
export type SchoolYearItem = {
  __typename?: 'SchoolYearItem';
  end: Scalars['Date']['output'];
  fullTimeHours?: Maybe<Scalars['Float']['output']>;
  /**
   * Ferien, die in das Schuljahr fallen, nach Beginn sortiert. Ferien hängen nicht an einem Schuljahr; sie zählen dazu,
   * wenn sie sich mit dem Schuljahr überschneiden, mit sieben Tagen Spielraum davor und danach.
   */
  holidays: Array<HolidayItem>;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  start: Scalars['Date']['output'];
  uuid: Scalars['ID']['output'];
};

/** Verweis auf ein Schuljahr innerhalb eines Item-Typs. */
export type SchoolYearRefItem = {
  __typename?: 'SchoolYearRefItem';
  end: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  start: Scalars['Date']['output'];
  uuid: Scalars['ID']['output'];
};

export type SetCoveringTeachersInput = {
  givenSubstituteHours?: InputMaybe<Scalars['Float']['input']>;
  teacherUuid: Scalars['ID']['input'];
};

export enum SolverEngine {
  /** Offline-Exporte; Lösung kommt per Upload (kein Live-Solver). */
  Asc = 'ASC',
  Mathplan = 'MATHPLAN',
  Opent8 = 'OPENT8',
  Timefold = 'TIMEFOLD',
}

/** Aufgabe, Lösung und Fehler eines Solver-Laufs; können mehrere Megabyte groß sein. */
export type SolverJobDetails = {
  __typename?: 'SolverJobDetails';
  errors?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
  problem?: Maybe<Scalars['String']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
};

/** Ein Lauf des Stundenplan-Solvers, ohne Aufgabe und Lösung (die liefert solverJobDetails). */
export type SolverJobItem = {
  __typename?: 'SolverJobItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  engine: SolverEngine;
  gap: Scalars['Float']['output'];
  jobId: Scalars['String']['output'];
  /** JSON der Optionen, mit denen der Lauf gestartet wurde. */
  jobOptions?: Maybe<Scalars['String']['output']>;
  /** JSON der laufenden Zwischenlösung für die Live-Vorschau. */
  previewCards?: Maybe<Scalars['String']['output']>;
  schoolYearName: Scalars['String']['output'];
  /** JSON der Score-Teile, je nach Engine. */
  scoreDetails?: Maybe<Scalars['String']['output']>;
  solutionFound: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  timetableName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['Int']['output'];
  versionUuid: Scalars['ID']['output'];
};

/** Ein Teil beim Aufteilen eines Termins. */
export type SplitEventPartInput = {
  /** Klassen (ganze Klasse) oder Gruppen des Termins */
  classOrGroupUuids: Array<Scalars['ID']['input']>;
  /** Räume des Termins für diesen Teil */
  roomUuids: Array<Scalars['ID']['input']>;
  /** Lehrkräfte des Termins, die in diesem Teil unterrichten */
  teacherUuids: Array<Scalars['ID']['input']>;
};

/**
 * Vollständiger Stand einer Schiene oder Epoche. Klassenzüge und Gültigkeit werden ersetzt: was hier nicht steht,
 * ist danach nicht mehr verbunden.
 */
export type SubjectContainerInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  colorLabel?: InputMaybe<Scalars['String']['input']>;
  gradeGroupUuids: Array<Scalars['ID']['input']>;
  grades: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  shortName: Scalars['String']['input'];
  validFromUuid: Scalars['ID']['input'];
  validUntilUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Schiene oder Epoche, wie sie die handgeschriebenen Root-Felder liefern. */
export type SubjectContainerItem = {
  __typename?: 'SubjectContainerItem';
  /** Klassenzüge, nach Kürzel sortiert. */
  gradeGroups: Array<GradeGroupRefItem>;
  grades: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  shortName: Scalars['String']['output'];
  /** null, solange es keine Einstellungen gibt (Altbestand). */
  timetableConfig?: Maybe<TimetableConfigItem>;
  uuid: Scalars['ID']['output'];
  validFrom?: Maybe<SchoolYearRefItem>;
  validUntil?: Maybe<SchoolYearRefItem>;
};

/** Verwendung einer Schiene oder Epoche. */
export type SubjectContainerUsage = {
  __typename?: 'SubjectContainerUsage';
  curriculaCount: Scalars['Int']['output'];
  lessonUnitsCount: Scalars['Int']['output'];
  lessonsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  teachingBlocksCount: Scalars['Int']['output'];
  /** uuid der Schiene oder Epoche. */
  uuid: Scalars['ID']['output'];
};

export enum SubjectFlag {
  Active = 'ACTIVE',
  EpochEnabled = 'EPOCH_ENABLED',
  Other = 'OTHER',
  SubjectHourEnabled = 'SUBJECT_HOUR_ENABLED',
}

export type SubjectGroupInput = {
  name: Scalars['String']['input'];
};

/** Fachgruppe, wie sie die handgeschriebenen Root-Felder liefern. */
export type SubjectGroupItem = {
  __typename?: 'SubjectGroupItem';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/**
 * Vollständiger Stand eines Fachs. Fachgruppe und Fachräume werden ersetzt: was hier nicht steht, ist danach
 * nicht mehr verbunden. Die Reihenfolge von defaultRoomUuids ist die Reihenfolge der Fachräume.
 */
export type SubjectInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  colorLabel?: InputMaybe<Scalars['String']['input']>;
  defaultRoomUuids: Array<Scalars['ID']['input']>;
  epochEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  other?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  subjectGroupUuid?: InputMaybe<Scalars['ID']['input']>;
  subjectHourEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Fach, wie es die handgeschriebenen Root-Felder liefern. */
export type SubjectItem = {
  __typename?: 'SubjectItem';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Fachräume in der festgelegten Reihenfolge. */
  defaultRooms: Array<RoomRefItem>;
  epochEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  other?: Maybe<Scalars['Boolean']['output']>;
  shortName: Scalars['String']['output'];
  subjectGroup?: Maybe<SubjectGroupItem>;
  subjectHourEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** null, solange das Fach keine Einstellungen hat (Altbestand). */
  timetableConfig?: Maybe<TimetableConfigItem>;
  uuid: Scalars['ID']['output'];
};

/** Verwendung eines Fachs in Zuordnungen und Sollstunden. */
export type SubjectUsage = {
  __typename?: 'SubjectUsage';
  curriculaCount: Scalars['Int']['output'];
  lessonsCount: Scalars['Int']['output'];
  /** uuid des Fachs. */
  uuid: Scalars['ID']['output'];
};

export type SubstitutionAnnouncementItem = {
  __typename?: 'SubstitutionAnnouncementItem';
  date: Scalars['Date']['output'];
  internalAnnouncement?: Maybe<Scalars['String']['output']>;
  publicAnnouncement?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type SubstitutionAppConfigInput = {
  allowIndividualLogins: Scalars['Boolean']['input'];
  showClassGroups: Scalars['Boolean']['input'];
  showCurrentSubject: Scalars['Boolean']['input'];
  showHolidays: Scalars['Boolean']['input'];
  showOriginalSubject: Scalars['Boolean']['input'];
  studentPassword: Scalars['String']['input'];
  teacherPassword: Scalars['String']['input'];
  timeDisplayMode: Scalars['String']['input'];
  useClassShortname: Scalars['Boolean']['input'];
  useRoomShortname: Scalars['Boolean']['input'];
  useTeacherShortname: Scalars['Boolean']['input'];
};

export type SubstitutionAppConfigItem = {
  __typename?: 'SubstitutionAppConfigItem';
  allowIndividualLogins: Scalars['Boolean']['output'];
  showClassGroups: Scalars['Boolean']['output'];
  showCurrentSubject: Scalars['Boolean']['output'];
  showHolidays: Scalars['Boolean']['output'];
  showOriginalSubject: Scalars['Boolean']['output'];
  studentPassword: Scalars['String']['output'];
  teacherPassword: Scalars['String']['output'];
  /** time oder lessonName. */
  timeDisplayMode: Scalars['String']['output'];
  useClassShortname: Scalars['Boolean']['output'];
  useRoomShortname: Scalars['Boolean']['output'];
  useTeacherShortname: Scalars['Boolean']['output'];
  uuid: Scalars['ID']['output'];
};

export enum SubstitutionColumns {
  Class = 'class',
  Comment = 'comment',
  Lesson = 'lesson',
  Missing = 'missing',
  Original = 'original',
  Reason = 'reason',
  Room = 'room',
  Subject = 'subject',
  Teacher = 'teacher',
}

export type SubstitutionPrintColumnConfigInput = {
  column: SubstitutionColumns;
  position: Scalars['Int']['input'];
  print: Scalars['Boolean']['input'];
  sortDirection: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
  width: Scalars['Float']['input'];
};

export type SubstitutionPrintColumnConfigItem = {
  __typename?: 'SubstitutionPrintColumnConfigItem';
  column: SubstitutionColumns;
  position: Scalars['Int']['output'];
  print: Scalars['Boolean']['output'];
  /** ascending oder descending. */
  sortDirection: Scalars['String']['output'];
  /** 1 bis 3: Rang in der Sortierung des Plans; 0: sortiert nicht. */
  sortOrder: Scalars['Int']['output'];
  /** Breite in Prozent der Seitenbreite. */
  width: Scalars['Float']['output'];
};

export type SubstitutionPrintConfigInput = {
  /** Je Spalte höchstens ein Eintrag; ersetzt alle bisherigen. */
  columnConfigs: Array<SubstitutionPrintColumnConfigInput>;
  fontScale: Scalars['Float']['input'];
  lineScale: Scalars['Float']['input'];
  pageOrientation: Scalars['String']['input'];
  printImages: Scalars['Boolean']['input'];
  showAnnouncements: Scalars['Boolean']['input'];
  showMissingTeachers: Scalars['Boolean']['input'];
  showMissingTeachersShortName: Scalars['Boolean']['input'];
  showSchoolEvents: Scalars['Boolean']['input'];
  useLessonName: Scalars['Boolean']['input'];
  useTeacherShortname: Scalars['Boolean']['input'];
};

export type SubstitutionPrintConfigItem = {
  __typename?: 'SubstitutionPrintConfigItem';
  /** Nach position. */
  columnConfigs: Array<SubstitutionPrintColumnConfigItem>;
  fontScale: Scalars['Float']['output'];
  lineScale: Scalars['Float']['output'];
  /** portait oder landscape. */
  pageOrientation: Scalars['String']['output'];
  printImages: Scalars['Boolean']['output'];
  showAnnouncements: Scalars['Boolean']['output'];
  showMissingTeachers: Scalars['Boolean']['output'];
  showMissingTeachersShortName: Scalars['Boolean']['output'];
  showSchoolEvents: Scalars['Boolean']['output'];
  useLessonName: Scalars['Boolean']['output'];
  useTeacherShortname: Scalars['Boolean']['output'];
  uuid: Scalars['ID']['output'];
};

export enum SubstitutionReason {
  Aggregated = 'AGGREGATED',
  Cancelled = 'CANCELLED',
  Moved = 'MOVED',
  SelfWork = 'SELF_WORK',
  Substituted = 'SUBSTITUTED',
}

/** Ein erzeugter Vertretungs-Bericht (Statistik als PDF oder Excel) eines Schuljahres. */
export type SubstitutionReportItem = {
  __typename?: 'SubstitutionReportItem';
  fileEntries: Array<ReportFileEntryItem>;
  jobCreated?: Maybe<Scalars['DateTime']['output']>;
  jobFinished?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: SubstitutionReportType;
  uuid: Scalars['ID']['output'];
};

export enum SubstitutionReportType {
  StatisticExcel = 'statisticExcel',
  StatisticMonth = 'statisticMonth',
  StatisticTotal = 'statisticTotal',
}

/** Anbindung der Vertretungs-Software; beide Felder sind JSON-Texte (Iphis: Zugang zur Datenbank, VPO: Adresse). */
export type SubstitutionSoftwareSettings = {
  __typename?: 'SubstitutionSoftwareSettings';
  iphisSubstitutionProps?: Maybe<Scalars['String']['output']>;
  vpoSubstitutionProps?: Maybe<Scalars['String']['output']>;
};

export type SubstitutionSoftwareSettingsInput = {
  iphisSubstitutionProps?: InputMaybe<Scalars['String']['input']>;
  vpoSubstitutionProps?: InputMaybe<Scalars['String']['input']>;
};

export type TeacherSubstitutionStats = {
  __typename?: 'TeacherSubstitutionStats';
  givenSubstituteHours: Scalars['Float']['output'];
  sameClass?: Maybe<Scalars['Boolean']['output']>;
  sameSubject?: Maybe<Scalars['Boolean']['output']>;
  substituteHours?: Maybe<Scalars['Int']['output']>;
  teacherUuid: Scalars['ID']['output'];
};

export type TeacherTeachingLoad = {
  __typename?: 'TeacherTeachingLoad';
  countClasses: Scalars['Int']['output'];
  countTeacher: Scalars['Int']['output'];
  deputat: Scalars['Float']['output'];
  factor: Scalars['Float']['output'];
  lessonClass: Array<LessonClassInterface>;
  lessonClassesDisplayName: Scalars['String']['output'];
  lessonUuid: Scalars['String']['output'];
  organization: TeachingLoadOrganizationRefItem;
  partialClasses: Scalars['Boolean']['output'];
  relevantFactors: Array<TeachingLoadRelevantFactorItem>;
  schoolYear: TeachingLoadSchoolYearRefItem;
  studentCards?: Maybe<Scalars['Float']['output']>;
  studentHours?: Maybe<Scalars['Float']['output']>;
  subjectContainerDisplayName?: Maybe<Scalars['String']['output']>;
  subjectContainerUuid?: Maybe<Scalars['String']['output']>;
  subjectDisplayName: Scalars['String']['output'];
  subjectUuid: Scalars['String']['output'];
  teacherCards?: Maybe<Scalars['Float']['output']>;
  teacherDisplayName: Scalars['String']['output'];
  teacherHours?: Maybe<Scalars['Float']['output']>;
  teacherUuid: Scalars['String']['output'];
  teachingBlockWeeks?: Maybe<Scalars['Float']['output']>;
  teachingBlocks?: Maybe<Scalars['Float']['output']>;
  timetableBlockDisplayName?: Maybe<Scalars['String']['output']>;
  timetableBlockSortName?: Maybe<Scalars['String']['output']>;
  timetableBlockUuid?: Maybe<Scalars['String']['output']>;
};

/** Eine gesteckte Klassenfahrt-Karte aus der aktiven Version eines Epochenplans. */
export type TeachingBlockClassTripCard = {
  __typename?: 'TeachingBlockClassTripCard';
  cardUuid: Scalars['ID']['output'];
  /** Klassen der Zuordnung, jede einmal. */
  classes: Array<TeachingBlockClassTripClass>;
  endDate: Scalars['Date']['output'];
  /** Räume der Karte. */
  roomUuids: Array<Scalars['ID']['output']>;
  startDate: Scalars['Date']['output'];
  subjectContainerName: Scalars['String']['output'];
  subjectName: Scalars['String']['output'];
  subjectShortName: Scalars['String']['output'];
  /** Anwesende Lehrkräfte der Zuordnung. */
  teacherUuids: Array<Scalars['ID']['output']>;
  teachingBlockUuid: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
  versionUuid: Scalars['ID']['output'];
};

export type TeachingBlockClassTripClass = {
  __typename?: 'TeachingBlockClassTripClass';
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type TeachingBlockCurrentStatus = {
  __typename?: 'TeachingBlockCurrentStatus';
  currentFrom?: Maybe<Scalars['DateTime']['output']>;
  isCurrent: Scalars['Boolean']['output'];
  teachingBlockUuid: Scalars['ID']['output'];
};

export type TeachingBlockExclusionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['DateTime']['input'];
  holderType: TeachingBlockResourceType;
  holderUuid: Scalars['ID']['input'];
  priority: Scalars['Int']['input'];
  to: Scalars['DateTime']['input'];
};

/** Ein Epochenplan mit der Liste seiner Versionen. */
export type TeachingBlockItem = {
  __typename?: 'TeachingBlockItem';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** true, solange keine Version aktiv geschaltet wurde. */
  draft: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  schoolYearUuid: Scalars['ID']['output'];
  subjectContainerUuid: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  /** Versionen, höchste Versionsnummer zuerst. */
  versions: Array<TeachingBlockVersionListItem>;
};

export enum TeachingBlockResourceType {
  Class = 'CLASS',
  Room = 'ROOM',
  Subject = 'SUBJECT',
  Teacher = 'TEACHER',
}

export type TeachingBlockVersionCard = {
  __typename?: 'TeachingBlockVersionCard';
  /** Dauer in Wochen. */
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  includeHoliday: Scalars['Boolean']['output'];
  lessonUuid: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  /** Der Karte zugewiesene Räume. */
  roomUuids: Array<Scalars['ID']['output']>;
  /** Gesetzt, sobald die Karte gesteckt ist. */
  startDate?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Lesemodell einer Epochenplan-Version. Verweise sind uuids; die Stammdaten lädt das Frontend getrennt. */
export type TeachingBlockVersionData = {
  __typename?: 'TeachingBlockVersionData';
  /** Karten der Version, die an einer Zuordnung hängen; kürzeste zuerst. */
  cards: Array<TeachingBlockVersionCard>;
  exclusions: Array<TeachingBlockVersionExclusion>;
  meta: TeachingBlockVersionMeta;
  /** Klassen, Lehrkräfte, Räume und Fächer, die in die Version übernommen sind. */
  resources: Array<TeachingBlockVersionResource>;
};

export type TeachingBlockVersionExclusion = {
  __typename?: 'TeachingBlockVersionExclusion';
  comment?: Maybe<Scalars['String']['output']>;
  from: Scalars['DateTime']['output'];
  holderType: TeachingBlockResourceType;
  holderUuid: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  to: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type TeachingBlockVersionInput = {
  active: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
};

export type TeachingBlockVersionListItem = {
  __typename?: 'TeachingBlockVersionListItem';
  active: Scalars['Boolean']['output'];
  cardsCount: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  isSnapshot: Scalars['Boolean']['output'];
  /** Version, deren Momentaufnahme diese Version ist. */
  originalUuid?: Maybe<Scalars['ID']['output']>;
  /** Version, aus der diese Version dupliziert wurde. */
  parentUuid?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type TeachingBlockVersionMeta = {
  __typename?: 'TeachingBlockVersionMeta';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  isSnapshot: Scalars['Boolean']['output'];
  schoolYearUuid: Scalars['ID']['output'];
  subjectContainerUuid: Scalars['ID']['output'];
  teachingBlockDraft: Scalars['Boolean']['output'];
  teachingBlockName: Scalars['String']['output'];
  teachingBlockUuid: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
  versionUuid: Scalars['ID']['output'];
};

export type TeachingBlockVersionResource = {
  __typename?: 'TeachingBlockVersionResource';
  constraints?: Maybe<Scalars['String']['output']>;
  resourceType: TeachingBlockResourceType;
  uuid: Scalars['ID']['output'];
};

export type TeachingLoadFactorInput = {
  active: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  factorType: FactorType;
  gradeGroupUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  grades?: InputMaybe<Array<Scalars['Int']['input']>>;
  schoolYearUuid: Scalars['ID']['input'];
  studentsMax?: InputMaybe<Scalars['Int']['input']>;
  studentsMin?: InputMaybe<Scalars['Int']['input']>;
  studentsPartialMax?: InputMaybe<Scalars['Int']['input']>;
  studentsPartialMin?: InputMaybe<Scalars['Int']['input']>;
  subjectContainerUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjectUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeGridEntryUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  value: Scalars['Float']['input'];
  valueMode: ValueMode;
  valuePartial?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw?: InputMaybe<Scalars['String']['input']>;
  valueRaw: Scalars['String']['input'];
};

/**
 * Deputatsfaktor, wie ihn die handgeschriebenen Root-Felder liefern. Eine leere Liste bei einem Bezug heißt:
 * der Faktor gilt für alle (Fächer, Schienen, Klassenzüge, Stunden, Lehrkräfte bzw. Jahrgangsstufen).
 */
export type TeachingLoadFactorItem = {
  __typename?: 'TeachingLoadFactorItem';
  active: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  factorType: FactorType;
  gradeGroup: Array<TeachingLoadFactorRef>;
  grades: Array<Scalars['Int']['output']>;
  schoolYearUuid: Scalars['ID']['output'];
  studentsMax?: Maybe<Scalars['Int']['output']>;
  studentsMin?: Maybe<Scalars['Int']['output']>;
  studentsPartialMax?: Maybe<Scalars['Int']['output']>;
  studentsPartialMin?: Maybe<Scalars['Int']['output']>;
  /** Nach Name. */
  subject: Array<TeachingLoadFactorRef>;
  subjectContainer: Array<TeachingLoadFactorRef>;
  /** Nach Listenname. */
  teachers: Array<TeachingLoadFactorTeacherRef>;
  timeGridEntries: Array<TeachingLoadFactorRef>;
  uuid: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
  valueMode: ValueMode;
  valuePartial?: Maybe<Scalars['Float']['output']>;
  valuePartialRaw?: Maybe<Scalars['String']['output']>;
  valueRaw: Scalars['String']['output'];
};

/** Verweis eines Deputatsfaktors auf Fach, Schiene, Klassenzug oder Stunde des Stundenrasters. */
export type TeachingLoadFactorRef = {
  __typename?: 'TeachingLoadFactorRef';
  name: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TeachingLoadFactorTeacherRef = {
  __typename?: 'TeachingLoadFactorTeacherRef';
  listName: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Verweis auf eine Gruppe in einer Deputats-Zeile. */
export type TeachingLoadGroupRefItem = {
  __typename?: 'TeachingLoadGroupRefItem';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Verweis auf die Organisation in einer Deputats-Zeile. */
export type TeachingLoadOrganizationRefItem = {
  __typename?: 'TeachingLoadOrganizationRefItem';
  uuid: Scalars['ID']['output'];
};

/** Ein Faktor, der in die Berechnung einer Deputats-Zeile eingeht. */
export type TeachingLoadRelevantFactorItem = {
  __typename?: 'TeachingLoadRelevantFactorItem';
  comment?: Maybe<Scalars['String']['output']>;
  factorType: FactorType;
  studentsMax?: Maybe<Scalars['Int']['output']>;
  studentsMin?: Maybe<Scalars['Int']['output']>;
  studentsPartialMax?: Maybe<Scalars['Int']['output']>;
  studentsPartialMin?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
  valueMode: ValueMode;
  valuePartial?: Maybe<Scalars['Float']['output']>;
  valuePartialRaw?: Maybe<Scalars['String']['output']>;
  valueRaw: Scalars['String']['output'];
};

export type TeachingLoadReportConfigInput = {
  hidePaidTeachingLoad?: InputMaybe<Scalars['Boolean']['input']>;
  noAdditionalTeachingLoad?: InputMaybe<Scalars['Boolean']['input']>;
  roundTeachingLoadResult?: InputMaybe<Scalars['Int']['input']>;
};

/** Einstellungen eines Deputats-Berichtstyps. null in einem Feld heißt: Vorgabe des Berichtstyps. */
export type TeachingLoadReportConfigItem = {
  __typename?: 'TeachingLoadReportConfigItem';
  hidePaidTeachingLoad?: Maybe<Scalars['Boolean']['output']>;
  noAdditionalTeachingLoad?: Maybe<Scalars['Boolean']['output']>;
  roundTeachingLoadResult?: Maybe<Scalars['Int']['output']>;
  type: TeachingLoadReportType;
  uuid: Scalars['ID']['output'];
};

/** Ein erzeugter Deputats-Bericht (PDF oder Excel) mit dem, wofür er erzeugt wurde: Schuljahr, Zeitraum oder Epochenplan. */
export type TeachingLoadReportItem = {
  __typename?: 'TeachingLoadReportItem';
  /** Name des Schuljahres bzw. Epochenplans; bei einem Zeitraum die Namen seiner Stundenpläne. */
  contextName: Scalars['String']['output'];
  contextUuid: Scalars['ID']['output'];
  fileEntries: Array<ReportFileEntryItem>;
  jobCreated?: Maybe<Scalars['DateTime']['output']>;
  jobFinished?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: TeachingLoadReportType;
  uuid: Scalars['ID']['output'];
};

export enum TeachingLoadReportType {
  CurrentClass = 'currentClass',
  CurrentExcel = 'currentExcel',
  CurrentExcelBerlin = 'currentExcelBerlin',
  CurrentKeyFigures = 'currentKeyFigures',
  CurrentLeliste = 'currentLeliste',
  CurrentOverview = 'currentOverview',
  CurrentSingleTeacher = 'currentSingleTeacher',
  CurrentSubjectGroup = 'currentSubjectGroup',
  Curriculum = 'curriculum',
  Metrics = 'metrics',
  PlanClass = 'planClass',
  PlanExcel = 'planExcel',
  PlanExcelBerlin = 'planExcelBerlin',
  PlanKeyFigures = 'planKeyFigures',
  PlanLeliste = 'planLeliste',
  PlanOverview = 'planOverview',
  PlanSingleTeacher = 'planSingleTeacher',
  PlanSubjectGroup = 'planSubjectGroup',
}

/** Verweis auf das Schuljahr in einer Deputats-Zeile. */
export type TeachingLoadSchoolYearRefItem = {
  __typename?: 'TeachingLoadSchoolYearRefItem';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Eintrag eines Zeitrasters (Stunde oder Pause), wie ihn die handgeschriebenen Root-Felder liefern. */
export type TimeGridEntryItem = {
  __typename?: 'TimeGridEntryItem';
  end: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  /** Position innerhalb des Zeitrasters, chronologisch vergeben. */
  order: Scalars['Int']['output'];
  pause: Scalars['Boolean']['output'];
  print: Scalars['Boolean']['output'];
  reliable: Scalars['Boolean']['output'];
  shortName: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type TimeGridEntryMappingInput = {
  /** Stunde im bisherigen Zeitraster */
  fromTimeGridEntryUuid: Scalars['ID']['input'];
  /** Stunde im neuen Zeitraster */
  toTimeGridEntryUuid: Scalars['ID']['input'];
};

/** Verwendung eines Zeitraster-Eintrags in gesteckten Stundenplan-Karten. */
export type TimeGridEntryUsage = {
  __typename?: 'TimeGridEntryUsage';
  /** Gesteckte Karten (mit Wochentag), die in diesem Eintrag beginnen oder enden. */
  placedCardsCount: Scalars['Int']['output'];
  /** uuid des Eintrags. */
  uuid: Scalars['ID']['output'];
};

/** Vollständiger Stand eines Zeitrasters ohne seine Einträge; eine nicht gesetzte Beschreibung wird geleert. */
export type TimeGridInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Zeitraster, wie es die handgeschriebenen Root-Felder liefern. */
export type TimeGridItem = {
  __typename?: 'TimeGridItem';
  description: Scalars['String']['output'];
  /** Einträge des Zeitrasters, nach Beginn sortiert. */
  entries: Array<TimeGridEntryItem>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type TimetableBlockInput = {
  end: Scalars['Date']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  start: Scalars['Date']['input'];
  timetableUuids: Array<Scalars['ID']['input']>;
};

/** Ein Zeitraum des Schuljahres, in dem die genannten Stundenpläne gelten. */
export type TimetableBlockItem = {
  __typename?: 'TimetableBlockItem';
  end: Scalars['Date']['output'];
  /** Namen der Stundenpläne des Zeitraums, mit Komma getrennt. */
  name: Scalars['String']['output'];
  schoolYearUuid: Scalars['ID']['output'];
  start: Scalars['Date']['output'];
  teachingLoadCalculated?: Maybe<Scalars['Float']['output']>;
  teachingLoadComment?: Maybe<Scalars['String']['output']>;
  /** Anteil des Zeitraums am Deputat des Schuljahres (1 = 100 %). */
  teachingLoadFactor?: Maybe<Scalars['Float']['output']>;
  /** Stundenpläne des Zeitraums, nach Name. */
  timetables: Array<TimetableBlockTimetableItem>;
  uuid: Scalars['ID']['output'];
};

export type TimetableBlockRefItem = {
  __typename?: 'TimetableBlockRefItem';
  end: Scalars['Date']['output'];
  start: Scalars['Date']['output'];
  uuid: Scalars['ID']['output'];
};

export type TimetableBlockTimetableItem = {
  __typename?: 'TimetableBlockTimetableItem';
  activeVersionUuid?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Eine Karte einer Stundenplan-Version, schlank: für Dialoge, die die Karten einer Zuordnung anlegen und löschen. */
export type TimetableCardItem = {
  __typename?: 'TimetableCardItem';
  /** Dauer in Stunden, bei Karten einer Epochenschiene in Wochen. */
  duration?: Maybe<Scalars['Int']['output']>;
  endTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  lessonUuid: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  roomUuids: Array<Scalars['ID']['output']>;
  startTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  subjectContainerUuid?: Maybe<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
  /** mon bis sun; null, solange die Karte nicht gesteckt ist. */
  weekday?: Maybe<Scalars['String']['output']>;
};

/** Farb- und Druckeinstellungen eines Fachs, einer Klasse, einer Person oder eines Raums. */
export type TimetableConfigItem = {
  __typename?: 'TimetableConfigItem';
  color?: Maybe<Scalars['String']['output']>;
  colorLabel?: Maybe<Scalars['String']['output']>;
  printOrder?: Maybe<Scalars['Int']['output']>;
  printPageNr?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  /** Stundenraster in der Reihenfolge ihrer Raster-Zuordnungen; mindestens eines. */
  timegridUuids: Array<Scalars['ID']['input']>;
};

/** Ein Stundenplan mit seinen Raster-Zuordnungen, Versionen und Zeiträumen. */
export type TimetableItem = {
  __typename?: 'TimetableItem';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  draft: Scalars['Boolean']['output'];
  friEnabled: Scalars['Boolean']['output'];
  monEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  satEnabled: Scalars['Boolean']['output'];
  schoolYearUuid: Scalars['ID']['output'];
  sunEnabled: Scalars['Boolean']['output'];
  thuEnabled: Scalars['Boolean']['output'];
  /** Raster-Zuordnungen in ihrer Reihenfolge. */
  timegridConfigs: Array<TimetableTimegridConfigItem>;
  /** Zeiträume, in denen der Stundenplan gilt, nach Beginn. */
  timetableBlocks: Array<TimetableBlockRefItem>;
  tueEnabled: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  /** Versionen, höchste Versionsnummer zuerst. */
  versions: Array<TimetableVersionListItem>;
  wedEnabled: Scalars['Boolean']['output'];
};

export enum TimetablePrintColorOrigins {
  Class = 'class',
  None = 'none',
  Room = 'room',
  Subject = 'subject',
  Teacher = 'teacher',
}

export enum TimetablePrintColorPositions {
  Bottom = 'bottom',
  Full = 'full',
  Left = 'left',
  None = 'none',
  Right = 'right',
  Top = 'top',
}

export type TimetablePrintConfigInput = {
  bottomCenter?: InputMaybe<TimetablePrintLayoutOptions>;
  bottomLeft?: InputMaybe<TimetablePrintLayoutOptions>;
  bottomRight?: InputMaybe<TimetablePrintLayoutOptions>;
  center?: InputMaybe<TimetablePrintLayoutOptions>;
  epochGridOwnPage?: InputMaybe<Scalars['Boolean']['input']>;
  exactMinute?: InputMaybe<Scalars['Boolean']['input']>;
  largeFont?: InputMaybe<Scalars['Boolean']['input']>;
  printClasses?: InputMaybe<Scalars['Boolean']['input']>;
  printColorOrigin?: InputMaybe<TimetablePrintColorOrigins>;
  printColorPosition?: InputMaybe<TimetablePrintColorPositions>;
  printLogo?: InputMaybe<Scalars['Boolean']['input']>;
  printSubtitle?: InputMaybe<Scalars['Boolean']['input']>;
  responsiblePersonNameFormat?: InputMaybe<TimetablePrintPersonNameFormats>;
  scaleText?: InputMaybe<Scalars['Boolean']['input']>;
  showCalendarWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  showSchoolWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  showWeekSchoolDays?: InputMaybe<Scalars['Boolean']['input']>;
  timeHorizontal?: InputMaybe<Scalars['Boolean']['input']>;
  topCenter?: InputMaybe<TimetablePrintLayoutOptions>;
  topLeft?: InputMaybe<TimetablePrintLayoutOptions>;
  topRight?: InputMaybe<TimetablePrintLayoutOptions>;
};

/** Druck-Einstellungen eines Stundenplan-Berichtstyps. null in einem Feld heißt: Vorgabe des Berichtstyps. */
export type TimetablePrintConfigItem = {
  __typename?: 'TimetablePrintConfigItem';
  bottomCenter?: Maybe<TimetablePrintLayoutOptions>;
  bottomLeft?: Maybe<TimetablePrintLayoutOptions>;
  bottomRight?: Maybe<TimetablePrintLayoutOptions>;
  center?: Maybe<TimetablePrintLayoutOptions>;
  epochGridOwnPage?: Maybe<Scalars['Boolean']['output']>;
  exactMinute?: Maybe<Scalars['Boolean']['output']>;
  largeFont?: Maybe<Scalars['Boolean']['output']>;
  printClasses?: Maybe<Scalars['Boolean']['output']>;
  printColorOrigin?: Maybe<TimetablePrintColorOrigins>;
  printColorPosition?: Maybe<TimetablePrintColorPositions>;
  printLogo?: Maybe<Scalars['Boolean']['output']>;
  printSubtitle?: Maybe<Scalars['Boolean']['output']>;
  responsiblePersonNameFormat?: Maybe<TimetablePrintPersonNameFormats>;
  scaleText?: Maybe<Scalars['Boolean']['output']>;
  showCalendarWeeks?: Maybe<Scalars['Boolean']['output']>;
  showSchoolWeeks?: Maybe<Scalars['Boolean']['output']>;
  showWeekSchoolDays?: Maybe<Scalars['Boolean']['output']>;
  timeHorizontal?: Maybe<Scalars['Boolean']['output']>;
  topCenter?: Maybe<TimetablePrintLayoutOptions>;
  topLeft?: Maybe<TimetablePrintLayoutOptions>;
  topRight?: Maybe<TimetablePrintLayoutOptions>;
  type: TimetableReportType;
  uuid: Scalars['ID']['output'];
};

export enum TimetablePrintLayoutOptions {
  ClassAndGroup = 'classAndGroup',
  ClassName = 'className',
  Empty = 'empty',
  GroupName = 'groupName',
  RoomName = 'roomName',
  RoomNumber = 'roomNumber',
  SubjectClassAndGroup = 'subjectClassAndGroup',
  SubjectLong = 'subjectLong',
  SubjectShort = 'subjectShort',
  TeacherAndRoom = 'teacherAndRoom',
  /** Kurzname der Lehrkraft, z. B. Bauer, I. (bei gleichen Kurznamen eindeutig gemacht) */
  TeacherDisplayNameShort = 'teacherDisplayNameShort',
  /** Nachname der Lehrkraft, z. B. Bauer */
  TeacherLastName = 'teacherLastName',
  TeacherLong = 'teacherLong',
  TeacherShort = 'teacherShort',
}

/** Namensform einer Person im Druck, z. B. der Raumverantwortlichen auf dem Türschild. */
export enum TimetablePrintPersonNameFormats {
  /** Voller Name, z. B. Ida Bauer */
  DisplayName = 'displayName',
  /** Nachname und Initiale, z. B. Bauer, I. (bei gleichen Kurznamen eindeutig gemacht) */
  DisplayNameShort = 'displayNameShort',
  /** Nachname, z. B. Bauer */
  LastName = 'lastName',
  /** Kürzel, z. B. BAU */
  ShortName = 'shortName',
}

/** Ein erzeugter Stundenplan-Bericht (PDF) mit dem, wofür er erzeugt wurde: Schuljahr, Zeitraum oder Epochenplan. */
export type TimetableReportItem = {
  __typename?: 'TimetableReportItem';
  /** Name des Schuljahres bzw. Epochenplans; bei einem Zeitraum die Namen seiner Stundenpläne. */
  contextName: Scalars['String']['output'];
  contextUuid: Scalars['ID']['output'];
  fileEntries: Array<ReportFileEntryItem>;
  jobCreated?: Maybe<Scalars['DateTime']['output']>;
  jobFinished?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: TimetableReportType;
  uuid: Scalars['ID']['output'];
};

export enum TimetableReportType {
  AllClasses = 'allClasses',
  AllRooms = 'allRooms',
  AllSubjects = 'allSubjects',
  AllTeachers = 'allTeachers',
  AttendanceSchedule = 'attendanceSchedule',
  DoorSigns = 'doorSigns',
  SchoolTrips = 'schoolTrips',
  SingleClass = 'singleClass',
  SingleRoom = 'singleRoom',
  SingleSubject = 'singleSubject',
  SingleTeacher = 'singleTeacher',
  TeachingBlocksAllClasses = 'teachingBlocksAllClasses',
  TeachingBlocksAllClassesCombined = 'teachingBlocksAllClassesCombined',
  TeachingBlocksClass = 'teachingBlocksClass',
  TeachingBlocksRoom = 'teachingBlocksRoom',
  TeachingBlocksSubject = 'teachingBlocksSubject',
  TeachingBlocksTeacher = 'teachingBlocksTeacher',
}

export type TimetableTimegridConfigItem = {
  __typename?: 'TimetableTimegridConfigItem';
  classUuids: Array<Scalars['ID']['output']>;
  order: Scalars['Int']['output'];
  timegridUuid?: Maybe<Scalars['ID']['output']>;
};

export type TimetableVersionAvailability = {
  __typename?: 'TimetableVersionAvailability';
  fri?: Maybe<Scalars['String']['output']>;
  mon?: Maybe<Scalars['String']['output']>;
  resourceType: TimetableVersionResourceType;
  resourceUuid: Scalars['ID']['output'];
  sat?: Maybe<Scalars['String']['output']>;
  sun?: Maybe<Scalars['String']['output']>;
  thu?: Maybe<Scalars['String']['output']>;
  tue?: Maybe<Scalars['String']['output']>;
  wed?: Maybe<Scalars['String']['output']>;
};

/** Bitfield-Strings je Wochentag wie in TimetableVersionAvailability (0 = nein, 1 = ja, 2 = vielleicht). */
export type TimetableVersionAvailabilityInput = {
  fri?: InputMaybe<Scalars['String']['input']>;
  mon?: InputMaybe<Scalars['String']['input']>;
  sat?: InputMaybe<Scalars['String']['input']>;
  sun?: InputMaybe<Scalars['String']['input']>;
  thu?: InputMaybe<Scalars['String']['input']>;
  tue?: InputMaybe<Scalars['String']['input']>;
  wed?: InputMaybe<Scalars['String']['input']>;
};

export type TimetableVersionCard = {
  __typename?: 'TimetableVersionCard';
  /** Wiederverwendung des bestehenden Typs */
  classGridCards: Array<ClassGridCard>;
  classUuids: Array<Scalars['ID']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  groupUuids: Array<Scalars['ID']['output']>;
  isSubjectContainer: Scalars['Boolean']['output'];
  lessonClasses: Array<TimetableVersionLessonClass>;
  lessonIsElective: Scalars['Boolean']['output'];
  /** Raumvorrat der Lesson (IS_IN_ROOM) – für den Board-Raumvorrat, unabhängig von Editor-Daten */
  lessonRoomSupplyUuids: Array<Scalars['ID']['output']>;
  lessonUuid: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  roomUuids: Array<Scalars['ID']['output']>;
  someLessonClassIsFunctionalClass: Scalars['Boolean']['output'];
  startTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  /** nur bei isSubjectContainer: platzierte Cards der aktiven TB-Version */
  subjectContainerSlots: Array<TimetableVersionSubjectContainerSlot>;
  subjectUuid: Scalars['ID']['output'];
  /** present-Teacher der Lesson */
  teacherUuids: Array<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
  weekday?: Maybe<Scalars['String']['output']>;
};

export type TimetableVersionClass = {
  __typename?: 'TimetableVersionClass';
  color?: Maybe<Scalars['String']['output']>;
  colorLabel?: Maybe<Scalars['String']['output']>;
  defaultRoomUuid?: Maybe<Scalars['ID']['output']>;
  divisionUuids: Array<Scalars['ID']['output']>;
  grade?: Maybe<Scalars['Int']['output']>;
  gradeGroupUuid?: Maybe<Scalars['ID']['output']>;
  inVersion: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  sortName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Der Bedingungs-Blob (JSON) einer Ressource in einer Stundenplan-Version; null, solange keine Bedingungen gesetzt sind. */
export type TimetableVersionConstraints = {
  __typename?: 'TimetableVersionConstraints';
  constraints?: Maybe<Scalars['String']['output']>;
  resourceType: TimetableVersionResourceType;
  resourceUuid: Scalars['ID']['output'];
};

export type TimetableVersionData = {
  __typename?: 'TimetableVersionData';
  /** null wenn Version readonly ist (oder includeEditorData: false) */
  editor?: Maybe<TimetableVersionEditorData>;
  meta: TimetableVersionMeta;
  view: TimetableVersionViewData;
};

export type TimetableVersionDivision = {
  __typename?: 'TimetableVersionDivision';
  classUuid: Scalars['ID']['output'];
  /** Gruppen-UUIDs in order der Connection */
  groupUuids: Array<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableVersionEditorData = {
  __typename?: 'TimetableVersionEditorData';
  divisions: Array<TimetableVersionDivision>;
  lessons: Array<TimetableVersionLesson>;
};

export type TimetableVersionGroup = {
  __typename?: 'TimetableVersionGroup';
  classFraction?: Maybe<Scalars['Float']['output']>;
  divisionUuid?: Maybe<Scalars['ID']['output']>;
  entireClass?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableVersionInput = {
  active: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Schlanke Lesson für Dialoge/DnD im Editor (TimetableVersionEditorData.lessons) */
export type TimetableVersionLesson = {
  __typename?: 'TimetableVersionLesson';
  comment?: Maybe<Scalars['String']['output']>;
  elective?: Maybe<Scalars['Boolean']['output']>;
  isSubjectContainerLesson: Scalars['Boolean']['output'];
  lessonClasses: Array<TimetableVersionLessonClass>;
  lessonUnits: Array<TimetableVersionLessonUnit>;
  onlyInTimetableVersion?: Maybe<Scalars['Boolean']['output']>;
  /** roomSupply in Connection-Order */
  roomSupplyUuids: Array<Scalars['ID']['output']>;
  studentCount?: Maybe<Scalars['Int']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  subjectUuid: Scalars['ID']['output'];
  /** present-Teacher in Connection-Order */
  teacherUuids: Array<Scalars['ID']['output']>;
  timetableEnabled?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableVersionLessonClass = {
  __typename?: 'TimetableVersionLessonClass';
  classUuid: Scalars['ID']['output'];
  groupUuids: Array<Scalars['ID']['output']>;
  usedDivisionUuid?: Maybe<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableVersionLessonData = {
  __typename?: 'TimetableVersionLessonData';
  lessons: Array<VersionLessonRow>;
};

/** Geteilt zwischen TimetableVersionLesson und VersionLessonRow */
export type TimetableVersionLessonUnit = {
  __typename?: 'TimetableVersionLessonUnit';
  count?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  subjectContainerUuid?: Maybe<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableVersionListItem = {
  __typename?: 'TimetableVersionListItem';
  active: Scalars['Boolean']['output'];
  cardsCount: Scalars['Int']['output'];
  /** Klassen, die in die Version übernommen sind. */
  classUuids: Array<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  isSnapshot: Scalars['Boolean']['output'];
  /** Version, deren Momentaufnahme diese Version ist. */
  originalUuid?: Maybe<Scalars['ID']['output']>;
  /** Version, aus der diese Version dupliziert wurde. */
  parentUuid?: Maybe<Scalars['ID']['output']>;
  placedCardsCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type TimetableVersionMeta = {
  __typename?: 'TimetableVersionMeta';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  generating?: Maybe<Scalars['Boolean']['output']>;
  isSnapshot: Scalars['Boolean']['output'];
  schoolYearUuid: Scalars['ID']['output'];
  timegridUuid?: Maybe<Scalars['ID']['output']>;
  /** timetableActive im FE == !draft */
  timetableDraft: Scalars['Boolean']['output'];
  timetableName: Scalars['String']['output'];
  timetableUuid: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
  versionUuid: Scalars['ID']['output'];
};

/**
 * Verfügbarkeit einer in die Stundenplan-Version aufgenommenen Ressource (Bitfield je Wochentag: 0 = nein, 1 = ja,
 * 2 = vielleicht). Eigener Typ neben TimetableVersionAvailability: das Lesemodell timetableVersionData soll im Client
 * nicht verworfen werden, wenn sich eine Verfügbarkeit ändert.
 */
export type TimetableVersionResourceAvailability = {
  __typename?: 'TimetableVersionResourceAvailability';
  fri?: Maybe<Scalars['String']['output']>;
  mon?: Maybe<Scalars['String']['output']>;
  resourceType: TimetableVersionResourceType;
  resourceUuid: Scalars['ID']['output'];
  sat?: Maybe<Scalars['String']['output']>;
  sun?: Maybe<Scalars['String']['output']>;
  thu?: Maybe<Scalars['String']['output']>;
  tue?: Maybe<Scalars['String']['output']>;
  wed?: Maybe<Scalars['String']['output']>;
};

export enum TimetableVersionResourceType {
  Class = 'CLASS',
  Room = 'ROOM',
  Subject = 'SUBJECT',
  Teacher = 'TEACHER',
}

export type TimetableVersionRoom = {
  __typename?: 'TimetableVersionRoom';
  classroom?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  roomNumber?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableVersionSubject = {
  __typename?: 'TimetableVersionSubject';
  active?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  defaultRoomUuids: Array<Scalars['ID']['output']>;
  epochEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  subjectHourEnabled?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableVersionSubjectContainer = {
  __typename?: 'TimetableVersionSubjectContainer';
  color?: Maybe<Scalars['String']['output']>;
  gradeGroupUuid?: Maybe<Scalars['ID']['output']>;
  grades?: Maybe<Array<Scalars['Int']['output']>>;
  name: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Belegungs-Slot aus aktiver TeachingBlockVersion (für SubjectContainer-Cards) */
export type TimetableVersionSubjectContainerSlot = {
  __typename?: 'TimetableVersionSubjectContainerSlot';
  endDate?: Maybe<Scalars['Date']['output']>;
  roomUuids: Array<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  teacherUuids: Array<Scalars['ID']['output']>;
};

export type TimetableVersionTeacher = {
  __typename?: 'TimetableVersionTeacher';
  active: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  defaultRoomUuid?: Maybe<Scalars['ID']['output']>;
  displayNameShort?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableVersionTimeGridEntry = {
  __typename?: 'TimetableVersionTimeGridEntry';
  end: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  pause?: Maybe<Scalars['Boolean']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type TimetableVersionViewData = {
  __typename?: 'TimetableVersionViewData';
  /** auch readonly: Matrizen im /Data-Bereich zeigen Verfügbarkeiten an */
  availabilities: Array<TimetableVersionAvailability>;
  cards: Array<TimetableVersionCard>;
  classes: Array<TimetableVersionClass>;
  groups: Array<TimetableVersionGroup>;
  rooms: Array<TimetableVersionRoom>;
  subjectContainers: Array<TimetableVersionSubjectContainer>;
  subjects: Array<TimetableVersionSubject>;
  teachers: Array<TimetableVersionTeacher>;
  timeGridEntries: Array<TimetableVersionTimeGridEntry>;
};

export type UpdateAbsenceInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<AbsenceReason>;
  removeSubstitutions?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateResponse = {
  __typename?: 'UpdateResponse';
  nodeUuids: Array<Scalars['String']['output']>;
  nodesUpdated: Scalars['Int']['output'];
};

export type UpdateTimeGridEntryInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  print?: InputMaybe<Scalars['Boolean']['input']>;
  reliable?: InputMaybe<Scalars['Boolean']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum UserStatus {
  Full = 'full',
  ImpersonateOnly = 'impersonateOnly',
  Invited = 'invited',
  None = 'none',
}

export enum ValueMode {
  Lesson = 'LESSON',
  UnitCount = 'UNIT_COUNT',
  UnitDurationCount = 'UNIT_DURATION_COUNT',
}

/**
 * Eine aktive Version, die gerade korrigiert wird (veröffentlichter Plan, bearbeitbar, mit Sicherung). Der Termin-Abgleich
 * hält ihre Tage zurück, bis die Korrektur abgeschlossen ist.
 */
export type VersionInCorrection = {
  __typename?: 'VersionInCorrection';
  description?: Maybe<Scalars['String']['output']>;
  /** Erster und letzter betroffener Tag ab heute (Abschnitte bzw. Epochen-Karten). */
  from?: Maybe<Scalars['Date']['output']>;
  /** Offene Tage des Termin-Abgleichs, die wegen dieser Korrektur warten. */
  heldDays: Scalars['Int']['output'];
  kind: VersionInCorrectionKind;
  planName: Scalars['String']['output'];
  /** Stundenplan bzw. Epochenplan. */
  planUuid: Scalars['ID']['output'];
  /** Beginn der Korrektur (jüngste Sicherung). */
  since: Scalars['DateTime']['output'];
  to?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Int']['output'];
  versionUuid: Scalars['ID']['output'];
};

/** Art einer Version in Korrektur. */
export enum VersionInCorrectionKind {
  TeachingBlock = 'TEACHING_BLOCK',
  Timetable = 'TIMETABLE',
}

/** Eine Zeile der TimetableVersionLessonsTable – server-seitig fertig gejoint/sortiert */
export type VersionLessonRow = {
  __typename?: 'VersionLessonRow';
  cardsCount: Scalars['Int']['output'];
  classSort?: Maybe<Scalars['String']['output']>;
  classUuids: Array<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  elective?: Maybe<Scalars['Boolean']['output']>;
  groupClassNames?: Maybe<Scalars['String']['output']>;
  groupUuids: Array<Scalars['ID']['output']>;
  /** Status-Ampel der Tabelle (getStatus) – server-seitig vorberechnen, wenn günstig */
  inActiveTimetable: Scalars['Boolean']['output'];
  isClassTrip?: Maybe<Scalars['Boolean']['output']>;
  isSubjectContainerLesson: Scalars['Boolean']['output'];
  lessonUnits: Array<TimetableVersionLessonUnit>;
  onlyInTimetableVersion?: Maybe<Scalars['Boolean']['output']>;
  placedCardsCount: Scalars['Int']['output'];
  roomUuids: Array<Scalars['ID']['output']>;
  studentCount?: Maybe<Scalars['Int']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  subjectName?: Maybe<Scalars['String']['output']>;
  subjectUuid: Scalars['ID']['output'];
  teacherUuids: Array<Scalars['ID']['output']>;
  teachersSort?: Maybe<Scalars['String']['output']>;
  teachingLoadEnabled?: Maybe<Scalars['Boolean']['output']>;
  timetableEnabled?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
};

export type AbsenceEntryFragment = {
  __typename?: 'AbsenceEntry';
  uuid: string;
  personUuid: string;
  personListName: string;
  reason: AbsenceReason;
  start: string;
  end: string;
  comment?: string | null;
};

export type AbsencesQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;

export type AbsencesQuery = {
  __typename?: 'Query';
  absencesInRange: Array<{
    __typename?: 'AbsenceEntry';
    uuid: string;
    personUuid: string;
    personListName: string;
    reason: AbsenceReason;
    start: string;
    end: string;
    comment?: string | null;
  }>;
};

export type AbsenceQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type AbsenceQuery = {
  __typename?: 'Query';
  absence?: {
    __typename?: 'AbsenceEntry';
    uuid: string;
    personUuid: string;
    personListName: string;
    reason: AbsenceReason;
    start: string;
    end: string;
    comment?: string | null;
  } | null;
};

export type CreateAbsenceMutationVariables = Exact<{
  input: CreateAbsenceInput;
}>;

export type CreateAbsenceMutation = {
  __typename?: 'Mutation';
  createAbsence: { __typename?: 'CreateResponse'; nodeUuids: Array<string> };
};

export type DeleteAbsenceMutationVariables = Exact<{
  input: OnlyUuids;
  removeSubstitutions: Scalars['Boolean']['input'];
}>;

export type DeleteAbsenceMutation = {
  __typename?: 'Mutation';
  deleteAbsence: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateAbsenceMutationVariables = Exact<{
  input: OnlyUuids;
  update: UpdateAbsenceInput;
}>;

export type UpdateAbsenceMutation = {
  __typename?: 'Mutation';
  updateAbsence: { __typename?: 'UpdateResponse'; nodeUuids: Array<string> };
};

export type SchoolEventLessonSyncsQueryVariables = Exact<{ [key: string]: never }>;

export type SchoolEventLessonSyncsQuery = {
  __typename?: 'Query';
  schoolEventLessonSyncs: Array<{
    __typename?: 'SchoolEventLessonSyncItem';
    uuid: string;
    oldFootprints: string;
    newFootprints: string;
    attempts: number;
    lastError?: string | null;
    lastAttemptAt?: string | null;
    createdAt: string;
  }>;
};

export type RetrySchoolEventLessonSyncsMutationVariables = Exact<{ [key: string]: never }>;

export type RetrySchoolEventLessonSyncsMutation = {
  __typename?: 'Mutation';
  retrySchoolEventLessonSyncs: { __typename?: 'SchoolEventLessonSyncRetryResult'; processed: number; pending: number };
};

export type DeleteSchoolEventLessonSyncMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteSchoolEventLessonSyncMutation = {
  __typename?: 'Mutation';
  deleteSchoolEventLessonSync: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type CreateBuildingsMutationVariables = Exact<{
  input: BuildingInput;
}>;

export type CreateBuildingsMutation = {
  __typename?: 'Mutation';
  createBuilding: {
    __typename?: 'BuildingItem';
    uuid: string;
    name: string;
    description?: string | null;
    active?: boolean | null;
  };
};

export type UpdateBuildingsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: BuildingInput;
}>;

export type UpdateBuildingsMutation = {
  __typename?: 'Mutation';
  updateBuilding: {
    __typename?: 'BuildingItem';
    uuid: string;
    name: string;
    description?: string | null;
    active?: boolean | null;
  };
};

export type DeleteBuildingsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteBuildingsMutation = {
  __typename?: 'Mutation';
  deleteBuilding: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type BuildingsListQueryVariables = Exact<{ [key: string]: never }>;

export type BuildingsListQuery = {
  __typename?: 'Query';
  buildings: Array<{
    __typename?: 'BuildingItem';
    uuid: string;
    name: string;
    description?: string | null;
    active?: boolean | null;
  }>;
};

export type DeleteClassesMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteClassesMutation = {
  __typename?: 'Mutation';
  deleteClass: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateClassesMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: ClassInput;
}>;

export type UpdateClassesMutation = {
  __typename?: 'Mutation';
  updateClass: { __typename?: 'ClassItem'; uuid: string };
};

export type CreateClassMutationVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
  input: ClassInput;
}>;

export type CreateClassMutation = { __typename?: 'Mutation'; createClass: { __typename?: 'ClassItem'; uuid: string } };

export type _UpdateClassesColorsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  color: Scalars['String']['input'];
}>;

export type _UpdateClassesColorsMutation = {
  __typename?: 'Mutation';
  setClassColor: { __typename?: 'ClassItem'; uuid: string };
};

export type _UpdateClassesAttendancePlanShowInSubstitutionPlanMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  functionalClassSubstitutionBehavior?: InputMaybe<FunctionalClassSubstitutionBehavior>;
}>;

export type _UpdateClassesAttendancePlanShowInSubstitutionPlanMutation = {
  __typename?: 'Mutation';
  setClassSubstitutionBehavior: { __typename?: 'ClassItem'; uuid: string };
};

export type ClassesListQueryVariables = Exact<{
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ClassesListQuery = {
  __typename?: 'Query';
  classes: Array<{
    __typename?: 'ClassItem';
    uuid: string;
    name: string;
    shortName: string;
    grade?: number | null;
    studentCount?: number | null;
    defaultRoomUuid?: string | null;
    schoolYearUuid?: string | null;
    certificatesEnabled?: boolean | null;
    tutorUuids: Array<string>;
    divisions: Array<{
      __typename?: 'ClassDivisionItem';
      uuid: string;
      name: string;
      groups: Array<{
        __typename?: 'ClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
    }>;
    gradeGroup?: { __typename?: 'GradeGroupRefItem'; uuid: string; name: string; shortName: string } | null;
    timetableConfig?: {
      __typename?: 'TimetableConfigItem';
      color?: string | null;
      colorLabel?: string | null;
      printOrder?: number | null;
      printPageNr?: number | null;
    } | null;
  }>;
  people: Array<{
    __typename?: 'PersonItem';
    uuid: string;
    firstName: string;
    lastName: string;
    fullName: string;
    displayNameShort: string;
    selectName: string;
  }>;
};

export type ClassByUuidQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type ClassByUuidQuery = {
  __typename?: 'Query';
  class?: { __typename?: 'ClassItem'; uuid: string; name: string } | null;
};

export type CreateCurriculumVersionMutationVariables = Exact<{
  input: CurriculumVersionInput;
}>;

export type CreateCurriculumVersionMutation = {
  __typename?: 'Mutation';
  createCurriculumVersion: {
    __typename?: 'CurriculumVersionItem';
    uuid: string;
    name: string;
    description?: string | null;
    curriculaCount: number;
  };
};

export type UpdateCurriculumVersionMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: CurriculumVersionInput;
}>;

export type UpdateCurriculumVersionMutation = {
  __typename?: 'Mutation';
  updateCurriculumVersion: {
    __typename?: 'CurriculumVersionItem';
    uuid: string;
    name: string;
    description?: string | null;
    curriculaCount: number;
  };
};

export type DeleteCurriculumVersionMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteCurriculumVersionMutation = {
  __typename?: 'Mutation';
  deleteCurriculumVersion: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type CreateCurriculumMutationVariables = Exact<{
  curriculumVersionUuid: Scalars['ID']['input'];
  input: CurriculumInput;
}>;

export type CreateCurriculumMutation = {
  __typename?: 'Mutation';
  createCurriculum: {
    __typename: 'CurriculumItem';
    uuid: string;
    curriculumVersionUuid: string;
    subTitle?: string | null;
    comment?: string | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    timetableEnabled?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    groupGradeNames: Array<string>;
    subject: {
      __typename?: 'CurriculumSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      grades: Array<number>;
    };
    persons: Array<{
      __typename?: 'CurriculumPersonItem';
      uuid: string;
      name?: string | null;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    curriculumGrades: Array<{
      __typename?: 'CurriculumGradeItem';
      uuid: string;
      grades: Array<number>;
      gradeGroups: Array<{ __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string }>;
      groups: Array<{
        __typename?: 'CurriculumGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      plannedClasses: Array<{
        __typename?: 'CurriculumPlannedClassItem';
        grade: number;
        name: string;
        shortName: string;
        gradeGroup?: { __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        groups: Array<{ __typename?: 'CurriculumPlannedGroupItem'; uuid: string; name: string; shortName: string }>;
      }>;
    }>;
    curriculumUnits: Array<{
      __typename?: 'CurriculumUnitItem';
      uuid: string;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'CurriculumUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'CurriculumRoomItem';
      roomUuid: string;
      descriptions?: string | null;
      order: number;
    }>;
    labels: Array<{ __typename?: 'CurriculumLabelItem'; uuid: string; color?: string | null; name: string }>;
    plannedLessons: Array<{
      __typename?: 'CurriculumPlannedLessonItem';
      uuid: string;
      classes: Array<{
        __typename?: 'CurriculumPlannedClassItem';
        grade: number;
        name: string;
        shortName: string;
        gradeGroup?: { __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        groups: Array<{ __typename?: 'CurriculumPlannedGroupItem'; uuid: string; name: string; shortName: string }>;
      }>;
    }>;
    lessons: Array<{ __typename?: 'CurriculumLessonRefItem'; uuid: string; schoolYearUuid?: string | null }>;
  };
};

export type UpdateCurriculumMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: CurriculumInput;
}>;

export type UpdateCurriculumMutation = {
  __typename?: 'Mutation';
  updateCurriculum: {
    __typename: 'CurriculumItem';
    uuid: string;
    curriculumVersionUuid: string;
    subTitle?: string | null;
    comment?: string | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    timetableEnabled?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    groupGradeNames: Array<string>;
    subject: {
      __typename?: 'CurriculumSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      grades: Array<number>;
    };
    persons: Array<{
      __typename?: 'CurriculumPersonItem';
      uuid: string;
      name?: string | null;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    curriculumGrades: Array<{
      __typename?: 'CurriculumGradeItem';
      uuid: string;
      grades: Array<number>;
      gradeGroups: Array<{ __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string }>;
      groups: Array<{
        __typename?: 'CurriculumGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      plannedClasses: Array<{
        __typename?: 'CurriculumPlannedClassItem';
        grade: number;
        name: string;
        shortName: string;
        gradeGroup?: { __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        groups: Array<{ __typename?: 'CurriculumPlannedGroupItem'; uuid: string; name: string; shortName: string }>;
      }>;
    }>;
    curriculumUnits: Array<{
      __typename?: 'CurriculumUnitItem';
      uuid: string;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'CurriculumUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'CurriculumRoomItem';
      roomUuid: string;
      descriptions?: string | null;
      order: number;
    }>;
    labels: Array<{ __typename?: 'CurriculumLabelItem'; uuid: string; color?: string | null; name: string }>;
    plannedLessons: Array<{
      __typename?: 'CurriculumPlannedLessonItem';
      uuid: string;
      classes: Array<{
        __typename?: 'CurriculumPlannedClassItem';
        grade: number;
        name: string;
        shortName: string;
        gradeGroup?: { __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        groups: Array<{ __typename?: 'CurriculumPlannedGroupItem'; uuid: string; name: string; shortName: string }>;
      }>;
    }>;
    lessons: Array<{ __typename?: 'CurriculumLessonRefItem'; uuid: string; schoolYearUuid?: string | null }>;
  };
};

export type SetCurriculaFlagMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  flag: CurriculumFlag;
  value: Scalars['Boolean']['input'];
}>;

export type SetCurriculaFlagMutation = {
  __typename?: 'Mutation';
  setCurriculaFlag: Array<{
    __typename?: 'CurriculumItem';
    uuid: string;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
  }>;
};

export type DeleteCurriculaMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteCurriculaMutation = {
  __typename?: 'Mutation';
  deleteCurricula: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type CreateLessonsFromCurriculaMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  curriculumUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type CreateLessonsFromCurriculaMutation = {
  __typename?: 'Mutation';
  createLessonsFromCurricula: {
    __typename?: 'CreateLessonsFromCurriculaResult';
    createdLessonUuids: Array<string>;
    skipped: Array<{ __typename?: 'CurriculumImportSkip'; curriculumUuid: string; reason: CurriculumImportSkipReason }>;
    failed: Array<{ __typename?: 'CurriculumImportFailure'; curriculumUuid: string; error: string }>;
  };
};

export type CurriculumVersionsListQueryVariables = Exact<{ [key: string]: never }>;

export type CurriculumVersionsListQuery = {
  __typename?: 'Query';
  curriculumVersions: Array<{
    __typename?: 'CurriculumVersionItem';
    uuid: string;
    name: string;
    description?: string | null;
    curriculaCount: number;
  }>;
};

export type CurriculaListQueryVariables = Exact<{
  curriculumVersionUuid?: InputMaybe<Scalars['ID']['input']>;
  subjectUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CurriculaListQuery = {
  __typename?: 'Query';
  curricula: Array<{
    __typename: 'CurriculumItem';
    uuid: string;
    curriculumVersionUuid: string;
    subTitle?: string | null;
    comment?: string | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    timetableEnabled?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    groupGradeNames: Array<string>;
    subject: {
      __typename?: 'CurriculumSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      grades: Array<number>;
    };
    persons: Array<{
      __typename?: 'CurriculumPersonItem';
      uuid: string;
      name?: string | null;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    curriculumGrades: Array<{
      __typename?: 'CurriculumGradeItem';
      uuid: string;
      grades: Array<number>;
      gradeGroups: Array<{ __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string }>;
      groups: Array<{
        __typename?: 'CurriculumGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      plannedClasses: Array<{
        __typename?: 'CurriculumPlannedClassItem';
        grade: number;
        name: string;
        shortName: string;
        gradeGroup?: { __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        groups: Array<{ __typename?: 'CurriculumPlannedGroupItem'; uuid: string; name: string; shortName: string }>;
      }>;
    }>;
    curriculumUnits: Array<{
      __typename?: 'CurriculumUnitItem';
      uuid: string;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'CurriculumUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'CurriculumRoomItem';
      roomUuid: string;
      descriptions?: string | null;
      order: number;
    }>;
    labels: Array<{ __typename?: 'CurriculumLabelItem'; uuid: string; color?: string | null; name: string }>;
    plannedLessons: Array<{
      __typename?: 'CurriculumPlannedLessonItem';
      uuid: string;
      classes: Array<{
        __typename?: 'CurriculumPlannedClassItem';
        grade: number;
        name: string;
        shortName: string;
        gradeGroup?: { __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        groups: Array<{ __typename?: 'CurriculumPlannedGroupItem'; uuid: string; name: string; shortName: string }>;
      }>;
    }>;
    lessons: Array<{ __typename?: 'CurriculumLessonRefItem'; uuid: string; schoolYearUuid?: string | null }>;
  }>;
};

export type CurriculaLessonStatusQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  curriculumUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type CurriculaLessonStatusQuery = {
  __typename?: 'Query';
  curriculaLessonStatus: Array<{
    __typename?: 'CurriculumLessonStatus';
    curriculumUuid: string;
    existing: number;
    possible: number;
    canImport: boolean;
  }>;
};

export type DependencyItemFragment = {
  __typename: 'DependencyItem';
  uuid: string;
  alias: string;
  priority: DependencyPriority;
  comment?: string | null;
  active: boolean;
  otherData?: string | null;
  subjects: Array<{ __typename?: 'DependencyResourceItem'; uuid: string; name: string; shortName: string }>;
  classes: Array<{ __typename?: 'DependencyResourceItem'; uuid: string; name: string; shortName: string }>;
};

export type DependenciesForVersionQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type DependenciesForVersionQuery = {
  __typename?: 'Query';
  dependenciesForVersion: Array<{
    __typename: 'DependencyItem';
    uuid: string;
    alias: string;
    priority: DependencyPriority;
    comment?: string | null;
    active: boolean;
    otherData?: string | null;
    subjects: Array<{ __typename?: 'DependencyResourceItem'; uuid: string; name: string; shortName: string }>;
    classes: Array<{ __typename?: 'DependencyResourceItem'; uuid: string; name: string; shortName: string }>;
  }>;
};

export type CreateDependencyMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  input: DependencyInput;
}>;

export type CreateDependencyMutation = {
  __typename?: 'Mutation';
  createDependency: {
    __typename: 'DependencyItem';
    uuid: string;
    alias: string;
    priority: DependencyPriority;
    comment?: string | null;
    active: boolean;
    otherData?: string | null;
    subjects: Array<{ __typename?: 'DependencyResourceItem'; uuid: string; name: string; shortName: string }>;
    classes: Array<{ __typename?: 'DependencyResourceItem'; uuid: string; name: string; shortName: string }>;
  };
};

export type UpdateDependencyMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: DependencyInput;
}>;

export type UpdateDependencyMutation = {
  __typename?: 'Mutation';
  updateDependency: {
    __typename: 'DependencyItem';
    uuid: string;
    alias: string;
    priority: DependencyPriority;
    comment?: string | null;
    active: boolean;
    otherData?: string | null;
    subjects: Array<{ __typename?: 'DependencyResourceItem'; uuid: string; name: string; shortName: string }>;
    classes: Array<{ __typename?: 'DependencyResourceItem'; uuid: string; name: string; shortName: string }>;
  };
};

export type SetDependencyActiveMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;

export type SetDependencyActiveMutation = {
  __typename?: 'Mutation';
  setDependencyActive: {
    __typename: 'DependencyItem';
    uuid: string;
    alias: string;
    priority: DependencyPriority;
    comment?: string | null;
    active: boolean;
    otherData?: string | null;
    subjects: Array<{ __typename?: 'DependencyResourceItem'; uuid: string; name: string; shortName: string }>;
    classes: Array<{ __typename?: 'DependencyResourceItem'; uuid: string; name: string; shortName: string }>;
  };
};

export type DeleteDependencyMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteDependencyMutation = {
  __typename?: 'Mutation';
  deleteDependency: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type ListPlannedTeacherTeachingLoadQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListPlannedTeacherTeachingLoadQuery = {
  __typename?: 'Query';
  plannedTeachingLoadByTeacher: Array<{
    __typename?: 'TeacherTeachingLoad';
    teacherUuid: string;
    teacherDisplayName: string;
    lessonUuid: string;
    subjectUuid: string;
    subjectDisplayName: string;
    subjectContainerUuid?: string | null;
    subjectContainerDisplayName?: string | null;
    partialClasses: boolean;
    lessonClassesDisplayName: string;
    countClasses: number;
    countTeacher: number;
    studentCards?: number | null;
    teacherCards?: number | null;
    studentHours?: number | null;
    teacherHours?: number | null;
    teachingBlockWeeks?: number | null;
    teachingBlocks?: number | null;
    factor: number;
    deputat: number;
    organization: { __typename?: 'TeachingLoadOrganizationRefItem'; uuid: string };
    schoolYear: { __typename?: 'TeachingLoadSchoolYearRefItem'; uuid: string; name: string };
    lessonClass: Array<{
      __typename?: 'LessonClassInterface';
      class: {
        __typename?: 'ClassInterface';
        uuid: string;
        grade?: number | null;
        gradeGroup?: { __typename?: 'GradeGroupRefItem'; uuid: string; name: string; shortName: string } | null;
      };
      groups: Array<{ __typename?: 'TeachingLoadGroupRefItem'; uuid: string; name: string; shortName: string }>;
    }>;
    relevantFactors: Array<{
      __typename?: 'TeachingLoadRelevantFactorItem';
      uuid: string;
      factorType: FactorType;
      value: number;
      valueRaw: string;
      valuePartial?: number | null;
      valuePartialRaw?: string | null;
      valueMode: ValueMode;
      studentsMin?: number | null;
      studentsMax?: number | null;
      studentsPartialMin?: number | null;
      studentsPartialMax?: number | null;
      comment?: string | null;
    }>;
  }>;
};

export type ListTeacherTeachingLoadQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  timetableBlockUuid: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListTeacherTeachingLoadQuery = {
  __typename?: 'Query';
  teachingLoadByTeacher: Array<{
    __typename?: 'TeacherTeachingLoad';
    teacherUuid: string;
    teacherDisplayName: string;
    subjectUuid: string;
    subjectDisplayName: string;
    subjectContainerUuid?: string | null;
    subjectContainerDisplayName?: string | null;
    partialClasses: boolean;
    lessonClassesDisplayName: string;
    countClasses: number;
    countTeacher: number;
    studentCards?: number | null;
    teacherCards?: number | null;
    studentHours?: number | null;
    teacherHours?: number | null;
    teachingBlockWeeks?: number | null;
    teachingBlocks?: number | null;
    factor: number;
    deputat: number;
    timetableBlockUuid?: string | null;
    timetableBlockDisplayName?: string | null;
    timetableBlockSortName?: string | null;
    organization: { __typename?: 'TeachingLoadOrganizationRefItem'; uuid: string };
    schoolYear: { __typename?: 'TeachingLoadSchoolYearRefItem'; uuid: string; name: string };
    lessonClass: Array<{
      __typename?: 'LessonClassInterface';
      class: {
        __typename?: 'ClassInterface';
        uuid: string;
        grade?: number | null;
        gradeGroup?: { __typename?: 'GradeGroupRefItem'; uuid: string; name: string; shortName: string } | null;
      };
      groups: Array<{ __typename?: 'TeachingLoadGroupRefItem'; uuid: string; name: string; shortName: string }>;
    }>;
    relevantFactors: Array<{
      __typename?: 'TeachingLoadRelevantFactorItem';
      uuid: string;
      factorType: FactorType;
      value: number;
      valueRaw: string;
      valuePartial?: number | null;
      valuePartialRaw?: string | null;
      valueMode: ValueMode;
      studentsMin?: number | null;
      studentsMax?: number | null;
      studentsPartialMin?: number | null;
      studentsPartialMax?: number | null;
      comment?: string | null;
    }>;
  }>;
};

export type CreateDivisionMutationVariables = Exact<{
  classUuid?: InputMaybe<Scalars['ID']['input']>;
  input: DivisionInput;
}>;

export type CreateDivisionMutation = {
  __typename?: 'Mutation';
  createDivision: {
    __typename: 'DivisionItem';
    uuid: string;
    name: string;
    class?: { __typename: 'DivisionClassItem'; uuid: string } | null;
    groups: Array<{
      __typename: 'GroupItem';
      uuid: string;
      name: string;
      shortName: string;
      studentCount?: number | null;
      order: number;
    }>;
  };
};

export type UpdateDivisionMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: DivisionInput;
}>;

export type UpdateDivisionMutation = {
  __typename?: 'Mutation';
  updateDivision: {
    __typename: 'DivisionItem';
    uuid: string;
    name: string;
    class?: { __typename: 'DivisionClassItem'; uuid: string } | null;
    groups: Array<{
      __typename: 'GroupItem';
      uuid: string;
      name: string;
      shortName: string;
      studentCount?: number | null;
      order: number;
    }>;
  };
};

export type DeleteDivisionMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteDivisionMutation = {
  __typename?: 'Mutation';
  deleteDivision: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type DivisionListItemFragment = {
  __typename: 'DivisionItem';
  uuid: string;
  name: string;
  class?: { __typename: 'DivisionClassItem'; uuid: string } | null;
  groups: Array<{
    __typename: 'GroupItem';
    uuid: string;
    name: string;
    shortName: string;
    studentCount?: number | null;
    order: number;
  }>;
};

export type ClassDivisionFormQueryVariables = Exact<{
  classUuid: Scalars['ID']['input'];
}>;

export type ClassDivisionFormQuery = {
  __typename?: 'Query';
  divisions: Array<{
    __typename: 'DivisionItem';
    uuid: string;
    name: string;
    class?: { __typename: 'DivisionClassItem'; uuid: string } | null;
    groups: Array<{
      __typename: 'GroupItem';
      uuid: string;
      name: string;
      shortName: string;
      studentCount?: number | null;
      order: number;
    }>;
  }>;
  defaultDivisions: Array<{
    __typename: 'DivisionItem';
    uuid: string;
    name: string;
    class?: { __typename: 'DivisionClassItem'; uuid: string } | null;
    groups: Array<{
      __typename: 'GroupItem';
      uuid: string;
      name: string;
      shortName: string;
      studentCount?: number | null;
      order: number;
    }>;
  }>;
};

export type DefaultDivisionsQueryVariables = Exact<{ [key: string]: never }>;

export type DefaultDivisionsQuery = {
  __typename?: 'Query';
  defaultDivisions: Array<{
    __typename: 'DivisionItem';
    uuid: string;
    name: string;
    class?: { __typename: 'DivisionClassItem'; uuid: string } | null;
    groups: Array<{
      __typename: 'GroupItem';
      uuid: string;
      name: string;
      shortName: string;
      studentCount?: number | null;
      order: number;
    }>;
  }>;
};

export type ClassDivisionsListQueryVariables = Exact<{
  classUuid: Scalars['ID']['input'];
}>;

export type ClassDivisionsListQuery = {
  __typename?: 'Query';
  divisions: Array<{
    __typename: 'DivisionItem';
    uuid: string;
    name: string;
    class?: { __typename: 'DivisionClassItem'; uuid: string } | null;
    groups: Array<{
      __typename: 'GroupItem';
      uuid: string;
      name: string;
      shortName: string;
      studentCount?: number | null;
      order: number;
    }>;
  }>;
  class?: { __typename: 'ClassItem'; uuid: string; name: string } | null;
};

export type TimetableReportsQueryVariables = Exact<{
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
  teachingBlockUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  timetableBlockUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type TimetableReportsQuery = {
  __typename?: 'Query';
  timetableReports: Array<{
    __typename: 'TimetableReportItem';
    uuid: string;
    title: string;
    type: TimetableReportType;
    jobCreated?: string | null;
    jobFinished?: string | null;
    contextUuid: string;
    contextName: string;
    fileEntries: Array<{ __typename?: 'ReportFileEntryItem'; uuid: string; filename?: string | null }>;
  }>;
};

export type TeachingLoadReportsQueryVariables = Exact<{
  type?: InputMaybe<TeachingLoadReportType>;
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
  teachingBlockUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  timetableBlockUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type TeachingLoadReportsQuery = {
  __typename?: 'Query';
  teachingLoadReports: Array<{
    __typename: 'TeachingLoadReportItem';
    uuid: string;
    title: string;
    type: TeachingLoadReportType;
    jobCreated?: string | null;
    jobFinished?: string | null;
    contextUuid: string;
    contextName: string;
    fileEntries: Array<{ __typename?: 'ReportFileEntryItem'; uuid: string; filename?: string | null }>;
  }>;
};

export type TeachingBlockVersionExclusionFragment = {
  __typename?: 'TeachingBlockVersionExclusion';
  uuid: string;
  holderType: TeachingBlockResourceType;
  holderUuid: string;
  from: string;
  to: string;
  priority: number;
  comment?: string | null;
};

export type CreateTeachingBlockExclusionMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  input: TeachingBlockExclusionInput;
}>;

export type CreateTeachingBlockExclusionMutation = {
  __typename?: 'Mutation';
  createTeachingBlockExclusion: {
    __typename?: 'TeachingBlockVersionExclusion';
    uuid: string;
    holderType: TeachingBlockResourceType;
    holderUuid: string;
    from: string;
    to: string;
    priority: number;
    comment?: string | null;
  };
};

export type UpdateTeachingBlockExclusionMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: TeachingBlockExclusionInput;
}>;

export type UpdateTeachingBlockExclusionMutation = {
  __typename?: 'Mutation';
  updateTeachingBlockExclusion: {
    __typename?: 'TeachingBlockVersionExclusion';
    uuid: string;
    holderType: TeachingBlockResourceType;
    holderUuid: string;
    from: string;
    to: string;
    priority: number;
    comment?: string | null;
  };
};

export type DeleteTeachingBlockExclusionsMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteTeachingBlockExclusionsMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlockExclusions: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type DeleteTeachingLoadFactorsMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteTeachingLoadFactorsMutation = {
  __typename?: 'Mutation';
  deleteTeachingLoadFactors: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type CreateTeachingLoadFactorMutationVariables = Exact<{
  input: TeachingLoadFactorInput;
}>;

export type CreateTeachingLoadFactorMutation = {
  __typename?: 'Mutation';
  createTeachingLoadFactor: {
    __typename?: 'TeachingLoadFactorItem';
    uuid: string;
    active: boolean;
    factorType: FactorType;
    schoolYearUuid: string;
    grades: Array<number>;
    value: number;
    valueRaw: string;
    valuePartial?: number | null;
    valuePartialRaw?: string | null;
    valueMode: ValueMode;
    studentsMin?: number | null;
    studentsMax?: number | null;
    studentsPartialMin?: number | null;
    studentsPartialMax?: number | null;
    comment?: string | null;
    subject: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string; shortName?: string | null }>;
    subjectContainer: Array<{
      __typename?: 'TeachingLoadFactorRef';
      uuid: string;
      name: string;
      shortName?: string | null;
    }>;
    gradeGroup: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string; shortName?: string | null }>;
    timeGridEntries: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string }>;
    teachers: Array<{
      __typename?: 'TeachingLoadFactorTeacherRef';
      uuid: string;
      shortName?: string | null;
      listName: string;
    }>;
  };
};

export type UpdateTeachingLoadFactorMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: TeachingLoadFactorInput;
}>;

export type UpdateTeachingLoadFactorMutation = {
  __typename?: 'Mutation';
  updateTeachingLoadFactor: {
    __typename?: 'TeachingLoadFactorItem';
    uuid: string;
    active: boolean;
    factorType: FactorType;
    schoolYearUuid: string;
    grades: Array<number>;
    value: number;
    valueRaw: string;
    valuePartial?: number | null;
    valuePartialRaw?: string | null;
    valueMode: ValueMode;
    studentsMin?: number | null;
    studentsMax?: number | null;
    studentsPartialMin?: number | null;
    studentsPartialMax?: number | null;
    comment?: string | null;
    subject: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string; shortName?: string | null }>;
    subjectContainer: Array<{
      __typename?: 'TeachingLoadFactorRef';
      uuid: string;
      name: string;
      shortName?: string | null;
    }>;
    gradeGroup: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string; shortName?: string | null }>;
    timeGridEntries: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string }>;
    teachers: Array<{
      __typename?: 'TeachingLoadFactorTeacherRef';
      uuid: string;
      shortName?: string | null;
      listName: string;
    }>;
  };
};

export type SetTeachingLoadFactorActiveMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;

export type SetTeachingLoadFactorActiveMutation = {
  __typename?: 'Mutation';
  setTeachingLoadFactorActive: { __typename?: 'TeachingLoadFactorItem'; uuid: string; active: boolean };
};

export type TeachingLoadFactorItemFragment = {
  __typename?: 'TeachingLoadFactorItem';
  uuid: string;
  active: boolean;
  factorType: FactorType;
  schoolYearUuid: string;
  grades: Array<number>;
  value: number;
  valueRaw: string;
  valuePartial?: number | null;
  valuePartialRaw?: string | null;
  valueMode: ValueMode;
  studentsMin?: number | null;
  studentsMax?: number | null;
  studentsPartialMin?: number | null;
  studentsPartialMax?: number | null;
  comment?: string | null;
  subject: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string; shortName?: string | null }>;
  subjectContainer: Array<{
    __typename?: 'TeachingLoadFactorRef';
    uuid: string;
    name: string;
    shortName?: string | null;
  }>;
  gradeGroup: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string; shortName?: string | null }>;
  timeGridEntries: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string }>;
  teachers: Array<{
    __typename?: 'TeachingLoadFactorTeacherRef';
    uuid: string;
    shortName?: string | null;
    listName: string;
  }>;
};

export type TeachingLoadFactorsQueryVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
}>;

export type TeachingLoadFactorsQuery = {
  __typename?: 'Query';
  teachingLoadFactors: Array<{
    __typename?: 'TeachingLoadFactorItem';
    uuid: string;
    active: boolean;
    factorType: FactorType;
    schoolYearUuid: string;
    grades: Array<number>;
    value: number;
    valueRaw: string;
    valuePartial?: number | null;
    valuePartialRaw?: string | null;
    valueMode: ValueMode;
    studentsMin?: number | null;
    studentsMax?: number | null;
    studentsPartialMin?: number | null;
    studentsPartialMax?: number | null;
    comment?: string | null;
    subject: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string; shortName?: string | null }>;
    subjectContainer: Array<{
      __typename?: 'TeachingLoadFactorRef';
      uuid: string;
      name: string;
      shortName?: string | null;
    }>;
    gradeGroup: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string; shortName?: string | null }>;
    timeGridEntries: Array<{ __typename?: 'TeachingLoadFactorRef'; uuid: string; name: string }>;
    teachers: Array<{
      __typename?: 'TeachingLoadFactorTeacherRef';
      uuid: string;
      shortName?: string | null;
      listName: string;
    }>;
  }>;
};

export type CreateGradeGroupsMutationVariables = Exact<{
  input: GradeGroupInput;
}>;

export type CreateGradeGroupsMutation = {
  __typename?: 'Mutation';
  createGradeGroup: { __typename?: 'GradeGroupItem'; uuid: string };
};

export type DeleteGradeGroupsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteGradeGroupsMutation = {
  __typename?: 'Mutation';
  deleteGradeGroup: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateGradeGroupsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: GradeGroupInput;
}>;

export type UpdateGradeGroupsMutation = {
  __typename?: 'Mutation';
  updateGradeGroup: { __typename?: 'GradeGroupItem'; uuid: string };
};

export type GradeGroupsListQueryVariables = Exact<{ [key: string]: never }>;

export type GradeGroupsListQuery = {
  __typename?: 'Query';
  gradeGroups: Array<{
    __typename?: 'GradeGroupItem';
    uuid: string;
    name: string;
    shortName: string;
    description?: string | null;
  }>;
};

export type DeleteHolidaysMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteHolidaysMutation = {
  __typename?: 'Mutation';
  deleteHoliday: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateHolidaysMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: HolidayInput;
}>;

export type UpdateHolidaysMutation = {
  __typename?: 'Mutation';
  updateHoliday: { __typename?: 'HolidayItem'; uuid: string };
};

export type CreateHolidaysMutationVariables = Exact<{
  input: HolidayInput;
}>;

export type CreateHolidaysMutation = {
  __typename?: 'Mutation';
  createHoliday: { __typename?: 'HolidayItem'; uuid: string };
};

export type ConnectLessonsToTimetableVersionMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
  lessonUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ConnectLessonsToTimetableVersionMutation = {
  __typename?: 'Mutation';
  connectLessonsToTimetableVersion: { __typename?: 'UpdateResponse'; nodesUpdated: number; nodeUuids: Array<string> };
};

export type InheritLessonTeachersMutationVariables = Exact<{
  lessonUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  type: InheritLessonTeachersType;
}>;

export type InheritLessonTeachersMutation = {
  __typename?: 'Mutation';
  inheritLessonTeachers: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type CopyLessonsToTimetableVersionMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
  lessonUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type CopyLessonsToTimetableVersionMutation = {
  __typename?: 'Mutation';
  copyLessonsToTimetableVersion: { __typename?: 'CreateResponse'; nodesCreated: number; nodeUuids: Array<string> };
};

export type MergeLessonsMutationVariables = Exact<{
  cardsFromLesson?: InputMaybe<Scalars['ID']['input']>;
  lessonUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  newCards: Array<MergeLessonNewCardsInput> | MergeLessonNewCardsInput;
  timetableVersion?: InputMaybe<Scalars['ID']['input']>;
}>;

export type MergeLessonsMutation = {
  __typename?: 'Mutation';
  mergeLessons: { __typename?: 'CreateResponse'; nodeUuids: Array<string>; nodesCreated: number };
};

export type CreateLessonMutationVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
  curriculumUuid?: InputMaybe<Scalars['ID']['input']>;
  input: LessonInput;
}>;

export type CreateLessonMutation = {
  __typename?: 'Mutation';
  createLesson: {
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  };
};

export type CreateLessonInTimetableVersionMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  input: LessonInput;
  cardDurations: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type CreateLessonInTimetableVersionMutation = {
  __typename?: 'Mutation';
  createLessonInTimetableVersion: {
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  };
};

export type CreateLessonInTeachingBlockVersionMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  input: LessonInput;
  cardDurations: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type CreateLessonInTeachingBlockVersionMutation = {
  __typename?: 'Mutation';
  createLessonInTeachingBlockVersion: {
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  };
};

export type UpdateLessonMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: LessonInput;
}>;

export type UpdateLessonMutation = {
  __typename?: 'Mutation';
  updateLesson: {
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  };
};

export type SetLessonsFlagMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  flag: LessonFlag;
  value: Scalars['Boolean']['input'];
}>;

export type SetLessonsFlagMutation = {
  __typename?: 'Mutation';
  setLessonsFlag: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type AssignTeachersToLessonsMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  teachers: Array<LessonTeacherInput> | LessonTeacherInput;
}>;

export type AssignTeachersToLessonsMutation = {
  __typename?: 'Mutation';
  assignTeachersToLessons: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type DetachTeachersFromLessonsMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DetachTeachersFromLessonsMutation = {
  __typename?: 'Mutation';
  detachTeachersFromLessons: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type DetachLessonsFromTimetableVersionMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DetachLessonsFromTimetableVersionMutation = {
  __typename?: 'Mutation';
  detachLessonsFromTimetableVersion: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type CopyLessonIntoTeachingBlockVersionMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  lessonUuid: Scalars['ID']['input'];
}>;

export type CopyLessonIntoTeachingBlockVersionMutation = {
  __typename?: 'Mutation';
  copyLessonIntoTeachingBlockVersion: {
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  };
};

export type DetachLessonsFromTeachingBlockVersionMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DetachLessonsFromTeachingBlockVersionMutation = {
  __typename?: 'Mutation';
  detachLessonsFromTeachingBlockVersion: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type DeleteLessonsMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteLessonsMutation = {
  __typename?: 'Mutation';
  deleteLessons: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type AttachLessonsToTeachingBlockVersionMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AttachLessonsToTeachingBlockVersionMutation = {
  __typename?: 'Mutation';
  attachLessonsToTeachingBlockVersion: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type LessonItemFragment = {
  __typename: 'LessonItem';
  uuid: string;
  subTitle?: string | null;
  comment?: string | null;
  studentCount?: number | null;
  elective?: boolean | null;
  isClassTrip?: boolean | null;
  teachingLoadEnabled?: boolean | null;
  timetableEnabled?: boolean | null;
  onlyInTimetableVersion: boolean;
  onlyInTeachingBlockVersion: boolean;
  schoolYearUuid?: string | null;
  subjectName: string;
  teachersSort: string;
  classSort: string;
  groupClassNames: string;
  gradeGroupUuids: Array<string>;
  curriculumUuid?: string | null;
  placedCardsCount: number;
  teachingBlockPlacedCardsCount: number;
  subject: {
    __typename?: 'LessonSubjectItem';
    uuid: string;
    name: string;
    shortName: string;
    isSubjectContainer: boolean;
    epochEnabled?: boolean | null;
    subjectHourEnabled?: boolean | null;
    active?: boolean | null;
    color?: string | null;
    defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
  };
  curriculumPersons: Array<{
    __typename?: 'LessonCurriculumPersonItem';
    uuid: string;
    description?: string | null;
    order: number;
    present?: boolean | null;
    teachingLoad?: boolean | null;
  }>;
  teachers: Array<{
    __typename?: 'LessonTeacherItem';
    uuid: string;
    shortName: string;
    firstName: string;
    lastName: string;
    fullName: string;
    displayNameShort: string;
    color?: string | null;
    order: number;
    description?: string | null;
    present?: boolean | null;
    teachingLoad?: boolean | null;
    teachingLoadHours?: number | null;
    writesCertificate?: boolean | null;
  }>;
  lessonClasses: Array<{
    __typename?: 'LessonClassItem';
    uuid: string;
    order: number;
    class: {
      __typename?: 'LessonClassClassItem';
      uuid: string;
      name: string;
      shortName: string;
      grade?: number | null;
      color?: string | null;
      gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
      defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
      divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
    };
    groups: Array<{
      __typename?: 'LessonClassGroupItem';
      uuid: string;
      name: string;
      shortName: string;
      classFraction: number;
    }>;
    usedDivision?: {
      __typename?: 'LessonClassDivisionItem';
      uuid: string;
      name: string;
      groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
    } | null;
  }>;
  lessonUnits: Array<{
    __typename?: 'LessonUnitItem';
    uuid: string;
    order: number;
    duration?: number | null;
    count?: number | null;
    subjectContainer?: {
      __typename?: 'LessonUnitSubjectContainerItem';
      uuid: string;
      name: string;
      shortName: string;
    } | null;
  }>;
  roomSupply: Array<{
    __typename?: 'LessonRoomItem';
    uuid: string;
    name: string;
    order: number;
    descriptions?: string | null;
  }>;
  versions: Array<{
    __typename?: 'LessonVersionItem';
    uuid: string;
    version?: number | null;
    active?: boolean | null;
    editable?: boolean | null;
    timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
  }>;
  teachingBlockVersions: Array<{
    __typename?: 'LessonTeachingBlockVersionItem';
    uuid: string;
    version?: number | null;
    active?: boolean | null;
    teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
  }>;
  editStatus: {
    __typename?: 'LessonEditStatusInfo';
    status: LessonEditStatus;
    reasons: Array<{
      __typename?: 'LessonEditStatusReasonDetail';
      reason: LessonEditStatusReason;
      label: string;
      references: Array<{
        __typename?: 'LessonEditStatusReference';
        planUuid: string;
        planName: string;
        versionUuid?: string | null;
        version?: number | null;
        label: string;
      }>;
    }>;
  };
  editStatusInVersion: {
    __typename?: 'LessonEditStatusInfo';
    status: LessonEditStatus;
    reasons: Array<{
      __typename?: 'LessonEditStatusReasonDetail';
      reason: LessonEditStatusReason;
      label: string;
      references: Array<{
        __typename?: 'LessonEditStatusReference';
        planUuid: string;
        planName: string;
        versionUuid?: string | null;
        version?: number | null;
        label: string;
      }>;
    }>;
  };
};

export type LessonsForSchoolYearQueryVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
}>;

export type LessonsForSchoolYearQuery = {
  __typename?: 'Query';
  lessonsForSchoolYear: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type LessonsByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type LessonsByUuidsQuery = {
  __typename?: 'Query';
  lessonsByUuids: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type LessonsForTimetableVersionQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type LessonsForTimetableVersionQuery = {
  __typename?: 'Query';
  lessonsForTimetableVersion: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type LessonsForTeachingBlockVersionQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type LessonsForTeachingBlockVersionQuery = {
  __typename?: 'Query';
  lessonsForTeachingBlockVersion: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type ImportableLessonsForTimetableVersionQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
}>;

export type ImportableLessonsForTimetableVersionQuery = {
  __typename?: 'Query';
  importableLessonsForTimetableVersion: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type ImportableLessonsForTeachingBlockVersionQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  subjectContainerUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
}>;

export type ImportableLessonsForTeachingBlockVersionQuery = {
  __typename?: 'Query';
  importableLessonsForTeachingBlockVersion: Array<{
    __typename: 'LessonItem';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    studentCount?: number | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    schoolYearUuid?: string | null;
    subjectName: string;
    teachersSort: string;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuids: Array<string>;
    curriculumUuid?: string | null;
    placedCardsCount: number;
    teachingBlockPlacedCardsCount: number;
    subject: {
      __typename?: 'LessonSubjectItem';
      uuid: string;
      name: string;
      shortName: string;
      isSubjectContainer: boolean;
      epochEnabled?: boolean | null;
      subjectHourEnabled?: boolean | null;
      active?: boolean | null;
      color?: string | null;
      defaultRooms: Array<{ __typename?: 'LessonRefItem'; uuid: string; name: string }>;
    };
    curriculumPersons: Array<{
      __typename?: 'LessonCurriculumPersonItem';
      uuid: string;
      description?: string | null;
      order: number;
      present?: boolean | null;
      teachingLoad?: boolean | null;
    }>;
    teachers: Array<{
      __typename?: 'LessonTeacherItem';
      uuid: string;
      shortName: string;
      firstName: string;
      lastName: string;
      fullName: string;
      displayNameShort: string;
      color?: string | null;
      order: number;
      description?: string | null;
      present?: boolean | null;
      teachingLoad?: boolean | null;
      teachingLoadHours?: number | null;
      writesCertificate?: boolean | null;
    }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      uuid: string;
      order: number;
      class: {
        __typename?: 'LessonClassClassItem';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        color?: string | null;
        gradeGroup?: { __typename?: 'LessonGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
        defaultRoom?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
        divisions: Array<{ __typename?: 'LessonClassDivisionRefItem'; uuid: string; groupUuids: Array<string> }>;
      };
      groups: Array<{
        __typename?: 'LessonClassGroupItem';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
      }>;
      usedDivision?: {
        __typename?: 'LessonClassDivisionItem';
        uuid: string;
        name: string;
        groups: Array<{ __typename?: 'LessonClassDivisionGroupItem'; uuid: string; name: string; order: number }>;
      } | null;
    }>;
    lessonUnits: Array<{
      __typename?: 'LessonUnitItem';
      uuid: string;
      order: number;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'LessonUnitSubjectContainerItem';
        uuid: string;
        name: string;
        shortName: string;
      } | null;
    }>;
    roomSupply: Array<{
      __typename?: 'LessonRoomItem';
      uuid: string;
      name: string;
      order: number;
      descriptions?: string | null;
    }>;
    versions: Array<{
      __typename?: 'LessonVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      editable?: boolean | null;
      timetable?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'LessonTeachingBlockVersionItem';
      uuid: string;
      version?: number | null;
      active?: boolean | null;
      teachingBlock?: { __typename?: 'LessonRefItem'; uuid: string; name: string } | null;
    }>;
    editStatus: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
    editStatusInVersion: {
      __typename?: 'LessonEditStatusInfo';
      status: LessonEditStatus;
      reasons: Array<{
        __typename?: 'LessonEditStatusReasonDetail';
        reason: LessonEditStatusReason;
        label: string;
        references: Array<{
          __typename?: 'LessonEditStatusReference';
          planUuid: string;
          planName: string;
          versionUuid?: string | null;
          version?: number | null;
          label: string;
        }>;
      }>;
    };
  }>;
};

export type SolverJobItemFragment = {
  __typename: 'SolverJobItem';
  jobId: string;
  engine: SolverEngine;
  status: string;
  gap: number;
  solutionFound: boolean;
  scoreDetails?: string | null;
  previewCards?: string | null;
  jobOptions?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  versionUuid: string;
  version: number;
  timetableName: string;
  schoolYearName: string;
};

export type LatestSolverJobForVersionQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type LatestSolverJobForVersionQuery = {
  __typename?: 'Query';
  latestSolverJobForVersion?: {
    __typename: 'SolverJobItem';
    jobId: string;
    engine: SolverEngine;
    status: string;
    gap: number;
    solutionFound: boolean;
    scoreDetails?: string | null;
    previewCards?: string | null;
    jobOptions?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    versionUuid: string;
    version: number;
    timetableName: string;
    schoolYearName: string;
  } | null;
};

export type SolverJobQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;

export type SolverJobQuery = {
  __typename?: 'Query';
  solverJob?: {
    __typename: 'SolverJobItem';
    jobId: string;
    engine: SolverEngine;
    status: string;
    gap: number;
    solutionFound: boolean;
    scoreDetails?: string | null;
    previewCards?: string | null;
    jobOptions?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    versionUuid: string;
    version: number;
    timetableName: string;
    schoolYearName: string;
  } | null;
};

export type SolverJobsQueryVariables = Exact<{ [key: string]: never }>;

export type SolverJobsQuery = {
  __typename?: 'Query';
  solverJobs: Array<{
    __typename: 'SolverJobItem';
    jobId: string;
    engine: SolverEngine;
    status: string;
    gap: number;
    solutionFound: boolean;
    scoreDetails?: string | null;
    previewCards?: string | null;
    jobOptions?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    versionUuid: string;
    version: number;
    timetableName: string;
    schoolYearName: string;
  }>;
};

export type SolverJobDetailsQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;

export type SolverJobDetailsQuery = {
  __typename?: 'Query';
  solverJobDetails?: {
    __typename: 'SolverJobDetails';
    jobId: string;
    problem?: string | null;
    solution?: string | null;
    errors?: string | null;
  } | null;
};

export type SetEnabledSolverEnginesMutationVariables = Exact<{
  engines: Array<SolverEngine> | SolverEngine;
}>;

export type SetEnabledSolverEnginesMutation = { __typename?: 'Mutation'; setEnabledSolverEngines: Array<SolverEngine> };

export type PimOrganizationsQueryVariables = Exact<{ [key: string]: never }>;

export type PimOrganizationsQuery = {
  __typename?: 'Query';
  pimOrganizations: Array<{
    __typename?: 'PimOrganization';
    uuid: string;
    name: string;
    planungEnabled?: boolean | null;
    iphisVplanEnabled?: boolean | null;
    vpoEnabled?: boolean | null;
  }>;
};

export type SubstitutionSoftwareSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type SubstitutionSoftwareSettingsQuery = {
  __typename?: 'Query';
  substitutionSoftwareSettings: {
    __typename?: 'SubstitutionSoftwareSettings';
    vpoSubstitutionProps?: string | null;
    iphisSubstitutionProps?: string | null;
  };
};

export type EnabledSolverEnginesQueryVariables = Exact<{ [key: string]: never }>;

export type EnabledSolverEnginesQuery = { __typename?: 'Query'; enabledSolverEngines: Array<SolverEngine> };

export type CreatePeopleMutationVariables = Exact<{
  input: PersonInput;
}>;

export type CreatePeopleMutation = {
  __typename?: 'Mutation';
  createPerson: { __typename?: 'PersonItem'; uuid: string };
};

export type UpdatePeopleMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: PersonInput;
}>;

export type UpdatePeopleMutation = {
  __typename?: 'Mutation';
  updatePerson: { __typename?: 'PersonItem'; uuid: string };
};

export type DeletePeopleMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeletePeopleMutation = {
  __typename?: 'Mutation';
  deletePeople: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateActivePeopleMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;

export type UpdateActivePeopleMutation = {
  __typename?: 'Mutation';
  setPeopleActive: Array<{ __typename?: 'PersonItem'; uuid: string }>;
};

export type UpdatePeopleColorMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  color: Scalars['String']['input'];
}>;

export type UpdatePeopleColorMutation = {
  __typename?: 'Mutation';
  setPersonColor: { __typename?: 'PersonItem'; uuid: string };
};

export type _PublishedSubstitutionsQueryVariables = Exact<{
  start: Scalars['Date']['input'];
  end: Scalars['Date']['input'];
}>;

export type _PublishedSubstitutionsQuery = {
  __typename?: 'Query';
  publishedSubstitutionDays: Array<{
    __typename?: 'PublishedSubstitutionDay';
    uuid: string;
    date: string;
    lastPublished?: string | null;
    teachers: string;
    classes: string;
    substitutions: string;
    notifications: string;
  }>;
};

export type CreateRoomsMutationVariables = Exact<{
  input: RoomInput;
}>;

export type CreateRoomsMutation = { __typename?: 'Mutation'; createRoom: { __typename?: 'RoomItem'; uuid: string } };

export type UpdateRoomsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: RoomInput;
}>;

export type UpdateRoomsMutation = { __typename?: 'Mutation'; updateRoom: { __typename?: 'RoomItem'; uuid: string } };

export type SetRoomsFlagMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  flag: RoomFlag;
  value: Scalars['Boolean']['input'];
}>;

export type SetRoomsFlagMutation = {
  __typename?: 'Mutation';
  setRoomsFlag: Array<{ __typename?: 'RoomItem'; uuid: string }>;
};

export type AssignRoomsToBuildingMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  buildingUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AssignRoomsToBuildingMutation = {
  __typename?: 'Mutation';
  assignRoomsToBuilding: Array<{ __typename?: 'RoomItem'; uuid: string }>;
};

export type DeleteRoomsMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteRoomsMutation = {
  __typename?: 'Mutation';
  deleteRooms: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type RoomsListQueryVariables = Exact<{ [key: string]: never }>;

export type RoomsListQuery = {
  __typename?: 'Query';
  rooms: Array<{
    __typename?: 'RoomItem';
    uuid: string;
    name: string;
    position?: string | null;
    roomNumber?: string | null;
    description?: string | null;
    classroom?: boolean | null;
    canBeLeased?: boolean | null;
    capacity?: number | null;
    chairs?: number | null;
    tables?: number | null;
    size?: number | null;
    responsiblePersonUuids: Array<string>;
    otherInventory?: string | null;
    barrierFree?: boolean | null;
    canBeDarkened?: boolean | null;
    hasProjector?: boolean | null;
    hasScreen?: boolean | null;
    hasMediaCabinet?: boolean | null;
    hasPiano?: boolean | null;
    building?: { __typename?: 'BuildingRefItem'; uuid: string; name: string } | null;
  }>;
  buildings: Array<{ __typename?: 'BuildingItem'; uuid: string; name: string }>;
  people: Array<{
    __typename?: 'PersonItem';
    uuid: string;
    firstName: string;
    lastName: string;
    displayNameShort: string;
  }>;
};

export type RoomUsageQueryVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RoomUsageQuery = {
  __typename?: 'Query';
  roomUsage: Array<{ __typename?: 'RoomUsage'; uuid: string; lessonsCount: number; curriculaCount: number }>;
};

export type CreateSchoolYearsMutationVariables = Exact<{
  input: SchoolYearInput;
}>;

export type CreateSchoolYearsMutation = {
  __typename?: 'Mutation';
  createSchoolYear: { __typename?: 'SchoolYearItem'; uuid: string };
};

export type UpdateSchoolYearsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: SchoolYearInput;
}>;

export type UpdateSchoolYearsMutation = {
  __typename?: 'Mutation';
  updateSchoolYear: { __typename?: 'SchoolYearItem'; uuid: string };
};

export type DeleteSchoolYearsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteSchoolYearsMutation = {
  __typename?: 'Mutation';
  deleteSchoolYear: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type SchoolYearsQueryVariables = Exact<{ [key: string]: never }>;

export type SchoolYearsQuery = {
  __typename?: 'Query';
  schoolYears: Array<{
    __typename?: 'SchoolYearItem';
    uuid: string;
    name: string;
    shortName: string;
    start: string;
    end: string;
    fullTimeHours?: number | null;
    holidays: Array<{ __typename?: 'HolidayItem'; uuid: string; name: string; start: string; end: string }>;
  }>;
};

export type DeleteSubjectContainerMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteSubjectContainerMutation = {
  __typename?: 'Mutation';
  deleteSubjectContainers: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateSubjectContainerMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: SubjectContainerInput;
}>;

export type UpdateSubjectContainerMutation = {
  __typename?: 'Mutation';
  updateSubjectContainer: { __typename?: 'SubjectContainerItem'; uuid: string };
};

export type CreateSubjectContainersMutationVariables = Exact<{
  input: SubjectContainerInput;
}>;

export type CreateSubjectContainersMutation = {
  __typename?: 'Mutation';
  createSubjectContainer: { __typename?: 'SubjectContainerItem'; uuid: string };
};

export type _UpdateSubjectContainersColorsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  color: Scalars['String']['input'];
}>;

export type _UpdateSubjectContainersColorsMutation = {
  __typename?: 'Mutation';
  setSubjectContainerColor: { __typename?: 'SubjectContainerItem'; uuid: string };
};

export type SubjectContainersListQueryVariables = Exact<{ [key: string]: never }>;

export type SubjectContainersListQuery = {
  __typename?: 'Query';
  subjectContainers: Array<{
    __typename?: 'SubjectContainerItem';
    uuid: string;
    name: string;
    grades: Array<number>;
    shortName: string;
    order?: number | null;
    gradeGroups: Array<{ __typename?: 'GradeGroupRefItem'; uuid: string; name: string; shortName: string }>;
    validFrom?: {
      __typename?: 'SchoolYearRefItem';
      uuid: string;
      name: string;
      shortName: string;
      start: string;
      end: string;
    } | null;
    validUntil?: {
      __typename?: 'SchoolYearRefItem';
      uuid: string;
      name: string;
      shortName: string;
      start: string;
      end: string;
    } | null;
    timetableConfig?: { __typename?: 'TimetableConfigItem'; color?: string | null; colorLabel?: string | null } | null;
  }>;
  schoolYears: Array<{
    __typename?: 'SchoolYearItem';
    uuid: string;
    name: string;
    shortName: string;
    start: string;
    end: string;
  }>;
};

export type SubjectContainerUsageQueryVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type SubjectContainerUsageQuery = {
  __typename?: 'Query';
  subjectContainerUsage: Array<{
    __typename?: 'SubjectContainerUsage';
    uuid: string;
    name: string;
    lessonsCount: number;
    curriculaCount: number;
    teachingBlocksCount: number;
    lessonUnitsCount: number;
  }>;
};

export type SubjectContainerUsedInLessonsQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type SubjectContainerUsedInLessonsQuery = {
  __typename?: 'Query';
  lessonsForSubjectContainer: Array<{ __typename?: 'LessonItem'; uuid: string; displayName: Array<string> }>;
};

export type DeleteSubjectGroupMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteSubjectGroupMutation = {
  __typename?: 'Mutation';
  deleteSubjectGroup: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateSubjectGroupMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: SubjectGroupInput;
}>;

export type UpdateSubjectGroupMutation = {
  __typename?: 'Mutation';
  updateSubjectGroup: { __typename?: 'SubjectGroupItem'; uuid: string; name: string };
};

export type CreateSubjectGroupMutationVariables = Exact<{
  input: SubjectGroupInput;
}>;

export type CreateSubjectGroupMutation = {
  __typename?: 'Mutation';
  createSubjectGroup: { __typename?: 'SubjectGroupItem'; uuid: string; name: string };
};

export type SubjectGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type SubjectGroupsQuery = {
  __typename?: 'Query';
  subjectGroups: Array<{ __typename?: 'SubjectGroupItem'; uuid: string; name: string }>;
};

export type SubjectFragmentFragment = {
  __typename?: 'SubjectItem';
  name: string;
  uuid: string;
  shortName: string;
  subjectHourEnabled?: boolean | null;
  epochEnabled?: boolean | null;
  active?: boolean | null;
  other?: boolean | null;
  defaultRooms: Array<{ __typename?: 'RoomRefItem'; uuid: string; name: string }>;
  subjectGroup?: { __typename?: 'SubjectGroupItem'; uuid: string; name: string } | null;
  timetableConfig?: {
    __typename?: 'TimetableConfigItem';
    uuid: string;
    color?: string | null;
    colorLabel?: string | null;
  } | null;
};

export type DeleteSubjectsMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteSubjectsMutation = {
  __typename?: 'Mutation';
  deleteSubjects: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateSubjectsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: SubjectInput;
}>;

export type UpdateSubjectsMutation = {
  __typename?: 'Mutation';
  updateSubject: {
    __typename?: 'SubjectItem';
    name: string;
    uuid: string;
    shortName: string;
    subjectHourEnabled?: boolean | null;
    epochEnabled?: boolean | null;
    active?: boolean | null;
    other?: boolean | null;
    defaultRooms: Array<{ __typename?: 'RoomRefItem'; uuid: string; name: string }>;
    subjectGroup?: { __typename?: 'SubjectGroupItem'; uuid: string; name: string } | null;
    timetableConfig?: {
      __typename?: 'TimetableConfigItem';
      uuid: string;
      color?: string | null;
      colorLabel?: string | null;
    } | null;
  };
};

export type SetSubjectsFlagMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  flag: SubjectFlag;
  value: Scalars['Boolean']['input'];
}>;

export type SetSubjectsFlagMutation = {
  __typename?: 'Mutation';
  setSubjectsFlag: Array<{
    __typename?: 'SubjectItem';
    name: string;
    uuid: string;
    shortName: string;
    subjectHourEnabled?: boolean | null;
    epochEnabled?: boolean | null;
    active?: boolean | null;
    other?: boolean | null;
    defaultRooms: Array<{ __typename?: 'RoomRefItem'; uuid: string; name: string }>;
    subjectGroup?: { __typename?: 'SubjectGroupItem'; uuid: string; name: string } | null;
    timetableConfig?: {
      __typename?: 'TimetableConfigItem';
      uuid: string;
      color?: string | null;
      colorLabel?: string | null;
    } | null;
  }>;
};

export type CreateSubjectMutationVariables = Exact<{
  input: SubjectInput;
}>;

export type CreateSubjectMutation = {
  __typename?: 'Mutation';
  createSubject: {
    __typename?: 'SubjectItem';
    name: string;
    uuid: string;
    shortName: string;
    subjectHourEnabled?: boolean | null;
    epochEnabled?: boolean | null;
    active?: boolean | null;
    other?: boolean | null;
    defaultRooms: Array<{ __typename?: 'RoomRefItem'; uuid: string; name: string }>;
    subjectGroup?: { __typename?: 'SubjectGroupItem'; uuid: string; name: string } | null;
    timetableConfig?: {
      __typename?: 'TimetableConfigItem';
      uuid: string;
      color?: string | null;
      colorLabel?: string | null;
    } | null;
  };
};

export type _UpdateSubjectsColorsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  color: Scalars['String']['input'];
}>;

export type _UpdateSubjectsColorsMutation = {
  __typename?: 'Mutation';
  setSubjectColor: {
    __typename?: 'SubjectItem';
    name: string;
    uuid: string;
    shortName: string;
    subjectHourEnabled?: boolean | null;
    epochEnabled?: boolean | null;
    active?: boolean | null;
    other?: boolean | null;
    defaultRooms: Array<{ __typename?: 'RoomRefItem'; uuid: string; name: string }>;
    subjectGroup?: { __typename?: 'SubjectGroupItem'; uuid: string; name: string } | null;
    timetableConfig?: {
      __typename?: 'TimetableConfigItem';
      uuid: string;
      color?: string | null;
      colorLabel?: string | null;
    } | null;
  };
};

export type SubjectsListQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SubjectsListQuery = {
  __typename?: 'Query';
  subjects: Array<{
    __typename?: 'SubjectItem';
    name: string;
    uuid: string;
    shortName: string;
    subjectHourEnabled?: boolean | null;
    epochEnabled?: boolean | null;
    active?: boolean | null;
    other?: boolean | null;
    timetableConfig?: {
      __typename?: 'TimetableConfigItem';
      color?: string | null;
      colorLabel?: string | null;
      printOrder?: number | null;
      printPageNr?: number | null;
      uuid: string;
    } | null;
    defaultRooms: Array<{ __typename?: 'RoomRefItem'; uuid: string; name: string }>;
    subjectGroup?: { __typename?: 'SubjectGroupItem'; uuid: string; name: string } | null;
  }>;
};

export type SubjectByUuidQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type SubjectByUuidQuery = {
  __typename?: 'Query';
  subject?: {
    __typename?: 'SubjectItem';
    name: string;
    uuid: string;
    shortName: string;
    subjectHourEnabled?: boolean | null;
    epochEnabled?: boolean | null;
    active?: boolean | null;
    other?: boolean | null;
    defaultRooms: Array<{ __typename?: 'RoomRefItem'; uuid: string; name: string }>;
    subjectGroup?: { __typename?: 'SubjectGroupItem'; uuid: string; name: string } | null;
    timetableConfig?: {
      __typename?: 'TimetableConfigItem';
      uuid: string;
      color?: string | null;
      colorLabel?: string | null;
    } | null;
  } | null;
};

export type SubjectUsageQueryVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type SubjectUsageQuery = {
  __typename?: 'Query';
  subjectUsage: Array<{ __typename?: 'SubjectUsage'; uuid: string; lessonsCount: number; curriculaCount: number }>;
};

export type SaveSubstitutionSoftwareSettingsMutationVariables = Exact<{
  input: SubstitutionSoftwareSettingsInput;
}>;

export type SaveSubstitutionSoftwareSettingsMutation = {
  __typename?: 'Mutation';
  saveSubstitutionSoftwareSettings: {
    __typename?: 'SubstitutionSoftwareSettings';
    vpoSubstitutionProps?: string | null;
    iphisSubstitutionProps?: string | null;
  };
};

export type TeachersSubstitutionsQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  classUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  subjectUuid?: InputMaybe<Scalars['String']['input']>;
}>;

export type TeachersSubstitutionsQuery = {
  __typename?: 'Query';
  teachersSubstitutions: Array<{
    __typename?: 'TeacherSubstitutionStats';
    givenSubstituteHours: number;
    sameClass?: boolean | null;
    sameSubject?: boolean | null;
    substituteHours?: number | null;
    teacherUuid: string;
  }>;
};

export type SubstitutionAnnouncementItemFragment = {
  __typename?: 'SubstitutionAnnouncementItem';
  uuid: string;
  date: string;
  publicAnnouncement?: string | null;
  internalAnnouncement?: string | null;
};

export type SubstitutionAnnouncementQueryVariables = Exact<{
  selectedDay: Scalars['Date']['input'];
}>;

export type SubstitutionAnnouncementQuery = {
  __typename?: 'Query';
  substitutionAnnouncement?: {
    __typename?: 'SubstitutionAnnouncementItem';
    uuid: string;
    date: string;
    publicAnnouncement?: string | null;
    internalAnnouncement?: string | null;
  } | null;
};

export type SaveSubstitutionAnnouncementMutationVariables = Exact<{
  date: Scalars['Date']['input'];
  publicAnnouncement?: InputMaybe<Scalars['String']['input']>;
  internalAnnouncement?: InputMaybe<Scalars['String']['input']>;
}>;

export type SaveSubstitutionAnnouncementMutation = {
  __typename?: 'Mutation';
  saveSubstitutionAnnouncement: {
    __typename?: 'SubstitutionAnnouncementItem';
    uuid: string;
    date: string;
    publicAnnouncement?: string | null;
    internalAnnouncement?: string | null;
  };
};

export type SubstitutionPrintConfigItemFragment = {
  __typename?: 'SubstitutionPrintConfigItem';
  uuid: string;
  showMissingTeachers: boolean;
  showMissingTeachersShortName: boolean;
  showAnnouncements: boolean;
  showSchoolEvents: boolean;
  useTeacherShortname: boolean;
  pageOrientation: string;
  printImages: boolean;
  useLessonName: boolean;
  lineScale: number;
  fontScale: number;
  columnConfigs: Array<{
    __typename?: 'SubstitutionPrintColumnConfigItem';
    position: number;
    column: SubstitutionColumns;
    print: boolean;
    width: number;
    sortOrder: number;
    sortDirection: string;
  }>;
};

export type SubstitutionPrintConfigQueryVariables = Exact<{ [key: string]: never }>;

export type SubstitutionPrintConfigQuery = {
  __typename?: 'Query';
  substitutionPrintConfig?: {
    __typename?: 'SubstitutionPrintConfigItem';
    uuid: string;
    showMissingTeachers: boolean;
    showMissingTeachersShortName: boolean;
    showAnnouncements: boolean;
    showSchoolEvents: boolean;
    useTeacherShortname: boolean;
    pageOrientation: string;
    printImages: boolean;
    useLessonName: boolean;
    lineScale: number;
    fontScale: number;
    columnConfigs: Array<{
      __typename?: 'SubstitutionPrintColumnConfigItem';
      position: number;
      column: SubstitutionColumns;
      print: boolean;
      width: number;
      sortOrder: number;
      sortDirection: string;
    }>;
  } | null;
};

export type SaveSubstitutionPrintConfigMutationVariables = Exact<{
  input: SubstitutionPrintConfigInput;
}>;

export type SaveSubstitutionPrintConfigMutation = {
  __typename?: 'Mutation';
  saveSubstitutionPrintConfig: {
    __typename?: 'SubstitutionPrintConfigItem';
    uuid: string;
    showMissingTeachers: boolean;
    showMissingTeachersShortName: boolean;
    showAnnouncements: boolean;
    showSchoolEvents: boolean;
    useTeacherShortname: boolean;
    pageOrientation: string;
    printImages: boolean;
    useLessonName: boolean;
    lineScale: number;
    fontScale: number;
    columnConfigs: Array<{
      __typename?: 'SubstitutionPrintColumnConfigItem';
      position: number;
      column: SubstitutionColumns;
      print: boolean;
      width: number;
      sortOrder: number;
      sortDirection: string;
    }>;
  };
};

export type SubstitutionAppConfigItemFragment = {
  __typename?: 'SubstitutionAppConfigItem';
  uuid: string;
  teacherPassword: string;
  studentPassword: string;
  allowIndividualLogins: boolean;
  useTeacherShortname: boolean;
  useClassShortname: boolean;
  useRoomShortname: boolean;
  timeDisplayMode: string;
  showClassGroups: boolean;
  showOriginalSubject: boolean;
  showCurrentSubject: boolean;
  showHolidays: boolean;
};

export type SubstitutionAppConfigQueryVariables = Exact<{ [key: string]: never }>;

export type SubstitutionAppConfigQuery = {
  __typename?: 'Query';
  substitutionAppConfig?: {
    __typename?: 'SubstitutionAppConfigItem';
    uuid: string;
    teacherPassword: string;
    studentPassword: string;
    allowIndividualLogins: boolean;
    useTeacherShortname: boolean;
    useClassShortname: boolean;
    useRoomShortname: boolean;
    timeDisplayMode: string;
    showClassGroups: boolean;
    showOriginalSubject: boolean;
    showCurrentSubject: boolean;
    showHolidays: boolean;
  } | null;
};

export type SaveSubstitutionAppConfigMutationVariables = Exact<{
  input: SubstitutionAppConfigInput;
}>;

export type SaveSubstitutionAppConfigMutation = {
  __typename?: 'Mutation';
  saveSubstitutionAppConfig: {
    __typename?: 'SubstitutionAppConfigItem';
    uuid: string;
    teacherPassword: string;
    studentPassword: string;
    allowIndividualLogins: boolean;
    useTeacherShortname: boolean;
    useClassShortname: boolean;
    useRoomShortname: boolean;
    timeDisplayMode: string;
    showClassGroups: boolean;
    showOriginalSubject: boolean;
    showCurrentSubject: boolean;
    showHolidays: boolean;
  };
};

export type SubstitutionReportQueryVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
  type?: InputMaybe<SubstitutionReportType>;
}>;

export type SubstitutionReportQuery = {
  __typename?: 'Query';
  substitutionReports: Array<{
    __typename?: 'SubstitutionReportItem';
    uuid: string;
    type: SubstitutionReportType;
    title: string;
    jobCreated?: string | null;
    jobFinished?: string | null;
    fileEntries: Array<{ __typename?: 'ReportFileEntryItem'; uuid: string; filename?: string | null }>;
  }>;
};

export type AttendancePlanEventsQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  day: Scalars['Date']['input'];
}>;

export type AttendancePlanEventsQuery = {
  __typename?: 'Query';
  attendancePlanEvents: Array<{
    __typename?: 'AttendancePlanEvent';
    uuid: string;
    start: string;
    end: string;
    subject: { __typename?: 'MinimalSubject'; uuid: string; shortName: string; name: string };
    persons: Array<{
      __typename: 'MinimalPerson';
      uuid: string;
      displayName: string;
      firstName: string;
      lastName: string;
      listName: string;
      selectName: string;
    }>;
    rooms: Array<{ __typename?: 'MinimalRoom'; uuid: string; name: string }>;
    class: { __typename?: 'MinimalClass'; uuid: string; shortName: string; name: string };
  }>;
};

export type CancelEventJobMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type CancelEventJobMutation = {
  __typename?: 'Mutation';
  cancelEventJob?: { __typename?: 'EventJobItem'; uuid: string; status: EventJobStatus } | null;
};

export type TeachingBlockClassTripCardsQueryVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
}>;

export type TeachingBlockClassTripCardsQuery = {
  __typename?: 'Query';
  teachingBlockClassTripCards: Array<{
    __typename?: 'TeachingBlockClassTripCard';
    cardUuid: string;
    teachingBlockUuid: string;
    subjectContainerName: string;
    versionUuid: string;
    version: number;
    startDate: string;
    endDate: string;
    teacherUuids: Array<string>;
    roomUuids: Array<string>;
    subjectName: string;
    subjectShortName: string;
    classes: Array<{ __typename?: 'TeachingBlockClassTripClass'; uuid: string; shortName: string }>;
  }>;
};

export type CreateBackendTeachingBlockVersionMutationVariables = Exact<{
  subjectContainerUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  connectLessons?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateBackendTeachingBlockVersionMutation = {
  __typename?: 'Mutation';
  createBackendTeachingBlockVersion: { __typename?: 'CreateResponse'; nodeUuids: Array<string>; nodesCreated: number };
};

export type TeachingBlockVersionCardFragment = {
  __typename?: 'TeachingBlockVersionCard';
  uuid: string;
  lessonUuid: string;
  duration?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  includeHoliday: boolean;
  locked: boolean;
  roomUuids: Array<string>;
};

export type CreateTeachingBlockCardsMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  lessonUuid: Scalars['ID']['input'];
  durations: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type CreateTeachingBlockCardsMutation = {
  __typename?: 'Mutation';
  createTeachingBlockCards: Array<{
    __typename?: 'TeachingBlockVersionCard';
    uuid: string;
    lessonUuid: string;
    duration?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    includeHoliday: boolean;
    locked: boolean;
    roomUuids: Array<string>;
  }>;
};

export type PlaceTeachingBlockCardMutationVariables = Exact<{
  cardUuid: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  includeHoliday: Scalars['Boolean']['input'];
}>;

export type PlaceTeachingBlockCardMutation = {
  __typename?: 'Mutation';
  placeTeachingBlockCard: {
    __typename?: 'TeachingBlockVersionCard';
    uuid: string;
    lessonUuid: string;
    duration?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    includeHoliday: boolean;
    locked: boolean;
    roomUuids: Array<string>;
  };
};

export type UnplaceTeachingBlockCardsMutationVariables = Exact<{
  cardUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type UnplaceTeachingBlockCardsMutation = {
  __typename?: 'Mutation';
  unplaceTeachingBlockCards: Array<{
    __typename?: 'TeachingBlockVersionCard';
    uuid: string;
    lessonUuid: string;
    duration?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    includeHoliday: boolean;
    locked: boolean;
    roomUuids: Array<string>;
  }>;
};

export type SetTeachingBlockCardsLockedMutationVariables = Exact<{
  cardUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  locked: Scalars['Boolean']['input'];
}>;

export type SetTeachingBlockCardsLockedMutation = {
  __typename?: 'Mutation';
  setTeachingBlockCardsLocked: Array<{
    __typename?: 'TeachingBlockVersionCard';
    uuid: string;
    lessonUuid: string;
    duration?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    includeHoliday: boolean;
    locked: boolean;
    roomUuids: Array<string>;
  }>;
};

export type SetTeachingBlockCardRoomsMutationVariables = Exact<{
  cardUuid: Scalars['ID']['input'];
  roomUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type SetTeachingBlockCardRoomsMutation = {
  __typename?: 'Mutation';
  setTeachingBlockCardRooms: {
    __typename?: 'TeachingBlockVersionCard';
    uuid: string;
    lessonUuid: string;
    duration?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    includeHoliday: boolean;
    locked: boolean;
    roomUuids: Array<string>;
  };
};

export type DeleteTeachingBlockCardsMutationVariables = Exact<{
  cardUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteTeachingBlockCardsMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlockCards: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type DeleteTeachingBlockVersionMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteTeachingBlockVersionMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlockVersion: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type DuplicateTeachingBlockVersionMutationVariables = Exact<{
  teachingBlockVersionUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  options: DuplicateTeachingBlockVersionOptions;
}>;

export type DuplicateTeachingBlockVersionMutation = {
  __typename?: 'Mutation';
  duplicateTeachingBlockVersion: {
    __typename?: 'DuplicateTeachingBlockVersionResponse';
    active?: boolean | null;
    description?: string | null;
    uuid: string;
    version: number;
  };
};

export type UpdateTeachingBlockVersionMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: TeachingBlockVersionInput;
}>;

export type UpdateTeachingBlockVersionMutation = {
  __typename?: 'Mutation';
  updateTeachingBlockVersion: {
    __typename?: 'TeachingBlockVersionMeta';
    versionUuid: string;
    description?: string | null;
    active: boolean;
    editable: boolean;
  };
};

export type SetTeachingBlockVersionEditableMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  editable: Scalars['Boolean']['input'];
}>;

export type SetTeachingBlockVersionEditableMutation = {
  __typename?: 'Mutation';
  setTeachingBlockVersionEditable: { __typename?: 'TeachingBlockVersionMeta'; versionUuid: string; editable: boolean };
};

export type AddTeachingBlockVersionResourcesMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  resourceType: TeachingBlockResourceType;
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AddTeachingBlockVersionResourcesMutation = {
  __typename?: 'Mutation';
  addTeachingBlockVersionResources: Array<{
    __typename?: 'TeachingBlockVersionResource';
    resourceType: TeachingBlockResourceType;
    uuid: string;
    constraints?: string | null;
  }>;
};

export type RemoveTeachingBlockVersionResourcesMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  resourceType: TeachingBlockResourceType;
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RemoveTeachingBlockVersionResourcesMutation = {
  __typename?: 'Mutation';
  removeTeachingBlockVersionResources: Array<{
    __typename?: 'TeachingBlockVersionResource';
    resourceType: TeachingBlockResourceType;
    uuid: string;
    constraints?: string | null;
  }>;
};

export type SubjectContainerPlaceholderLessonsQueryVariables = Exact<{
  subjectContainerUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
}>;

export type SubjectContainerPlaceholderLessonsQuery = {
  __typename?: 'Query';
  lessonsForSubjectContainer: Array<{
    __typename?: 'LessonItem';
    uuid: string;
    lessonClasses: Array<{
      __typename?: 'LessonClassItem';
      class: { __typename?: 'LessonClassClassItem'; uuid: string };
    }>;
  }>;
};

export type TeachingBlockVersionDataQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type TeachingBlockVersionDataQuery = {
  __typename?: 'Query';
  teachingBlockVersionData?: {
    __typename?: 'TeachingBlockVersionData';
    meta: {
      __typename?: 'TeachingBlockVersionMeta';
      versionUuid: string;
      version: number;
      description?: string | null;
      active: boolean;
      editable: boolean;
      isSnapshot: boolean;
      teachingBlockUuid: string;
      teachingBlockName: string;
      teachingBlockDraft: boolean;
      subjectContainerUuid: string;
      schoolYearUuid: string;
    };
    resources: Array<{
      __typename?: 'TeachingBlockVersionResource';
      resourceType: TeachingBlockResourceType;
      uuid: string;
      constraints?: string | null;
    }>;
    cards: Array<{
      __typename?: 'TeachingBlockVersionCard';
      uuid: string;
      lessonUuid: string;
      duration?: number | null;
      startDate?: string | null;
      endDate?: string | null;
      includeHoliday: boolean;
      locked: boolean;
      roomUuids: Array<string>;
    }>;
    exclusions: Array<{
      __typename?: 'TeachingBlockVersionExclusion';
      uuid: string;
      holderType: TeachingBlockResourceType;
      holderUuid: string;
      from: string;
      to: string;
      priority: number;
      comment?: string | null;
    }>;
  } | null;
};

export type TeachingBlockItemFragment = {
  __typename: 'TeachingBlockItem';
  uuid: string;
  name: string;
  draft: boolean;
  comment?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  schoolYearUuid: string;
  subjectContainerUuid: string;
  versions: Array<{
    __typename: 'TeachingBlockVersionListItem';
    uuid: string;
    version: number;
    active: boolean;
    editable: boolean;
    isSnapshot: boolean;
    description?: string | null;
    cardsCount: number;
    parentUuid?: string | null;
    originalUuid?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  }>;
};

export type TeachingBlocksQueryVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
  onlyWithActiveVersion?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type TeachingBlocksQuery = {
  __typename?: 'Query';
  teachingBlocks: Array<{
    __typename: 'TeachingBlockItem';
    uuid: string;
    name: string;
    draft: boolean;
    comment?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    schoolYearUuid: string;
    subjectContainerUuid: string;
    versions: Array<{
      __typename: 'TeachingBlockVersionListItem';
      uuid: string;
      version: number;
      active: boolean;
      editable: boolean;
      isSnapshot: boolean;
      description?: string | null;
      cardsCount: number;
      parentUuid?: string | null;
      originalUuid?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    }>;
  }>;
};

export type TeachingBlockForVersionQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type TeachingBlockForVersionQuery = {
  __typename?: 'Query';
  teachingBlockForVersion?: {
    __typename: 'TeachingBlockItem';
    uuid: string;
    name: string;
    draft: boolean;
    comment?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    schoolYearUuid: string;
    subjectContainerUuid: string;
    versions: Array<{
      __typename: 'TeachingBlockVersionListItem';
      uuid: string;
      version: number;
      active: boolean;
      editable: boolean;
      isSnapshot: boolean;
      description?: string | null;
      cardsCount: number;
      parentUuid?: string | null;
      originalUuid?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    }>;
  } | null;
};

export type TeachingBlockForSubjectContainerQueryVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
  subjectContainerUuid: Scalars['ID']['input'];
}>;

export type TeachingBlockForSubjectContainerQuery = {
  __typename?: 'Query';
  teachingBlockForSubjectContainer?: {
    __typename: 'TeachingBlockItem';
    uuid: string;
    name: string;
    draft: boolean;
    comment?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    schoolYearUuid: string;
    subjectContainerUuid: string;
    versions: Array<{
      __typename: 'TeachingBlockVersionListItem';
      uuid: string;
      version: number;
      active: boolean;
      editable: boolean;
      isSnapshot: boolean;
      description?: string | null;
      cardsCount: number;
      parentUuid?: string | null;
      originalUuid?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    }>;
  } | null;
};

export type SetTeachingBlockCommentMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;

export type SetTeachingBlockCommentMutation = {
  __typename?: 'Mutation';
  setTeachingBlockComment: {
    __typename: 'TeachingBlockItem';
    uuid: string;
    name: string;
    draft: boolean;
    comment?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    schoolYearUuid: string;
    subjectContainerUuid: string;
    versions: Array<{
      __typename: 'TeachingBlockVersionListItem';
      uuid: string;
      version: number;
      active: boolean;
      editable: boolean;
      isSnapshot: boolean;
      description?: string | null;
      cardsCount: number;
      parentUuid?: string | null;
      originalUuid?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    }>;
  };
};

export type DeleteTeachingBlockMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteTeachingBlockMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlock: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type TeachingBlockCurrentStatusQueryVariables = Exact<{
  teachingBlockUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type TeachingBlockCurrentStatusQuery = {
  __typename?: 'Query';
  teachingBlockCurrentStatus: Array<{
    __typename: 'TeachingBlockCurrentStatus';
    currentFrom?: string | null;
    isCurrent: boolean;
    teachingBlockUuid: string;
  }>;
};

export type TimeGridEntryItemFragment = {
  __typename?: 'TimeGridEntryItem';
  uuid: string;
  name: string;
  shortName: string;
  start: string;
  end: string;
  order: number;
  reliable: boolean;
  pause: boolean;
  print: boolean;
};

export type TimeGridItemFragment = {
  __typename?: 'TimeGridItem';
  uuid: string;
  name: string;
  description: string;
  entries: Array<{
    __typename?: 'TimeGridEntryItem';
    uuid: string;
    name: string;
    shortName: string;
    start: string;
    end: string;
    order: number;
    reliable: boolean;
    pause: boolean;
    print: boolean;
  }>;
};

export type DeleteTimeGridEntryMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteTimeGridEntryMutation = {
  __typename?: 'Mutation';
  deleteTimeGridEntry: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type UpdateTimeGridEntryMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  update: UpdateTimeGridEntryInput;
}>;

export type UpdateTimeGridEntryMutation = {
  __typename?: 'Mutation';
  updateTimeGridEntry: { __typename: 'UpdateResponse'; nodeUuids: Array<string> };
};

export type CreateTimeGridEntryMutationVariables = Exact<{
  input: CreateTimeGridEntryInput;
}>;

export type CreateTimeGridEntryMutation = {
  __typename?: 'Mutation';
  createTimeGridEntry: { __typename: 'CreateResponse'; nodeUuids: Array<string> };
};

export type UpdateTimeGridMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: TimeGridInput;
}>;

export type UpdateTimeGridMutation = {
  __typename?: 'Mutation';
  updateTimeGrid: { __typename?: 'TimeGridItem'; uuid: string };
};

export type CreateTimeGridMutationVariables = Exact<{
  input: TimeGridInput;
}>;

export type CreateTimeGridMutation = {
  __typename?: 'Mutation';
  createTimeGrid: { __typename?: 'TimeGridItem'; uuid: string };
};

export type TimeGridQueryVariables = Exact<{ [key: string]: never }>;

export type TimeGridQuery = {
  __typename?: 'Query';
  timeGrids: Array<{
    __typename?: 'TimeGridItem';
    uuid: string;
    name: string;
    description: string;
    entries: Array<{
      __typename?: 'TimeGridEntryItem';
      uuid: string;
      name: string;
      shortName: string;
      start: string;
      end: string;
      order: number;
      reliable: boolean;
      pause: boolean;
      print: boolean;
    }>;
  }>;
};

export type TimeGridEntryUsageQueryVariables = Exact<{
  timeGridUuid: Scalars['ID']['input'];
}>;

export type TimeGridEntryUsageQuery = {
  __typename?: 'Query';
  timeGridEntryUsage: Array<{ __typename?: 'TimeGridEntryUsage'; uuid: string; placedCardsCount: number }>;
};

export type TimeGridMigrationCardsQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type TimeGridMigrationCardsQuery = {
  __typename?: 'Query';
  placedTimetableCards: Array<{
    __typename?: 'TimetableCardItem';
    uuid: string;
    startTimeGridEntryUuid?: string | null;
    endTimeGridEntryUuid?: string | null;
  }>;
};

export type TimetableItemFragment = {
  __typename: 'TimetableItem';
  uuid: string;
  name: string;
  draft: boolean;
  comment?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  schoolYearUuid: string;
  monEnabled: boolean;
  tueEnabled: boolean;
  wedEnabled: boolean;
  thuEnabled: boolean;
  friEnabled: boolean;
  satEnabled: boolean;
  sunEnabled: boolean;
  timegridConfigs: Array<{
    __typename?: 'TimetableTimegridConfigItem';
    order: number;
    timegridUuid?: string | null;
    classUuids: Array<string>;
  }>;
  versions: Array<{
    __typename: 'TimetableVersionListItem';
    uuid: string;
    version: number;
    active: boolean;
    editable: boolean;
    isSnapshot: boolean;
    description?: string | null;
    cardsCount: number;
    placedCardsCount: number;
    parentUuid?: string | null;
    originalUuid?: string | null;
    classUuids: Array<string>;
    createdAt?: string | null;
    updatedAt?: string | null;
  }>;
  timetableBlocks: Array<{ __typename?: 'TimetableBlockRefItem'; uuid: string; start: string; end: string }>;
};

export type TimetablesQueryVariables = Exact<{
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TimetablesQuery = {
  __typename?: 'Query';
  timetables: Array<{
    __typename: 'TimetableItem';
    uuid: string;
    name: string;
    draft: boolean;
    comment?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    schoolYearUuid: string;
    monEnabled: boolean;
    tueEnabled: boolean;
    wedEnabled: boolean;
    thuEnabled: boolean;
    friEnabled: boolean;
    satEnabled: boolean;
    sunEnabled: boolean;
    timegridConfigs: Array<{
      __typename?: 'TimetableTimegridConfigItem';
      order: number;
      timegridUuid?: string | null;
      classUuids: Array<string>;
    }>;
    versions: Array<{
      __typename: 'TimetableVersionListItem';
      uuid: string;
      version: number;
      active: boolean;
      editable: boolean;
      isSnapshot: boolean;
      description?: string | null;
      cardsCount: number;
      placedCardsCount: number;
      parentUuid?: string | null;
      originalUuid?: string | null;
      classUuids: Array<string>;
      createdAt?: string | null;
      updatedAt?: string | null;
    }>;
    timetableBlocks: Array<{ __typename?: 'TimetableBlockRefItem'; uuid: string; start: string; end: string }>;
  }>;
};

export type TimetableForVersionQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type TimetableForVersionQuery = {
  __typename?: 'Query';
  timetableForVersion?: {
    __typename: 'TimetableItem';
    uuid: string;
    name: string;
    draft: boolean;
    comment?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    schoolYearUuid: string;
    monEnabled: boolean;
    tueEnabled: boolean;
    wedEnabled: boolean;
    thuEnabled: boolean;
    friEnabled: boolean;
    satEnabled: boolean;
    sunEnabled: boolean;
    timegridConfigs: Array<{
      __typename?: 'TimetableTimegridConfigItem';
      order: number;
      timegridUuid?: string | null;
      classUuids: Array<string>;
    }>;
    versions: Array<{
      __typename: 'TimetableVersionListItem';
      uuid: string;
      version: number;
      active: boolean;
      editable: boolean;
      isSnapshot: boolean;
      description?: string | null;
      cardsCount: number;
      placedCardsCount: number;
      parentUuid?: string | null;
      originalUuid?: string | null;
      classUuids: Array<string>;
      createdAt?: string | null;
      updatedAt?: string | null;
    }>;
    timetableBlocks: Array<{ __typename?: 'TimetableBlockRefItem'; uuid: string; start: string; end: string }>;
  } | null;
};

export type CreateTimetableMutationVariables = Exact<{
  input: TimetableInput;
}>;

export type CreateTimetableMutation = {
  __typename?: 'Mutation';
  createTimetable: {
    __typename: 'TimetableItem';
    uuid: string;
    name: string;
    draft: boolean;
    comment?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    schoolYearUuid: string;
    monEnabled: boolean;
    tueEnabled: boolean;
    wedEnabled: boolean;
    thuEnabled: boolean;
    friEnabled: boolean;
    satEnabled: boolean;
    sunEnabled: boolean;
    timegridConfigs: Array<{
      __typename?: 'TimetableTimegridConfigItem';
      order: number;
      timegridUuid?: string | null;
      classUuids: Array<string>;
    }>;
    versions: Array<{
      __typename: 'TimetableVersionListItem';
      uuid: string;
      version: number;
      active: boolean;
      editable: boolean;
      isSnapshot: boolean;
      description?: string | null;
      cardsCount: number;
      placedCardsCount: number;
      parentUuid?: string | null;
      originalUuid?: string | null;
      classUuids: Array<string>;
      createdAt?: string | null;
      updatedAt?: string | null;
    }>;
    timetableBlocks: Array<{ __typename?: 'TimetableBlockRefItem'; uuid: string; start: string; end: string }>;
  };
};

export type UpdateTimetableMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: TimetableInput;
}>;

export type UpdateTimetableMutation = {
  __typename?: 'Mutation';
  updateTimetable: {
    __typename: 'TimetableItem';
    uuid: string;
    name: string;
    draft: boolean;
    comment?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    schoolYearUuid: string;
    monEnabled: boolean;
    tueEnabled: boolean;
    wedEnabled: boolean;
    thuEnabled: boolean;
    friEnabled: boolean;
    satEnabled: boolean;
    sunEnabled: boolean;
    timegridConfigs: Array<{
      __typename?: 'TimetableTimegridConfigItem';
      order: number;
      timegridUuid?: string | null;
      classUuids: Array<string>;
    }>;
    versions: Array<{
      __typename: 'TimetableVersionListItem';
      uuid: string;
      version: number;
      active: boolean;
      editable: boolean;
      isSnapshot: boolean;
      description?: string | null;
      cardsCount: number;
      placedCardsCount: number;
      parentUuid?: string | null;
      originalUuid?: string | null;
      classUuids: Array<string>;
      createdAt?: string | null;
      updatedAt?: string | null;
    }>;
    timetableBlocks: Array<{ __typename?: 'TimetableBlockRefItem'; uuid: string; start: string; end: string }>;
  };
};

export type DeleteTimetablesMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteTimetablesMutation = {
  __typename?: 'Mutation';
  deleteTimetables: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type TimetableBlockItemFragment = {
  __typename: 'TimetableBlockItem';
  uuid: string;
  name: string;
  start: string;
  end: string;
  schoolYearUuid: string;
  teachingLoadFactor?: number | null;
  teachingLoadComment?: string | null;
  teachingLoadCalculated?: number | null;
  timetables: Array<{
    __typename: 'TimetableBlockTimetableItem';
    uuid: string;
    name: string;
    activeVersionUuid?: string | null;
  }>;
};

export type TimetableBlocksQueryVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
  onlyWithActiveVersion?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
}>;

export type TimetableBlocksQuery = {
  __typename?: 'Query';
  timetableBlocks: Array<{
    __typename: 'TimetableBlockItem';
    uuid: string;
    name: string;
    start: string;
    end: string;
    schoolYearUuid: string;
    teachingLoadFactor?: number | null;
    teachingLoadComment?: string | null;
    teachingLoadCalculated?: number | null;
    timetables: Array<{
      __typename: 'TimetableBlockTimetableItem';
      uuid: string;
      name: string;
      activeVersionUuid?: string | null;
    }>;
  }>;
};

export type TimetableBlockQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type TimetableBlockQuery = {
  __typename?: 'Query';
  timetableBlock?: {
    __typename: 'TimetableBlockItem';
    uuid: string;
    name: string;
    start: string;
    end: string;
    schoolYearUuid: string;
    teachingLoadFactor?: number | null;
    teachingLoadComment?: string | null;
    teachingLoadCalculated?: number | null;
    timetables: Array<{
      __typename: 'TimetableBlockTimetableItem';
      uuid: string;
      name: string;
      activeVersionUuid?: string | null;
    }>;
  } | null;
};

export type CreateTimetableBlockMutationVariables = Exact<{
  input: TimetableBlockInput;
}>;

export type CreateTimetableBlockMutation = {
  __typename?: 'Mutation';
  createTimetableBlock: {
    __typename: 'TimetableBlockItem';
    uuid: string;
    name: string;
    start: string;
    end: string;
    schoolYearUuid: string;
    teachingLoadFactor?: number | null;
    teachingLoadComment?: string | null;
    teachingLoadCalculated?: number | null;
    timetables: Array<{
      __typename: 'TimetableBlockTimetableItem';
      uuid: string;
      name: string;
      activeVersionUuid?: string | null;
    }>;
  };
};

export type UpdateTimetableBlockMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: TimetableBlockInput;
}>;

export type UpdateTimetableBlockMutation = {
  __typename?: 'Mutation';
  updateTimetableBlock: {
    __typename: 'TimetableBlockItem';
    uuid: string;
    name: string;
    start: string;
    end: string;
    schoolYearUuid: string;
    teachingLoadFactor?: number | null;
    teachingLoadComment?: string | null;
    teachingLoadCalculated?: number | null;
    timetables: Array<{
      __typename: 'TimetableBlockTimetableItem';
      uuid: string;
      name: string;
      activeVersionUuid?: string | null;
    }>;
  };
};

export type SetTimetableBlockTeachingLoadFactorMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  factor: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;

export type SetTimetableBlockTeachingLoadFactorMutation = {
  __typename?: 'Mutation';
  setTimetableBlockTeachingLoadFactor: {
    __typename: 'TimetableBlockItem';
    uuid: string;
    name: string;
    start: string;
    end: string;
    schoolYearUuid: string;
    teachingLoadFactor?: number | null;
    teachingLoadComment?: string | null;
    teachingLoadCalculated?: number | null;
    timetables: Array<{
      __typename: 'TimetableBlockTimetableItem';
      uuid: string;
      name: string;
      activeVersionUuid?: string | null;
    }>;
  };
};

export type DeleteTimetableBlockMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteTimetableBlockMutation = {
  __typename?: 'Mutation';
  deleteTimetableBlock: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type SetCardRoomsMutationVariables = Exact<{
  cardUuid: Scalars['ID']['input'];
  roomUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type SetCardRoomsMutation = {
  __typename?: 'Mutation';
  setTimetableCardRooms: { __typename?: 'UpdateResponse'; nodesUpdated: number };
};

export type CreateTimetableVersionMutationVariables = Exact<{
  timetableUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type CreateTimetableVersionMutation = {
  __typename?: 'Mutation';
  createTimetableVersion: { __typename?: 'CreateResponse'; nodeUuids: Array<string>; nodesCreated: number };
};

export type DuplicateTimetableVersionMutationVariables = Exact<{
  timetableVersionUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  options: DuplicateTimetableVersionOptions;
}>;

export type DuplicateTimetableVersionMutation = {
  __typename?: 'Mutation';
  duplicateTimetableVersion: {
    __typename?: 'DuplicateTimetableVersionResponse';
    active?: boolean | null;
    description?: string | null;
    uuid: string;
    version: number;
  };
};

export type DeleteTimetableVersionMutationVariables = Exact<{
  timetableVersionUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type DeleteTimetableVersionMutation = {
  __typename?: 'Mutation';
  deleteTimetableVersion: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type TimetableCardItemFragment = {
  __typename: 'TimetableCardItem';
  uuid: string;
  lessonUuid: string;
  duration?: number | null;
  weekday?: string | null;
  locked: boolean;
  startTimeGridEntryUuid?: string | null;
  endTimeGridEntryUuid?: string | null;
  subjectContainerUuid?: string | null;
  roomUuids: Array<string>;
};

export type TimetableCardsForLessonQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  lessonUuid: Scalars['ID']['input'];
}>;

export type TimetableCardsForLessonQuery = {
  __typename?: 'Query';
  timetableCardsForLesson: Array<{
    __typename: 'TimetableCardItem';
    uuid: string;
    lessonUuid: string;
    duration?: number | null;
    weekday?: string | null;
    locked: boolean;
    startTimeGridEntryUuid?: string | null;
    endTimeGridEntryUuid?: string | null;
    subjectContainerUuid?: string | null;
    roomUuids: Array<string>;
  }>;
};

export type TimetableCardsCountForTimeGridEntryQueryVariables = Exact<{
  timeGridEntryUuid: Scalars['ID']['input'];
}>;

export type TimetableCardsCountForTimeGridEntryQuery = {
  __typename?: 'Query';
  timetableCardsCountForTimeGridEntry: number;
};

export type CreateTimetableCardsMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  lessonUuid: Scalars['ID']['input'];
  durations: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  subjectContainerUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CreateTimetableCardsMutation = {
  __typename?: 'Mutation';
  createTimetableCards: Array<{
    __typename: 'TimetableCardItem';
    uuid: string;
    lessonUuid: string;
    duration?: number | null;
    weekday?: string | null;
    locked: boolean;
    startTimeGridEntryUuid?: string | null;
    endTimeGridEntryUuid?: string | null;
    subjectContainerUuid?: string | null;
    roomUuids: Array<string>;
  }>;
};

export type PlaceTimetableCardMutationVariables = Exact<{
  cardUuid: Scalars['ID']['input'];
  weekday: Scalars['String']['input'];
  startTimeGridEntryUuid: Scalars['ID']['input'];
  endTimeGridEntryUuid: Scalars['ID']['input'];
}>;

export type PlaceTimetableCardMutation = { __typename?: 'Mutation'; placeTimetableCard: string };

export type UnplaceTimetableCardsMutationVariables = Exact<{
  cardUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type UnplaceTimetableCardsMutation = { __typename?: 'Mutation'; unplaceTimetableCards: Array<string> };

export type SetTimetableCardsLockedMutationVariables = Exact<{
  cardUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  locked: Scalars['Boolean']['input'];
}>;

export type SetTimetableCardsLockedMutation = { __typename?: 'Mutation'; setTimetableCardsLocked: Array<string> };

export type DeleteTimetableCardsMutationVariables = Exact<{
  cardUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteTimetableCardsMutation = {
  __typename?: 'Mutation';
  deleteTimetableCards: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type TimetableVersionMetaItemFragment = {
  __typename: 'TimetableVersionMeta';
  versionUuid: string;
  version: number;
  description?: string | null;
  active: boolean;
  editable: boolean;
  isSnapshot: boolean;
  timetableUuid: string;
  timetableName: string;
  timetableDraft: boolean;
  schoolYearUuid: string;
};

export type TimetableVersionAvailabilityItemFragment = {
  __typename: 'TimetableVersionResourceAvailability';
  resourceType: TimetableVersionResourceType;
  resourceUuid: string;
  mon?: string | null;
  tue?: string | null;
  wed?: string | null;
  thu?: string | null;
  fri?: string | null;
  sat?: string | null;
  sun?: string | null;
};

export type TimetableVersionConstraintsItemFragment = {
  __typename: 'TimetableVersionConstraints';
  resourceType: TimetableVersionResourceType;
  resourceUuid: string;
  constraints?: string | null;
};

export type TimetableVersionMetaQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type TimetableVersionMetaQuery = {
  __typename?: 'Query';
  timetableVersion?: {
    __typename: 'TimetableVersionMeta';
    versionUuid: string;
    version: number;
    description?: string | null;
    active: boolean;
    editable: boolean;
    isSnapshot: boolean;
    timetableUuid: string;
    timetableName: string;
    timetableDraft: boolean;
    schoolYearUuid: string;
  } | null;
};

export type ActiveTimetableVersionsQueryVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
}>;

export type ActiveTimetableVersionsQuery = {
  __typename?: 'Query';
  activeTimetableVersions: Array<{
    __typename: 'ActiveTimetableVersion';
    uuid: string;
    version: number;
    timetableUuid: string;
    timetableName: string;
    classUuids: Array<string>;
    teacherUuids: Array<string>;
    roomUuids: Array<string>;
  }>;
};

export type TimetableVersionAvailabilitiesQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  resourceType?: InputMaybe<TimetableVersionResourceType>;
}>;

export type TimetableVersionAvailabilitiesQuery = {
  __typename?: 'Query';
  timetableVersionAvailabilities: Array<{
    __typename: 'TimetableVersionResourceAvailability';
    resourceType: TimetableVersionResourceType;
    resourceUuid: string;
    mon?: string | null;
    tue?: string | null;
    wed?: string | null;
    thu?: string | null;
    fri?: string | null;
    sat?: string | null;
    sun?: string | null;
  }>;
};

export type TimetableVersionConstraintsQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  resourceType: TimetableVersionResourceType;
  resourceUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type TimetableVersionConstraintsQuery = {
  __typename?: 'Query';
  timetableVersionConstraints: Array<{
    __typename: 'TimetableVersionConstraints';
    resourceType: TimetableVersionResourceType;
    resourceUuid: string;
    constraints?: string | null;
  }>;
};

export type TimetableVersionConstraintSettingsQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type TimetableVersionConstraintSettingsQuery = {
  __typename?: 'Query';
  timetableVersionConstraintSettings?: string | null;
};

export type UpdateTimetableVersionMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: TimetableVersionInput;
}>;

export type UpdateTimetableVersionMutation = {
  __typename?: 'Mutation';
  updateTimetableVersion: {
    __typename: 'TimetableVersionMeta';
    versionUuid: string;
    version: number;
    description?: string | null;
    active: boolean;
    editable: boolean;
    isSnapshot: boolean;
    timetableUuid: string;
    timetableName: string;
    timetableDraft: boolean;
    schoolYearUuid: string;
  };
};

export type SetTimetableVersionEditableMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  editable: Scalars['Boolean']['input'];
}>;

export type SetTimetableVersionEditableMutation = {
  __typename?: 'Mutation';
  setTimetableVersionEditable: {
    __typename: 'TimetableVersionMeta';
    versionUuid: string;
    version: number;
    description?: string | null;
    active: boolean;
    editable: boolean;
    isSnapshot: boolean;
    timetableUuid: string;
    timetableName: string;
    timetableDraft: boolean;
    schoolYearUuid: string;
  };
};

export type AddTimetableVersionResourcesMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  resourceType: TimetableVersionResourceType;
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AddTimetableVersionResourcesMutation = {
  __typename?: 'Mutation';
  addTimetableVersionResources: Array<{
    __typename: 'TimetableVersionResourceAvailability';
    resourceType: TimetableVersionResourceType;
    resourceUuid: string;
    mon?: string | null;
    tue?: string | null;
    wed?: string | null;
    thu?: string | null;
    fri?: string | null;
    sat?: string | null;
    sun?: string | null;
  }>;
};

export type RemoveTimetableVersionResourcesMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  resourceType: TimetableVersionResourceType;
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RemoveTimetableVersionResourcesMutation = {
  __typename?: 'Mutation';
  removeTimetableVersionResources: Array<{
    __typename: 'TimetableVersionResourceAvailability';
    resourceType: TimetableVersionResourceType;
    resourceUuid: string;
    mon?: string | null;
    tue?: string | null;
    wed?: string | null;
    thu?: string | null;
    fri?: string | null;
    sat?: string | null;
    sun?: string | null;
  }>;
};

export type SetTimetableVersionAvailabilityMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  resourceType: TimetableVersionResourceType;
  resourceUuid: Scalars['ID']['input'];
  availability: TimetableVersionAvailabilityInput;
}>;

export type SetTimetableVersionAvailabilityMutation = {
  __typename?: 'Mutation';
  setTimetableVersionAvailability: {
    __typename: 'TimetableVersionResourceAvailability';
    resourceType: TimetableVersionResourceType;
    resourceUuid: string;
    mon?: string | null;
    tue?: string | null;
    wed?: string | null;
    thu?: string | null;
    fri?: string | null;
    sat?: string | null;
    sun?: string | null;
  };
};

export type SetTimetableVersionConstraintsMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  resourceType: TimetableVersionResourceType;
  resourceUuid: Scalars['ID']['input'];
  constraints?: InputMaybe<Scalars['String']['input']>;
}>;

export type SetTimetableVersionConstraintsMutation = {
  __typename?: 'Mutation';
  setTimetableVersionConstraints: {
    __typename: 'TimetableVersionConstraints';
    resourceType: TimetableVersionResourceType;
    resourceUuid: string;
    constraints?: string | null;
  };
};

export type SetTimetableVersionConstraintSettingsMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
}>;

export type SetTimetableVersionConstraintSettingsMutation = {
  __typename?: 'Mutation';
  setTimetableVersionConstraintSettings?: string | null;
};

export type AddUserMutationVariables = Exact<{
  frontendUri: Scalars['String']['input'];
  planungPersonUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  profileUuid?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type AddUserMutation = {
  __typename?: 'Mutation';
  addUser: {
    __typename?: 'PimProfile';
    uuid: string;
    lastName: string;
    firstName: string;
    userStatus?: UserStatus | null;
    userEmail?: string | null;
    profileEmail?: string | null;
    role: string;
    permissions: Array<string>;
    accessGranted?: boolean | null;
    selectName?: string | null;
  };
};

export type UpdateGrantedProfilesMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  profiles: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  roles: Array<Scalars['String']['input']> | Scalars['String']['input'];
  frontendUri: Scalars['String']['input'];
}>;

export type UpdateGrantedProfilesMutation = {
  __typename?: 'Mutation';
  updateGrantedProfiles: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type UpdateUserPermissionsMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  profileUuid: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type UpdateUserPermissionsMutation = {
  __typename?: 'Mutation';
  updateUserPermissions: {
    __typename?: 'PimProfile';
    uuid: string;
    lastName: string;
    firstName: string;
    userStatus?: UserStatus | null;
    userEmail?: string | null;
    profileEmail?: string | null;
    role: string;
    permissions: Array<string>;
    accessGranted?: boolean | null;
    selectName?: string | null;
  };
};

export type InviteUserMutationVariables = Exact<{
  frontendUri: Scalars['String']['input'];
  organizationUuid: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  profileUuid: Scalars['ID']['input'];
}>;

export type InviteUserMutation = {
  __typename?: 'Mutation';
  inviteUser: {
    __typename?: 'PimProfile';
    uuid: string;
    lastName: string;
    firstName: string;
    userStatus?: UserStatus | null;
    userEmail?: string | null;
    profileEmail?: string | null;
    role: string;
    permissions: Array<string>;
    accessGranted?: boolean | null;
    selectName?: string | null;
  };
};

export type RemovePlanungAccessMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  profileUuid: Scalars['ID']['input'];
}>;

export type RemovePlanungAccessMutation = {
  __typename?: 'Mutation';
  removePlanungAccess: {
    __typename?: 'PimProfile';
    uuid: string;
    lastName: string;
    firstName: string;
    userStatus?: UserStatus | null;
    userEmail?: string | null;
    profileEmail?: string | null;
    role: string;
    permissions: Array<string>;
    accessGranted?: boolean | null;
    selectName?: string | null;
  };
};

export type PimProfilesQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type PimProfilesQuery = {
  __typename?: 'Query';
  pimProfiles: Array<{
    __typename?: 'PimProfile';
    uuid: string;
    lastName: string;
    firstName: string;
    userStatus?: UserStatus | null;
    userEmail?: string | null;
    profileEmail?: string | null;
    role: string;
    permissions: Array<string>;
    accessGranted?: boolean | null;
    selectName?: string | null;
  }>;
};

export type _TimetablePrintConfigFragment = {
  __typename: 'TimetablePrintConfigItem';
  uuid: string;
  type: TimetableReportType;
  topLeft?: TimetablePrintLayoutOptions | null;
  topCenter?: TimetablePrintLayoutOptions | null;
  topRight?: TimetablePrintLayoutOptions | null;
  center?: TimetablePrintLayoutOptions | null;
  bottomLeft?: TimetablePrintLayoutOptions | null;
  bottomCenter?: TimetablePrintLayoutOptions | null;
  bottomRight?: TimetablePrintLayoutOptions | null;
  printColorOrigin?: TimetablePrintColorOrigins | null;
  printColorPosition?: TimetablePrintColorPositions | null;
  printClasses?: boolean | null;
  scaleText?: boolean | null;
  exactMinute?: boolean | null;
  printSubtitle?: boolean | null;
  printLogo?: boolean | null;
  largeFont?: boolean | null;
  showSchoolWeeks?: boolean | null;
  showCalendarWeeks?: boolean | null;
  showWeekSchoolDays?: boolean | null;
  timeHorizontal?: boolean | null;
  epochGridOwnPage?: boolean | null;
  responsiblePersonNameFormat?: TimetablePrintPersonNameFormats | null;
};

export type _TeachingLoadReportConfigFragment = {
  __typename: 'TeachingLoadReportConfigItem';
  uuid: string;
  type: TeachingLoadReportType;
  noAdditionalTeachingLoad?: boolean | null;
  hidePaidTeachingLoad?: boolean | null;
  roundTeachingLoadResult?: number | null;
};

export type _SchoolEventFragment = {
  __typename: 'SchoolEvent';
  uuid: string;
  start: string;
  end: string;
  canceled: boolean;
  comment?: string | null;
  isClassTrip: boolean;
  recurrenceUuid?: string | null;
  groupClassNames: string;
  groupClassNamesLong: string;
  persons: Array<{ __typename: 'MinimalPerson'; uuid: string; displayName: string; listName: string }>;
  rooms: Array<{ __typename: 'MinimalRoom'; uuid: string; name: string }>;
  subject: { __typename: 'MinimalSubject'; uuid: string; name: string; shortName: string };
  classesOrGroups: Array<{ __typename: 'MinimalClass'; uuid: string } | { __typename: 'MinimalGroup'; uuid: string }>;
};

export type _EventFragment = {
  __typename: 'EventItem';
  uuid: string;
  start: string;
  end: string;
  comment?: string | null;
  canceled: boolean;
  currentState?: string | null;
  isClassTrip: boolean;
  isClassbookRelevant: boolean;
  substitutionReasons?: SubstitutionReason | null;
  substitutionComment?: string | null;
  print: boolean;
  timeGridEntryShortName?: string | null;
  aggregatedIntoUuid?: string | null;
  originalPersonUuids: Array<string>;
  subjectUuid?: string | null;
  roomUuids: Array<string>;
  isSchoolEvent: boolean;
  persons: Array<{
    __typename?: 'EventItemPerson';
    uuid: string;
    isCoveringTeacher: boolean;
    givenSubstituteHours?: number | null;
  }>;
  originalClassesOrGroups: Array<{ __typename?: 'EventClassOrGroupRef'; type: EventClassOrGroupType; uuid: string }>;
  classesOrGroups: Array<{ __typename?: 'EventClassOrGroupRef'; type: EventClassOrGroupType; uuid: string }>;
  originalRooms: Array<{ __typename?: 'EventItemRoom'; uuid: string; name: string }>;
};

export type _SchoolYearFragmentFragment = {
  __typename: 'SchoolYearItem';
  uuid: string;
  name: string;
  start: string;
  end: string;
};

export type _SubjectFragmentFragment = {
  __typename: 'SubjectItem';
  uuid: string;
  name: string;
  shortName: string;
  active?: boolean | null;
  epochEnabled?: boolean | null;
  subjectHourEnabled?: boolean | null;
  other?: boolean | null;
  defaultRooms: Array<{ __typename: 'RoomRefItem'; uuid: string }>;
  timetableConfig?: { __typename: 'TimetableConfigItem'; color?: string | null } | null;
};

export type _SubjectContainerFragmentFragment = {
  __typename: 'SubjectContainerItem';
  uuid: string;
  name: string;
  shortName: string;
  grades: Array<number>;
  validFrom?: { __typename: 'SchoolYearRefItem'; uuid: string } | null;
  validUntil?: { __typename: 'SchoolYearRefItem'; uuid: string } | null;
  gradeGroups: Array<{ __typename: 'GradeGroupRefItem'; uuid: string }>;
  timetableConfig?: { __typename: 'TimetableConfigItem'; uuid: string; color?: string | null } | null;
};

export type _PersonFragmentFragment = {
  __typename: 'PersonItem';
  uuid: string;
  firstName: string;
  lastName: string;
  displayName: string;
  displayNameShort: string;
  fullName: string;
  prefixName?: string | null;
  title?: string | null;
  selectName: string;
  pimProfileUuid?: string | null;
  listName: string;
  shortName: string;
  salutation?: string | null;
  birthday?: string | null;
  email?: string | null;
  personalId?: string | null;
  gender?: string | null;
  active: boolean;
  role?: PersonRole | null;
  contractUuids: Array<string>;
  defaultRoomUuid?: string | null;
  qualifications: Array<{
    __typename: 'QualificationItem';
    subjectUuid: string;
    maxGrade?: number | null;
    minGrade?: number | null;
    maxTeachingLoad?: number | null;
  }>;
  timetableConfig?: { __typename: 'TimetableConfigItem'; uuid: string; color?: string | null } | null;
};

export type _ContractFragmentFragment = {
  __typename: 'ContractItem';
  uuid: string;
  personUuid: string;
  name: string;
  validFrom: string;
  validUntil?: string | null;
  hoursWeekly?: number | null;
  freelancer?: boolean | null;
  billingMethod?: BillingMethods | null;
  limitedToFullTime?: boolean | null;
  substituteHours?: number | null;
};

export type _ClassFragmentFragment = {
  __typename: 'ClassItem';
  uuid: string;
  name: string;
  sortName: string;
  shortName: string;
  studentCount?: number | null;
  grade?: number | null;
  functionalClassSubstitutionBehavior?: FunctionalClassSubstitutionBehavior | null;
  relevantForSubstitution?: boolean | null;
  certificatesEnabled?: boolean | null;
  tutorUuids: Array<string>;
  defaultRoomUuid?: string | null;
  schoolYearUuid?: string | null;
  gradeGroup?: { __typename: 'GradeGroupRefItem'; uuid: string } | null;
  divisions: Array<{ __typename: 'ClassDivisionItem'; uuid: string }>;
  timetableConfig?: {
    __typename: 'TimetableConfigItem';
    uuid: string;
    color?: string | null;
    colorLabel?: string | null;
    printPageNr?: number | null;
    printOrder?: number | null;
  } | null;
};

export type _DivisionFragmentFragment = {
  __typename: 'DivisionItem';
  uuid: string;
  name: string;
  groups: Array<{ __typename: 'GroupItem'; uuid: string; order: number }>;
  class?: { __typename?: 'DivisionClassItem'; uuid: string; name: string; shortName: string } | null;
};

export type _GroupFragmentFragment = {
  __typename: 'GroupItem';
  uuid: string;
  name: string;
  shortName: string;
  entireClass?: boolean | null;
  classFraction: number;
  divisionUuid: string;
  order: number;
};

export type _RoomFragmentFragment = {
  __typename: 'RoomItem';
  uuid: string;
  name: string;
  roomNumber?: string | null;
  description?: string | null;
  classroom?: boolean | null;
  responsiblePersonUuids: Array<string>;
  building?: { __typename: 'BuildingRefItem'; uuid: string; name: string } | null;
};

export type _GradeGroupFragmentFragment = {
  __typename: 'GradeGroupItem';
  uuid: string;
  name: string;
  shortName: string;
};

export type _SubstitutionFilterTimetableVersionsQueryVariables = Exact<{
  date: Scalars['Date']['input'];
}>;

export type _SubstitutionFilterTimetableVersionsQuery = {
  __typename?: 'Query';
  activeTimetableVersionsForDate: Array<{
    __typename?: 'ActiveTimetableVersion';
    uuid: string;
    timetableUuid: string;
    timetableName: string;
    classUuids: Array<string>;
  }>;
};

export type _GradeGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type _GradeGroupsQuery = {
  __typename?: 'Query';
  gradeGroups: Array<{ __typename: 'GradeGroupItem'; uuid: string; name: string; shortName: string }>;
};

export type _ClassesQueryVariables = Exact<{
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type _ClassesQuery = {
  __typename?: 'Query';
  classes: Array<{
    __typename: 'ClassItem';
    uuid: string;
    name: string;
    sortName: string;
    shortName: string;
    studentCount?: number | null;
    grade?: number | null;
    functionalClassSubstitutionBehavior?: FunctionalClassSubstitutionBehavior | null;
    relevantForSubstitution?: boolean | null;
    certificatesEnabled?: boolean | null;
    tutorUuids: Array<string>;
    defaultRoomUuid?: string | null;
    schoolYearUuid?: string | null;
    gradeGroup?: { __typename: 'GradeGroupRefItem'; uuid: string } | null;
    divisions: Array<{ __typename: 'ClassDivisionItem'; uuid: string }>;
    timetableConfig?: {
      __typename: 'TimetableConfigItem';
      uuid: string;
      color?: string | null;
      colorLabel?: string | null;
      printPageNr?: number | null;
      printOrder?: number | null;
    } | null;
  }>;
};

export type _SubjectsQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type _SubjectsQuery = {
  __typename?: 'Query';
  subjects: Array<{
    __typename: 'SubjectItem';
    uuid: string;
    name: string;
    shortName: string;
    active?: boolean | null;
    epochEnabled?: boolean | null;
    subjectHourEnabled?: boolean | null;
    other?: boolean | null;
    defaultRooms: Array<{ __typename: 'RoomRefItem'; uuid: string }>;
    timetableConfig?: { __typename: 'TimetableConfigItem'; color?: string | null } | null;
  }>;
};

export type _SubjectContainersQueryVariables = Exact<{ [key: string]: never }>;

export type _SubjectContainersQuery = {
  __typename?: 'Query';
  subjectContainers: Array<{
    __typename: 'SubjectContainerItem';
    uuid: string;
    name: string;
    shortName: string;
    grades: Array<number>;
    validFrom?: { __typename: 'SchoolYearRefItem'; uuid: string } | null;
    validUntil?: { __typename: 'SchoolYearRefItem'; uuid: string } | null;
    gradeGroups: Array<{ __typename: 'GradeGroupRefItem'; uuid: string }>;
    timetableConfig?: { __typename: 'TimetableConfigItem'; uuid: string; color?: string | null } | null;
  }>;
};

export type _PersonQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type _PersonQuery = {
  __typename?: 'Query';
  person?: {
    __typename: 'PersonItem';
    uuid: string;
    firstName: string;
    lastName: string;
    displayName: string;
    displayNameShort: string;
    fullName: string;
    prefixName?: string | null;
    title?: string | null;
    selectName: string;
    pimProfileUuid?: string | null;
    listName: string;
    shortName: string;
    salutation?: string | null;
    birthday?: string | null;
    email?: string | null;
    personalId?: string | null;
    gender?: string | null;
    active: boolean;
    role?: PersonRole | null;
    contractUuids: Array<string>;
    defaultRoomUuid?: string | null;
    qualifications: Array<{
      __typename: 'QualificationItem';
      subjectUuid: string;
      maxGrade?: number | null;
      minGrade?: number | null;
      maxTeachingLoad?: number | null;
    }>;
    timetableConfig?: { __typename: 'TimetableConfigItem'; uuid: string; color?: string | null } | null;
  } | null;
};

export type _PeopleQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PersonRole>;
}>;

export type _PeopleQuery = {
  __typename?: 'Query';
  people: Array<{
    __typename: 'PersonItem';
    uuid: string;
    firstName: string;
    lastName: string;
    displayName: string;
    displayNameShort: string;
    fullName: string;
    prefixName?: string | null;
    title?: string | null;
    selectName: string;
    pimProfileUuid?: string | null;
    listName: string;
    shortName: string;
    salutation?: string | null;
    birthday?: string | null;
    email?: string | null;
    personalId?: string | null;
    gender?: string | null;
    active: boolean;
    role?: PersonRole | null;
    contractUuids: Array<string>;
    defaultRoomUuid?: string | null;
    qualifications: Array<{
      __typename: 'QualificationItem';
      subjectUuid: string;
      maxGrade?: number | null;
      minGrade?: number | null;
      maxTeachingLoad?: number | null;
    }>;
    timetableConfig?: { __typename: 'TimetableConfigItem'; uuid: string; color?: string | null } | null;
  }>;
};

export type LessonUuidsWithCardsQueryVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type LessonUuidsWithCardsQuery = { __typename?: 'Query'; lessonUuidsWithCards: Array<string> };

export type _RoomsQueryVariables = Exact<{ [key: string]: never }>;

export type _RoomsQuery = {
  __typename?: 'Query';
  rooms: Array<{
    __typename: 'RoomItem';
    uuid: string;
    name: string;
    roomNumber?: string | null;
    description?: string | null;
    classroom?: boolean | null;
    responsiblePersonUuids: Array<string>;
    building?: { __typename: 'BuildingRefItem'; uuid: string; name: string } | null;
  }>;
};

export type _DivisionsQueryVariables = Exact<{
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type _DivisionsQuery = {
  __typename?: 'Query';
  divisions: Array<{
    __typename: 'DivisionItem';
    uuid: string;
    name: string;
    groups: Array<{ __typename: 'GroupItem'; uuid: string; order: number }>;
    class?: { __typename?: 'DivisionClassItem'; uuid: string; name: string; shortName: string } | null;
  }>;
};

export type _GroupsQueryVariables = Exact<{
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type _GroupsQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'GroupItem';
    uuid: string;
    name: string;
    shortName: string;
    entireClass?: boolean | null;
    classFraction: number;
    divisionUuid: string;
    order: number;
  }>;
};

export type _ContractsQueryVariables = Exact<{
  personUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type _ContractsQuery = {
  __typename?: 'Query';
  contracts: Array<{
    __typename: 'ContractItem';
    uuid: string;
    personUuid: string;
    name: string;
    validFrom: string;
    validUntil?: string | null;
    hoursWeekly?: number | null;
    freelancer?: boolean | null;
    billingMethod?: BillingMethods | null;
    limitedToFullTime?: boolean | null;
    substituteHours?: number | null;
  }>;
};

export type _SchoolYearsQueryVariables = Exact<{ [key: string]: never }>;

export type _SchoolYearsQuery = {
  __typename?: 'Query';
  schoolYears: Array<{ __typename: 'SchoolYearItem'; uuid: string; name: string; start: string; end: string }>;
};

export type _TimetablePrintConfigQueryVariables = Exact<{
  type: TimetableReportType;
}>;

export type _TimetablePrintConfigQuery = {
  __typename?: 'Query';
  timetablePrintConfig?: {
    __typename: 'TimetablePrintConfigItem';
    uuid: string;
    type: TimetableReportType;
    topLeft?: TimetablePrintLayoutOptions | null;
    topCenter?: TimetablePrintLayoutOptions | null;
    topRight?: TimetablePrintLayoutOptions | null;
    center?: TimetablePrintLayoutOptions | null;
    bottomLeft?: TimetablePrintLayoutOptions | null;
    bottomCenter?: TimetablePrintLayoutOptions | null;
    bottomRight?: TimetablePrintLayoutOptions | null;
    printColorOrigin?: TimetablePrintColorOrigins | null;
    printColorPosition?: TimetablePrintColorPositions | null;
    printClasses?: boolean | null;
    scaleText?: boolean | null;
    exactMinute?: boolean | null;
    printSubtitle?: boolean | null;
    printLogo?: boolean | null;
    largeFont?: boolean | null;
    showSchoolWeeks?: boolean | null;
    showCalendarWeeks?: boolean | null;
    showWeekSchoolDays?: boolean | null;
    timeHorizontal?: boolean | null;
    epochGridOwnPage?: boolean | null;
    responsiblePersonNameFormat?: TimetablePrintPersonNameFormats | null;
  } | null;
};

export type _TeachingLoadReportConfigQueryVariables = Exact<{
  type: TeachingLoadReportType;
}>;

export type _TeachingLoadReportConfigQuery = {
  __typename?: 'Query';
  teachingLoadReportConfig?: {
    __typename: 'TeachingLoadReportConfigItem';
    uuid: string;
    type: TeachingLoadReportType;
    noAdditionalTeachingLoad?: boolean | null;
    hidePaidTeachingLoad?: boolean | null;
    roundTeachingLoadResult?: number | null;
  } | null;
};

export type _EventsInRangeQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  includeSchoolEvents?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type _EventsInRangeQuery = {
  __typename?: 'Query';
  eventsInRange: Array<{
    __typename: 'EventItem';
    uuid: string;
    start: string;
    end: string;
    comment?: string | null;
    canceled: boolean;
    currentState?: string | null;
    isClassTrip: boolean;
    isClassbookRelevant: boolean;
    substitutionReasons?: SubstitutionReason | null;
    substitutionComment?: string | null;
    print: boolean;
    timeGridEntryShortName?: string | null;
    aggregatedIntoUuid?: string | null;
    originalPersonUuids: Array<string>;
    subjectUuid?: string | null;
    roomUuids: Array<string>;
    isSchoolEvent: boolean;
    persons: Array<{
      __typename?: 'EventItemPerson';
      uuid: string;
      isCoveringTeacher: boolean;
      givenSubstituteHours?: number | null;
    }>;
    originalClassesOrGroups: Array<{ __typename?: 'EventClassOrGroupRef'; type: EventClassOrGroupType; uuid: string }>;
    classesOrGroups: Array<{ __typename?: 'EventClassOrGroupRef'; type: EventClassOrGroupType; uuid: string }>;
    originalRooms: Array<{ __typename?: 'EventItemRoom'; uuid: string; name: string }>;
  }>;
};

export type _EventByUuidQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type _EventByUuidQuery = {
  __typename?: 'Query';
  event?: {
    __typename: 'EventItem';
    uuid: string;
    start: string;
    end: string;
    comment?: string | null;
    canceled: boolean;
    currentState?: string | null;
    isClassTrip: boolean;
    isClassbookRelevant: boolean;
    substitutionReasons?: SubstitutionReason | null;
    substitutionComment?: string | null;
    print: boolean;
    timeGridEntryShortName?: string | null;
    aggregatedIntoUuid?: string | null;
    originalPersonUuids: Array<string>;
    subjectUuid?: string | null;
    roomUuids: Array<string>;
    isSchoolEvent: boolean;
    persons: Array<{
      __typename?: 'EventItemPerson';
      uuid: string;
      isCoveringTeacher: boolean;
      givenSubstituteHours?: number | null;
    }>;
    originalClassesOrGroups: Array<{ __typename?: 'EventClassOrGroupRef'; type: EventClassOrGroupType; uuid: string }>;
    classesOrGroups: Array<{ __typename?: 'EventClassOrGroupRef'; type: EventClassOrGroupType; uuid: string }>;
    originalRooms: Array<{ __typename?: 'EventItemRoom'; uuid: string; name: string }>;
  } | null;
};

export type _AdminEventsQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type _AdminEventsQuery = {
  __typename?: 'Query';
  adminEvents: Array<{
    __typename: 'EventItem';
    uuid: string;
    start: string;
    end: string;
    comment?: string | null;
    canceled: boolean;
    currentState?: string | null;
    isClassTrip: boolean;
    isClassbookRelevant: boolean;
    substitutionReasons?: SubstitutionReason | null;
    substitutionComment?: string | null;
    print: boolean;
    timeGridEntryShortName?: string | null;
    aggregatedIntoUuid?: string | null;
    originalPersonUuids: Array<string>;
    subjectUuid?: string | null;
    roomUuids: Array<string>;
    isSchoolEvent: boolean;
    persons: Array<{
      __typename?: 'EventItemPerson';
      uuid: string;
      isCoveringTeacher: boolean;
      givenSubstituteHours?: number | null;
    }>;
    originalClassesOrGroups: Array<{ __typename?: 'EventClassOrGroupRef'; type: EventClassOrGroupType; uuid: string }>;
    classesOrGroups: Array<{ __typename?: 'EventClassOrGroupRef'; type: EventClassOrGroupType; uuid: string }>;
    originalRooms: Array<{ __typename?: 'EventItemRoom'; uuid: string; name: string }>;
  }>;
};

export type _AdminEventsCountQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;

export type _AdminEventsCountQuery = { __typename?: 'Query'; adminEventsCount: number };

export type _SchoolEventsQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;

export type _SchoolEventsQuery = {
  __typename?: 'Query';
  schoolEvents: Array<{
    __typename: 'SchoolEvent';
    uuid: string;
    start: string;
    end: string;
    canceled: boolean;
    comment?: string | null;
    isClassTrip: boolean;
    recurrenceUuid?: string | null;
    groupClassNames: string;
    groupClassNamesLong: string;
    persons: Array<{ __typename: 'MinimalPerson'; uuid: string; displayName: string; listName: string }>;
    rooms: Array<{ __typename: 'MinimalRoom'; uuid: string; name: string }>;
    subject: { __typename: 'MinimalSubject'; uuid: string; name: string; shortName: string };
    classesOrGroups: Array<{ __typename: 'MinimalClass'; uuid: string } | { __typename: 'MinimalGroup'; uuid: string }>;
  }>;
};

export type _RecurringEventQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type _RecurringEventQuery = {
  __typename?: 'Query';
  recurringEvent?: {
    __typename: 'RecurringEventItem';
    uuid: string;
    rrule: string;
    excludeHolidays: boolean;
    futureEventsCount: number;
  } | null;
};

export type _PreviewTeachingLoadQueryVariables = Exact<{
  organizationUuid: Scalars['String']['input'];
  schoolYearUuid: Scalars['String']['input'];
  subjectUuid: Scalars['String']['input'];
  teacherUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  lessonClasses: Array<PreviewLessonClassInput> | PreviewLessonClassInput;
  lessonUnits: Array<PreviewLessonUnitInput> | PreviewLessonUnitInput;
}>;

export type _PreviewTeachingLoadQuery = {
  __typename?: 'Query';
  previewTeachingLoad: Array<{
    __typename: 'PreviewDeputatResult';
    deputat: number;
    factor: number;
    teacherUuid: string;
  }>;
};

export type _CreateSingleSchoolEventMutationVariables = Exact<{
  input: SchoolEventCreateInput;
}>;

export type _CreateSingleSchoolEventMutation = {
  __typename?: 'Mutation';
  createSchoolEvent: { __typename: 'CreateResponse'; nodesCreated: number; nodeUuids: Array<string> };
};

export type _CreateRecurringSchoolEventMutationVariables = Exact<{
  input: RecurrenceSchoolEventCreateInput;
}>;

export type _CreateRecurringSchoolEventMutation = {
  __typename?: 'Mutation';
  createRecurrenceSchoolEvents: { __typename?: 'CreateResponse'; nodeUuids: Array<string> };
};

export type _DeleteSchoolEventsMutationVariables = Exact<{
  uuids: OnlyUuids;
}>;

export type _DeleteSchoolEventsMutation = {
  __typename?: 'Mutation';
  deleteSchoolEvents: { __typename: 'DeleteInfo'; nodesDeleted: number };
};

export type _UpdateSchoolEventMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
  update: SchoolEventUpdateInput;
}>;

export type _UpdateSchoolEventMutation = {
  __typename?: 'Mutation';
  updateSchoolEvent: { __typename: 'UpdateResponse'; nodeUuids: Array<string> };
};

export type _UpdateRecurrenceSchoolEventsMutationVariables = Exact<{
  recurrenceUuid: Scalars['ID']['input'];
  rrule: Scalars['String']['input'];
  excludeHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  update: SchoolEventUpdateInput;
}>;

export type _UpdateRecurrenceSchoolEventsMutation = {
  __typename?: 'Mutation';
  updateRecurrenceSchoolEvents: { __typename: 'UpdateResponse'; nodeUuids: Array<string> };
};

export type _DeleteRecurrenceSchoolEventsMutationVariables = Exact<{
  recurrenceUuid: Scalars['ID']['input'];
}>;

export type _DeleteRecurrenceSchoolEventsMutation = {
  __typename?: 'Mutation';
  deleteRecurrenceSchoolEvents: { __typename: 'DeleteInfo'; nodesDeleted: number };
};

export type _SetPrintEventMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
  print: Scalars['Boolean']['input'];
}>;

export type _SetPrintEventMutation = {
  __typename?: 'Mutation';
  setPrintEvent: { __typename: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type _SetSubstitutionMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
  coveringTeachers: Array<SetCoveringTeachersInput> | SetCoveringTeachersInput;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  rooms: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type _SetSubstitutionMutation = {
  __typename?: 'Mutation';
  setSubstitution: { __typename: 'EntitiesUpdateInfo' };
};

export type _CancelEventMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
}>;

export type _CancelEventMutation = { __typename?: 'Mutation'; cancelEvent: { __typename: 'EntitiesUpdateInfo' } };

export type _SetSelfWorkEventMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  rooms: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type _SetSelfWorkEventMutation = {
  __typename?: 'Mutation';
  setSelfWorkForEvent: { __typename: 'EntitiesUpdateInfo' };
};

export type _ResetEventMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
}>;

export type _ResetEventMutation = { __typename?: 'Mutation'; resetEvent: { __typename: 'EntitiesUpdateInfo' } };

export type _MergeEventsMutationVariables = Exact<{
  eventsToMerge: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  targetEvent: Scalars['ID']['input'];
  rooms: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
}>;

export type _MergeEventsMutation = { __typename?: 'Mutation'; mergeEvents: { __typename: 'EntitiesUpdateInfo' } };

export type _SaveTimetablePrintConfigMutationVariables = Exact<{
  type: TimetableReportType;
  input: TimetablePrintConfigInput;
}>;

export type _SaveTimetablePrintConfigMutation = {
  __typename?: 'Mutation';
  saveTimetablePrintConfig: {
    __typename: 'TimetablePrintConfigItem';
    uuid: string;
    type: TimetableReportType;
    topLeft?: TimetablePrintLayoutOptions | null;
    topCenter?: TimetablePrintLayoutOptions | null;
    topRight?: TimetablePrintLayoutOptions | null;
    center?: TimetablePrintLayoutOptions | null;
    bottomLeft?: TimetablePrintLayoutOptions | null;
    bottomCenter?: TimetablePrintLayoutOptions | null;
    bottomRight?: TimetablePrintLayoutOptions | null;
    printColorOrigin?: TimetablePrintColorOrigins | null;
    printColorPosition?: TimetablePrintColorPositions | null;
    printClasses?: boolean | null;
    scaleText?: boolean | null;
    exactMinute?: boolean | null;
    printSubtitle?: boolean | null;
    printLogo?: boolean | null;
    largeFont?: boolean | null;
    showSchoolWeeks?: boolean | null;
    showCalendarWeeks?: boolean | null;
    showWeekSchoolDays?: boolean | null;
    timeHorizontal?: boolean | null;
    epochGridOwnPage?: boolean | null;
    responsiblePersonNameFormat?: TimetablePrintPersonNameFormats | null;
  };
};

export type _SaveTeachingLoadReportConfigMutationVariables = Exact<{
  type: TeachingLoadReportType;
  input: TeachingLoadReportConfigInput;
}>;

export type _SaveTeachingLoadReportConfigMutation = {
  __typename?: 'Mutation';
  saveTeachingLoadReportConfig: {
    __typename: 'TeachingLoadReportConfigItem';
    uuid: string;
    type: TeachingLoadReportType;
    noAdditionalTeachingLoad?: boolean | null;
    hidePaidTeachingLoad?: boolean | null;
    roundTeachingLoadResult?: number | null;
  };
};

export type MyUserConfigFragmentFragment = {
  __typename?: 'MyUserConfig';
  schoolYearUuid?: string | null;
  tableConfigs: Array<{
    __typename?: 'MyTableConfig';
    table: string;
    hiddenColumns: Array<string>;
    columnsSort: string;
  }>;
  uiSettings: Array<{
    __typename?: 'MyUiSettings';
    scope: string;
    version: number;
    data: string;
    updatedAt?: string | null;
  }>;
};

export type CurriculumPlannedClassFragment = {
  __typename?: 'CurriculumPlannedClassItem';
  grade: number;
  name: string;
  shortName: string;
  gradeGroup?: { __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
  groups: Array<{ __typename?: 'CurriculumPlannedGroupItem'; uuid: string; name: string; shortName: string }>;
};

export type CurriculumFragment = {
  __typename: 'CurriculumItem';
  uuid: string;
  curriculumVersionUuid: string;
  subTitle?: string | null;
  comment?: string | null;
  elective?: boolean | null;
  isClassTrip?: boolean | null;
  timetableEnabled?: boolean | null;
  teachingLoadEnabled?: boolean | null;
  groupGradeNames: Array<string>;
  subject: {
    __typename?: 'CurriculumSubjectItem';
    uuid: string;
    name: string;
    shortName: string;
    isSubjectContainer: boolean;
    epochEnabled?: boolean | null;
    subjectHourEnabled?: boolean | null;
    grades: Array<number>;
  };
  persons: Array<{
    __typename?: 'CurriculumPersonItem';
    uuid: string;
    name?: string | null;
    description?: string | null;
    order: number;
    present?: boolean | null;
    teachingLoad?: boolean | null;
  }>;
  curriculumGrades: Array<{
    __typename?: 'CurriculumGradeItem';
    uuid: string;
    grades: Array<number>;
    gradeGroups: Array<{ __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string }>;
    groups: Array<{
      __typename?: 'CurriculumGroupItem';
      uuid: string;
      name: string;
      shortName: string;
      classFraction: number;
    }>;
    plannedClasses: Array<{
      __typename?: 'CurriculumPlannedClassItem';
      grade: number;
      name: string;
      shortName: string;
      gradeGroup?: { __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
      groups: Array<{ __typename?: 'CurriculumPlannedGroupItem'; uuid: string; name: string; shortName: string }>;
    }>;
  }>;
  curriculumUnits: Array<{
    __typename?: 'CurriculumUnitItem';
    uuid: string;
    duration?: number | null;
    count?: number | null;
    subjectContainer?: {
      __typename?: 'CurriculumUnitSubjectContainerItem';
      uuid: string;
      name: string;
      shortName: string;
    } | null;
  }>;
  roomSupply: Array<{
    __typename?: 'CurriculumRoomItem';
    roomUuid: string;
    descriptions?: string | null;
    order: number;
  }>;
  labels: Array<{ __typename?: 'CurriculumLabelItem'; uuid: string; color?: string | null; name: string }>;
  plannedLessons: Array<{
    __typename?: 'CurriculumPlannedLessonItem';
    uuid: string;
    classes: Array<{
      __typename?: 'CurriculumPlannedClassItem';
      grade: number;
      name: string;
      shortName: string;
      gradeGroup?: { __typename?: 'CurriculumGradeGroupItem'; uuid: string; name: string; shortName: string } | null;
      groups: Array<{ __typename?: 'CurriculumPlannedGroupItem'; uuid: string; name: string; shortName: string }>;
    }>;
  }>;
  lessons: Array<{ __typename?: 'CurriculumLessonRefItem'; uuid: string; schoolYearUuid?: string | null }>;
};

export type LessonUsageFragment = {
  __typename?: 'LessonUsage';
  uuid: string;
  lessonsCount: number;
  lessons: Array<{
    __typename?: 'LessonUsageItem';
    uuid: string;
    subjectName: string;
    classShortNames: Array<string>;
    onlyInTimetableVersion: boolean;
    onlyInTeachingBlockVersion: boolean;
    versionsCount: number;
    versions: Array<{ __typename?: 'LessonUsageVersionItem'; uuid: string; timetableName: string; version: number }>;
  }>;
};

export type ClassUsageQueryVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ClassUsageQuery = {
  __typename?: 'Query';
  classUsage: Array<{
    __typename?: 'LessonUsage';
    uuid: string;
    lessonsCount: number;
    lessons: Array<{
      __typename?: 'LessonUsageItem';
      uuid: string;
      subjectName: string;
      classShortNames: Array<string>;
      onlyInTimetableVersion: boolean;
      onlyInTeachingBlockVersion: boolean;
      versionsCount: number;
      versions: Array<{ __typename?: 'LessonUsageVersionItem'; uuid: string; timetableName: string; version: number }>;
    }>;
  }>;
};

export type PersonUsageQueryVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type PersonUsageQuery = {
  __typename?: 'Query';
  personUsage: Array<{
    __typename?: 'LessonUsage';
    uuid: string;
    lessonsCount: number;
    lessons: Array<{
      __typename?: 'LessonUsageItem';
      uuid: string;
      subjectName: string;
      classShortNames: Array<string>;
      onlyInTimetableVersion: boolean;
      onlyInTeachingBlockVersion: boolean;
      versionsCount: number;
      versions: Array<{ __typename?: 'LessonUsageVersionItem'; uuid: string; timetableName: string; version: number }>;
    }>;
  }>;
};

export type DivisionUsageQueryVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DivisionUsageQuery = {
  __typename?: 'Query';
  divisionUsage: Array<{
    __typename?: 'LessonUsage';
    uuid: string;
    lessonsCount: number;
    lessons: Array<{
      __typename?: 'LessonUsageItem';
      uuid: string;
      subjectName: string;
      classShortNames: Array<string>;
      onlyInTimetableVersion: boolean;
      onlyInTeachingBlockVersion: boolean;
      versionsCount: number;
      versions: Array<{ __typename?: 'LessonUsageVersionItem'; uuid: string; timetableName: string; version: number }>;
    }>;
  }>;
};

export type EventSyncStatusQueryVariables = Exact<{ [key: string]: never }>;

export type EventSyncStatusQuery = {
  __typename?: 'Query';
  eventSyncStatus: {
    __typename?: 'EventSyncStatus';
    openDays: number;
    firstOpenDay?: string | null;
    lastOpenDay?: string | null;
    versionsInCorrection: Array<{
      __typename?: 'VersionInCorrection';
      kind: VersionInCorrectionKind;
      versionUuid: string;
      version: number;
      description?: string | null;
      planUuid: string;
      planName: string;
      from?: string | null;
      to?: string | null;
      heldDays: number;
    }>;
  };
};

export type EventJobsQueryVariables = Exact<{
  runningOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type EventJobsQuery = {
  __typename?: 'Query';
  eventJobs: Array<{
    __typename?: 'EventJobItem';
    uuid: string;
    timetableVersionUuid?: string | null;
    to: string;
    from: string;
    processed: number;
    eventsTo?: string | null;
    eventsFrom?: string | null;
    createdEvents: number;
    updatedEvents: number;
    deletedEvents: number;
    status: EventJobStatus;
    createdAt?: string | null;
  }>;
};

export type TimetableVersionDataQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type TimetableVersionDataQuery = {
  __typename?: 'Query';
  timetableVersionData: {
    __typename?: 'TimetableVersionData';
    meta: {
      __typename?: 'TimetableVersionMeta';
      versionUuid: string;
      version: number;
      description?: string | null;
      active: boolean;
      editable: boolean;
      isSnapshot: boolean;
      generating?: boolean | null;
      timetableUuid: string;
      timetableName: string;
      timetableDraft: boolean;
      schoolYearUuid: string;
      timegridUuid?: string | null;
    };
    view: {
      __typename?: 'TimetableVersionViewData';
      timeGridEntries: Array<{
        __typename?: 'TimetableVersionTimeGridEntry';
        uuid: string;
        name?: string | null;
        shortName?: string | null;
        start: string;
        end: string;
        pause?: boolean | null;
        order: number;
      }>;
      teachers: Array<{
        __typename?: 'TimetableVersionTeacher';
        uuid: string;
        firstName?: string | null;
        lastName: string;
        shortName?: string | null;
        displayNameShort?: string | null;
        color?: string | null;
        active: boolean;
        defaultRoomUuid?: string | null;
      }>;
      classes: Array<{
        __typename?: 'TimetableVersionClass';
        uuid: string;
        name: string;
        shortName: string;
        sortName?: string | null;
        grade?: number | null;
        gradeGroupUuid?: string | null;
        color?: string | null;
        colorLabel?: string | null;
        divisionUuids: Array<string>;
        inVersion: boolean;
        defaultRoomUuid?: string | null;
      }>;
      rooms: Array<{
        __typename?: 'TimetableVersionRoom';
        uuid: string;
        name: string;
        roomNumber?: string | null;
        classroom?: boolean | null;
      }>;
      subjects: Array<{
        __typename?: 'TimetableVersionSubject';
        uuid: string;
        name: string;
        shortName?: string | null;
        color?: string | null;
        active?: boolean | null;
        epochEnabled?: boolean | null;
        subjectHourEnabled?: boolean | null;
        defaultRoomUuids: Array<string>;
      }>;
      subjectContainers: Array<{
        __typename?: 'TimetableVersionSubjectContainer';
        uuid: string;
        name: string;
        shortName?: string | null;
        color?: string | null;
        grades?: Array<number> | null;
        gradeGroupUuid?: string | null;
      }>;
      groups: Array<{
        __typename?: 'TimetableVersionGroup';
        uuid: string;
        name: string;
        shortName?: string | null;
        classFraction?: number | null;
        entireClass?: boolean | null;
        divisionUuid?: string | null;
      }>;
      cards: Array<{
        __typename?: 'TimetableVersionCard';
        uuid: string;
        duration?: number | null;
        weekday?: string | null;
        locked: boolean;
        startTimeGridEntryUuid?: string | null;
        endTimeGridEntryUuid?: string | null;
        lessonUuid: string;
        lessonIsElective: boolean;
        someLessonClassIsFunctionalClass: boolean;
        subjectUuid: string;
        isSubjectContainer: boolean;
        roomUuids: Array<string>;
        lessonRoomSupplyUuids: Array<string>;
        teacherUuids: Array<string>;
        classUuids: Array<string>;
        groupUuids: Array<string>;
        lessonClasses: Array<{
          __typename?: 'TimetableVersionLessonClass';
          uuid: string;
          classUuid: string;
          groupUuids: Array<string>;
          usedDivisionUuid?: string | null;
        }>;
        classGridCards: Array<{
          __typename?: 'ClassGridCard';
          uuid: string;
          timetableCardUuid: string;
          classUuid: string;
          lessonUuid: string;
          divisionsCount?: number | null;
          colors: Array<string>;
          locked?: boolean | null;
          duration?: number | null;
          endTimeGridEntryUuid?: string | null;
          startTimeGridEntryUuid?: string | null;
          weekday?: string | null;
          cssHeight?: string | null;
          cssGradientString?: string | null;
          usedPosition: number;
          cssTop?: string | null;
          textColor?: string | null;
        }>;
        subjectContainerSlots: Array<{
          __typename?: 'TimetableVersionSubjectContainerSlot';
          teacherUuids: Array<string>;
          roomUuids: Array<string>;
          startDate?: string | null;
          endDate?: string | null;
        }>;
      }>;
      availabilities: Array<{
        __typename?: 'TimetableVersionAvailability';
        resourceType: TimetableVersionResourceType;
        resourceUuid: string;
        mon?: string | null;
        tue?: string | null;
        wed?: string | null;
        thu?: string | null;
        fri?: string | null;
        sat?: string | null;
        sun?: string | null;
      }>;
    };
    editor?: {
      __typename?: 'TimetableVersionEditorData';
      divisions: Array<{
        __typename?: 'TimetableVersionDivision';
        uuid: string;
        name?: string | null;
        classUuid: string;
        groupUuids: Array<string>;
      }>;
      lessons: Array<{
        __typename?: 'TimetableVersionLesson';
        uuid: string;
        subTitle?: string | null;
        comment?: string | null;
        elective?: boolean | null;
        studentCount?: number | null;
        timetableEnabled?: boolean | null;
        onlyInTimetableVersion?: boolean | null;
        subjectUuid: string;
        isSubjectContainerLesson: boolean;
        teacherUuids: Array<string>;
        roomSupplyUuids: Array<string>;
        lessonClasses: Array<{
          __typename?: 'TimetableVersionLessonClass';
          uuid: string;
          classUuid: string;
          groupUuids: Array<string>;
          usedDivisionUuid?: string | null;
        }>;
        lessonUnits: Array<{
          __typename?: 'TimetableVersionLessonUnit';
          uuid: string;
          duration?: number | null;
          count?: number | null;
          subjectContainerUuid?: string | null;
        }>;
      }>;
    } | null;
  };
};

export type TimetableVersionLessonDataQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
}>;

export type TimetableVersionLessonDataQuery = {
  __typename?: 'Query';
  timetableVersionLessonData: {
    __typename?: 'TimetableVersionLessonData';
    lessons: Array<{
      __typename?: 'VersionLessonRow';
      uuid: string;
      classSort?: string | null;
      subjectName?: string | null;
      teachersSort?: string | null;
      subjectUuid: string;
      isSubjectContainerLesson: boolean;
      subTitle?: string | null;
      comment?: string | null;
      elective?: boolean | null;
      isClassTrip?: boolean | null;
      teachingLoadEnabled?: boolean | null;
      timetableEnabled?: boolean | null;
      onlyInTimetableVersion?: boolean | null;
      placedCardsCount: number;
      cardsCount: number;
      studentCount?: number | null;
      groupClassNames?: string | null;
      teacherUuids: Array<string>;
      classUuids: Array<string>;
      groupUuids: Array<string>;
      roomUuids: Array<string>;
      inActiveTimetable: boolean;
      lessonUnits: Array<{
        __typename?: 'TimetableVersionLessonUnit';
        uuid: string;
        duration?: number | null;
        count?: number | null;
        subjectContainerUuid?: string | null;
      }>;
    }>;
  };
};

export type DeleteAdditionalTeachingLoadsMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteAdditionalTeachingLoadsMutation = {
  __typename?: 'Mutation';
  deleteAdditionalTeachingLoads: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type CreateAdditionalTeachingLoadMutationVariables = Exact<{
  input: AdditionalTeachingLoadInput;
}>;

export type CreateAdditionalTeachingLoadMutation = {
  __typename?: 'Mutation';
  createAdditionalTeachingLoad: {
    __typename?: 'AdditionalTeachingLoadItem';
    uuid: string;
    comment?: string | null;
    hours: number;
    hoursRaw?: string | null;
    teacherListName: string;
    class?: { __typename?: 'AdditionalTeachingLoadRef'; uuid: string; name: string } | null;
    teacher: { __typename?: 'AdditionalTeachingLoadTeacherRef'; uuid: string; listName: string };
    subject?: { __typename?: 'AdditionalTeachingLoadRef'; uuid: string; name: string } | null;
  };
};

export type UpdateAdditionalTeachingLoadMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  input: AdditionalTeachingLoadInput;
}>;

export type UpdateAdditionalTeachingLoadMutation = {
  __typename?: 'Mutation';
  updateAdditionalTeachingLoad: {
    __typename?: 'AdditionalTeachingLoadItem';
    uuid: string;
    comment?: string | null;
    hours: number;
    hoursRaw?: string | null;
    teacherListName: string;
    class?: { __typename?: 'AdditionalTeachingLoadRef'; uuid: string; name: string } | null;
    teacher: { __typename?: 'AdditionalTeachingLoadTeacherRef'; uuid: string; listName: string };
    subject?: { __typename?: 'AdditionalTeachingLoadRef'; uuid: string; name: string } | null;
  };
};

export type AdditionalTeachingLoadItemFragment = {
  __typename?: 'AdditionalTeachingLoadItem';
  uuid: string;
  comment?: string | null;
  hours: number;
  hoursRaw?: string | null;
  teacherListName: string;
  class?: { __typename?: 'AdditionalTeachingLoadRef'; uuid: string; name: string } | null;
  teacher: { __typename?: 'AdditionalTeachingLoadTeacherRef'; uuid: string; listName: string };
  subject?: { __typename?: 'AdditionalTeachingLoadRef'; uuid: string; name: string } | null;
};

export type AdditionalTeachingLoadsListQueryVariables = Exact<{
  schoolyear: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AdditionalTeachingLoadsListQuery = {
  __typename?: 'Query';
  additionalTeachingLoads: Array<{
    __typename?: 'AdditionalTeachingLoadItem';
    uuid: string;
    comment?: string | null;
    hours: number;
    hoursRaw?: string | null;
    teacherListName: string;
    class?: { __typename?: 'AdditionalTeachingLoadRef'; uuid: string; name: string } | null;
    teacher: { __typename?: 'AdditionalTeachingLoadTeacherRef'; uuid: string; listName: string };
    subject?: { __typename?: 'AdditionalTeachingLoadRef'; uuid: string; name: string } | null;
  }>;
};

export type ConnectEntityWithVersionMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
}>;

export type ConnectEntityWithVersionMutation = {
  __typename?: 'Mutation';
  connectEntityWithVersion?: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number } | null;
};

export type SetMySchoolYearMutationVariables = Exact<{
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SetMySchoolYearMutation = {
  __typename?: 'Mutation';
  setMySchoolYear: {
    __typename?: 'MyUserConfig';
    schoolYearUuid?: string | null;
    tableConfigs: Array<{
      __typename?: 'MyTableConfig';
      table: string;
      hiddenColumns: Array<string>;
      columnsSort: string;
    }>;
    uiSettings: Array<{
      __typename?: 'MyUiSettings';
      scope: string;
      version: number;
      data: string;
      updatedAt?: string | null;
    }>;
  };
};

export type UpsertMyTableConfigMutationVariables = Exact<{
  table: Scalars['String']['input'];
  hiddenColumns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  columnsSort: Scalars['String']['input'];
}>;

export type UpsertMyTableConfigMutation = {
  __typename?: 'Mutation';
  upsertMyTableConfig: {
    __typename?: 'MyTableConfig';
    table: string;
    hiddenColumns: Array<string>;
    columnsSort: string;
  };
};

export type UpsertMyUiSettingsMutationVariables = Exact<{
  scope: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  data: Scalars['String']['input'];
}>;

export type UpsertMyUiSettingsMutation = {
  __typename?: 'Mutation';
  upsertMyUiSettings: {
    __typename?: 'MyUiSettings';
    scope: string;
    version: number;
    data: string;
    updatedAt?: string | null;
  };
};

export type ResetMyUiSettingsMutationVariables = Exact<{
  scopes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type ResetMyUiSettingsMutation = { __typename?: 'Mutation'; resetMyUiSettings: boolean };

export type ResetMyTableConfigsMutationVariables = Exact<{
  tables?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type ResetMyTableConfigsMutation = { __typename?: 'Mutation'; resetMyTableConfigs: boolean };

export type MyUserConfigQueryVariables = Exact<{ [key: string]: never }>;

export type MyUserConfigQuery = {
  __typename?: 'Query';
  myUserConfig: {
    __typename?: 'MyUserConfig';
    schoolYearUuid?: string | null;
    tableConfigs: Array<{
      __typename?: 'MyTableConfig';
      table: string;
      hiddenColumns: Array<string>;
      columnsSort: string;
    }>;
    uiSettings: Array<{
      __typename?: 'MyUiSettings';
      scope: string;
      version: number;
      data: string;
      updatedAt?: string | null;
    }>;
  };
};

export const AbsenceEntryFragmentDoc = gql`
    fragment AbsenceEntry on AbsenceEntry {
  uuid
  personUuid
  personListName
  reason
  start
  end
  comment
}
    `;
export const DependencyItemFragmentDoc = gql`
    fragment DependencyItem on DependencyItem {
  __typename
  uuid
  alias
  priority
  comment
  active
  otherData
  subjects {
    uuid
    name
    shortName
  }
  classes {
    uuid
    name
    shortName
  }
}
    `;
export const DivisionListItemFragmentDoc = gql`
    fragment DivisionListItem on DivisionItem {
  __typename
  uuid
  name
  class {
    __typename
    uuid
  }
  groups {
    __typename
    uuid
    name
    shortName
    studentCount
    order
  }
}
    `;
export const TeachingBlockVersionExclusionFragmentDoc = gql`
    fragment TeachingBlockVersionExclusion on TeachingBlockVersionExclusion {
  uuid
  holderType
  holderUuid
  from
  to
  priority
  comment
}
    `;
export const TeachingLoadFactorItemFragmentDoc = gql`
    fragment TeachingLoadFactorItem on TeachingLoadFactorItem {
  uuid
  active
  factorType
  schoolYearUuid
  grades
  value
  valueRaw
  valuePartial
  valuePartialRaw
  valueMode
  studentsMin
  studentsMax
  studentsPartialMin
  studentsPartialMax
  comment
  subject {
    uuid
    name
    shortName
  }
  subjectContainer {
    uuid
    name
    shortName
  }
  gradeGroup {
    uuid
    name
    shortName
  }
  timeGridEntries {
    uuid
    name
  }
  teachers {
    uuid
    shortName
    listName
  }
}
    `;
export const LessonItemFragmentDoc = gql`
    fragment LessonItem on LessonItem {
  __typename
  uuid
  subTitle
  comment
  studentCount
  elective
  isClassTrip
  teachingLoadEnabled
  timetableEnabled
  onlyInTimetableVersion
  onlyInTeachingBlockVersion
  schoolYearUuid
  subjectName
  teachersSort
  classSort
  groupClassNames
  gradeGroupUuids
  curriculumUuid
  placedCardsCount
  teachingBlockPlacedCardsCount
  subject {
    uuid
    name
    shortName
    isSubjectContainer
    epochEnabled
    subjectHourEnabled
    active
    color
    defaultRooms {
      uuid
      name
    }
  }
  curriculumPersons {
    uuid
    description
    order
    present
    teachingLoad
  }
  teachers {
    uuid
    shortName
    firstName
    lastName
    fullName
    displayNameShort
    color
    order
    description
    present
    teachingLoad
    teachingLoadHours
    writesCertificate
  }
  lessonClasses {
    uuid
    order
    class {
      uuid
      name
      shortName
      grade
      gradeGroup {
        uuid
        name
        shortName
      }
      defaultRoom {
        uuid
        name
      }
      color
      divisions {
        uuid
        groupUuids
      }
    }
    groups {
      uuid
      name
      shortName
      classFraction
    }
    usedDivision {
      uuid
      name
      groups {
        uuid
        name
        order
      }
    }
  }
  lessonUnits {
    uuid
    order
    duration
    count
    subjectContainer {
      uuid
      name
      shortName
    }
  }
  roomSupply {
    uuid
    name
    order
    descriptions
  }
  versions {
    uuid
    version
    active
    editable
    timetable {
      uuid
      name
    }
  }
  teachingBlockVersions {
    uuid
    version
    active
    teachingBlock {
      uuid
      name
    }
  }
  editStatus {
    status
    reasons {
      reason
      label
      references {
        planUuid
        planName
        versionUuid
        version
        label
      }
    }
  }
  editStatusInVersion {
    status
    reasons {
      reason
      label
      references {
        planUuid
        planName
        versionUuid
        version
        label
      }
    }
  }
}
    `;
export const SolverJobItemFragmentDoc = gql`
    fragment SolverJobItem on SolverJobItem {
  __typename
  jobId
  engine
  status
  gap
  solutionFound
  scoreDetails
  previewCards
  jobOptions
  createdAt
  updatedAt
  versionUuid
  version
  timetableName
  schoolYearName
}
    `;
export const SubjectFragmentFragmentDoc = gql`
    fragment SubjectFragment on SubjectItem {
  name
  uuid
  shortName
  subjectHourEnabled
  epochEnabled
  active
  other
  defaultRooms {
    uuid
    name
  }
  subjectGroup {
    uuid
    name
  }
  timetableConfig {
    uuid
    color
    colorLabel
  }
}
    `;
export const SubstitutionAnnouncementItemFragmentDoc = gql`
    fragment SubstitutionAnnouncementItem on SubstitutionAnnouncementItem {
  uuid
  date
  publicAnnouncement
  internalAnnouncement
}
    `;
export const SubstitutionPrintConfigItemFragmentDoc = gql`
    fragment SubstitutionPrintConfigItem on SubstitutionPrintConfigItem {
  uuid
  showMissingTeachers
  showMissingTeachersShortName
  showAnnouncements
  showSchoolEvents
  useTeacherShortname
  pageOrientation
  printImages
  useLessonName
  lineScale
  fontScale
  columnConfigs {
    position
    column
    print
    width
    sortOrder
    sortDirection
  }
}
    `;
export const SubstitutionAppConfigItemFragmentDoc = gql`
    fragment SubstitutionAppConfigItem on SubstitutionAppConfigItem {
  uuid
  teacherPassword
  studentPassword
  allowIndividualLogins
  useTeacherShortname
  useClassShortname
  useRoomShortname
  timeDisplayMode
  showClassGroups
  showOriginalSubject
  showCurrentSubject
  showHolidays
}
    `;
export const TeachingBlockVersionCardFragmentDoc = gql`
    fragment TeachingBlockVersionCard on TeachingBlockVersionCard {
  uuid
  lessonUuid
  duration
  startDate
  endDate
  includeHoliday
  locked
  roomUuids
}
    `;
export const TeachingBlockItemFragmentDoc = gql`
    fragment TeachingBlockItem on TeachingBlockItem {
  __typename
  uuid
  name
  draft
  comment
  createdAt
  updatedAt
  schoolYearUuid
  subjectContainerUuid
  versions {
    __typename
    uuid
    version
    active
    editable
    isSnapshot
    description
    cardsCount
    parentUuid
    originalUuid
    createdAt
    updatedAt
  }
}
    `;
export const TimeGridEntryItemFragmentDoc = gql`
    fragment timeGridEntryItem on TimeGridEntryItem {
  uuid
  name
  shortName
  start
  end
  order
  reliable
  pause
  print
}
    `;
export const TimeGridItemFragmentDoc = gql`
    fragment timeGridItem on TimeGridItem {
  uuid
  name
  description
  entries {
    ...timeGridEntryItem
  }
}
    ${TimeGridEntryItemFragmentDoc}`;
export const TimetableItemFragmentDoc = gql`
    fragment TimetableItem on TimetableItem {
  __typename
  uuid
  name
  draft
  comment
  createdAt
  updatedAt
  schoolYearUuid
  monEnabled
  tueEnabled
  wedEnabled
  thuEnabled
  friEnabled
  satEnabled
  sunEnabled
  timegridConfigs {
    order
    timegridUuid
    classUuids
  }
  versions {
    __typename
    uuid
    version
    active
    editable
    isSnapshot
    description
    cardsCount
    placedCardsCount
    parentUuid
    originalUuid
    classUuids
    createdAt
    updatedAt
  }
  timetableBlocks {
    uuid
    start
    end
  }
}
    `;
export const TimetableBlockItemFragmentDoc = gql`
    fragment TimetableBlockItem on TimetableBlockItem {
  __typename
  uuid
  name
  start
  end
  schoolYearUuid
  teachingLoadFactor
  teachingLoadComment
  teachingLoadCalculated
  timetables {
    __typename
    uuid
    name
    activeVersionUuid
  }
}
    `;
export const TimetableCardItemFragmentDoc = gql`
    fragment TimetableCardItem on TimetableCardItem {
  __typename
  uuid
  lessonUuid
  duration
  weekday
  locked
  startTimeGridEntryUuid
  endTimeGridEntryUuid
  subjectContainerUuid
  roomUuids
}
    `;
export const TimetableVersionMetaItemFragmentDoc = gql`
    fragment TimetableVersionMetaItem on TimetableVersionMeta {
  __typename
  versionUuid
  version
  description
  active
  editable
  isSnapshot
  timetableUuid
  timetableName
  timetableDraft
  schoolYearUuid
}
    `;
export const TimetableVersionAvailabilityItemFragmentDoc = gql`
    fragment TimetableVersionAvailabilityItem on TimetableVersionResourceAvailability {
  __typename
  resourceType
  resourceUuid
  mon
  tue
  wed
  thu
  fri
  sat
  sun
}
    `;
export const TimetableVersionConstraintsItemFragmentDoc = gql`
    fragment TimetableVersionConstraintsItem on TimetableVersionConstraints {
  __typename
  resourceType
  resourceUuid
  constraints
}
    `;
export const _TimetablePrintConfigFragmentDoc = gql`
    fragment _TimetablePrintConfig on TimetablePrintConfigItem {
  __typename
  uuid
  type
  topLeft
  topCenter
  topRight
  center
  bottomLeft
  bottomCenter
  bottomRight
  printColorOrigin
  printColorPosition
  printClasses
  scaleText
  exactMinute
  printSubtitle
  printLogo
  largeFont
  showSchoolWeeks
  showCalendarWeeks
  showWeekSchoolDays
  timeHorizontal
  epochGridOwnPage
  responsiblePersonNameFormat
}
    `;
export const _TeachingLoadReportConfigFragmentDoc = gql`
    fragment _TeachingLoadReportConfig on TeachingLoadReportConfigItem {
  __typename
  uuid
  type
  noAdditionalTeachingLoad
  hidePaidTeachingLoad
  roundTeachingLoadResult
}
    `;
export const _SchoolEventFragmentDoc = gql`
    fragment _SchoolEvent on SchoolEvent {
  __typename
  uuid
  start
  end
  canceled
  comment
  isClassTrip
  recurrenceUuid
  persons {
    __typename
    uuid
    displayName
    listName
  }
  rooms {
    __typename
    uuid
    name
  }
  subject {
    __typename
    uuid
    name
    shortName
  }
  classesOrGroups {
    ... on MinimalClass {
      __typename
      uuid
    }
    ... on MinimalGroup {
      __typename
      uuid
    }
  }
  groupClassNames
  groupClassNamesLong
}
    `;
export const _EventFragmentDoc = gql`
    fragment _Event on EventItem {
  __typename
  uuid
  start
  end
  comment
  canceled
  currentState
  isClassTrip
  isClassbookRelevant
  substitutionReasons
  substitutionComment
  print
  timeGridEntryShortName
  aggregatedIntoUuid
  persons {
    uuid
    isCoveringTeacher
    givenSubstituteHours
  }
  originalPersonUuids
  subjectUuid
  roomUuids
  isSchoolEvent
  originalClassesOrGroups {
    type
    uuid
  }
  classesOrGroups {
    type
    uuid
  }
  originalRooms {
    uuid
    name
  }
}
    `;
export const _SchoolYearFragmentFragmentDoc = gql`
    fragment _SchoolYearFragment on SchoolYearItem {
  __typename
  uuid
  name
  start
  end
}
    `;
export const _SubjectFragmentFragmentDoc = gql`
    fragment _SubjectFragment on SubjectItem {
  __typename
  uuid
  name
  shortName
  active
  defaultRooms {
    __typename
    uuid
  }
  epochEnabled
  subjectHourEnabled
  other
  timetableConfig {
    __typename
    color
  }
}
    `;
export const _SubjectContainerFragmentFragmentDoc = gql`
    fragment _SubjectContainerFragment on SubjectContainerItem {
  __typename
  uuid
  name
  shortName
  grades
  validFrom {
    __typename
    uuid
  }
  validUntil {
    __typename
    uuid
  }
  gradeGroups {
    __typename
    uuid
  }
  timetableConfig {
    __typename
    uuid
    color
  }
}
    `;
export const _PersonFragmentFragmentDoc = gql`
    fragment _PersonFragment on PersonItem {
  __typename
  uuid
  firstName
  lastName
  displayName
  displayNameShort
  fullName
  prefixName
  title
  selectName
  pimProfileUuid
  listName
  shortName
  salutation
  birthday
  email
  personalId
  gender
  active
  role
  qualifications {
    __typename
    subjectUuid
    maxGrade
    minGrade
    maxTeachingLoad
  }
  timetableConfig {
    __typename
    uuid
    color
  }
  contractUuids
  defaultRoomUuid
}
    `;
export const _ContractFragmentFragmentDoc = gql`
    fragment _ContractFragment on ContractItem {
  __typename
  uuid
  personUuid
  name
  validFrom
  validUntil
  hoursWeekly
  freelancer
  billingMethod
  limitedToFullTime
  substituteHours
}
    `;
export const _ClassFragmentFragmentDoc = gql`
    fragment _ClassFragment on ClassItem {
  __typename
  uuid
  name
  sortName
  shortName
  studentCount
  grade
  gradeGroup {
    __typename
    uuid
  }
  functionalClassSubstitutionBehavior
  relevantForSubstitution
  certificatesEnabled
  divisions {
    __typename
    uuid
  }
  tutorUuids
  timetableConfig {
    __typename
    uuid
    color
    colorLabel
    printPageNr
    printOrder
  }
  defaultRoomUuid
  schoolYearUuid
}
    `;
export const _DivisionFragmentFragmentDoc = gql`
    fragment _DivisionFragment on DivisionItem {
  __typename
  uuid
  name
  groups {
    __typename
    uuid
    order
  }
  class {
    uuid
    name
    shortName
  }
}
    `;
export const _GroupFragmentFragmentDoc = gql`
    fragment _GroupFragment on GroupItem {
  __typename
  uuid
  name
  shortName
  entireClass
  classFraction
  divisionUuid
  order
}
    `;
export const _RoomFragmentFragmentDoc = gql`
    fragment _RoomFragment on RoomItem {
  __typename
  uuid
  name
  roomNumber
  description
  classroom
  building {
    __typename
    uuid
    name
  }
  responsiblePersonUuids
}
    `;
export const _GradeGroupFragmentFragmentDoc = gql`
    fragment _GradeGroupFragment on GradeGroupItem {
  __typename
  uuid
  name
  shortName
}
    `;
export const MyUserConfigFragmentFragmentDoc = gql`
    fragment MyUserConfigFragment on MyUserConfig {
  schoolYearUuid
  tableConfigs {
    table
    hiddenColumns
    columnsSort
  }
  uiSettings {
    scope
    version
    data
    updatedAt
  }
}
    `;
export const CurriculumPlannedClassFragmentDoc = gql`
    fragment CurriculumPlannedClass on CurriculumPlannedClassItem {
  grade
  name
  shortName
  gradeGroup {
    uuid
    name
    shortName
  }
  groups {
    uuid
    name
    shortName
  }
}
    `;
export const CurriculumFragmentDoc = gql`
    fragment Curriculum on CurriculumItem {
  __typename
  uuid
  curriculumVersionUuid
  subTitle
  comment
  elective
  isClassTrip
  timetableEnabled
  teachingLoadEnabled
  subject {
    uuid
    name
    shortName
    isSubjectContainer
    epochEnabled
    subjectHourEnabled
    grades
  }
  persons {
    uuid
    name
    description
    order
    present
    teachingLoad
  }
  curriculumGrades {
    uuid
    grades
    gradeGroups {
      uuid
      name
      shortName
    }
    groups {
      uuid
      name
      shortName
      classFraction
    }
    plannedClasses {
      ...CurriculumPlannedClass
    }
  }
  curriculumUnits {
    uuid
    duration
    count
    subjectContainer {
      uuid
      name
      shortName
    }
  }
  roomSupply {
    roomUuid
    descriptions
    order
  }
  labels {
    uuid
    color
    name
  }
  plannedLessons {
    uuid
    classes {
      ...CurriculumPlannedClass
    }
  }
  groupGradeNames
  lessons {
    uuid
    schoolYearUuid
  }
}
    ${CurriculumPlannedClassFragmentDoc}`;
export const LessonUsageFragmentDoc = gql`
    fragment LessonUsage on LessonUsage {
  uuid
  lessonsCount
  lessons {
    uuid
    subjectName
    classShortNames
    onlyInTimetableVersion
    onlyInTeachingBlockVersion
    versionsCount
    versions {
      uuid
      timetableName
      version
    }
  }
}
    `;
export const AdditionalTeachingLoadItemFragmentDoc = gql`
    fragment AdditionalTeachingLoadItem on AdditionalTeachingLoadItem {
  uuid
  comment
  hours
  hoursRaw
  class {
    uuid
    name
  }
  teacher {
    uuid
    listName
  }
  teacherListName
  subject {
    uuid
    name
  }
}
    `;
export const AbsencesDocument = gql`
    query Absences($start: DateTime!, $end: DateTime!) {
  absencesInRange(start: $start, end: $end) {
    ...AbsenceEntry
  }
}
    ${AbsenceEntryFragmentDoc}`;

export function useAbsencesQuery(options: Omit<Urql.UseQueryArgs<AbsencesQueryVariables>, 'query'>) {
  return Urql.useQuery<AbsencesQuery, AbsencesQueryVariables>({ query: AbsencesDocument, ...options });
}
export const AbsenceDocument = gql`
    query Absence($uuid: ID!) {
  absence(uuid: $uuid) {
    ...AbsenceEntry
  }
}
    ${AbsenceEntryFragmentDoc}`;

export function useAbsenceQuery(options: Omit<Urql.UseQueryArgs<AbsenceQueryVariables>, 'query'>) {
  return Urql.useQuery<AbsenceQuery, AbsenceQueryVariables>({ query: AbsenceDocument, ...options });
}
export const CreateAbsenceDocument = gql`
    mutation createAbsence($input: CreateAbsenceInput!) {
  createAbsence(input: $input) {
    nodeUuids
  }
}
    `;

export function useCreateAbsenceMutation() {
  return Urql.useMutation<CreateAbsenceMutation, CreateAbsenceMutationVariables>(CreateAbsenceDocument);
}
export const DeleteAbsenceDocument = gql`
    mutation deleteAbsence($input: OnlyUuids!, $removeSubstitutions: Boolean!) {
  deleteAbsence(where: $input, removeSubstitutions: $removeSubstitutions) {
    nodesDeleted
  }
}
    `;

export function useDeleteAbsenceMutation() {
  return Urql.useMutation<DeleteAbsenceMutation, DeleteAbsenceMutationVariables>(DeleteAbsenceDocument);
}
export const UpdateAbsenceDocument = gql`
    mutation updateAbsence($input: OnlyUuids!, $update: UpdateAbsenceInput!) {
  updateAbsence(where: $input, update: $update) {
    nodeUuids
  }
}
    `;

export function useUpdateAbsenceMutation() {
  return Urql.useMutation<UpdateAbsenceMutation, UpdateAbsenceMutationVariables>(UpdateAbsenceDocument);
}
export const SchoolEventLessonSyncsDocument = gql`
    query SchoolEventLessonSyncs {
  schoolEventLessonSyncs {
    uuid
    oldFootprints
    newFootprints
    attempts
    lastError
    lastAttemptAt
    createdAt
  }
}
    `;

export function useSchoolEventLessonSyncsQuery(
  options?: Omit<Urql.UseQueryArgs<SchoolEventLessonSyncsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SchoolEventLessonSyncsQuery, SchoolEventLessonSyncsQueryVariables>({
    query: SchoolEventLessonSyncsDocument,
    ...options,
  });
}
export const RetrySchoolEventLessonSyncsDocument = gql`
    mutation RetrySchoolEventLessonSyncs {
  retrySchoolEventLessonSyncs {
    processed
    pending
  }
}
    `;

export function useRetrySchoolEventLessonSyncsMutation() {
  return Urql.useMutation<RetrySchoolEventLessonSyncsMutation, RetrySchoolEventLessonSyncsMutationVariables>(
    RetrySchoolEventLessonSyncsDocument,
  );
}
export const DeleteSchoolEventLessonSyncDocument = gql`
    mutation DeleteSchoolEventLessonSync($uuid: ID!) {
  deleteSchoolEventLessonSync(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteSchoolEventLessonSyncMutation() {
  return Urql.useMutation<DeleteSchoolEventLessonSyncMutation, DeleteSchoolEventLessonSyncMutationVariables>(
    DeleteSchoolEventLessonSyncDocument,
  );
}
export const CreateBuildingsDocument = gql`
    mutation createBuildings($input: BuildingInput!) {
  createBuilding(input: $input) {
    uuid
    name
    description
    active
  }
}
    `;

export function useCreateBuildingsMutation() {
  return Urql.useMutation<CreateBuildingsMutation, CreateBuildingsMutationVariables>(CreateBuildingsDocument);
}
export const UpdateBuildingsDocument = gql`
    mutation updateBuildings($uuid: ID!, $input: BuildingInput!) {
  updateBuilding(uuid: $uuid, input: $input) {
    uuid
    name
    description
    active
  }
}
    `;

export function useUpdateBuildingsMutation() {
  return Urql.useMutation<UpdateBuildingsMutation, UpdateBuildingsMutationVariables>(UpdateBuildingsDocument);
}
export const DeleteBuildingsDocument = gql`
    mutation deleteBuildings($uuid: ID!) {
  deleteBuilding(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteBuildingsMutation() {
  return Urql.useMutation<DeleteBuildingsMutation, DeleteBuildingsMutationVariables>(DeleteBuildingsDocument);
}
export const BuildingsListDocument = gql`
    query BuildingsList {
  buildings {
    uuid
    name
    description
    active
  }
}
    `;

export function useBuildingsListQuery(options?: Omit<Urql.UseQueryArgs<BuildingsListQueryVariables>, 'query'>) {
  return Urql.useQuery<BuildingsListQuery, BuildingsListQueryVariables>({ query: BuildingsListDocument, ...options });
}
export const DeleteClassesDocument = gql`
    mutation deleteClasses($uuid: ID!) {
  deleteClass(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteClassesMutation() {
  return Urql.useMutation<DeleteClassesMutation, DeleteClassesMutationVariables>(DeleteClassesDocument);
}
export const UpdateClassesDocument = gql`
    mutation updateClasses($uuid: ID!, $input: ClassInput!) {
  updateClass(uuid: $uuid, input: $input) {
    uuid
  }
}
    `;

export function useUpdateClassesMutation() {
  return Urql.useMutation<UpdateClassesMutation, UpdateClassesMutationVariables>(UpdateClassesDocument);
}
export const CreateClassDocument = gql`
    mutation createClass($schoolYearUuid: ID!, $input: ClassInput!) {
  createClass(schoolYearUuid: $schoolYearUuid, input: $input) {
    uuid
  }
}
    `;

export function useCreateClassMutation() {
  return Urql.useMutation<CreateClassMutation, CreateClassMutationVariables>(CreateClassDocument);
}
export const _UpdateClassesColorsDocument = gql`
    mutation _updateClassesColors($uuid: ID!, $color: String!) {
  setClassColor(uuid: $uuid, color: $color) {
    uuid
  }
}
    `;

export function use_UpdateClassesColorsMutation() {
  return Urql.useMutation<_UpdateClassesColorsMutation, _UpdateClassesColorsMutationVariables>(
    _UpdateClassesColorsDocument,
  );
}
export const _UpdateClassesAttendancePlanShowInSubstitutionPlanDocument = gql`
    mutation _updateClassesAttendancePlanShowInSubstitutionPlan($uuid: ID!, $functionalClassSubstitutionBehavior: FunctionalClassSubstitutionBehavior) {
  setClassSubstitutionBehavior(
    uuid: $uuid
    behavior: $functionalClassSubstitutionBehavior
  ) {
    uuid
  }
}
    `;

export function use_UpdateClassesAttendancePlanShowInSubstitutionPlanMutation() {
  return Urql.useMutation<
    _UpdateClassesAttendancePlanShowInSubstitutionPlanMutation,
    _UpdateClassesAttendancePlanShowInSubstitutionPlanMutationVariables
  >(_UpdateClassesAttendancePlanShowInSubstitutionPlanDocument);
}
export const ClassesListDocument = gql`
    query ClassesList($schoolYearUuid: ID) {
  classes(schoolYearUuid: $schoolYearUuid) {
    uuid
    name
    shortName
    grade
    studentCount
    defaultRoomUuid
    schoolYearUuid
    divisions {
      uuid
      name
      groups {
        uuid
        name
        shortName
        classFraction
      }
    }
    gradeGroup {
      uuid
      name
      shortName
    }
    certificatesEnabled
    timetableConfig {
      color
      colorLabel
      printOrder
      printPageNr
    }
    tutorUuids
  }
  people {
    uuid
    firstName
    lastName
    fullName
    displayNameShort
    selectName
  }
}
    `;

export function useClassesListQuery(options?: Omit<Urql.UseQueryArgs<ClassesListQueryVariables>, 'query'>) {
  return Urql.useQuery<ClassesListQuery, ClassesListQueryVariables>({ query: ClassesListDocument, ...options });
}
export const ClassByUuidDocument = gql`
    query ClassByUuid($uuid: ID!) {
  class(uuid: $uuid) {
    uuid
    name
  }
}
    `;

export function useClassByUuidQuery(options: Omit<Urql.UseQueryArgs<ClassByUuidQueryVariables>, 'query'>) {
  return Urql.useQuery<ClassByUuidQuery, ClassByUuidQueryVariables>({ query: ClassByUuidDocument, ...options });
}
export const CreateCurriculumVersionDocument = gql`
    mutation CreateCurriculumVersion($input: CurriculumVersionInput!) {
  createCurriculumVersion(input: $input) {
    uuid
    name
    description
    curriculaCount
  }
}
    `;

export function useCreateCurriculumVersionMutation() {
  return Urql.useMutation<CreateCurriculumVersionMutation, CreateCurriculumVersionMutationVariables>(
    CreateCurriculumVersionDocument,
  );
}
export const UpdateCurriculumVersionDocument = gql`
    mutation UpdateCurriculumVersion($uuid: ID!, $input: CurriculumVersionInput!) {
  updateCurriculumVersion(uuid: $uuid, input: $input) {
    uuid
    name
    description
    curriculaCount
  }
}
    `;

export function useUpdateCurriculumVersionMutation() {
  return Urql.useMutation<UpdateCurriculumVersionMutation, UpdateCurriculumVersionMutationVariables>(
    UpdateCurriculumVersionDocument,
  );
}
export const DeleteCurriculumVersionDocument = gql`
    mutation DeleteCurriculumVersion($uuid: ID!) {
  deleteCurriculumVersion(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteCurriculumVersionMutation() {
  return Urql.useMutation<DeleteCurriculumVersionMutation, DeleteCurriculumVersionMutationVariables>(
    DeleteCurriculumVersionDocument,
  );
}
export const CreateCurriculumDocument = gql`
    mutation CreateCurriculum($curriculumVersionUuid: ID!, $input: CurriculumInput!) {
  createCurriculum(curriculumVersionUuid: $curriculumVersionUuid, input: $input) {
    ...Curriculum
  }
}
    ${CurriculumFragmentDoc}`;

export function useCreateCurriculumMutation() {
  return Urql.useMutation<CreateCurriculumMutation, CreateCurriculumMutationVariables>(CreateCurriculumDocument);
}
export const UpdateCurriculumDocument = gql`
    mutation UpdateCurriculum($uuid: ID!, $input: CurriculumInput!) {
  updateCurriculum(uuid: $uuid, input: $input) {
    ...Curriculum
  }
}
    ${CurriculumFragmentDoc}`;

export function useUpdateCurriculumMutation() {
  return Urql.useMutation<UpdateCurriculumMutation, UpdateCurriculumMutationVariables>(UpdateCurriculumDocument);
}
export const SetCurriculaFlagDocument = gql`
    mutation SetCurriculaFlag($uuids: [ID!]!, $flag: CurriculumFlag!, $value: Boolean!) {
  setCurriculaFlag(uuids: $uuids, flag: $flag, value: $value) {
    uuid
    teachingLoadEnabled
    timetableEnabled
    elective
    isClassTrip
  }
}
    `;

export function useSetCurriculaFlagMutation() {
  return Urql.useMutation<SetCurriculaFlagMutation, SetCurriculaFlagMutationVariables>(SetCurriculaFlagDocument);
}
export const DeleteCurriculaDocument = gql`
    mutation DeleteCurricula($uuids: [ID!]!) {
  deleteCurricula(uuids: $uuids) {
    nodesDeleted
    relationshipsDeleted
  }
}
    `;

export function useDeleteCurriculaMutation() {
  return Urql.useMutation<DeleteCurriculaMutation, DeleteCurriculaMutationVariables>(DeleteCurriculaDocument);
}
export const CreateLessonsFromCurriculaDocument = gql`
    mutation CreateLessonsFromCurricula($organizationUuid: ID!, $schoolYearUuid: ID!, $curriculumUuids: [ID!]!) {
  createLessonsFromCurricula(
    organizationUuid: $organizationUuid
    schoolYearUuid: $schoolYearUuid
    curriculumUuids: $curriculumUuids
  ) {
    createdLessonUuids
    skipped {
      curriculumUuid
      reason
    }
    failed {
      curriculumUuid
      error
    }
  }
}
    `;

export function useCreateLessonsFromCurriculaMutation() {
  return Urql.useMutation<CreateLessonsFromCurriculaMutation, CreateLessonsFromCurriculaMutationVariables>(
    CreateLessonsFromCurriculaDocument,
  );
}
export const CurriculumVersionsListDocument = gql`
    query CurriculumVersionsList {
  curriculumVersions {
    uuid
    name
    description
    curriculaCount
  }
}
    `;

export function useCurriculumVersionsListQuery(
  options?: Omit<Urql.UseQueryArgs<CurriculumVersionsListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CurriculumVersionsListQuery, CurriculumVersionsListQueryVariables>({
    query: CurriculumVersionsListDocument,
    ...options,
  });
}
export const CurriculaListDocument = gql`
    query CurriculaList($curriculumVersionUuid: ID, $subjectUuid: ID) {
  curricula(
    curriculumVersionUuid: $curriculumVersionUuid
    subjectUuid: $subjectUuid
  ) {
    ...Curriculum
  }
}
    ${CurriculumFragmentDoc}`;

export function useCurriculaListQuery(options?: Omit<Urql.UseQueryArgs<CurriculaListQueryVariables>, 'query'>) {
  return Urql.useQuery<CurriculaListQuery, CurriculaListQueryVariables>({ query: CurriculaListDocument, ...options });
}
export const CurriculaLessonStatusDocument = gql`
    query CurriculaLessonStatus($organizationUuid: ID!, $schoolYearUuid: ID!, $curriculumUuids: [ID!]) {
  curriculaLessonStatus(
    organizationUuid: $organizationUuid
    schoolYearUuid: $schoolYearUuid
    curriculumUuids: $curriculumUuids
  ) {
    curriculumUuid
    existing
    possible
    canImport
  }
}
    `;

export function useCurriculaLessonStatusQuery(
  options: Omit<Urql.UseQueryArgs<CurriculaLessonStatusQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CurriculaLessonStatusQuery, CurriculaLessonStatusQueryVariables>({
    query: CurriculaLessonStatusDocument,
    ...options,
  });
}
export const DependenciesForVersionDocument = gql`
    query DependenciesForVersion($versionUuid: ID!) {
  dependenciesForVersion(versionUuid: $versionUuid) {
    ...DependencyItem
  }
}
    ${DependencyItemFragmentDoc}`;

export function useDependenciesForVersionQuery(
  options: Omit<Urql.UseQueryArgs<DependenciesForVersionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<DependenciesForVersionQuery, DependenciesForVersionQueryVariables>({
    query: DependenciesForVersionDocument,
    ...options,
  });
}
export const CreateDependencyDocument = gql`
    mutation CreateDependency($versionUuid: ID!, $input: DependencyInput!) {
  createDependency(versionUuid: $versionUuid, input: $input) {
    ...DependencyItem
  }
}
    ${DependencyItemFragmentDoc}`;

export function useCreateDependencyMutation() {
  return Urql.useMutation<CreateDependencyMutation, CreateDependencyMutationVariables>(CreateDependencyDocument);
}
export const UpdateDependencyDocument = gql`
    mutation UpdateDependency($uuid: ID!, $input: DependencyInput!) {
  updateDependency(uuid: $uuid, input: $input) {
    ...DependencyItem
  }
}
    ${DependencyItemFragmentDoc}`;

export function useUpdateDependencyMutation() {
  return Urql.useMutation<UpdateDependencyMutation, UpdateDependencyMutationVariables>(UpdateDependencyDocument);
}
export const SetDependencyActiveDocument = gql`
    mutation SetDependencyActive($uuid: ID!, $active: Boolean!) {
  setDependencyActive(uuid: $uuid, active: $active) {
    ...DependencyItem
  }
}
    ${DependencyItemFragmentDoc}`;

export function useSetDependencyActiveMutation() {
  return Urql.useMutation<SetDependencyActiveMutation, SetDependencyActiveMutationVariables>(
    SetDependencyActiveDocument,
  );
}
export const DeleteDependencyDocument = gql`
    mutation DeleteDependency($uuid: ID!) {
  deleteDependency(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteDependencyMutation() {
  return Urql.useMutation<DeleteDependencyMutation, DeleteDependencyMutationVariables>(DeleteDependencyDocument);
}
export const ListPlannedTeacherTeachingLoadDocument = gql`
    query ListPlannedTeacherTeachingLoad($organizationUuid: ID!, $schoolYearUuid: ID!, $teacherUuid: ID) {
  plannedTeachingLoadByTeacher(
    organizationUuid: $organizationUuid
    schoolYearUuid: $schoolYearUuid
    teacherUuid: $teacherUuid
  ) {
    organization {
      uuid
    }
    schoolYear {
      uuid
      name
    }
    teacherUuid
    teacherDisplayName
    lessonUuid
    subjectUuid
    subjectDisplayName
    subjectContainerUuid
    subjectContainerDisplayName
    partialClasses
    lessonClass {
      class {
        uuid
        grade
        gradeGroup {
          uuid
          name
          shortName
        }
      }
      groups {
        uuid
        name
        shortName
      }
    }
    lessonClassesDisplayName
    countClasses
    countTeacher
    studentCards
    teacherCards
    studentHours
    teacherHours
    teachingBlockWeeks
    teachingBlocks
    relevantFactors {
      uuid
      factorType
      value
      valueRaw
      valuePartial
      valuePartialRaw
      valueMode
      studentsMin
      studentsMax
      studentsPartialMin
      studentsPartialMax
      comment
    }
    factor
    deputat
  }
}
    `;

export function useListPlannedTeacherTeachingLoadQuery(
  options: Omit<Urql.UseQueryArgs<ListPlannedTeacherTeachingLoadQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListPlannedTeacherTeachingLoadQuery, ListPlannedTeacherTeachingLoadQueryVariables>({
    query: ListPlannedTeacherTeachingLoadDocument,
    ...options,
  });
}
export const ListTeacherTeachingLoadDocument = gql`
    query ListTeacherTeachingLoad($organizationUuid: ID!, $schoolYearUuid: ID!, $timetableBlockUuid: ID!, $teacherUuid: ID) {
  teachingLoadByTeacher(
    organizationUuid: $organizationUuid
    schoolYearUuid: $schoolYearUuid
    timetableBlockUuid: $timetableBlockUuid
    teacherUuid: $teacherUuid
  ) {
    organization {
      uuid
    }
    schoolYear {
      uuid
      name
    }
    teacherUuid
    teacherDisplayName
    subjectUuid
    subjectDisplayName
    subjectContainerUuid
    subjectContainerDisplayName
    partialClasses
    lessonClass {
      class {
        uuid
        grade
        gradeGroup {
          uuid
          name
          shortName
        }
      }
      groups {
        uuid
        name
        shortName
      }
    }
    lessonClassesDisplayName
    countClasses
    countTeacher
    studentCards
    teacherCards
    studentHours
    teacherHours
    teachingBlockWeeks
    teachingBlocks
    relevantFactors {
      uuid
      factorType
      value
      valueRaw
      valuePartial
      valuePartialRaw
      valueMode
      studentsMin
      studentsMax
      studentsPartialMin
      studentsPartialMax
      comment
    }
    factor
    deputat
    timetableBlockUuid
    timetableBlockDisplayName
    timetableBlockSortName
  }
}
    `;

export function useListTeacherTeachingLoadQuery(
  options: Omit<Urql.UseQueryArgs<ListTeacherTeachingLoadQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListTeacherTeachingLoadQuery, ListTeacherTeachingLoadQueryVariables>({
    query: ListTeacherTeachingLoadDocument,
    ...options,
  });
}
export const CreateDivisionDocument = gql`
    mutation createDivision($classUuid: ID, $input: DivisionInput!) {
  createDivision(classUuid: $classUuid, input: $input) {
    ...DivisionListItem
  }
}
    ${DivisionListItemFragmentDoc}`;

export function useCreateDivisionMutation() {
  return Urql.useMutation<CreateDivisionMutation, CreateDivisionMutationVariables>(CreateDivisionDocument);
}
export const UpdateDivisionDocument = gql`
    mutation updateDivision($uuid: ID!, $input: DivisionInput!) {
  updateDivision(uuid: $uuid, input: $input) {
    ...DivisionListItem
  }
}
    ${DivisionListItemFragmentDoc}`;

export function useUpdateDivisionMutation() {
  return Urql.useMutation<UpdateDivisionMutation, UpdateDivisionMutationVariables>(UpdateDivisionDocument);
}
export const DeleteDivisionDocument = gql`
    mutation deleteDivision($uuid: ID!) {
  deleteDivision(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteDivisionMutation() {
  return Urql.useMutation<DeleteDivisionMutation, DeleteDivisionMutationVariables>(DeleteDivisionDocument);
}
export const ClassDivisionFormDocument = gql`
    query ClassDivisionForm($classUuid: ID!) {
  divisions(classUuid: $classUuid) {
    ...DivisionListItem
  }
  defaultDivisions {
    ...DivisionListItem
  }
}
    ${DivisionListItemFragmentDoc}`;

export function useClassDivisionFormQuery(options: Omit<Urql.UseQueryArgs<ClassDivisionFormQueryVariables>, 'query'>) {
  return Urql.useQuery<ClassDivisionFormQuery, ClassDivisionFormQueryVariables>({
    query: ClassDivisionFormDocument,
    ...options,
  });
}
export const DefaultDivisionsDocument = gql`
    query DefaultDivisions {
  defaultDivisions {
    ...DivisionListItem
  }
}
    ${DivisionListItemFragmentDoc}`;

export function useDefaultDivisionsQuery(options?: Omit<Urql.UseQueryArgs<DefaultDivisionsQueryVariables>, 'query'>) {
  return Urql.useQuery<DefaultDivisionsQuery, DefaultDivisionsQueryVariables>({
    query: DefaultDivisionsDocument,
    ...options,
  });
}
export const ClassDivisionsListDocument = gql`
    query ClassDivisionsList($classUuid: ID!) {
  divisions(classUuid: $classUuid) {
    ...DivisionListItem
  }
  class(uuid: $classUuid) {
    __typename
    uuid
    name
  }
}
    ${DivisionListItemFragmentDoc}`;

export function useClassDivisionsListQuery(
  options: Omit<Urql.UseQueryArgs<ClassDivisionsListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ClassDivisionsListQuery, ClassDivisionsListQueryVariables>({
    query: ClassDivisionsListDocument,
    ...options,
  });
}
export const TimetableReportsDocument = gql`
    query TimetableReports($schoolYearUuid: ID, $teachingBlockUuids: [ID!], $timetableBlockUuids: [ID!]) {
  timetableReports(
    schoolYearUuid: $schoolYearUuid
    teachingBlockUuids: $teachingBlockUuids
    timetableBlockUuids: $timetableBlockUuids
  ) {
    __typename
    uuid
    title
    type
    jobCreated
    jobFinished
    contextUuid
    contextName
    fileEntries {
      uuid
      filename
    }
  }
}
    `;

export function useTimetableReportsQuery(options?: Omit<Urql.UseQueryArgs<TimetableReportsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimetableReportsQuery, TimetableReportsQueryVariables>({
    query: TimetableReportsDocument,
    ...options,
  });
}
export const TeachingLoadReportsDocument = gql`
    query TeachingLoadReports($type: TeachingLoadReportType, $schoolYearUuid: ID, $teachingBlockUuids: [ID!], $timetableBlockUuids: [ID!]) {
  teachingLoadReports(
    type: $type
    schoolYearUuid: $schoolYearUuid
    teachingBlockUuids: $teachingBlockUuids
    timetableBlockUuids: $timetableBlockUuids
  ) {
    __typename
    uuid
    title
    type
    jobCreated
    jobFinished
    contextUuid
    contextName
    fileEntries {
      uuid
      filename
    }
  }
}
    `;

export function useTeachingLoadReportsQuery(
  options?: Omit<Urql.UseQueryArgs<TeachingLoadReportsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingLoadReportsQuery, TeachingLoadReportsQueryVariables>({
    query: TeachingLoadReportsDocument,
    ...options,
  });
}
export const CreateTeachingBlockExclusionDocument = gql`
    mutation CreateTeachingBlockExclusion($versionUuid: ID!, $input: TeachingBlockExclusionInput!) {
  createTeachingBlockExclusion(versionUuid: $versionUuid, input: $input) {
    ...TeachingBlockVersionExclusion
  }
}
    ${TeachingBlockVersionExclusionFragmentDoc}`;

export function useCreateTeachingBlockExclusionMutation() {
  return Urql.useMutation<CreateTeachingBlockExclusionMutation, CreateTeachingBlockExclusionMutationVariables>(
    CreateTeachingBlockExclusionDocument,
  );
}
export const UpdateTeachingBlockExclusionDocument = gql`
    mutation UpdateTeachingBlockExclusion($uuid: ID!, $input: TeachingBlockExclusionInput!) {
  updateTeachingBlockExclusion(uuid: $uuid, input: $input) {
    ...TeachingBlockVersionExclusion
  }
}
    ${TeachingBlockVersionExclusionFragmentDoc}`;

export function useUpdateTeachingBlockExclusionMutation() {
  return Urql.useMutation<UpdateTeachingBlockExclusionMutation, UpdateTeachingBlockExclusionMutationVariables>(
    UpdateTeachingBlockExclusionDocument,
  );
}
export const DeleteTeachingBlockExclusionsDocument = gql`
    mutation DeleteTeachingBlockExclusions($uuids: [ID!]!) {
  deleteTeachingBlockExclusions(uuids: $uuids) {
    nodesDeleted
  }
}
    `;

export function useDeleteTeachingBlockExclusionsMutation() {
  return Urql.useMutation<DeleteTeachingBlockExclusionsMutation, DeleteTeachingBlockExclusionsMutationVariables>(
    DeleteTeachingBlockExclusionsDocument,
  );
}
export const DeleteTeachingLoadFactorsDocument = gql`
    mutation deleteTeachingLoadFactors($uuids: [ID!]!) {
  deleteTeachingLoadFactors(uuids: $uuids) {
    nodesDeleted
  }
}
    `;

export function useDeleteTeachingLoadFactorsMutation() {
  return Urql.useMutation<DeleteTeachingLoadFactorsMutation, DeleteTeachingLoadFactorsMutationVariables>(
    DeleteTeachingLoadFactorsDocument,
  );
}
export const CreateTeachingLoadFactorDocument = gql`
    mutation createTeachingLoadFactor($input: TeachingLoadFactorInput!) {
  createTeachingLoadFactor(input: $input) {
    ...TeachingLoadFactorItem
  }
}
    ${TeachingLoadFactorItemFragmentDoc}`;

export function useCreateTeachingLoadFactorMutation() {
  return Urql.useMutation<CreateTeachingLoadFactorMutation, CreateTeachingLoadFactorMutationVariables>(
    CreateTeachingLoadFactorDocument,
  );
}
export const UpdateTeachingLoadFactorDocument = gql`
    mutation updateTeachingLoadFactor($uuid: ID!, $input: TeachingLoadFactorInput!) {
  updateTeachingLoadFactor(uuid: $uuid, input: $input) {
    ...TeachingLoadFactorItem
  }
}
    ${TeachingLoadFactorItemFragmentDoc}`;

export function useUpdateTeachingLoadFactorMutation() {
  return Urql.useMutation<UpdateTeachingLoadFactorMutation, UpdateTeachingLoadFactorMutationVariables>(
    UpdateTeachingLoadFactorDocument,
  );
}
export const SetTeachingLoadFactorActiveDocument = gql`
    mutation setTeachingLoadFactorActive($uuid: ID!, $active: Boolean!) {
  setTeachingLoadFactorActive(uuid: $uuid, active: $active) {
    uuid
    active
  }
}
    `;

export function useSetTeachingLoadFactorActiveMutation() {
  return Urql.useMutation<SetTeachingLoadFactorActiveMutation, SetTeachingLoadFactorActiveMutationVariables>(
    SetTeachingLoadFactorActiveDocument,
  );
}
export const TeachingLoadFactorsDocument = gql`
    query TeachingLoadFactors($schoolYearUuid: ID!) {
  teachingLoadFactors(schoolYearUuid: $schoolYearUuid) {
    ...TeachingLoadFactorItem
  }
}
    ${TeachingLoadFactorItemFragmentDoc}`;

export function useTeachingLoadFactorsQuery(
  options: Omit<Urql.UseQueryArgs<TeachingLoadFactorsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingLoadFactorsQuery, TeachingLoadFactorsQueryVariables>({
    query: TeachingLoadFactorsDocument,
    ...options,
  });
}
export const CreateGradeGroupsDocument = gql`
    mutation createGradeGroups($input: GradeGroupInput!) {
  createGradeGroup(input: $input) {
    uuid
  }
}
    `;

export function useCreateGradeGroupsMutation() {
  return Urql.useMutation<CreateGradeGroupsMutation, CreateGradeGroupsMutationVariables>(CreateGradeGroupsDocument);
}
export const DeleteGradeGroupsDocument = gql`
    mutation deleteGradeGroups($uuid: ID!) {
  deleteGradeGroup(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteGradeGroupsMutation() {
  return Urql.useMutation<DeleteGradeGroupsMutation, DeleteGradeGroupsMutationVariables>(DeleteGradeGroupsDocument);
}
export const UpdateGradeGroupsDocument = gql`
    mutation updateGradeGroups($uuid: ID!, $input: GradeGroupInput!) {
  updateGradeGroup(uuid: $uuid, input: $input) {
    uuid
  }
}
    `;

export function useUpdateGradeGroupsMutation() {
  return Urql.useMutation<UpdateGradeGroupsMutation, UpdateGradeGroupsMutationVariables>(UpdateGradeGroupsDocument);
}
export const GradeGroupsListDocument = gql`
    query GradeGroupsList {
  gradeGroups {
    uuid
    name
    shortName
    description
  }
}
    `;

export function useGradeGroupsListQuery(options?: Omit<Urql.UseQueryArgs<GradeGroupsListQueryVariables>, 'query'>) {
  return Urql.useQuery<GradeGroupsListQuery, GradeGroupsListQueryVariables>({
    query: GradeGroupsListDocument,
    ...options,
  });
}
export const DeleteHolidaysDocument = gql`
    mutation deleteHolidays($uuid: ID!) {
  deleteHoliday(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteHolidaysMutation() {
  return Urql.useMutation<DeleteHolidaysMutation, DeleteHolidaysMutationVariables>(DeleteHolidaysDocument);
}
export const UpdateHolidaysDocument = gql`
    mutation updateHolidays($uuid: ID!, $input: HolidayInput!) {
  updateHoliday(uuid: $uuid, input: $input) {
    uuid
  }
}
    `;

export function useUpdateHolidaysMutation() {
  return Urql.useMutation<UpdateHolidaysMutation, UpdateHolidaysMutationVariables>(UpdateHolidaysDocument);
}
export const CreateHolidaysDocument = gql`
    mutation createHolidays($input: HolidayInput!) {
  createHoliday(input: $input) {
    uuid
  }
}
    `;

export function useCreateHolidaysMutation() {
  return Urql.useMutation<CreateHolidaysMutation, CreateHolidaysMutationVariables>(CreateHolidaysDocument);
}
export const ConnectLessonsToTimetableVersionDocument = gql`
    mutation connectLessonsToTimetableVersion($organizationUuid: ID!, $timetableVersionUuid: ID!, $lessonUuids: [ID!]!) {
  connectLessonsToTimetableVersion(
    organizationUuid: $organizationUuid
    timetableVersionUuid: $timetableVersionUuid
    lessonUuids: $lessonUuids
  ) {
    nodesUpdated
    nodeUuids
  }
}
    `;

export function useConnectLessonsToTimetableVersionMutation() {
  return Urql.useMutation<ConnectLessonsToTimetableVersionMutation, ConnectLessonsToTimetableVersionMutationVariables>(
    ConnectLessonsToTimetableVersionDocument,
  );
}
export const InheritLessonTeachersDocument = gql`
    mutation inheritLessonTeachers($lessonUuids: [ID!]!, $type: InheritLessonTeachersType!) {
  inheritLessonTeachers(lessonUuids: $lessonUuids, type: $type) {
    entitiesUpdated
  }
}
    `;

export function useInheritLessonTeachersMutation() {
  return Urql.useMutation<InheritLessonTeachersMutation, InheritLessonTeachersMutationVariables>(
    InheritLessonTeachersDocument,
  );
}
export const CopyLessonsToTimetableVersionDocument = gql`
    mutation copyLessonsToTimetableVersion($organizationUuid: ID!, $timetableVersionUuid: ID!, $lessonUuids: [ID!]!) {
  copyLessonsToTimetableVersion(
    organizationUuid: $organizationUuid
    timetableVersionUuid: $timetableVersionUuid
    lessonUuids: $lessonUuids
  ) {
    nodesCreated
    nodeUuids
  }
}
    `;

export function useCopyLessonsToTimetableVersionMutation() {
  return Urql.useMutation<CopyLessonsToTimetableVersionMutation, CopyLessonsToTimetableVersionMutationVariables>(
    CopyLessonsToTimetableVersionDocument,
  );
}
export const MergeLessonsDocument = gql`
    mutation mergeLessons($cardsFromLesson: ID, $lessonUuids: [ID!]!, $newCards: [MergeLessonNewCardsInput!]!, $timetableVersion: ID) {
  mergeLessons(
    cardsFromLesson: $cardsFromLesson
    lessonUuids: $lessonUuids
    newCards: $newCards
    timetableVersion: $timetableVersion
  ) {
    nodeUuids
    nodesCreated
  }
}
    `;

export function useMergeLessonsMutation() {
  return Urql.useMutation<MergeLessonsMutation, MergeLessonsMutationVariables>(MergeLessonsDocument);
}
export const CreateLessonDocument = gql`
    mutation CreateLesson($schoolYearUuid: ID!, $curriculumUuid: ID, $input: LessonInput!) {
  createLesson(
    schoolYearUuid: $schoolYearUuid
    curriculumUuid: $curriculumUuid
    input: $input
  ) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useCreateLessonMutation() {
  return Urql.useMutation<CreateLessonMutation, CreateLessonMutationVariables>(CreateLessonDocument);
}
export const CreateLessonInTimetableVersionDocument = gql`
    mutation CreateLessonInTimetableVersion($versionUuid: ID!, $schoolYearUuid: ID!, $input: LessonInput!, $cardDurations: [Int!]!) {
  createLessonInTimetableVersion(
    versionUuid: $versionUuid
    schoolYearUuid: $schoolYearUuid
    input: $input
    cardDurations: $cardDurations
  ) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useCreateLessonInTimetableVersionMutation() {
  return Urql.useMutation<CreateLessonInTimetableVersionMutation, CreateLessonInTimetableVersionMutationVariables>(
    CreateLessonInTimetableVersionDocument,
  );
}
export const CreateLessonInTeachingBlockVersionDocument = gql`
    mutation CreateLessonInTeachingBlockVersion($versionUuid: ID!, $schoolYearUuid: ID!, $input: LessonInput!, $cardDurations: [Int!]!) {
  createLessonInTeachingBlockVersion(
    versionUuid: $versionUuid
    schoolYearUuid: $schoolYearUuid
    input: $input
    cardDurations: $cardDurations
  ) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useCreateLessonInTeachingBlockVersionMutation() {
  return Urql.useMutation<
    CreateLessonInTeachingBlockVersionMutation,
    CreateLessonInTeachingBlockVersionMutationVariables
  >(CreateLessonInTeachingBlockVersionDocument);
}
export const UpdateLessonDocument = gql`
    mutation UpdateLesson($uuid: ID!, $input: LessonInput!) {
  updateLesson(uuid: $uuid, input: $input) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useUpdateLessonMutation() {
  return Urql.useMutation<UpdateLessonMutation, UpdateLessonMutationVariables>(UpdateLessonDocument);
}
export const SetLessonsFlagDocument = gql`
    mutation SetLessonsFlag($uuids: [ID!]!, $flag: LessonFlag!, $value: Boolean!) {
  setLessonsFlag(uuids: $uuids, flag: $flag, value: $value) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useSetLessonsFlagMutation() {
  return Urql.useMutation<SetLessonsFlagMutation, SetLessonsFlagMutationVariables>(SetLessonsFlagDocument);
}
export const AssignTeachersToLessonsDocument = gql`
    mutation AssignTeachersToLessons($uuids: [ID!]!, $teachers: [LessonTeacherInput!]!) {
  assignTeachersToLessons(uuids: $uuids, teachers: $teachers) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useAssignTeachersToLessonsMutation() {
  return Urql.useMutation<AssignTeachersToLessonsMutation, AssignTeachersToLessonsMutationVariables>(
    AssignTeachersToLessonsDocument,
  );
}
export const DetachTeachersFromLessonsDocument = gql`
    mutation DetachTeachersFromLessons($uuids: [ID!]!) {
  detachTeachersFromLessons(uuids: $uuids) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useDetachTeachersFromLessonsMutation() {
  return Urql.useMutation<DetachTeachersFromLessonsMutation, DetachTeachersFromLessonsMutationVariables>(
    DetachTeachersFromLessonsDocument,
  );
}
export const DetachLessonsFromTimetableVersionDocument = gql`
    mutation DetachLessonsFromTimetableVersion($versionUuid: ID!, $uuids: [ID!]!) {
  detachLessonsFromTimetableVersion(versionUuid: $versionUuid, uuids: $uuids) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useDetachLessonsFromTimetableVersionMutation() {
  return Urql.useMutation<
    DetachLessonsFromTimetableVersionMutation,
    DetachLessonsFromTimetableVersionMutationVariables
  >(DetachLessonsFromTimetableVersionDocument);
}
export const CopyLessonIntoTeachingBlockVersionDocument = gql`
    mutation CopyLessonIntoTeachingBlockVersion($versionUuid: ID!, $lessonUuid: ID!) {
  copyLessonIntoTeachingBlockVersion(
    versionUuid: $versionUuid
    lessonUuid: $lessonUuid
  ) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useCopyLessonIntoTeachingBlockVersionMutation() {
  return Urql.useMutation<
    CopyLessonIntoTeachingBlockVersionMutation,
    CopyLessonIntoTeachingBlockVersionMutationVariables
  >(CopyLessonIntoTeachingBlockVersionDocument);
}
export const DetachLessonsFromTeachingBlockVersionDocument = gql`
    mutation DetachLessonsFromTeachingBlockVersion($versionUuid: ID!, $uuids: [ID!]!) {
  detachLessonsFromTeachingBlockVersion(versionUuid: $versionUuid, uuids: $uuids) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useDetachLessonsFromTeachingBlockVersionMutation() {
  return Urql.useMutation<
    DetachLessonsFromTeachingBlockVersionMutation,
    DetachLessonsFromTeachingBlockVersionMutationVariables
  >(DetachLessonsFromTeachingBlockVersionDocument);
}
export const DeleteLessonsDocument = gql`
    mutation DeleteLessons($uuids: [ID!]!) {
  deleteLessons(uuids: $uuids) {
    nodesDeleted
  }
}
    `;

export function useDeleteLessonsMutation() {
  return Urql.useMutation<DeleteLessonsMutation, DeleteLessonsMutationVariables>(DeleteLessonsDocument);
}
export const AttachLessonsToTeachingBlockVersionDocument = gql`
    mutation AttachLessonsToTeachingBlockVersion($versionUuid: ID!, $uuids: [ID!]!) {
  attachLessonsToTeachingBlockVersion(versionUuid: $versionUuid, uuids: $uuids) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useAttachLessonsToTeachingBlockVersionMutation() {
  return Urql.useMutation<
    AttachLessonsToTeachingBlockVersionMutation,
    AttachLessonsToTeachingBlockVersionMutationVariables
  >(AttachLessonsToTeachingBlockVersionDocument);
}
export const LessonsForSchoolYearDocument = gql`
    query LessonsForSchoolYear($schoolYearUuid: ID!) {
  lessonsForSchoolYear(schoolYearUuid: $schoolYearUuid) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useLessonsForSchoolYearQuery(
  options: Omit<Urql.UseQueryArgs<LessonsForSchoolYearQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LessonsForSchoolYearQuery, LessonsForSchoolYearQueryVariables>({
    query: LessonsForSchoolYearDocument,
    ...options,
  });
}
export const LessonsByUuidsDocument = gql`
    query LessonsByUuids($uuids: [ID!]!) {
  lessonsByUuids(uuids: $uuids) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useLessonsByUuidsQuery(options: Omit<Urql.UseQueryArgs<LessonsByUuidsQueryVariables>, 'query'>) {
  return Urql.useQuery<LessonsByUuidsQuery, LessonsByUuidsQueryVariables>({
    query: LessonsByUuidsDocument,
    ...options,
  });
}
export const LessonsForTimetableVersionDocument = gql`
    query LessonsForTimetableVersion($versionUuid: ID!) {
  lessonsForTimetableVersion(versionUuid: $versionUuid) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useLessonsForTimetableVersionQuery(
  options: Omit<Urql.UseQueryArgs<LessonsForTimetableVersionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LessonsForTimetableVersionQuery, LessonsForTimetableVersionQueryVariables>({
    query: LessonsForTimetableVersionDocument,
    ...options,
  });
}
export const LessonsForTeachingBlockVersionDocument = gql`
    query LessonsForTeachingBlockVersion($versionUuid: ID!) {
  lessonsForTeachingBlockVersion(versionUuid: $versionUuid) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useLessonsForTeachingBlockVersionQuery(
  options: Omit<Urql.UseQueryArgs<LessonsForTeachingBlockVersionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LessonsForTeachingBlockVersionQuery, LessonsForTeachingBlockVersionQueryVariables>({
    query: LessonsForTeachingBlockVersionDocument,
    ...options,
  });
}
export const ImportableLessonsForTimetableVersionDocument = gql`
    query ImportableLessonsForTimetableVersion($versionUuid: ID!, $schoolYearUuid: ID!) {
  importableLessonsForTimetableVersion(
    versionUuid: $versionUuid
    schoolYearUuid: $schoolYearUuid
  ) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useImportableLessonsForTimetableVersionQuery(
  options: Omit<Urql.UseQueryArgs<ImportableLessonsForTimetableVersionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ImportableLessonsForTimetableVersionQuery, ImportableLessonsForTimetableVersionQueryVariables>({
    query: ImportableLessonsForTimetableVersionDocument,
    ...options,
  });
}
export const ImportableLessonsForTeachingBlockVersionDocument = gql`
    query ImportableLessonsForTeachingBlockVersion($versionUuid: ID!, $subjectContainerUuid: ID!, $schoolYearUuid: ID!) {
  importableLessonsForTeachingBlockVersion(
    versionUuid: $versionUuid
    subjectContainerUuid: $subjectContainerUuid
    schoolYearUuid: $schoolYearUuid
  ) {
    ...LessonItem
  }
}
    ${LessonItemFragmentDoc}`;

export function useImportableLessonsForTeachingBlockVersionQuery(
  options: Omit<Urql.UseQueryArgs<ImportableLessonsForTeachingBlockVersionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    ImportableLessonsForTeachingBlockVersionQuery,
    ImportableLessonsForTeachingBlockVersionQueryVariables
  >({ query: ImportableLessonsForTeachingBlockVersionDocument, ...options });
}
export const LatestSolverJobForVersionDocument = gql`
    query LatestSolverJobForVersion($versionUuid: ID!) {
  latestSolverJobForVersion(versionUuid: $versionUuid) {
    ...SolverJobItem
  }
}
    ${SolverJobItemFragmentDoc}`;

export function useLatestSolverJobForVersionQuery(
  options: Omit<Urql.UseQueryArgs<LatestSolverJobForVersionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LatestSolverJobForVersionQuery, LatestSolverJobForVersionQueryVariables>({
    query: LatestSolverJobForVersionDocument,
    ...options,
  });
}
export const SolverJobDocument = gql`
    query SolverJob($jobId: String!) {
  solverJob(jobId: $jobId) {
    ...SolverJobItem
  }
}
    ${SolverJobItemFragmentDoc}`;

export function useSolverJobQuery(options: Omit<Urql.UseQueryArgs<SolverJobQueryVariables>, 'query'>) {
  return Urql.useQuery<SolverJobQuery, SolverJobQueryVariables>({ query: SolverJobDocument, ...options });
}
export const SolverJobsDocument = gql`
    query SolverJobs {
  solverJobs {
    ...SolverJobItem
  }
}
    ${SolverJobItemFragmentDoc}`;

export function useSolverJobsQuery(options?: Omit<Urql.UseQueryArgs<SolverJobsQueryVariables>, 'query'>) {
  return Urql.useQuery<SolverJobsQuery, SolverJobsQueryVariables>({ query: SolverJobsDocument, ...options });
}
export const SolverJobDetailsDocument = gql`
    query SolverJobDetails($jobId: String!) {
  solverJobDetails(jobId: $jobId) {
    __typename
    jobId
    problem
    solution
    errors
  }
}
    `;

export function useSolverJobDetailsQuery(options: Omit<Urql.UseQueryArgs<SolverJobDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<SolverJobDetailsQuery, SolverJobDetailsQueryVariables>({
    query: SolverJobDetailsDocument,
    ...options,
  });
}
export const SetEnabledSolverEnginesDocument = gql`
    mutation SetEnabledSolverEngines($engines: [SolverEngine!]!) {
  setEnabledSolverEngines(engines: $engines)
}
    `;

export function useSetEnabledSolverEnginesMutation() {
  return Urql.useMutation<SetEnabledSolverEnginesMutation, SetEnabledSolverEnginesMutationVariables>(
    SetEnabledSolverEnginesDocument,
  );
}
export const PimOrganizationsDocument = gql`
    query PimOrganizations {
  pimOrganizations {
    uuid
    name
    planungEnabled
    iphisVplanEnabled
    vpoEnabled
  }
}
    `;

export function usePimOrganizationsQuery(options?: Omit<Urql.UseQueryArgs<PimOrganizationsQueryVariables>, 'query'>) {
  return Urql.useQuery<PimOrganizationsQuery, PimOrganizationsQueryVariables>({
    query: PimOrganizationsDocument,
    ...options,
  });
}
export const SubstitutionSoftwareSettingsDocument = gql`
    query SubstitutionSoftwareSettings {
  substitutionSoftwareSettings {
    vpoSubstitutionProps
    iphisSubstitutionProps
  }
}
    `;

export function useSubstitutionSoftwareSettingsQuery(
  options?: Omit<Urql.UseQueryArgs<SubstitutionSoftwareSettingsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubstitutionSoftwareSettingsQuery, SubstitutionSoftwareSettingsQueryVariables>({
    query: SubstitutionSoftwareSettingsDocument,
    ...options,
  });
}
export const EnabledSolverEnginesDocument = gql`
    query EnabledSolverEngines {
  enabledSolverEngines
}
    `;

export function useEnabledSolverEnginesQuery(
  options?: Omit<Urql.UseQueryArgs<EnabledSolverEnginesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<EnabledSolverEnginesQuery, EnabledSolverEnginesQueryVariables>({
    query: EnabledSolverEnginesDocument,
    ...options,
  });
}
export const CreatePeopleDocument = gql`
    mutation createPeople($input: PersonInput!) {
  createPerson(input: $input) {
    uuid
  }
}
    `;

export function useCreatePeopleMutation() {
  return Urql.useMutation<CreatePeopleMutation, CreatePeopleMutationVariables>(CreatePeopleDocument);
}
export const UpdatePeopleDocument = gql`
    mutation updatePeople($uuid: ID!, $input: PersonInput!) {
  updatePerson(uuid: $uuid, input: $input) {
    uuid
  }
}
    `;

export function useUpdatePeopleMutation() {
  return Urql.useMutation<UpdatePeopleMutation, UpdatePeopleMutationVariables>(UpdatePeopleDocument);
}
export const DeletePeopleDocument = gql`
    mutation deletePeople($uuids: [ID!]!) {
  deletePeople(uuids: $uuids) {
    nodesDeleted
  }
}
    `;

export function useDeletePeopleMutation() {
  return Urql.useMutation<DeletePeopleMutation, DeletePeopleMutationVariables>(DeletePeopleDocument);
}
export const UpdateActivePeopleDocument = gql`
    mutation updateActivePeople($uuids: [ID!]!, $active: Boolean!) {
  setPeopleActive(uuids: $uuids, active: $active) {
    uuid
  }
}
    `;

export function useUpdateActivePeopleMutation() {
  return Urql.useMutation<UpdateActivePeopleMutation, UpdateActivePeopleMutationVariables>(UpdateActivePeopleDocument);
}
export const UpdatePeopleColorDocument = gql`
    mutation updatePeopleColor($uuid: ID!, $color: String!) {
  setPersonColor(uuid: $uuid, color: $color) {
    uuid
  }
}
    `;

export function useUpdatePeopleColorMutation() {
  return Urql.useMutation<UpdatePeopleColorMutation, UpdatePeopleColorMutationVariables>(UpdatePeopleColorDocument);
}
export const _PublishedSubstitutionsDocument = gql`
    query _PublishedSubstitutions($start: Date!, $end: Date!) {
  publishedSubstitutionDays(start: $start, end: $end) {
    uuid
    date
    lastPublished
    teachers
    classes
    substitutions
    notifications
  }
}
    `;

export function use_PublishedSubstitutionsQuery(
  options: Omit<Urql.UseQueryArgs<_PublishedSubstitutionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_PublishedSubstitutionsQuery, _PublishedSubstitutionsQueryVariables>({
    query: _PublishedSubstitutionsDocument,
    ...options,
  });
}
export const CreateRoomsDocument = gql`
    mutation createRooms($input: RoomInput!) {
  createRoom(input: $input) {
    uuid
  }
}
    `;

export function useCreateRoomsMutation() {
  return Urql.useMutation<CreateRoomsMutation, CreateRoomsMutationVariables>(CreateRoomsDocument);
}
export const UpdateRoomsDocument = gql`
    mutation updateRooms($uuid: ID!, $input: RoomInput!) {
  updateRoom(uuid: $uuid, input: $input) {
    uuid
  }
}
    `;

export function useUpdateRoomsMutation() {
  return Urql.useMutation<UpdateRoomsMutation, UpdateRoomsMutationVariables>(UpdateRoomsDocument);
}
export const SetRoomsFlagDocument = gql`
    mutation setRoomsFlag($uuids: [ID!]!, $flag: RoomFlag!, $value: Boolean!) {
  setRoomsFlag(uuids: $uuids, flag: $flag, value: $value) {
    uuid
  }
}
    `;

export function useSetRoomsFlagMutation() {
  return Urql.useMutation<SetRoomsFlagMutation, SetRoomsFlagMutationVariables>(SetRoomsFlagDocument);
}
export const AssignRoomsToBuildingDocument = gql`
    mutation assignRoomsToBuilding($uuids: [ID!]!, $buildingUuid: ID) {
  assignRoomsToBuilding(uuids: $uuids, buildingUuid: $buildingUuid) {
    uuid
  }
}
    `;

export function useAssignRoomsToBuildingMutation() {
  return Urql.useMutation<AssignRoomsToBuildingMutation, AssignRoomsToBuildingMutationVariables>(
    AssignRoomsToBuildingDocument,
  );
}
export const DeleteRoomsDocument = gql`
    mutation deleteRooms($uuids: [ID!]!) {
  deleteRooms(uuids: $uuids) {
    nodesDeleted
  }
}
    `;

export function useDeleteRoomsMutation() {
  return Urql.useMutation<DeleteRoomsMutation, DeleteRoomsMutationVariables>(DeleteRoomsDocument);
}
export const RoomsListDocument = gql`
    query RoomsList {
  rooms {
    uuid
    name
    building {
      uuid
      name
    }
    position
    roomNumber
    description
    classroom
    canBeLeased
    capacity
    chairs
    tables
    size
    responsiblePersonUuids
    otherInventory
    barrierFree
    canBeDarkened
    hasProjector
    hasScreen
    hasMediaCabinet
    hasPiano
  }
  buildings {
    uuid
    name
  }
  people {
    uuid
    firstName
    lastName
    displayNameShort
  }
}
    `;

export function useRoomsListQuery(options?: Omit<Urql.UseQueryArgs<RoomsListQueryVariables>, 'query'>) {
  return Urql.useQuery<RoomsListQuery, RoomsListQueryVariables>({ query: RoomsListDocument, ...options });
}
export const RoomUsageDocument = gql`
    query RoomUsage($uuids: [ID!]!) {
  roomUsage(uuids: $uuids) {
    uuid
    lessonsCount
    curriculaCount
  }
}
    `;

export function useRoomUsageQuery(options: Omit<Urql.UseQueryArgs<RoomUsageQueryVariables>, 'query'>) {
  return Urql.useQuery<RoomUsageQuery, RoomUsageQueryVariables>({ query: RoomUsageDocument, ...options });
}
export const CreateSchoolYearsDocument = gql`
    mutation createSchoolYears($input: SchoolYearInput!) {
  createSchoolYear(input: $input) {
    uuid
  }
}
    `;

export function useCreateSchoolYearsMutation() {
  return Urql.useMutation<CreateSchoolYearsMutation, CreateSchoolYearsMutationVariables>(CreateSchoolYearsDocument);
}
export const UpdateSchoolYearsDocument = gql`
    mutation updateSchoolYears($uuid: ID!, $input: SchoolYearInput!) {
  updateSchoolYear(uuid: $uuid, input: $input) {
    uuid
  }
}
    `;

export function useUpdateSchoolYearsMutation() {
  return Urql.useMutation<UpdateSchoolYearsMutation, UpdateSchoolYearsMutationVariables>(UpdateSchoolYearsDocument);
}
export const DeleteSchoolYearsDocument = gql`
    mutation deleteSchoolYears($uuid: ID!) {
  deleteSchoolYear(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteSchoolYearsMutation() {
  return Urql.useMutation<DeleteSchoolYearsMutation, DeleteSchoolYearsMutationVariables>(DeleteSchoolYearsDocument);
}
export const SchoolYearsDocument = gql`
    query SchoolYears {
  schoolYears {
    uuid
    name
    shortName
    start
    end
    fullTimeHours
    holidays {
      uuid
      name
      start
      end
    }
  }
}
    `;

export function useSchoolYearsQuery(options?: Omit<Urql.UseQueryArgs<SchoolYearsQueryVariables>, 'query'>) {
  return Urql.useQuery<SchoolYearsQuery, SchoolYearsQueryVariables>({ query: SchoolYearsDocument, ...options });
}
export const DeleteSubjectContainerDocument = gql`
    mutation deleteSubjectContainer($uuids: [ID!]!) {
  deleteSubjectContainers(uuids: $uuids) {
    nodesDeleted
  }
}
    `;

export function useDeleteSubjectContainerMutation() {
  return Urql.useMutation<DeleteSubjectContainerMutation, DeleteSubjectContainerMutationVariables>(
    DeleteSubjectContainerDocument,
  );
}
export const UpdateSubjectContainerDocument = gql`
    mutation updateSubjectContainer($uuid: ID!, $input: SubjectContainerInput!) {
  updateSubjectContainer(uuid: $uuid, input: $input) {
    uuid
  }
}
    `;

export function useUpdateSubjectContainerMutation() {
  return Urql.useMutation<UpdateSubjectContainerMutation, UpdateSubjectContainerMutationVariables>(
    UpdateSubjectContainerDocument,
  );
}
export const CreateSubjectContainersDocument = gql`
    mutation CreateSubjectContainers($input: SubjectContainerInput!) {
  createSubjectContainer(input: $input) {
    uuid
  }
}
    `;

export function useCreateSubjectContainersMutation() {
  return Urql.useMutation<CreateSubjectContainersMutation, CreateSubjectContainersMutationVariables>(
    CreateSubjectContainersDocument,
  );
}
export const _UpdateSubjectContainersColorsDocument = gql`
    mutation _updateSubjectContainersColors($uuid: ID!, $color: String!) {
  setSubjectContainerColor(uuid: $uuid, color: $color) {
    uuid
  }
}
    `;

export function use_UpdateSubjectContainersColorsMutation() {
  return Urql.useMutation<_UpdateSubjectContainersColorsMutation, _UpdateSubjectContainersColorsMutationVariables>(
    _UpdateSubjectContainersColorsDocument,
  );
}
export const SubjectContainersListDocument = gql`
    query SubjectContainersList {
  subjectContainers {
    uuid
    name
    gradeGroups {
      uuid
      name
      shortName
    }
    grades
    shortName
    order
    validFrom {
      uuid
      name
      shortName
      start
      end
    }
    validUntil {
      uuid
      name
      shortName
      start
      end
    }
    timetableConfig {
      color
      colorLabel
    }
  }
  schoolYears {
    uuid
    name
    shortName
    start
    end
  }
}
    `;

export function useSubjectContainersListQuery(
  options?: Omit<Urql.UseQueryArgs<SubjectContainersListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubjectContainersListQuery, SubjectContainersListQueryVariables>({
    query: SubjectContainersListDocument,
    ...options,
  });
}
export const SubjectContainerUsageDocument = gql`
    query SubjectContainerUsage($uuids: [ID!]!) {
  subjectContainerUsage(uuids: $uuids) {
    uuid
    name
    lessonsCount
    curriculaCount
    teachingBlocksCount
    lessonUnitsCount
  }
}
    `;

export function useSubjectContainerUsageQuery(
  options: Omit<Urql.UseQueryArgs<SubjectContainerUsageQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubjectContainerUsageQuery, SubjectContainerUsageQueryVariables>({
    query: SubjectContainerUsageDocument,
    ...options,
  });
}
export const SubjectContainerUsedInLessonsDocument = gql`
    query SubjectContainerUsedInLessons($uuid: ID!) {
  lessonsForSubjectContainer(subjectContainerUuid: $uuid) {
    uuid
    displayName
  }
}
    `;

export function useSubjectContainerUsedInLessonsQuery(
  options: Omit<Urql.UseQueryArgs<SubjectContainerUsedInLessonsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubjectContainerUsedInLessonsQuery, SubjectContainerUsedInLessonsQueryVariables>({
    query: SubjectContainerUsedInLessonsDocument,
    ...options,
  });
}
export const DeleteSubjectGroupDocument = gql`
    mutation deleteSubjectGroup($uuid: ID!) {
  deleteSubjectGroup(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteSubjectGroupMutation() {
  return Urql.useMutation<DeleteSubjectGroupMutation, DeleteSubjectGroupMutationVariables>(DeleteSubjectGroupDocument);
}
export const UpdateSubjectGroupDocument = gql`
    mutation updateSubjectGroup($uuid: ID!, $input: SubjectGroupInput!) {
  updateSubjectGroup(uuid: $uuid, input: $input) {
    uuid
    name
  }
}
    `;

export function useUpdateSubjectGroupMutation() {
  return Urql.useMutation<UpdateSubjectGroupMutation, UpdateSubjectGroupMutationVariables>(UpdateSubjectGroupDocument);
}
export const CreateSubjectGroupDocument = gql`
    mutation CreateSubjectGroup($input: SubjectGroupInput!) {
  createSubjectGroup(input: $input) {
    uuid
    name
  }
}
    `;

export function useCreateSubjectGroupMutation() {
  return Urql.useMutation<CreateSubjectGroupMutation, CreateSubjectGroupMutationVariables>(CreateSubjectGroupDocument);
}
export const SubjectGroupsDocument = gql`
    query SubjectGroups {
  subjectGroups {
    uuid
    name
  }
}
    `;

export function useSubjectGroupsQuery(options?: Omit<Urql.UseQueryArgs<SubjectGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<SubjectGroupsQuery, SubjectGroupsQueryVariables>({ query: SubjectGroupsDocument, ...options });
}
export const DeleteSubjectsDocument = gql`
    mutation deleteSubjects($uuids: [ID!]!) {
  deleteSubjects(uuids: $uuids) {
    nodesDeleted
  }
}
    `;

export function useDeleteSubjectsMutation() {
  return Urql.useMutation<DeleteSubjectsMutation, DeleteSubjectsMutationVariables>(DeleteSubjectsDocument);
}
export const UpdateSubjectsDocument = gql`
    mutation updateSubjects($uuid: ID!, $input: SubjectInput!) {
  updateSubject(uuid: $uuid, input: $input) {
    ...SubjectFragment
  }
}
    ${SubjectFragmentFragmentDoc}`;

export function useUpdateSubjectsMutation() {
  return Urql.useMutation<UpdateSubjectsMutation, UpdateSubjectsMutationVariables>(UpdateSubjectsDocument);
}
export const SetSubjectsFlagDocument = gql`
    mutation setSubjectsFlag($uuids: [ID!]!, $flag: SubjectFlag!, $value: Boolean!) {
  setSubjectsFlag(uuids: $uuids, flag: $flag, value: $value) {
    ...SubjectFragment
  }
}
    ${SubjectFragmentFragmentDoc}`;

export function useSetSubjectsFlagMutation() {
  return Urql.useMutation<SetSubjectsFlagMutation, SetSubjectsFlagMutationVariables>(SetSubjectsFlagDocument);
}
export const CreateSubjectDocument = gql`
    mutation createSubject($input: SubjectInput!) {
  createSubject(input: $input) {
    ...SubjectFragment
  }
}
    ${SubjectFragmentFragmentDoc}`;

export function useCreateSubjectMutation() {
  return Urql.useMutation<CreateSubjectMutation, CreateSubjectMutationVariables>(CreateSubjectDocument);
}
export const _UpdateSubjectsColorsDocument = gql`
    mutation _updateSubjectsColors($uuid: ID!, $color: String!) {
  setSubjectColor(uuid: $uuid, color: $color) {
    ...SubjectFragment
  }
}
    ${SubjectFragmentFragmentDoc}`;

export function use_UpdateSubjectsColorsMutation() {
  return Urql.useMutation<_UpdateSubjectsColorsMutation, _UpdateSubjectsColorsMutationVariables>(
    _UpdateSubjectsColorsDocument,
  );
}
export const SubjectsListDocument = gql`
    query SubjectsList($activeOnly: Boolean) {
  subjects(activeOnly: $activeOnly) {
    ...SubjectFragment
    timetableConfig {
      color
      colorLabel
      printOrder
      printPageNr
    }
  }
}
    ${SubjectFragmentFragmentDoc}`;

export function useSubjectsListQuery(options?: Omit<Urql.UseQueryArgs<SubjectsListQueryVariables>, 'query'>) {
  return Urql.useQuery<SubjectsListQuery, SubjectsListQueryVariables>({ query: SubjectsListDocument, ...options });
}
export const SubjectByUuidDocument = gql`
    query SubjectByUuid($uuid: ID!) {
  subject(uuid: $uuid) {
    ...SubjectFragment
  }
}
    ${SubjectFragmentFragmentDoc}`;

export function useSubjectByUuidQuery(options: Omit<Urql.UseQueryArgs<SubjectByUuidQueryVariables>, 'query'>) {
  return Urql.useQuery<SubjectByUuidQuery, SubjectByUuidQueryVariables>({ query: SubjectByUuidDocument, ...options });
}
export const SubjectUsageDocument = gql`
    query SubjectUsage($uuids: [ID!]!) {
  subjectUsage(uuids: $uuids) {
    uuid
    lessonsCount
    curriculaCount
  }
}
    `;

export function useSubjectUsageQuery(options: Omit<Urql.UseQueryArgs<SubjectUsageQueryVariables>, 'query'>) {
  return Urql.useQuery<SubjectUsageQuery, SubjectUsageQueryVariables>({ query: SubjectUsageDocument, ...options });
}
export const SaveSubstitutionSoftwareSettingsDocument = gql`
    mutation SaveSubstitutionSoftwareSettings($input: SubstitutionSoftwareSettingsInput!) {
  saveSubstitutionSoftwareSettings(input: $input) {
    vpoSubstitutionProps
    iphisSubstitutionProps
  }
}
    `;

export function useSaveSubstitutionSoftwareSettingsMutation() {
  return Urql.useMutation<SaveSubstitutionSoftwareSettingsMutation, SaveSubstitutionSoftwareSettingsMutationVariables>(
    SaveSubstitutionSoftwareSettingsDocument,
  );
}
export const TeachersSubstitutionsDocument = gql`
    query TeachersSubstitutions($organizationUuid: ID!, $classUuids: [ID!]!, $schoolYearUuid: ID!, $subjectUuid: String) {
  teachersSubstitutions(
    organizationUuid: $organizationUuid
    classUuids: $classUuids
    schoolYearUuid: $schoolYearUuid
    subjectUuid: $subjectUuid
  ) {
    givenSubstituteHours
    sameClass
    sameSubject
    substituteHours
    teacherUuid
  }
}
    `;

export function useTeachersSubstitutionsQuery(
  options: Omit<Urql.UseQueryArgs<TeachersSubstitutionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachersSubstitutionsQuery, TeachersSubstitutionsQueryVariables>({
    query: TeachersSubstitutionsDocument,
    ...options,
  });
}
export const SubstitutionAnnouncementDocument = gql`
    query SubstitutionAnnouncement($selectedDay: Date!) {
  substitutionAnnouncement(date: $selectedDay) {
    ...SubstitutionAnnouncementItem
  }
}
    ${SubstitutionAnnouncementItemFragmentDoc}`;

export function useSubstitutionAnnouncementQuery(
  options: Omit<Urql.UseQueryArgs<SubstitutionAnnouncementQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubstitutionAnnouncementQuery, SubstitutionAnnouncementQueryVariables>({
    query: SubstitutionAnnouncementDocument,
    ...options,
  });
}
export const SaveSubstitutionAnnouncementDocument = gql`
    mutation SaveSubstitutionAnnouncement($date: Date!, $publicAnnouncement: String, $internalAnnouncement: String) {
  saveSubstitutionAnnouncement(
    date: $date
    publicAnnouncement: $publicAnnouncement
    internalAnnouncement: $internalAnnouncement
  ) {
    ...SubstitutionAnnouncementItem
  }
}
    ${SubstitutionAnnouncementItemFragmentDoc}`;

export function useSaveSubstitutionAnnouncementMutation() {
  return Urql.useMutation<SaveSubstitutionAnnouncementMutation, SaveSubstitutionAnnouncementMutationVariables>(
    SaveSubstitutionAnnouncementDocument,
  );
}
export const SubstitutionPrintConfigDocument = gql`
    query SubstitutionPrintConfig {
  substitutionPrintConfig {
    ...SubstitutionPrintConfigItem
  }
}
    ${SubstitutionPrintConfigItemFragmentDoc}`;

export function useSubstitutionPrintConfigQuery(
  options?: Omit<Urql.UseQueryArgs<SubstitutionPrintConfigQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubstitutionPrintConfigQuery, SubstitutionPrintConfigQueryVariables>({
    query: SubstitutionPrintConfigDocument,
    ...options,
  });
}
export const SaveSubstitutionPrintConfigDocument = gql`
    mutation SaveSubstitutionPrintConfig($input: SubstitutionPrintConfigInput!) {
  saveSubstitutionPrintConfig(input: $input) {
    ...SubstitutionPrintConfigItem
  }
}
    ${SubstitutionPrintConfigItemFragmentDoc}`;

export function useSaveSubstitutionPrintConfigMutation() {
  return Urql.useMutation<SaveSubstitutionPrintConfigMutation, SaveSubstitutionPrintConfigMutationVariables>(
    SaveSubstitutionPrintConfigDocument,
  );
}
export const SubstitutionAppConfigDocument = gql`
    query SubstitutionAppConfig {
  substitutionAppConfig {
    ...SubstitutionAppConfigItem
  }
}
    ${SubstitutionAppConfigItemFragmentDoc}`;

export function useSubstitutionAppConfigQuery(
  options?: Omit<Urql.UseQueryArgs<SubstitutionAppConfigQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubstitutionAppConfigQuery, SubstitutionAppConfigQueryVariables>({
    query: SubstitutionAppConfigDocument,
    ...options,
  });
}
export const SaveSubstitutionAppConfigDocument = gql`
    mutation SaveSubstitutionAppConfig($input: SubstitutionAppConfigInput!) {
  saveSubstitutionAppConfig(input: $input) {
    ...SubstitutionAppConfigItem
  }
}
    ${SubstitutionAppConfigItemFragmentDoc}`;

export function useSaveSubstitutionAppConfigMutation() {
  return Urql.useMutation<SaveSubstitutionAppConfigMutation, SaveSubstitutionAppConfigMutationVariables>(
    SaveSubstitutionAppConfigDocument,
  );
}
export const SubstitutionReportDocument = gql`
    query SubstitutionReport($schoolYearUuid: ID!, $type: SubstitutionReportType) {
  substitutionReports(schoolYearUuid: $schoolYearUuid, type: $type) {
    uuid
    type
    title
    jobCreated
    jobFinished
    fileEntries {
      uuid
      filename
    }
  }
}
    `;

export function useSubstitutionReportQuery(
  options: Omit<Urql.UseQueryArgs<SubstitutionReportQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubstitutionReportQuery, SubstitutionReportQueryVariables>({
    query: SubstitutionReportDocument,
    ...options,
  });
}
export const AttendancePlanEventsDocument = gql`
    query AttendancePlanEvents($organizationUuid: ID!, $day: Date!) {
  attendancePlanEvents(organizationUuid: $organizationUuid, day: $day) {
    uuid
    start
    end
    subject {
      uuid
      shortName
      name
    }
    persons {
      __typename
      uuid
      displayName
      firstName
      lastName
      listName
      selectName
    }
    rooms {
      uuid
      name
    }
    class {
      uuid
      shortName
      name
    }
  }
}
    `;

export function useAttendancePlanEventsQuery(
  options: Omit<Urql.UseQueryArgs<AttendancePlanEventsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<AttendancePlanEventsQuery, AttendancePlanEventsQueryVariables>({
    query: AttendancePlanEventsDocument,
    ...options,
  });
}
export const CancelEventJobDocument = gql`
    mutation CancelEventJob($uuid: ID!) {
  cancelEventJob(uuid: $uuid) {
    uuid
    status
  }
}
    `;

export function useCancelEventJobMutation() {
  return Urql.useMutation<CancelEventJobMutation, CancelEventJobMutationVariables>(CancelEventJobDocument);
}
export const TeachingBlockClassTripCardsDocument = gql`
    query teachingBlockClassTripCards($schoolYearUuid: ID!) {
  teachingBlockClassTripCards(schoolYearUuid: $schoolYearUuid) {
    cardUuid
    teachingBlockUuid
    subjectContainerName
    versionUuid
    version
    startDate
    endDate
    classes {
      uuid
      shortName
    }
    teacherUuids
    roomUuids
    subjectName
    subjectShortName
  }
}
    `;

export function useTeachingBlockClassTripCardsQuery(
  options: Omit<Urql.UseQueryArgs<TeachingBlockClassTripCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingBlockClassTripCardsQuery, TeachingBlockClassTripCardsQueryVariables>({
    query: TeachingBlockClassTripCardsDocument,
    ...options,
  });
}
export const CreateBackendTeachingBlockVersionDocument = gql`
    mutation CreateBackendTeachingBlockVersion($subjectContainerUuid: ID!, $schoolYearUuid: ID!, $organizationUuid: ID!, $connectLessons: Boolean) {
  createBackendTeachingBlockVersion(
    organizationUuid: $organizationUuid
    schoolYearUuid: $schoolYearUuid
    subjectContainerUuid: $subjectContainerUuid
    connectLessons: $connectLessons
  ) {
    nodeUuids
    nodesCreated
  }
}
    `;

export function useCreateBackendTeachingBlockVersionMutation() {
  return Urql.useMutation<
    CreateBackendTeachingBlockVersionMutation,
    CreateBackendTeachingBlockVersionMutationVariables
  >(CreateBackendTeachingBlockVersionDocument);
}
export const CreateTeachingBlockCardsDocument = gql`
    mutation CreateTeachingBlockCards($versionUuid: ID!, $lessonUuid: ID!, $durations: [Int!]!) {
  createTeachingBlockCards(
    versionUuid: $versionUuid
    lessonUuid: $lessonUuid
    durations: $durations
  ) {
    ...TeachingBlockVersionCard
  }
}
    ${TeachingBlockVersionCardFragmentDoc}`;

export function useCreateTeachingBlockCardsMutation() {
  return Urql.useMutation<CreateTeachingBlockCardsMutation, CreateTeachingBlockCardsMutationVariables>(
    CreateTeachingBlockCardsDocument,
  );
}
export const PlaceTeachingBlockCardDocument = gql`
    mutation PlaceTeachingBlockCard($cardUuid: ID!, $startDate: Date!, $endDate: Date!, $includeHoliday: Boolean!) {
  placeTeachingBlockCard(
    cardUuid: $cardUuid
    startDate: $startDate
    endDate: $endDate
    includeHoliday: $includeHoliday
  ) {
    ...TeachingBlockVersionCard
  }
}
    ${TeachingBlockVersionCardFragmentDoc}`;

export function usePlaceTeachingBlockCardMutation() {
  return Urql.useMutation<PlaceTeachingBlockCardMutation, PlaceTeachingBlockCardMutationVariables>(
    PlaceTeachingBlockCardDocument,
  );
}
export const UnplaceTeachingBlockCardsDocument = gql`
    mutation UnplaceTeachingBlockCards($cardUuids: [ID!]!) {
  unplaceTeachingBlockCards(cardUuids: $cardUuids) {
    ...TeachingBlockVersionCard
  }
}
    ${TeachingBlockVersionCardFragmentDoc}`;

export function useUnplaceTeachingBlockCardsMutation() {
  return Urql.useMutation<UnplaceTeachingBlockCardsMutation, UnplaceTeachingBlockCardsMutationVariables>(
    UnplaceTeachingBlockCardsDocument,
  );
}
export const SetTeachingBlockCardsLockedDocument = gql`
    mutation SetTeachingBlockCardsLocked($cardUuids: [ID!]!, $locked: Boolean!) {
  setTeachingBlockCardsLocked(cardUuids: $cardUuids, locked: $locked) {
    ...TeachingBlockVersionCard
  }
}
    ${TeachingBlockVersionCardFragmentDoc}`;

export function useSetTeachingBlockCardsLockedMutation() {
  return Urql.useMutation<SetTeachingBlockCardsLockedMutation, SetTeachingBlockCardsLockedMutationVariables>(
    SetTeachingBlockCardsLockedDocument,
  );
}
export const SetTeachingBlockCardRoomsDocument = gql`
    mutation SetTeachingBlockCardRooms($cardUuid: ID!, $roomUuids: [ID!]!) {
  setTeachingBlockCardRooms(cardUuid: $cardUuid, roomUuids: $roomUuids) {
    ...TeachingBlockVersionCard
  }
}
    ${TeachingBlockVersionCardFragmentDoc}`;

export function useSetTeachingBlockCardRoomsMutation() {
  return Urql.useMutation<SetTeachingBlockCardRoomsMutation, SetTeachingBlockCardRoomsMutationVariables>(
    SetTeachingBlockCardRoomsDocument,
  );
}
export const DeleteTeachingBlockCardsDocument = gql`
    mutation DeleteTeachingBlockCards($cardUuids: [ID!]!) {
  deleteTeachingBlockCards(cardUuids: $cardUuids) {
    nodesDeleted
  }
}
    `;

export function useDeleteTeachingBlockCardsMutation() {
  return Urql.useMutation<DeleteTeachingBlockCardsMutation, DeleteTeachingBlockCardsMutationVariables>(
    DeleteTeachingBlockCardsDocument,
  );
}
export const DeleteTeachingBlockVersionDocument = gql`
    mutation DeleteTeachingBlockVersion($uuid: ID!) {
  deleteTeachingBlockVersion(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteTeachingBlockVersionMutation() {
  return Urql.useMutation<DeleteTeachingBlockVersionMutation, DeleteTeachingBlockVersionMutationVariables>(
    DeleteTeachingBlockVersionDocument,
  );
}
export const DuplicateTeachingBlockVersionDocument = gql`
    mutation DuplicateTeachingBlockVersion($teachingBlockVersionUuid: ID!, $organizationUuid: ID!, $options: DuplicateTeachingBlockVersionOptions!) {
  duplicateTeachingBlockVersion(
    organizationUuid: $organizationUuid
    teachingBlockVersionUuid: $teachingBlockVersionUuid
    options: $options
  ) {
    active
    description
    uuid
    version
  }
}
    `;

export function useDuplicateTeachingBlockVersionMutation() {
  return Urql.useMutation<DuplicateTeachingBlockVersionMutation, DuplicateTeachingBlockVersionMutationVariables>(
    DuplicateTeachingBlockVersionDocument,
  );
}
export const UpdateTeachingBlockVersionDocument = gql`
    mutation UpdateTeachingBlockVersion($uuid: ID!, $input: TeachingBlockVersionInput!) {
  updateTeachingBlockVersion(uuid: $uuid, input: $input) {
    versionUuid
    description
    active
    editable
  }
}
    `;

export function useUpdateTeachingBlockVersionMutation() {
  return Urql.useMutation<UpdateTeachingBlockVersionMutation, UpdateTeachingBlockVersionMutationVariables>(
    UpdateTeachingBlockVersionDocument,
  );
}
export const SetTeachingBlockVersionEditableDocument = gql`
    mutation SetTeachingBlockVersionEditable($uuid: ID!, $editable: Boolean!) {
  setTeachingBlockVersionEditable(uuid: $uuid, editable: $editable) {
    versionUuid
    editable
  }
}
    `;

export function useSetTeachingBlockVersionEditableMutation() {
  return Urql.useMutation<SetTeachingBlockVersionEditableMutation, SetTeachingBlockVersionEditableMutationVariables>(
    SetTeachingBlockVersionEditableDocument,
  );
}
export const AddTeachingBlockVersionResourcesDocument = gql`
    mutation AddTeachingBlockVersionResources($versionUuid: ID!, $resourceType: TeachingBlockResourceType!, $uuids: [ID!]!) {
  addTeachingBlockVersionResources(
    versionUuid: $versionUuid
    resourceType: $resourceType
    uuids: $uuids
  ) {
    resourceType
    uuid
    constraints
  }
}
    `;

export function useAddTeachingBlockVersionResourcesMutation() {
  return Urql.useMutation<AddTeachingBlockVersionResourcesMutation, AddTeachingBlockVersionResourcesMutationVariables>(
    AddTeachingBlockVersionResourcesDocument,
  );
}
export const RemoveTeachingBlockVersionResourcesDocument = gql`
    mutation RemoveTeachingBlockVersionResources($versionUuid: ID!, $resourceType: TeachingBlockResourceType!, $uuids: [ID!]!) {
  removeTeachingBlockVersionResources(
    versionUuid: $versionUuid
    resourceType: $resourceType
    uuids: $uuids
  ) {
    resourceType
    uuid
    constraints
  }
}
    `;

export function useRemoveTeachingBlockVersionResourcesMutation() {
  return Urql.useMutation<
    RemoveTeachingBlockVersionResourcesMutation,
    RemoveTeachingBlockVersionResourcesMutationVariables
  >(RemoveTeachingBlockVersionResourcesDocument);
}
export const SubjectContainerPlaceholderLessonsDocument = gql`
    query SubjectContainerPlaceholderLessons($subjectContainerUuid: ID!, $schoolYearUuid: ID!) {
  lessonsForSubjectContainer(
    subjectContainerUuid: $subjectContainerUuid
    schoolYearUuid: $schoolYearUuid
  ) {
    uuid
    lessonClasses {
      class {
        uuid
      }
    }
  }
}
    `;

export function useSubjectContainerPlaceholderLessonsQuery(
  options: Omit<Urql.UseQueryArgs<SubjectContainerPlaceholderLessonsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubjectContainerPlaceholderLessonsQuery, SubjectContainerPlaceholderLessonsQueryVariables>({
    query: SubjectContainerPlaceholderLessonsDocument,
    ...options,
  });
}
export const TeachingBlockVersionDataDocument = gql`
    query TeachingBlockVersionData($versionUuid: ID!) {
  teachingBlockVersionData(versionUuid: $versionUuid) {
    meta {
      versionUuid
      version
      description
      active
      editable
      isSnapshot
      teachingBlockUuid
      teachingBlockName
      teachingBlockDraft
      subjectContainerUuid
      schoolYearUuid
    }
    resources {
      resourceType
      uuid
      constraints
    }
    cards {
      uuid
      lessonUuid
      duration
      startDate
      endDate
      includeHoliday
      locked
      roomUuids
    }
    exclusions {
      uuid
      holderType
      holderUuid
      from
      to
      priority
      comment
    }
  }
}
    `;

export function useTeachingBlockVersionDataQuery(
  options: Omit<Urql.UseQueryArgs<TeachingBlockVersionDataQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingBlockVersionDataQuery, TeachingBlockVersionDataQueryVariables>({
    query: TeachingBlockVersionDataDocument,
    ...options,
  });
}
export const TeachingBlocksDocument = gql`
    query TeachingBlocks($schoolYearUuid: ID!, $onlyWithActiveVersion: Boolean) {
  teachingBlocks(
    schoolYearUuid: $schoolYearUuid
    onlyWithActiveVersion: $onlyWithActiveVersion
  ) {
    ...TeachingBlockItem
  }
}
    ${TeachingBlockItemFragmentDoc}`;

export function useTeachingBlocksQuery(options: Omit<Urql.UseQueryArgs<TeachingBlocksQueryVariables>, 'query'>) {
  return Urql.useQuery<TeachingBlocksQuery, TeachingBlocksQueryVariables>({
    query: TeachingBlocksDocument,
    ...options,
  });
}
export const TeachingBlockForVersionDocument = gql`
    query TeachingBlockForVersion($versionUuid: ID!) {
  teachingBlockForVersion(versionUuid: $versionUuid) {
    ...TeachingBlockItem
  }
}
    ${TeachingBlockItemFragmentDoc}`;

export function useTeachingBlockForVersionQuery(
  options: Omit<Urql.UseQueryArgs<TeachingBlockForVersionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingBlockForVersionQuery, TeachingBlockForVersionQueryVariables>({
    query: TeachingBlockForVersionDocument,
    ...options,
  });
}
export const TeachingBlockForSubjectContainerDocument = gql`
    query TeachingBlockForSubjectContainer($schoolYearUuid: ID!, $subjectContainerUuid: ID!) {
  teachingBlockForSubjectContainer(
    schoolYearUuid: $schoolYearUuid
    subjectContainerUuid: $subjectContainerUuid
  ) {
    ...TeachingBlockItem
  }
}
    ${TeachingBlockItemFragmentDoc}`;

export function useTeachingBlockForSubjectContainerQuery(
  options: Omit<Urql.UseQueryArgs<TeachingBlockForSubjectContainerQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingBlockForSubjectContainerQuery, TeachingBlockForSubjectContainerQueryVariables>({
    query: TeachingBlockForSubjectContainerDocument,
    ...options,
  });
}
export const SetTeachingBlockCommentDocument = gql`
    mutation SetTeachingBlockComment($uuid: ID!, $comment: String) {
  setTeachingBlockComment(uuid: $uuid, comment: $comment) {
    ...TeachingBlockItem
  }
}
    ${TeachingBlockItemFragmentDoc}`;

export function useSetTeachingBlockCommentMutation() {
  return Urql.useMutation<SetTeachingBlockCommentMutation, SetTeachingBlockCommentMutationVariables>(
    SetTeachingBlockCommentDocument,
  );
}
export const DeleteTeachingBlockDocument = gql`
    mutation DeleteTeachingBlock($uuid: ID!) {
  deleteTeachingBlock(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteTeachingBlockMutation() {
  return Urql.useMutation<DeleteTeachingBlockMutation, DeleteTeachingBlockMutationVariables>(
    DeleteTeachingBlockDocument,
  );
}
export const TeachingBlockCurrentStatusDocument = gql`
    query TeachingBlockCurrentStatus($teachingBlockUuids: [ID!]!) {
  teachingBlockCurrentStatus(teachingBlockUuids: $teachingBlockUuids) {
    __typename
    currentFrom
    isCurrent
    teachingBlockUuid
  }
}
    `;

export function useTeachingBlockCurrentStatusQuery(
  options: Omit<Urql.UseQueryArgs<TeachingBlockCurrentStatusQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingBlockCurrentStatusQuery, TeachingBlockCurrentStatusQueryVariables>({
    query: TeachingBlockCurrentStatusDocument,
    ...options,
  });
}
export const DeleteTimeGridEntryDocument = gql`
    mutation deleteTimeGridEntry($uuid: ID!) {
  deleteTimeGridEntry(uuid: $uuid) {
    nodesDeleted
    relationshipsDeleted
  }
}
    `;

export function useDeleteTimeGridEntryMutation() {
  return Urql.useMutation<DeleteTimeGridEntryMutation, DeleteTimeGridEntryMutationVariables>(
    DeleteTimeGridEntryDocument,
  );
}
export const UpdateTimeGridEntryDocument = gql`
    mutation updateTimeGridEntry($uuid: ID!, $update: UpdateTimeGridEntryInput!) {
  updateTimeGridEntry(uuid: $uuid, update: $update) {
    __typename
    nodeUuids
  }
}
    `;

export function useUpdateTimeGridEntryMutation() {
  return Urql.useMutation<UpdateTimeGridEntryMutation, UpdateTimeGridEntryMutationVariables>(
    UpdateTimeGridEntryDocument,
  );
}
export const CreateTimeGridEntryDocument = gql`
    mutation createTimeGridEntry($input: CreateTimeGridEntryInput!) {
  createTimeGridEntry(input: $input) {
    __typename
    nodeUuids
  }
}
    `;

export function useCreateTimeGridEntryMutation() {
  return Urql.useMutation<CreateTimeGridEntryMutation, CreateTimeGridEntryMutationVariables>(
    CreateTimeGridEntryDocument,
  );
}
export const UpdateTimeGridDocument = gql`
    mutation updateTimeGrid($uuid: ID!, $input: TimeGridInput!) {
  updateTimeGrid(uuid: $uuid, input: $input) {
    uuid
  }
}
    `;

export function useUpdateTimeGridMutation() {
  return Urql.useMutation<UpdateTimeGridMutation, UpdateTimeGridMutationVariables>(UpdateTimeGridDocument);
}
export const CreateTimeGridDocument = gql`
    mutation createTimeGrid($input: TimeGridInput!) {
  createTimeGrid(input: $input) {
    uuid
  }
}
    `;

export function useCreateTimeGridMutation() {
  return Urql.useMutation<CreateTimeGridMutation, CreateTimeGridMutationVariables>(CreateTimeGridDocument);
}
export const TimeGridDocument = gql`
    query TimeGrid {
  timeGrids {
    ...timeGridItem
  }
}
    ${TimeGridItemFragmentDoc}`;

export function useTimeGridQuery(options?: Omit<Urql.UseQueryArgs<TimeGridQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeGridQuery, TimeGridQueryVariables>({ query: TimeGridDocument, ...options });
}
export const TimeGridEntryUsageDocument = gql`
    query TimeGridEntryUsage($timeGridUuid: ID!) {
  timeGridEntryUsage(timeGridUuid: $timeGridUuid) {
    uuid
    placedCardsCount
  }
}
    `;

export function useTimeGridEntryUsageQuery(
  options: Omit<Urql.UseQueryArgs<TimeGridEntryUsageQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimeGridEntryUsageQuery, TimeGridEntryUsageQueryVariables>({
    query: TimeGridEntryUsageDocument,
    ...options,
  });
}
export const TimeGridMigrationCardsDocument = gql`
    query TimeGridMigrationCards($versionUuid: ID!) {
  placedTimetableCards(versionUuid: $versionUuid) {
    uuid
    startTimeGridEntryUuid
    endTimeGridEntryUuid
  }
}
    `;

export function useTimeGridMigrationCardsQuery(
  options: Omit<Urql.UseQueryArgs<TimeGridMigrationCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimeGridMigrationCardsQuery, TimeGridMigrationCardsQueryVariables>({
    query: TimeGridMigrationCardsDocument,
    ...options,
  });
}
export const TimetablesDocument = gql`
    query Timetables($schoolYearUuid: ID) {
  timetables(schoolYearUuid: $schoolYearUuid) {
    ...TimetableItem
  }
}
    ${TimetableItemFragmentDoc}`;

export function useTimetablesQuery(options?: Omit<Urql.UseQueryArgs<TimetablesQueryVariables>, 'query'>) {
  return Urql.useQuery<TimetablesQuery, TimetablesQueryVariables>({ query: TimetablesDocument, ...options });
}
export const TimetableForVersionDocument = gql`
    query TimetableForVersion($versionUuid: ID!) {
  timetableForVersion(versionUuid: $versionUuid) {
    ...TimetableItem
  }
}
    ${TimetableItemFragmentDoc}`;

export function useTimetableForVersionQuery(
  options: Omit<Urql.UseQueryArgs<TimetableForVersionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableForVersionQuery, TimetableForVersionQueryVariables>({
    query: TimetableForVersionDocument,
    ...options,
  });
}
export const CreateTimetableDocument = gql`
    mutation CreateTimetable($input: TimetableInput!) {
  createTimetable(input: $input) {
    ...TimetableItem
  }
}
    ${TimetableItemFragmentDoc}`;

export function useCreateTimetableMutation() {
  return Urql.useMutation<CreateTimetableMutation, CreateTimetableMutationVariables>(CreateTimetableDocument);
}
export const UpdateTimetableDocument = gql`
    mutation UpdateTimetable($uuid: ID!, $input: TimetableInput!) {
  updateTimetable(uuid: $uuid, input: $input) {
    ...TimetableItem
  }
}
    ${TimetableItemFragmentDoc}`;

export function useUpdateTimetableMutation() {
  return Urql.useMutation<UpdateTimetableMutation, UpdateTimetableMutationVariables>(UpdateTimetableDocument);
}
export const DeleteTimetablesDocument = gql`
    mutation DeleteTimetables($uuids: [ID!]!) {
  deleteTimetables(uuids: $uuids) {
    nodesDeleted
  }
}
    `;

export function useDeleteTimetablesMutation() {
  return Urql.useMutation<DeleteTimetablesMutation, DeleteTimetablesMutationVariables>(DeleteTimetablesDocument);
}
export const TimetableBlocksDocument = gql`
    query TimetableBlocks($schoolYearUuid: ID!, $onlyWithActiveVersion: Boolean, $date: Date) {
  timetableBlocks(
    schoolYearUuid: $schoolYearUuid
    onlyWithActiveVersion: $onlyWithActiveVersion
    date: $date
  ) {
    ...TimetableBlockItem
  }
}
    ${TimetableBlockItemFragmentDoc}`;

export function useTimetableBlocksQuery(options: Omit<Urql.UseQueryArgs<TimetableBlocksQueryVariables>, 'query'>) {
  return Urql.useQuery<TimetableBlocksQuery, TimetableBlocksQueryVariables>({
    query: TimetableBlocksDocument,
    ...options,
  });
}
export const TimetableBlockDocument = gql`
    query TimetableBlock($uuid: ID!) {
  timetableBlock(uuid: $uuid) {
    ...TimetableBlockItem
  }
}
    ${TimetableBlockItemFragmentDoc}`;

export function useTimetableBlockQuery(options: Omit<Urql.UseQueryArgs<TimetableBlockQueryVariables>, 'query'>) {
  return Urql.useQuery<TimetableBlockQuery, TimetableBlockQueryVariables>({
    query: TimetableBlockDocument,
    ...options,
  });
}
export const CreateTimetableBlockDocument = gql`
    mutation CreateTimetableBlock($input: TimetableBlockInput!) {
  createTimetableBlock(input: $input) {
    ...TimetableBlockItem
  }
}
    ${TimetableBlockItemFragmentDoc}`;

export function useCreateTimetableBlockMutation() {
  return Urql.useMutation<CreateTimetableBlockMutation, CreateTimetableBlockMutationVariables>(
    CreateTimetableBlockDocument,
  );
}
export const UpdateTimetableBlockDocument = gql`
    mutation UpdateTimetableBlock($uuid: ID!, $input: TimetableBlockInput!) {
  updateTimetableBlock(uuid: $uuid, input: $input) {
    ...TimetableBlockItem
  }
}
    ${TimetableBlockItemFragmentDoc}`;

export function useUpdateTimetableBlockMutation() {
  return Urql.useMutation<UpdateTimetableBlockMutation, UpdateTimetableBlockMutationVariables>(
    UpdateTimetableBlockDocument,
  );
}
export const SetTimetableBlockTeachingLoadFactorDocument = gql`
    mutation SetTimetableBlockTeachingLoadFactor($uuid: ID!, $factor: Float!, $comment: String) {
  setTimetableBlockTeachingLoadFactor(
    uuid: $uuid
    factor: $factor
    comment: $comment
  ) {
    ...TimetableBlockItem
  }
}
    ${TimetableBlockItemFragmentDoc}`;

export function useSetTimetableBlockTeachingLoadFactorMutation() {
  return Urql.useMutation<
    SetTimetableBlockTeachingLoadFactorMutation,
    SetTimetableBlockTeachingLoadFactorMutationVariables
  >(SetTimetableBlockTeachingLoadFactorDocument);
}
export const DeleteTimetableBlockDocument = gql`
    mutation DeleteTimetableBlock($uuid: ID!) {
  deleteTimetableBlock(uuid: $uuid) {
    nodesDeleted
  }
}
    `;

export function useDeleteTimetableBlockMutation() {
  return Urql.useMutation<DeleteTimetableBlockMutation, DeleteTimetableBlockMutationVariables>(
    DeleteTimetableBlockDocument,
  );
}
export const SetCardRoomsDocument = gql`
    mutation SetCardRooms($cardUuid: ID!, $roomUuids: [ID!]!) {
  setTimetableCardRooms(cardUuid: $cardUuid, roomUuids: $roomUuids) {
    nodesUpdated
  }
}
    `;

export function useSetCardRoomsMutation() {
  return Urql.useMutation<SetCardRoomsMutation, SetCardRoomsMutationVariables>(SetCardRoomsDocument);
}
export const CreateTimetableVersionDocument = gql`
    mutation CreateTimetableVersion($timetableUuid: ID!, $organizationUuid: ID!) {
  createTimetableVersion(
    timetableUuid: $timetableUuid
    organizationUuid: $organizationUuid
  ) {
    nodeUuids
    nodesCreated
  }
}
    `;

export function useCreateTimetableVersionMutation() {
  return Urql.useMutation<CreateTimetableVersionMutation, CreateTimetableVersionMutationVariables>(
    CreateTimetableVersionDocument,
  );
}
export const DuplicateTimetableVersionDocument = gql`
    mutation DuplicateTimetableVersion($timetableVersionUuid: ID!, $organizationUuid: ID!, $options: DuplicateTimetableVersionOptions!) {
  duplicateTimetableVersion(
    timetableVersionUuid: $timetableVersionUuid
    options: $options
    organizationUuid: $organizationUuid
  ) {
    active
    description
    uuid
    version
  }
}
    `;

export function useDuplicateTimetableVersionMutation() {
  return Urql.useMutation<DuplicateTimetableVersionMutation, DuplicateTimetableVersionMutationVariables>(
    DuplicateTimetableVersionDocument,
  );
}
export const DeleteTimetableVersionDocument = gql`
    mutation DeleteTimetableVersion($timetableVersionUuid: ID!, $organizationUuid: ID!) {
  deleteTimetableVersion(
    timetableVersionUuid: $timetableVersionUuid
    organizationUuid: $organizationUuid
  ) {
    nodesDeleted
  }
}
    `;

export function useDeleteTimetableVersionMutation() {
  return Urql.useMutation<DeleteTimetableVersionMutation, DeleteTimetableVersionMutationVariables>(
    DeleteTimetableVersionDocument,
  );
}
export const TimetableCardsForLessonDocument = gql`
    query TimetableCardsForLesson($versionUuid: ID!, $lessonUuid: ID!) {
  timetableCardsForLesson(versionUuid: $versionUuid, lessonUuid: $lessonUuid) {
    ...TimetableCardItem
  }
}
    ${TimetableCardItemFragmentDoc}`;

export function useTimetableCardsForLessonQuery(
  options: Omit<Urql.UseQueryArgs<TimetableCardsForLessonQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableCardsForLessonQuery, TimetableCardsForLessonQueryVariables>({
    query: TimetableCardsForLessonDocument,
    ...options,
  });
}
export const TimetableCardsCountForTimeGridEntryDocument = gql`
    query TimetableCardsCountForTimeGridEntry($timeGridEntryUuid: ID!) {
  timetableCardsCountForTimeGridEntry(timeGridEntryUuid: $timeGridEntryUuid)
}
    `;

export function useTimetableCardsCountForTimeGridEntryQuery(
  options: Omit<Urql.UseQueryArgs<TimetableCardsCountForTimeGridEntryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableCardsCountForTimeGridEntryQuery, TimetableCardsCountForTimeGridEntryQueryVariables>({
    query: TimetableCardsCountForTimeGridEntryDocument,
    ...options,
  });
}
export const CreateTimetableCardsDocument = gql`
    mutation CreateTimetableCards($versionUuid: ID!, $lessonUuid: ID!, $durations: [Int!]!, $subjectContainerUuid: ID) {
  createTimetableCards(
    versionUuid: $versionUuid
    lessonUuid: $lessonUuid
    durations: $durations
    subjectContainerUuid: $subjectContainerUuid
  ) {
    ...TimetableCardItem
  }
}
    ${TimetableCardItemFragmentDoc}`;

export function useCreateTimetableCardsMutation() {
  return Urql.useMutation<CreateTimetableCardsMutation, CreateTimetableCardsMutationVariables>(
    CreateTimetableCardsDocument,
  );
}
export const PlaceTimetableCardDocument = gql`
    mutation PlaceTimetableCard($cardUuid: ID!, $weekday: String!, $startTimeGridEntryUuid: ID!, $endTimeGridEntryUuid: ID!) {
  placeTimetableCard(
    cardUuid: $cardUuid
    weekday: $weekday
    startTimeGridEntryUuid: $startTimeGridEntryUuid
    endTimeGridEntryUuid: $endTimeGridEntryUuid
  )
}
    `;

export function usePlaceTimetableCardMutation() {
  return Urql.useMutation<PlaceTimetableCardMutation, PlaceTimetableCardMutationVariables>(PlaceTimetableCardDocument);
}
export const UnplaceTimetableCardsDocument = gql`
    mutation UnplaceTimetableCards($cardUuids: [ID!]!) {
  unplaceTimetableCards(cardUuids: $cardUuids)
}
    `;

export function useUnplaceTimetableCardsMutation() {
  return Urql.useMutation<UnplaceTimetableCardsMutation, UnplaceTimetableCardsMutationVariables>(
    UnplaceTimetableCardsDocument,
  );
}
export const SetTimetableCardsLockedDocument = gql`
    mutation SetTimetableCardsLocked($cardUuids: [ID!]!, $locked: Boolean!) {
  setTimetableCardsLocked(cardUuids: $cardUuids, locked: $locked)
}
    `;

export function useSetTimetableCardsLockedMutation() {
  return Urql.useMutation<SetTimetableCardsLockedMutation, SetTimetableCardsLockedMutationVariables>(
    SetTimetableCardsLockedDocument,
  );
}
export const DeleteTimetableCardsDocument = gql`
    mutation DeleteTimetableCards($cardUuids: [ID!]!) {
  deleteTimetableCards(cardUuids: $cardUuids) {
    nodesDeleted
  }
}
    `;

export function useDeleteTimetableCardsMutation() {
  return Urql.useMutation<DeleteTimetableCardsMutation, DeleteTimetableCardsMutationVariables>(
    DeleteTimetableCardsDocument,
  );
}
export const TimetableVersionMetaDocument = gql`
    query TimetableVersionMeta($uuid: ID!) {
  timetableVersion(uuid: $uuid) {
    ...TimetableVersionMetaItem
  }
}
    ${TimetableVersionMetaItemFragmentDoc}`;

export function useTimetableVersionMetaQuery(
  options: Omit<Urql.UseQueryArgs<TimetableVersionMetaQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableVersionMetaQuery, TimetableVersionMetaQueryVariables>({
    query: TimetableVersionMetaDocument,
    ...options,
  });
}
export const ActiveTimetableVersionsDocument = gql`
    query ActiveTimetableVersions($schoolYearUuid: ID!) {
  activeTimetableVersions(schoolYearUuid: $schoolYearUuid) {
    __typename
    uuid
    version
    timetableUuid
    timetableName
    classUuids
    teacherUuids
    roomUuids
  }
}
    `;

export function useActiveTimetableVersionsQuery(
  options: Omit<Urql.UseQueryArgs<ActiveTimetableVersionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ActiveTimetableVersionsQuery, ActiveTimetableVersionsQueryVariables>({
    query: ActiveTimetableVersionsDocument,
    ...options,
  });
}
export const TimetableVersionAvailabilitiesDocument = gql`
    query TimetableVersionAvailabilities($versionUuid: ID!, $resourceType: TimetableVersionResourceType) {
  timetableVersionAvailabilities(
    versionUuid: $versionUuid
    resourceType: $resourceType
  ) {
    ...TimetableVersionAvailabilityItem
  }
}
    ${TimetableVersionAvailabilityItemFragmentDoc}`;

export function useTimetableVersionAvailabilitiesQuery(
  options: Omit<Urql.UseQueryArgs<TimetableVersionAvailabilitiesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableVersionAvailabilitiesQuery, TimetableVersionAvailabilitiesQueryVariables>({
    query: TimetableVersionAvailabilitiesDocument,
    ...options,
  });
}
export const TimetableVersionConstraintsDocument = gql`
    query TimetableVersionConstraints($versionUuid: ID!, $resourceType: TimetableVersionResourceType!, $resourceUuids: [ID!]) {
  timetableVersionConstraints(
    versionUuid: $versionUuid
    resourceType: $resourceType
    resourceUuids: $resourceUuids
  ) {
    ...TimetableVersionConstraintsItem
  }
}
    ${TimetableVersionConstraintsItemFragmentDoc}`;

export function useTimetableVersionConstraintsQuery(
  options: Omit<Urql.UseQueryArgs<TimetableVersionConstraintsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableVersionConstraintsQuery, TimetableVersionConstraintsQueryVariables>({
    query: TimetableVersionConstraintsDocument,
    ...options,
  });
}
export const TimetableVersionConstraintSettingsDocument = gql`
    query TimetableVersionConstraintSettings($versionUuid: ID!) {
  timetableVersionConstraintSettings(versionUuid: $versionUuid)
}
    `;

export function useTimetableVersionConstraintSettingsQuery(
  options: Omit<Urql.UseQueryArgs<TimetableVersionConstraintSettingsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableVersionConstraintSettingsQuery, TimetableVersionConstraintSettingsQueryVariables>({
    query: TimetableVersionConstraintSettingsDocument,
    ...options,
  });
}
export const UpdateTimetableVersionDocument = gql`
    mutation UpdateTimetableVersion($uuid: ID!, $input: TimetableVersionInput!) {
  updateTimetableVersion(uuid: $uuid, input: $input) {
    ...TimetableVersionMetaItem
  }
}
    ${TimetableVersionMetaItemFragmentDoc}`;

export function useUpdateTimetableVersionMutation() {
  return Urql.useMutation<UpdateTimetableVersionMutation, UpdateTimetableVersionMutationVariables>(
    UpdateTimetableVersionDocument,
  );
}
export const SetTimetableVersionEditableDocument = gql`
    mutation SetTimetableVersionEditable($uuid: ID!, $editable: Boolean!) {
  setTimetableVersionEditable(uuid: $uuid, editable: $editable) {
    ...TimetableVersionMetaItem
  }
}
    ${TimetableVersionMetaItemFragmentDoc}`;

export function useSetTimetableVersionEditableMutation() {
  return Urql.useMutation<SetTimetableVersionEditableMutation, SetTimetableVersionEditableMutationVariables>(
    SetTimetableVersionEditableDocument,
  );
}
export const AddTimetableVersionResourcesDocument = gql`
    mutation AddTimetableVersionResources($versionUuid: ID!, $resourceType: TimetableVersionResourceType!, $uuids: [ID!]!) {
  addTimetableVersionResources(
    versionUuid: $versionUuid
    resourceType: $resourceType
    uuids: $uuids
  ) {
    ...TimetableVersionAvailabilityItem
  }
}
    ${TimetableVersionAvailabilityItemFragmentDoc}`;

export function useAddTimetableVersionResourcesMutation() {
  return Urql.useMutation<AddTimetableVersionResourcesMutation, AddTimetableVersionResourcesMutationVariables>(
    AddTimetableVersionResourcesDocument,
  );
}
export const RemoveTimetableVersionResourcesDocument = gql`
    mutation RemoveTimetableVersionResources($versionUuid: ID!, $resourceType: TimetableVersionResourceType!, $uuids: [ID!]!) {
  removeTimetableVersionResources(
    versionUuid: $versionUuid
    resourceType: $resourceType
    uuids: $uuids
  ) {
    ...TimetableVersionAvailabilityItem
  }
}
    ${TimetableVersionAvailabilityItemFragmentDoc}`;

export function useRemoveTimetableVersionResourcesMutation() {
  return Urql.useMutation<RemoveTimetableVersionResourcesMutation, RemoveTimetableVersionResourcesMutationVariables>(
    RemoveTimetableVersionResourcesDocument,
  );
}
export const SetTimetableVersionAvailabilityDocument = gql`
    mutation SetTimetableVersionAvailability($versionUuid: ID!, $resourceType: TimetableVersionResourceType!, $resourceUuid: ID!, $availability: TimetableVersionAvailabilityInput!) {
  setTimetableVersionAvailability(
    versionUuid: $versionUuid
    resourceType: $resourceType
    resourceUuid: $resourceUuid
    availability: $availability
  ) {
    ...TimetableVersionAvailabilityItem
  }
}
    ${TimetableVersionAvailabilityItemFragmentDoc}`;

export function useSetTimetableVersionAvailabilityMutation() {
  return Urql.useMutation<SetTimetableVersionAvailabilityMutation, SetTimetableVersionAvailabilityMutationVariables>(
    SetTimetableVersionAvailabilityDocument,
  );
}
export const SetTimetableVersionConstraintsDocument = gql`
    mutation SetTimetableVersionConstraints($versionUuid: ID!, $resourceType: TimetableVersionResourceType!, $resourceUuid: ID!, $constraints: String) {
  setTimetableVersionConstraints(
    versionUuid: $versionUuid
    resourceType: $resourceType
    resourceUuid: $resourceUuid
    constraints: $constraints
  ) {
    ...TimetableVersionConstraintsItem
  }
}
    ${TimetableVersionConstraintsItemFragmentDoc}`;

export function useSetTimetableVersionConstraintsMutation() {
  return Urql.useMutation<SetTimetableVersionConstraintsMutation, SetTimetableVersionConstraintsMutationVariables>(
    SetTimetableVersionConstraintsDocument,
  );
}
export const SetTimetableVersionConstraintSettingsDocument = gql`
    mutation SetTimetableVersionConstraintSettings($versionUuid: ID!, $data: String) {
  setTimetableVersionConstraintSettings(versionUuid: $versionUuid, data: $data)
}
    `;

export function useSetTimetableVersionConstraintSettingsMutation() {
  return Urql.useMutation<
    SetTimetableVersionConstraintSettingsMutation,
    SetTimetableVersionConstraintSettingsMutationVariables
  >(SetTimetableVersionConstraintSettingsDocument);
}
export const AddUserDocument = gql`
    mutation addUser($frontendUri: String!, $planungPersonUuid: ID!, $organizationUuid: ID!, $email: String!, $profileUuid: ID, $permissions: [String!]) {
  addUser(
    frontendUri: $frontendUri
    planungPersonUuid: $planungPersonUuid
    organizationUuid: $organizationUuid
    email: $email
    profileUuid: $profileUuid
    permissions: $permissions
  ) {
    uuid
    lastName
    firstName
    userStatus
    userEmail
    profileEmail
    role
    permissions
    accessGranted
    selectName
  }
}
    `;

export function useAddUserMutation() {
  return Urql.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument);
}
export const UpdateGrantedProfilesDocument = gql`
    mutation updateGrantedProfiles($organizationUuid: ID!, $profiles: [ID!]!, $roles: [String!]!, $frontendUri: String!) {
  updateGrantedProfiles(
    organizationUuid: $organizationUuid
    profiles: $profiles
    roles: $roles
    frontendUri: $frontendUri
  ) {
    entitiesUpdated
  }
}
    `;

export function useUpdateGrantedProfilesMutation() {
  return Urql.useMutation<UpdateGrantedProfilesMutation, UpdateGrantedProfilesMutationVariables>(
    UpdateGrantedProfilesDocument,
  );
}
export const UpdateUserPermissionsDocument = gql`
    mutation updateUserPermissions($organizationUuid: ID!, $profileUuid: ID!, $permissions: [String!]!) {
  updateUserPermissions(
    organizationUuid: $organizationUuid
    profileUuid: $profileUuid
    permissions: $permissions
  ) {
    uuid
    lastName
    firstName
    userStatus
    userEmail
    profileEmail
    role
    permissions
    accessGranted
    selectName
  }
}
    `;

export function useUpdateUserPermissionsMutation() {
  return Urql.useMutation<UpdateUserPermissionsMutation, UpdateUserPermissionsMutationVariables>(
    UpdateUserPermissionsDocument,
  );
}
export const InviteUserDocument = gql`
    mutation inviteUser($frontendUri: String!, $organizationUuid: ID!, $email: String!, $profileUuid: ID!) {
  inviteUser(
    frontendUri: $frontendUri
    organizationUuid: $organizationUuid
    email: $email
    profileUuid: $profileUuid
  ) {
    uuid
    lastName
    firstName
    userStatus
    userEmail
    profileEmail
    role
    permissions
    accessGranted
    selectName
  }
}
    `;

export function useInviteUserMutation() {
  return Urql.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument);
}
export const RemovePlanungAccessDocument = gql`
    mutation removePlanungAccess($organizationUuid: ID!, $profileUuid: ID!) {
  removePlanungAccess(
    organizationUuid: $organizationUuid
    profileUuid: $profileUuid
  ) {
    uuid
    lastName
    firstName
    userStatus
    userEmail
    profileEmail
    role
    permissions
    accessGranted
    selectName
  }
}
    `;

export function useRemovePlanungAccessMutation() {
  return Urql.useMutation<RemovePlanungAccessMutation, RemovePlanungAccessMutationVariables>(
    RemovePlanungAccessDocument,
  );
}
export const PimProfilesDocument = gql`
    query pimProfiles($organizationUuid: ID!) {
  pimProfiles(organizationUuid: $organizationUuid) {
    uuid
    lastName
    firstName
    userStatus
    userEmail
    profileEmail
    role
    permissions
    accessGranted
    selectName
  }
}
    `;

export function usePimProfilesQuery(options: Omit<Urql.UseQueryArgs<PimProfilesQueryVariables>, 'query'>) {
  return Urql.useQuery<PimProfilesQuery, PimProfilesQueryVariables>({ query: PimProfilesDocument, ...options });
}
export const _SubstitutionFilterTimetableVersionsDocument = gql`
    query _SubstitutionFilterTimetableVersions($date: Date!) {
  activeTimetableVersionsForDate(date: $date) {
    uuid
    timetableUuid
    timetableName
    classUuids
  }
}
    `;

export function use_SubstitutionFilterTimetableVersionsQuery(
  options: Omit<Urql.UseQueryArgs<_SubstitutionFilterTimetableVersionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_SubstitutionFilterTimetableVersionsQuery, _SubstitutionFilterTimetableVersionsQueryVariables>({
    query: _SubstitutionFilterTimetableVersionsDocument,
    ...options,
  });
}
export const _GradeGroupsDocument = gql`
    query _GradeGroups {
  gradeGroups {
    ..._GradeGroupFragment
  }
}
    ${_GradeGroupFragmentFragmentDoc}`;

export function use_GradeGroupsQuery(options?: Omit<Urql.UseQueryArgs<_GradeGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<_GradeGroupsQuery, _GradeGroupsQueryVariables>({ query: _GradeGroupsDocument, ...options });
}
export const _ClassesDocument = gql`
    query _Classes($schoolYearUuid: ID) {
  classes(schoolYearUuid: $schoolYearUuid) {
    ..._ClassFragment
  }
}
    ${_ClassFragmentFragmentDoc}`;

export function use_ClassesQuery(options?: Omit<Urql.UseQueryArgs<_ClassesQueryVariables>, 'query'>) {
  return Urql.useQuery<_ClassesQuery, _ClassesQueryVariables>({ query: _ClassesDocument, ...options });
}
export const _SubjectsDocument = gql`
    query _Subjects($activeOnly: Boolean) {
  subjects(activeOnly: $activeOnly) {
    ..._SubjectFragment
  }
}
    ${_SubjectFragmentFragmentDoc}`;

export function use_SubjectsQuery(options?: Omit<Urql.UseQueryArgs<_SubjectsQueryVariables>, 'query'>) {
  return Urql.useQuery<_SubjectsQuery, _SubjectsQueryVariables>({ query: _SubjectsDocument, ...options });
}
export const _SubjectContainersDocument = gql`
    query _SubjectContainers {
  subjectContainers {
    ..._SubjectContainerFragment
  }
}
    ${_SubjectContainerFragmentFragmentDoc}`;

export function use_SubjectContainersQuery(
  options?: Omit<Urql.UseQueryArgs<_SubjectContainersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_SubjectContainersQuery, _SubjectContainersQueryVariables>({
    query: _SubjectContainersDocument,
    ...options,
  });
}
export const _PersonDocument = gql`
    query _Person($uuid: ID!) {
  person(uuid: $uuid) {
    ..._PersonFragment
  }
}
    ${_PersonFragmentFragmentDoc}`;

export function use_PersonQuery(options: Omit<Urql.UseQueryArgs<_PersonQueryVariables>, 'query'>) {
  return Urql.useQuery<_PersonQuery, _PersonQueryVariables>({ query: _PersonDocument, ...options });
}
export const _PeopleDocument = gql`
    query _People($activeOnly: Boolean, $role: PersonRole) {
  people(activeOnly: $activeOnly, role: $role) {
    ..._PersonFragment
  }
}
    ${_PersonFragmentFragmentDoc}`;

export function use_PeopleQuery(options?: Omit<Urql.UseQueryArgs<_PeopleQueryVariables>, 'query'>) {
  return Urql.useQuery<_PeopleQuery, _PeopleQueryVariables>({ query: _PeopleDocument, ...options });
}
export const LessonUuidsWithCardsDocument = gql`
    query LessonUuidsWithCards($uuids: [ID!]!) {
  lessonUuidsWithCards(uuids: $uuids)
}
    `;

export function useLessonUuidsWithCardsQuery(
  options: Omit<Urql.UseQueryArgs<LessonUuidsWithCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LessonUuidsWithCardsQuery, LessonUuidsWithCardsQueryVariables>({
    query: LessonUuidsWithCardsDocument,
    ...options,
  });
}
export const _RoomsDocument = gql`
    query _Rooms {
  rooms {
    ..._RoomFragment
  }
}
    ${_RoomFragmentFragmentDoc}`;

export function use_RoomsQuery(options?: Omit<Urql.UseQueryArgs<_RoomsQueryVariables>, 'query'>) {
  return Urql.useQuery<_RoomsQuery, _RoomsQueryVariables>({ query: _RoomsDocument, ...options });
}
export const _DivisionsDocument = gql`
    query _Divisions($schoolYearUuid: ID) {
  divisions(schoolYearUuid: $schoolYearUuid) {
    ..._DivisionFragment
  }
}
    ${_DivisionFragmentFragmentDoc}`;

export function use_DivisionsQuery(options?: Omit<Urql.UseQueryArgs<_DivisionsQueryVariables>, 'query'>) {
  return Urql.useQuery<_DivisionsQuery, _DivisionsQueryVariables>({ query: _DivisionsDocument, ...options });
}
export const _GroupsDocument = gql`
    query _Groups($schoolYearUuid: ID) {
  groups(schoolYearUuid: $schoolYearUuid) {
    ..._GroupFragment
  }
}
    ${_GroupFragmentFragmentDoc}`;

export function use_GroupsQuery(options?: Omit<Urql.UseQueryArgs<_GroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<_GroupsQuery, _GroupsQueryVariables>({ query: _GroupsDocument, ...options });
}
export const _ContractsDocument = gql`
    query _Contracts($personUuids: [ID!]) {
  contracts(personUuids: $personUuids) {
    ..._ContractFragment
  }
}
    ${_ContractFragmentFragmentDoc}`;

export function use_ContractsQuery(options?: Omit<Urql.UseQueryArgs<_ContractsQueryVariables>, 'query'>) {
  return Urql.useQuery<_ContractsQuery, _ContractsQueryVariables>({ query: _ContractsDocument, ...options });
}
export const _SchoolYearsDocument = gql`
    query _SchoolYears {
  schoolYears {
    ..._SchoolYearFragment
  }
}
    ${_SchoolYearFragmentFragmentDoc}`;

export function use_SchoolYearsQuery(options?: Omit<Urql.UseQueryArgs<_SchoolYearsQueryVariables>, 'query'>) {
  return Urql.useQuery<_SchoolYearsQuery, _SchoolYearsQueryVariables>({ query: _SchoolYearsDocument, ...options });
}
export const _TimetablePrintConfigDocument = gql`
    query _TimetablePrintConfig($type: TimetableReportType!) {
  timetablePrintConfig(type: $type) {
    ..._TimetablePrintConfig
  }
}
    ${_TimetablePrintConfigFragmentDoc}`;

export function use_TimetablePrintConfigQuery(
  options: Omit<Urql.UseQueryArgs<_TimetablePrintConfigQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_TimetablePrintConfigQuery, _TimetablePrintConfigQueryVariables>({
    query: _TimetablePrintConfigDocument,
    ...options,
  });
}
export const _TeachingLoadReportConfigDocument = gql`
    query _TeachingLoadReportConfig($type: TeachingLoadReportType!) {
  teachingLoadReportConfig(type: $type) {
    ..._TeachingLoadReportConfig
  }
}
    ${_TeachingLoadReportConfigFragmentDoc}`;

export function use_TeachingLoadReportConfigQuery(
  options: Omit<Urql.UseQueryArgs<_TeachingLoadReportConfigQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_TeachingLoadReportConfigQuery, _TeachingLoadReportConfigQueryVariables>({
    query: _TeachingLoadReportConfigDocument,
    ...options,
  });
}
export const _EventsInRangeDocument = gql`
    query _EventsInRange($start: DateTime!, $end: DateTime!, $includeSchoolEvents: Boolean) {
  eventsInRange(
    start: $start
    end: $end
    includeSchoolEvents: $includeSchoolEvents
  ) {
    ..._Event
  }
}
    ${_EventFragmentDoc}`;

export function use_EventsInRangeQuery(options: Omit<Urql.UseQueryArgs<_EventsInRangeQueryVariables>, 'query'>) {
  return Urql.useQuery<_EventsInRangeQuery, _EventsInRangeQueryVariables>({
    query: _EventsInRangeDocument,
    ...options,
  });
}
export const _EventByUuidDocument = gql`
    query _EventByUuid($uuid: ID!) {
  event(uuid: $uuid) {
    ..._Event
  }
}
    ${_EventFragmentDoc}`;

export function use_EventByUuidQuery(options: Omit<Urql.UseQueryArgs<_EventByUuidQueryVariables>, 'query'>) {
  return Urql.useQuery<_EventByUuidQuery, _EventByUuidQueryVariables>({ query: _EventByUuidDocument, ...options });
}
export const _AdminEventsDocument = gql`
    query _AdminEvents($start: DateTime!, $end: DateTime!, $limit: Int!, $offset: Int!) {
  adminEvents(start: $start, end: $end, limit: $limit, offset: $offset) {
    ..._Event
  }
}
    ${_EventFragmentDoc}`;

export function use_AdminEventsQuery(options: Omit<Urql.UseQueryArgs<_AdminEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<_AdminEventsQuery, _AdminEventsQueryVariables>({ query: _AdminEventsDocument, ...options });
}
export const _AdminEventsCountDocument = gql`
    query _AdminEventsCount($start: DateTime!, $end: DateTime!) {
  adminEventsCount(start: $start, end: $end)
}
    `;

export function use_AdminEventsCountQuery(options: Omit<Urql.UseQueryArgs<_AdminEventsCountQueryVariables>, 'query'>) {
  return Urql.useQuery<_AdminEventsCountQuery, _AdminEventsCountQueryVariables>({
    query: _AdminEventsCountDocument,
    ...options,
  });
}
export const _SchoolEventsDocument = gql`
    query _SchoolEvents($organizationUuid: ID!, $from: Date!, $to: Date!) {
  schoolEvents(organizationUuid: $organizationUuid, from: $from, to: $to) {
    ..._SchoolEvent
  }
}
    ${_SchoolEventFragmentDoc}`;

export function use_SchoolEventsQuery(options: Omit<Urql.UseQueryArgs<_SchoolEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<_SchoolEventsQuery, _SchoolEventsQueryVariables>({ query: _SchoolEventsDocument, ...options });
}
export const _RecurringEventDocument = gql`
    query _RecurringEvent($uuid: ID!) {
  recurringEvent(uuid: $uuid) {
    __typename
    uuid
    rrule
    excludeHolidays
    futureEventsCount
  }
}
    `;

export function use_RecurringEventQuery(options: Omit<Urql.UseQueryArgs<_RecurringEventQueryVariables>, 'query'>) {
  return Urql.useQuery<_RecurringEventQuery, _RecurringEventQueryVariables>({
    query: _RecurringEventDocument,
    ...options,
  });
}
export const _PreviewTeachingLoadDocument = gql`
    query _PreviewTeachingLoad($organizationUuid: String!, $schoolYearUuid: String!, $subjectUuid: String!, $teacherUuids: [String!]!, $lessonClasses: [PreviewLessonClassInput!]!, $lessonUnits: [PreviewLessonUnitInput!]!) {
  previewTeachingLoad(
    organizationUuid: $organizationUuid
    schoolYearUuid: $schoolYearUuid
    subjectUuid: $subjectUuid
    teacherUuids: $teacherUuids
    lessonClasses: $lessonClasses
    lessonUnits: $lessonUnits
  ) {
    __typename
    deputat
    factor
    teacherUuid
  }
}
    `;

export function use_PreviewTeachingLoadQuery(
  options: Omit<Urql.UseQueryArgs<_PreviewTeachingLoadQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_PreviewTeachingLoadQuery, _PreviewTeachingLoadQueryVariables>({
    query: _PreviewTeachingLoadDocument,
    ...options,
  });
}
export const _CreateSingleSchoolEventDocument = gql`
    mutation _CreateSingleSchoolEvent($input: SchoolEventCreateInput!) {
  createSchoolEvent(input: $input) {
    __typename
    nodesCreated
    nodeUuids
  }
}
    `;

export function use_CreateSingleSchoolEventMutation() {
  return Urql.useMutation<_CreateSingleSchoolEventMutation, _CreateSingleSchoolEventMutationVariables>(
    _CreateSingleSchoolEventDocument,
  );
}
export const _CreateRecurringSchoolEventDocument = gql`
    mutation _CreateRecurringSchoolEvent($input: RecurrenceSchoolEventCreateInput!) {
  createRecurrenceSchoolEvents(input: $input) {
    nodeUuids
  }
}
    `;

export function use_CreateRecurringSchoolEventMutation() {
  return Urql.useMutation<_CreateRecurringSchoolEventMutation, _CreateRecurringSchoolEventMutationVariables>(
    _CreateRecurringSchoolEventDocument,
  );
}
export const _DeleteSchoolEventsDocument = gql`
    mutation _DeleteSchoolEvents($uuids: OnlyUuids!) {
  deleteSchoolEvents(where: $uuids) {
    __typename
    nodesDeleted
  }
}
    `;

export function use_DeleteSchoolEventsMutation() {
  return Urql.useMutation<_DeleteSchoolEventsMutation, _DeleteSchoolEventsMutationVariables>(
    _DeleteSchoolEventsDocument,
  );
}
export const _UpdateSchoolEventDocument = gql`
    mutation _UpdateSchoolEvent($eventUuid: ID!, $update: SchoolEventUpdateInput!) {
  updateSchoolEvent(eventUuid: $eventUuid, update: $update) {
    __typename
    nodeUuids
  }
}
    `;

export function use_UpdateSchoolEventMutation() {
  return Urql.useMutation<_UpdateSchoolEventMutation, _UpdateSchoolEventMutationVariables>(_UpdateSchoolEventDocument);
}
export const _UpdateRecurrenceSchoolEventsDocument = gql`
    mutation _UpdateRecurrenceSchoolEvents($recurrenceUuid: ID!, $rrule: String!, $excludeHolidays: Boolean, $update: SchoolEventUpdateInput!) {
  updateRecurrenceSchoolEvents(
    recurrenceUuid: $recurrenceUuid
    rrule: $rrule
    excludeHolidays: $excludeHolidays
    update: $update
  ) {
    __typename
    nodeUuids
  }
}
    `;

export function use_UpdateRecurrenceSchoolEventsMutation() {
  return Urql.useMutation<_UpdateRecurrenceSchoolEventsMutation, _UpdateRecurrenceSchoolEventsMutationVariables>(
    _UpdateRecurrenceSchoolEventsDocument,
  );
}
export const _DeleteRecurrenceSchoolEventsDocument = gql`
    mutation _DeleteRecurrenceSchoolEvents($recurrenceUuid: ID!) {
  deleteRecurrenceSchoolEvents(recurrenceUuid: $recurrenceUuid) {
    nodesDeleted
    __typename
  }
}
    `;

export function use_DeleteRecurrenceSchoolEventsMutation() {
  return Urql.useMutation<_DeleteRecurrenceSchoolEventsMutation, _DeleteRecurrenceSchoolEventsMutationVariables>(
    _DeleteRecurrenceSchoolEventsDocument,
  );
}
export const _SetPrintEventDocument = gql`
    mutation _SetPrintEvent($eventUuid: ID!, $print: Boolean!) {
  setPrintEvent(eventUuid: $eventUuid, print: $print) {
    __typename
    entitiesUpdated
  }
}
    `;

export function use_SetPrintEventMutation() {
  return Urql.useMutation<_SetPrintEventMutation, _SetPrintEventMutationVariables>(_SetPrintEventDocument);
}
export const _SetSubstitutionDocument = gql`
    mutation _SetSubstitution($eventUuid: ID!, $coveringTeachers: [SetCoveringTeachersInput!]!, $substitutionComment: String, $rooms: [ID!]!) {
  setSubstitution(
    eventUuid: $eventUuid
    coveringTeachers: $coveringTeachers
    substitutionComment: $substitutionComment
    rooms: $rooms
  ) {
    __typename
  }
}
    `;

export function use_SetSubstitutionMutation() {
  return Urql.useMutation<_SetSubstitutionMutation, _SetSubstitutionMutationVariables>(_SetSubstitutionDocument);
}
export const _CancelEventDocument = gql`
    mutation _CancelEvent($eventUuid: ID!, $substitutionComment: String) {
  cancelEvent(eventUuid: $eventUuid, substitutionComment: $substitutionComment) {
    __typename
  }
}
    `;

export function use_CancelEventMutation() {
  return Urql.useMutation<_CancelEventMutation, _CancelEventMutationVariables>(_CancelEventDocument);
}
export const _SetSelfWorkEventDocument = gql`
    mutation _SetSelfWorkEvent($eventUuid: ID!, $substitutionComment: String, $rooms: [ID!]!) {
  setSelfWorkForEvent(
    eventUuid: $eventUuid
    substitutionComment: $substitutionComment
    rooms: $rooms
  ) {
    __typename
  }
}
    `;

export function use_SetSelfWorkEventMutation() {
  return Urql.useMutation<_SetSelfWorkEventMutation, _SetSelfWorkEventMutationVariables>(_SetSelfWorkEventDocument);
}
export const _ResetEventDocument = gql`
    mutation _ResetEvent($eventUuid: ID!) {
  resetEvent(eventUuid: $eventUuid) {
    __typename
  }
}
    `;

export function use_ResetEventMutation() {
  return Urql.useMutation<_ResetEventMutation, _ResetEventMutationVariables>(_ResetEventDocument);
}
export const _MergeEventsDocument = gql`
    mutation _MergeEvents($eventsToMerge: [ID!]!, $targetEvent: ID!, $rooms: [ID!]!, $substitutionComment: String) {
  mergeEvents(
    eventsToMerge: $eventsToMerge
    targetEvent: $targetEvent
    rooms: $rooms
    substitutionComment: $substitutionComment
  ) {
    __typename
  }
}
    `;

export function use_MergeEventsMutation() {
  return Urql.useMutation<_MergeEventsMutation, _MergeEventsMutationVariables>(_MergeEventsDocument);
}
export const _SaveTimetablePrintConfigDocument = gql`
    mutation _SaveTimetablePrintConfig($type: TimetableReportType!, $input: TimetablePrintConfigInput!) {
  saveTimetablePrintConfig(type: $type, input: $input) {
    ..._TimetablePrintConfig
  }
}
    ${_TimetablePrintConfigFragmentDoc}`;

export function use_SaveTimetablePrintConfigMutation() {
  return Urql.useMutation<_SaveTimetablePrintConfigMutation, _SaveTimetablePrintConfigMutationVariables>(
    _SaveTimetablePrintConfigDocument,
  );
}
export const _SaveTeachingLoadReportConfigDocument = gql`
    mutation _SaveTeachingLoadReportConfig($type: TeachingLoadReportType!, $input: TeachingLoadReportConfigInput!) {
  saveTeachingLoadReportConfig(type: $type, input: $input) {
    ..._TeachingLoadReportConfig
  }
}
    ${_TeachingLoadReportConfigFragmentDoc}`;

export function use_SaveTeachingLoadReportConfigMutation() {
  return Urql.useMutation<_SaveTeachingLoadReportConfigMutation, _SaveTeachingLoadReportConfigMutationVariables>(
    _SaveTeachingLoadReportConfigDocument,
  );
}
export const ClassUsageDocument = gql`
    query ClassUsage($uuids: [ID!]!) {
  classUsage(uuids: $uuids) {
    ...LessonUsage
  }
}
    ${LessonUsageFragmentDoc}`;

export function useClassUsageQuery(options: Omit<Urql.UseQueryArgs<ClassUsageQueryVariables>, 'query'>) {
  return Urql.useQuery<ClassUsageQuery, ClassUsageQueryVariables>({ query: ClassUsageDocument, ...options });
}
export const PersonUsageDocument = gql`
    query PersonUsage($uuids: [ID!]!) {
  personUsage(uuids: $uuids) {
    ...LessonUsage
  }
}
    ${LessonUsageFragmentDoc}`;

export function usePersonUsageQuery(options: Omit<Urql.UseQueryArgs<PersonUsageQueryVariables>, 'query'>) {
  return Urql.useQuery<PersonUsageQuery, PersonUsageQueryVariables>({ query: PersonUsageDocument, ...options });
}
export const DivisionUsageDocument = gql`
    query DivisionUsage($uuids: [ID!]!) {
  divisionUsage(uuids: $uuids) {
    ...LessonUsage
  }
}
    ${LessonUsageFragmentDoc}`;

export function useDivisionUsageQuery(options: Omit<Urql.UseQueryArgs<DivisionUsageQueryVariables>, 'query'>) {
  return Urql.useQuery<DivisionUsageQuery, DivisionUsageQueryVariables>({ query: DivisionUsageDocument, ...options });
}
export const EventSyncStatusDocument = gql`
    query EventSyncStatus {
  eventSyncStatus {
    openDays
    firstOpenDay
    lastOpenDay
    versionsInCorrection {
      kind
      versionUuid
      version
      description
      planUuid
      planName
      from
      to
      heldDays
    }
  }
}
    `;

export function useEventSyncStatusQuery(options?: Omit<Urql.UseQueryArgs<EventSyncStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<EventSyncStatusQuery, EventSyncStatusQueryVariables>({
    query: EventSyncStatusDocument,
    ...options,
  });
}
export const EventJobsDocument = gql`
    query EventJobs($runningOnly: Boolean) {
  eventJobs(runningOnly: $runningOnly) {
    uuid
    timetableVersionUuid
    to
    from
    processed
    eventsTo
    eventsFrom
    createdEvents
    updatedEvents
    deletedEvents
    status
    createdAt
  }
}
    `;

export function useEventJobsQuery(options?: Omit<Urql.UseQueryArgs<EventJobsQueryVariables>, 'query'>) {
  return Urql.useQuery<EventJobsQuery, EventJobsQueryVariables>({ query: EventJobsDocument, ...options });
}
export const TimetableVersionDataDocument = gql`
    query TimetableVersionData($versionUuid: ID!) {
  timetableVersionData(versionUuid: $versionUuid) {
    meta {
      versionUuid
      version
      description
      active
      editable
      isSnapshot
      generating
      timetableUuid
      timetableName
      timetableDraft
      schoolYearUuid
      timegridUuid
    }
    view {
      timeGridEntries {
        uuid
        name
        shortName
        start
        end
        pause
        order
      }
      teachers {
        uuid
        firstName
        lastName
        shortName
        displayNameShort
        color
        active
        defaultRoomUuid
      }
      classes {
        uuid
        name
        shortName
        sortName
        grade
        gradeGroupUuid
        color
        colorLabel
        divisionUuids
        inVersion
        defaultRoomUuid
      }
      rooms {
        uuid
        name
        roomNumber
        classroom
      }
      subjects {
        uuid
        name
        shortName
        color
        active
        epochEnabled
        subjectHourEnabled
        defaultRoomUuids
      }
      subjectContainers {
        uuid
        name
        shortName
        color
        grades
        gradeGroupUuid
      }
      groups {
        uuid
        name
        shortName
        classFraction
        entireClass
        divisionUuid
      }
      cards {
        uuid
        duration
        weekday
        locked
        startTimeGridEntryUuid
        endTimeGridEntryUuid
        lessonUuid
        lessonIsElective
        someLessonClassIsFunctionalClass
        subjectUuid
        isSubjectContainer
        roomUuids
        lessonRoomSupplyUuids
        teacherUuids
        classUuids
        groupUuids
        lessonClasses {
          uuid
          classUuid
          groupUuids
          usedDivisionUuid
        }
        classGridCards {
          uuid
          timetableCardUuid
          classUuid
          lessonUuid
          divisionsCount
          colors
          locked
          duration
          endTimeGridEntryUuid
          startTimeGridEntryUuid
          weekday
          cssHeight
          cssGradientString
          usedPosition
          cssTop
          textColor
        }
        subjectContainerSlots {
          teacherUuids
          roomUuids
          startDate
          endDate
        }
      }
      availabilities {
        resourceType
        resourceUuid
        mon
        tue
        wed
        thu
        fri
        sat
        sun
      }
    }
    editor {
      divisions {
        uuid
        name
        classUuid
        groupUuids
      }
      lessons {
        uuid
        subTitle
        comment
        elective
        studentCount
        timetableEnabled
        onlyInTimetableVersion
        subjectUuid
        isSubjectContainerLesson
        teacherUuids
        lessonClasses {
          uuid
          classUuid
          groupUuids
          usedDivisionUuid
        }
        lessonUnits {
          uuid
          duration
          count
          subjectContainerUuid
        }
        roomSupplyUuids
      }
    }
  }
}
    `;

export function useTimetableVersionDataQuery(
  options: Omit<Urql.UseQueryArgs<TimetableVersionDataQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableVersionDataQuery, TimetableVersionDataQueryVariables>({
    query: TimetableVersionDataDocument,
    ...options,
  });
}
export const TimetableVersionLessonDataDocument = gql`
    query TimetableVersionLessonData($versionUuid: ID!) {
  timetableVersionLessonData(versionUuid: $versionUuid) {
    lessons {
      uuid
      classSort
      subjectName
      teachersSort
      subjectUuid
      isSubjectContainerLesson
      subTitle
      comment
      elective
      isClassTrip
      teachingLoadEnabled
      timetableEnabled
      onlyInTimetableVersion
      placedCardsCount
      cardsCount
      studentCount
      groupClassNames
      teacherUuids
      classUuids
      groupUuids
      roomUuids
      lessonUnits {
        uuid
        duration
        count
        subjectContainerUuid
      }
      inActiveTimetable
    }
  }
}
    `;

export function useTimetableVersionLessonDataQuery(
  options: Omit<Urql.UseQueryArgs<TimetableVersionLessonDataQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableVersionLessonDataQuery, TimetableVersionLessonDataQueryVariables>({
    query: TimetableVersionLessonDataDocument,
    ...options,
  });
}
export const DeleteAdditionalTeachingLoadsDocument = gql`
    mutation DeleteAdditionalTeachingLoads($uuids: [ID!]!) {
  deleteAdditionalTeachingLoads(uuids: $uuids) {
    nodesDeleted
  }
}
    `;

export function useDeleteAdditionalTeachingLoadsMutation() {
  return Urql.useMutation<DeleteAdditionalTeachingLoadsMutation, DeleteAdditionalTeachingLoadsMutationVariables>(
    DeleteAdditionalTeachingLoadsDocument,
  );
}
export const CreateAdditionalTeachingLoadDocument = gql`
    mutation CreateAdditionalTeachingLoad($input: AdditionalTeachingLoadInput!) {
  createAdditionalTeachingLoad(input: $input) {
    ...AdditionalTeachingLoadItem
  }
}
    ${AdditionalTeachingLoadItemFragmentDoc}`;

export function useCreateAdditionalTeachingLoadMutation() {
  return Urql.useMutation<CreateAdditionalTeachingLoadMutation, CreateAdditionalTeachingLoadMutationVariables>(
    CreateAdditionalTeachingLoadDocument,
  );
}
export const UpdateAdditionalTeachingLoadDocument = gql`
    mutation UpdateAdditionalTeachingLoad($uuid: ID!, $input: AdditionalTeachingLoadInput!) {
  updateAdditionalTeachingLoad(uuid: $uuid, input: $input) {
    ...AdditionalTeachingLoadItem
  }
}
    ${AdditionalTeachingLoadItemFragmentDoc}`;

export function useUpdateAdditionalTeachingLoadMutation() {
  return Urql.useMutation<UpdateAdditionalTeachingLoadMutation, UpdateAdditionalTeachingLoadMutationVariables>(
    UpdateAdditionalTeachingLoadDocument,
  );
}
export const AdditionalTeachingLoadsListDocument = gql`
    query AdditionalTeachingLoadsList($schoolyear: ID!, $teacherUuid: ID) {
  additionalTeachingLoads(schoolYearUuid: $schoolyear, teacherUuid: $teacherUuid) {
    ...AdditionalTeachingLoadItem
  }
}
    ${AdditionalTeachingLoadItemFragmentDoc}`;

export function useAdditionalTeachingLoadsListQuery(
  options: Omit<Urql.UseQueryArgs<AdditionalTeachingLoadsListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<AdditionalTeachingLoadsListQuery, AdditionalTeachingLoadsListQueryVariables>({
    query: AdditionalTeachingLoadsListDocument,
    ...options,
  });
}
export const ConnectEntityWithVersionDocument = gql`
    mutation ConnectEntityWithVersion($organizationUuid: ID!, $versionUuid: ID!, $entityType: String!) {
  connectEntityWithVersion(
    organizationUuid: $organizationUuid
    versionUuid: $versionUuid
    entityType: $entityType
  ) {
    entitiesUpdated
  }
}
    `;

export function useConnectEntityWithVersionMutation() {
  return Urql.useMutation<ConnectEntityWithVersionMutation, ConnectEntityWithVersionMutationVariables>(
    ConnectEntityWithVersionDocument,
  );
}
export const SetMySchoolYearDocument = gql`
    mutation SetMySchoolYear($schoolYearUuid: ID) {
  setMySchoolYear(schoolYearUuid: $schoolYearUuid) {
    ...MyUserConfigFragment
  }
}
    ${MyUserConfigFragmentFragmentDoc}`;

export function useSetMySchoolYearMutation() {
  return Urql.useMutation<SetMySchoolYearMutation, SetMySchoolYearMutationVariables>(SetMySchoolYearDocument);
}
export const UpsertMyTableConfigDocument = gql`
    mutation UpsertMyTableConfig($table: String!, $hiddenColumns: [String!]!, $columnsSort: String!) {
  upsertMyTableConfig(
    table: $table
    hiddenColumns: $hiddenColumns
    columnsSort: $columnsSort
  ) {
    table
    hiddenColumns
    columnsSort
  }
}
    `;

export function useUpsertMyTableConfigMutation() {
  return Urql.useMutation<UpsertMyTableConfigMutation, UpsertMyTableConfigMutationVariables>(
    UpsertMyTableConfigDocument,
  );
}
export const UpsertMyUiSettingsDocument = gql`
    mutation UpsertMyUiSettings($scope: String!, $version: Int!, $data: String!) {
  upsertMyUiSettings(scope: $scope, version: $version, data: $data) {
    scope
    version
    data
    updatedAt
  }
}
    `;

export function useUpsertMyUiSettingsMutation() {
  return Urql.useMutation<UpsertMyUiSettingsMutation, UpsertMyUiSettingsMutationVariables>(UpsertMyUiSettingsDocument);
}
export const ResetMyUiSettingsDocument = gql`
    mutation ResetMyUiSettings($scopes: [String!]) {
  resetMyUiSettings(scopes: $scopes)
}
    `;

export function useResetMyUiSettingsMutation() {
  return Urql.useMutation<ResetMyUiSettingsMutation, ResetMyUiSettingsMutationVariables>(ResetMyUiSettingsDocument);
}
export const ResetMyTableConfigsDocument = gql`
    mutation ResetMyTableConfigs($tables: [String!]) {
  resetMyTableConfigs(tables: $tables)
}
    `;

export function useResetMyTableConfigsMutation() {
  return Urql.useMutation<ResetMyTableConfigsMutation, ResetMyTableConfigsMutationVariables>(
    ResetMyTableConfigsDocument,
  );
}
export const MyUserConfigDocument = gql`
    query MyUserConfig {
  myUserConfig {
    ...MyUserConfigFragment
  }
}
    ${MyUserConfigFragmentFragmentDoc}`;

export function useMyUserConfigQuery(options?: Omit<Urql.UseQueryArgs<MyUserConfigQueryVariables>, 'query'>) {
  return Urql.useQuery<MyUserConfigQuery, MyUserConfigQueryVariables>({ query: MyUserConfigDocument, ...options });
}
